(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Dynamically import all .js files
 * */ var $6391e2b97e6756d6$exports = {};
var $008cc81fbaa87c40$exports = {};
const $008cc81fbaa87c40$var$selectors = {
    component: "[data-cp]",
    image: "[data-cp-image]",
    format: "[data-cp-format]"
};
const $008cc81fbaa87c40$var$initComponent = (component)=>{
    const formats = component.querySelectorAll($008cc81fbaa87c40$var$selectors.format);
    const images = component.querySelectorAll($008cc81fbaa87c40$var$selectors.image);
    formats?.forEach((format, activeIndex)=>format.addEventListener("click", ()=>images.forEach((image, index)=>image.setAttribute("data-cp-image", index === activeIndex ? "active" : ""))));
    formats[0].click();
};
document.addEventListener("DOMContentLoaded", async function() {
    const components = document.querySelectorAll($008cc81fbaa87c40$var$selectors.component);
    components?.forEach((component)=>$008cc81fbaa87c40$var$initComponent(component));
}, {
    once: true
});


var $6d529dde93b473aa$exports = {};
const $6d529dde93b473aa$var$selectors = {
    component: "[data-cp]",
    image: "[data-cp-image]",
    format: "[data-cp-format]"
};
const $6d529dde93b473aa$var$initComponent = (component)=>{
    const formats = component.querySelectorAll($6d529dde93b473aa$var$selectors.format);
    const images = component.querySelectorAll($6d529dde93b473aa$var$selectors.image);
    if (!formats.length || !images.length) return;
    const activate = (activeIndex)=>{
        images.forEach((image, index)=>image.setAttribute("data-cp-image", index === activeIndex ? "active" : ""));
    };
    formats.forEach((format, activeIndex)=>format.addEventListener("click", ()=>activate(activeIndex)));
    activate(0);
};
document.addEventListener("DOMContentLoaded", function() {
    const components = document.querySelectorAll($6d529dde93b473aa$var$selectors.component);
    components?.forEach((component)=>$6d529dde93b473aa$var$initComponent(component));
}, {
    once: true
});


var $6565e75a167d356f$exports = {};
const $6565e75a167d356f$var$selectors = {
    component: "[data-language-switcher]"
};
const $6565e75a167d356f$var$initComponent = (component)=>{
    document.addEventListener("click", (e)=>{
        if (!component.contains(e.target)) component.removeAttribute("open");
    });
};
document.addEventListener("DOMContentLoaded", ()=>{
    const components = document.querySelectorAll($6565e75a167d356f$var$selectors.component);
    components?.forEach($6565e75a167d356f$var$initComponent);
}, {
    once: true
});


var $8e22ce6962ee56c6$exports = {};
/**
 * Swiper 11.2.10
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 28, 2025
 */ /**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $5233158554eefdb5$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $5233158554eefdb5$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($5233158554eefdb5$var$isObject(src[key]) && $5233158554eefdb5$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $5233158554eefdb5$var$extend(target[key], src[key]);
    });
}
const $5233158554eefdb5$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $5233158554eefdb5$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $5233158554eefdb5$var$extend(doc, $5233158554eefdb5$var$ssrDocument);
    return doc;
}
const $5233158554eefdb5$var$ssrWindow = {
    document: $5233158554eefdb5$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $5233158554eefdb5$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $5233158554eefdb5$var$extend(win, $5233158554eefdb5$var$ssrWindow);
    return win;
}



function $4f4944a941445684$export$35e795649ee09318(classes) {
    if (classes === void 0) classes = '';
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $4f4944a941445684$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $4f4944a941445684$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $4f4944a941445684$export$2d1720544b23b823() {
    return Date.now();
}
function $4f4944a941445684$var$getComputedStyle(el) {
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $4f4944a941445684$export$342063e11d6c3cad(el, axis) {
    if (axis === void 0) axis = 'x';
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $4f4944a941445684$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $4f4944a941445684$export$ae1af26003f05816(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $4f4944a941445684$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $4f4944a941445684$export$d141bba7fdc215a3() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$4f4944a941445684$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($4f4944a941445684$export$ae1af26003f05816(to[nextKey]) && $4f4944a941445684$export$ae1af26003f05816(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $4f4944a941445684$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$4f4944a941445684$export$ae1af26003f05816(to[nextKey]) && $4f4944a941445684$export$ae1af26003f05816(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $4f4944a941445684$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $4f4944a941445684$export$407448d2b89b1813(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $4f4944a941445684$export$3b14a55fb2447963(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $4f4944a941445684$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $4f4944a941445684$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = '';
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $4f4944a941445684$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $4f4944a941445684$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $4f4944a941445684$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $4f4944a941445684$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $4f4944a941445684$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $4f4944a941445684$export$35e795649ee09318(classes));
    return el;
}
function $4f4944a941445684$export$4368d992c4eafac0(el) {
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const document1 = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $4f4944a941445684$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $4f4944a941445684$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $4f4944a941445684$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $4f4944a941445684$export$23f2a1d2818174ef(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $4f4944a941445684$export$8b22cf2602fb60ce(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $4f4944a941445684$export$882b5998b3b9117c(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $4f4944a941445684$export$dda1d9f60106f0e9(el, size, includeMargins) {
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $4f4944a941445684$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $4f4944a941445684$export$ffb5f4729a158638(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $4f4944a941445684$export$2408f22a0fab9ae5(el, html) {
    if (html === void 0) html = '';
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $ef08903b40b10988$var$support;
function $ef08903b40b10988$var$calcSupport() {
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const document1 = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $ef08903b40b10988$var$getSupport() {
    if (!$ef08903b40b10988$var$support) $ef08903b40b10988$var$support = $ef08903b40b10988$var$calcSupport();
    return $ef08903b40b10988$var$support;
}
let $ef08903b40b10988$var$deviceCached;
function $ef08903b40b10988$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $ef08903b40b10988$var$getSupport();
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $ef08903b40b10988$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$ef08903b40b10988$var$deviceCached) $ef08903b40b10988$var$deviceCached = $ef08903b40b10988$var$calcDevice(overrides);
    return $ef08903b40b10988$var$deviceCached;
}
let $ef08903b40b10988$var$browser;
function $ef08903b40b10988$var$calcBrowser() {
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const device = $ef08903b40b10988$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $ef08903b40b10988$var$getBrowser() {
    if (!$ef08903b40b10988$var$browser) $ef08903b40b10988$var$browser = $ef08903b40b10988$var$calcBrowser();
    return $ef08903b40b10988$var$browser;
}
function $ef08903b40b10988$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $ef08903b40b10988$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $4f4944a941445684$export$8b22cf2602fb60ce)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $ef08903b40b10988$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $ef08903b40b10988$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $4f4944a941445684$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $4f4944a941445684$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $4f4944a941445684$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $4f4944a941445684$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $ef08903b40b10988$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $4f4944a941445684$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $4f4944a941445684$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $4f4944a941445684$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $4f4944a941445684$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $4f4944a941445684$export$dda1d9f60106f0e9)(slide, 'width', true) : (0, $4f4944a941445684$export$dda1d9f60106f0e9)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $4f4944a941445684$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $4f4944a941445684$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $ef08903b40b10988$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $ef08903b40b10988$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $ef08903b40b10988$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $ef08903b40b10988$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $ef08903b40b10988$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $ef08903b40b10988$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $ef08903b40b10988$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $ef08903b40b10988$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $ef08903b40b10988$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $4f4944a941445684$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $4f4944a941445684$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $4f4944a941445684$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $ef08903b40b10988$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $ef08903b40b10988$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $ef08903b40b10988$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $ef08903b40b10988$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $ef08903b40b10988$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $ef08903b40b10988$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $ef08903b40b10988$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $ef08903b40b10988$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $ef08903b40b10988$var$unlazy(swiper, i);
    }
};
function $ef08903b40b10988$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $ef08903b40b10988$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $ef08903b40b10988$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $ef08903b40b10988$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $ef08903b40b10988$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $ef08903b40b10988$var$update = {
    updateSize: $ef08903b40b10988$var$updateSize,
    updateSlides: $ef08903b40b10988$var$updateSlides,
    updateAutoHeight: $ef08903b40b10988$var$updateAutoHeight,
    updateSlidesOffset: $ef08903b40b10988$var$updateSlidesOffset,
    updateSlidesProgress: $ef08903b40b10988$var$updateSlidesProgress,
    updateProgress: $ef08903b40b10988$var$updateProgress,
    updateSlidesClasses: $ef08903b40b10988$var$updateSlidesClasses,
    updateActiveIndex: $ef08903b40b10988$var$updateActiveIndex,
    updateClickedSlide: $ef08903b40b10988$var$updateClickedSlide
};
function $ef08903b40b10988$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $4f4944a941445684$export$342063e11d6c3cad)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $ef08903b40b10988$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $ef08903b40b10988$var$minTranslate() {
    return -this.snapGrid[0];
}
function $ef08903b40b10988$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $ef08903b40b10988$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $4f4944a941445684$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $ef08903b40b10988$var$translate = {
    getTranslate: $ef08903b40b10988$var$getSwiperTranslate,
    setTranslate: $ef08903b40b10988$var$setTranslate,
    minTranslate: $ef08903b40b10988$var$minTranslate,
    maxTranslate: $ef08903b40b10988$var$maxTranslate,
    translateTo: $ef08903b40b10988$var$translateTo
};
function $ef08903b40b10988$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $ef08903b40b10988$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $ef08903b40b10988$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $ef08903b40b10988$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $ef08903b40b10988$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $ef08903b40b10988$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $ef08903b40b10988$var$transition = {
    setTransition: $ef08903b40b10988$var$setTransition,
    transitionStart: $ef08903b40b10988$var$transitionStart,
    transitionEnd: $ef08903b40b10988$var$transitionEnd
};
function $ef08903b40b10988$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $4f4944a941445684$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $ef08903b40b10988$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $ef08903b40b10988$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $ef08903b40b10988$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $ef08903b40b10988$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $ef08903b40b10988$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $ef08903b40b10988$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $ef08903b40b10988$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $4f4944a941445684$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $4f4944a941445684$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $ef08903b40b10988$var$slide = {
    slideTo: $ef08903b40b10988$var$slideTo,
    slideToLoop: $ef08903b40b10988$var$slideToLoop,
    slideNext: $ef08903b40b10988$var$slideNext,
    slidePrev: $ef08903b40b10988$var$slidePrev,
    slideReset: $ef08903b40b10988$var$slideReset,
    slideToClosest: $ef08903b40b10988$var$slideToClosest,
    slideToClickedSlide: $ef08903b40b10988$var$slideToClickedSlide
};
function $ef08903b40b10988$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $4f4944a941445684$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $4f4944a941445684$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $4f4944a941445684$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $4f4944a941445684$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $4f4944a941445684$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $4f4944a941445684$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : 'next',
        initial: initial
    });
}
function $ef08903b40b10988$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, initialSlide: initialSlide } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = centeredSlides ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $4f4944a941445684$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $4f4944a941445684$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $ef08903b40b10988$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $ef08903b40b10988$var$loop = {
    loopCreate: $ef08903b40b10988$var$loopCreate,
    loopFix: $ef08903b40b10988$var$loopFix,
    loopDestroy: $ef08903b40b10988$var$loopDestroy
};
function $ef08903b40b10988$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $ef08903b40b10988$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $ef08903b40b10988$var$grabCursor = {
    setGrabCursor: $ef08903b40b10988$var$setGrabCursor,
    unsetGrabCursor: $ef08903b40b10988$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $ef08903b40b10988$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $5233158554eefdb5$export$39b482c5e57630a8)() || el === (0, $5233158554eefdb5$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $ef08903b40b10988$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $ef08903b40b10988$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $ef08903b40b10988$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $4f4944a941445684$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $ef08903b40b10988$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$ef08903b40b10988$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $4f4944a941445684$export$2d1720544b23b823)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $ef08903b40b10988$var$onTouchMove(event) {
    const document1 = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $4f4944a941445684$export$2d1720544b23b823)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $ef08903b40b10988$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $4f4944a941445684$export$2d1720544b23b823)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $4f4944a941445684$export$2d1720544b23b823)();
    (0, $4f4944a941445684$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $ef08903b40b10988$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $ef08903b40b10988$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $ef08903b40b10988$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $ef08903b40b10988$var$onLoad(e) {
    const swiper = this;
    $ef08903b40b10988$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $ef08903b40b10988$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $ef08903b40b10988$var$events = (swiper, method)=>{
    const document1 = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $ef08903b40b10988$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $ef08903b40b10988$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $ef08903b40b10988$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $ef08903b40b10988$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $ef08903b40b10988$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $ef08903b40b10988$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $ef08903b40b10988$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $ef08903b40b10988$var$onScroll.bind(swiper);
    swiper.onClick = $ef08903b40b10988$var$onClick.bind(swiper);
    swiper.onLoad = $ef08903b40b10988$var$onLoad.bind(swiper);
    $ef08903b40b10988$var$events(swiper, 'on');
}
function $ef08903b40b10988$var$detachEvents() {
    const swiper = this;
    $ef08903b40b10988$var$events(swiper, 'off');
}
var $ef08903b40b10988$var$events$1 = {
    attachEvents: $ef08903b40b10988$var$attachEvents,
    detachEvents: $ef08903b40b10988$var$detachEvents
};
const $ef08903b40b10988$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $ef08903b40b10988$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $ef08903b40b10988$var$isGridEnabled(swiper, params);
    const isMultiRow = $ef08903b40b10988$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $4f4944a941445684$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $ef08903b40b10988$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $ef08903b40b10988$var$breakpoints = {
    setBreakpoint: $ef08903b40b10988$var$setBreakpoint,
    getBreakpoint: $ef08903b40b10988$var$getBreakpoint
};
function $ef08903b40b10988$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $ef08903b40b10988$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $ef08903b40b10988$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $ef08903b40b10988$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $ef08903b40b10988$var$classes = {
    addClasses: $ef08903b40b10988$var$addClasses,
    removeClasses: $ef08903b40b10988$var$removeClasses
};
function $ef08903b40b10988$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $ef08903b40b10988$var$checkOverflow$1 = {
    checkOverflow: $ef08903b40b10988$var$checkOverflow
};
var $ef08903b40b10988$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $ef08903b40b10988$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $4f4944a941445684$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $4f4944a941445684$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $4f4944a941445684$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $ef08903b40b10988$var$prototypes = {
    eventsEmitter: $ef08903b40b10988$var$eventsEmitter,
    update: $ef08903b40b10988$var$update,
    translate: $ef08903b40b10988$var$translate,
    transition: $ef08903b40b10988$var$transition,
    slide: $ef08903b40b10988$var$slide,
    loop: $ef08903b40b10988$var$loop,
    grabCursor: $ef08903b40b10988$var$grabCursor,
    events: $ef08903b40b10988$var$events$1,
    breakpoints: $ef08903b40b10988$var$breakpoints,
    checkOverflow: $ef08903b40b10988$var$checkOverflow$1,
    classes: $ef08903b40b10988$var$classes
};
const $ef08903b40b10988$var$extendedDefaults = {};
class $ef08903b40b10988$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $4f4944a941445684$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $4f4944a941445684$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $ef08903b40b10988$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $ef08903b40b10988$var$getSupport();
        swiper.device = $ef08903b40b10988$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $ef08903b40b10988$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $ef08903b40b10988$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $4f4944a941445684$export$d141bba7fdc215a3)({}, $ef08903b40b10988$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $4f4944a941445684$export$d141bba7fdc215a3)({}, swiperParams, $ef08903b40b10988$var$extendedDefaults, params);
        swiper.originalParams = (0, $4f4944a941445684$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $4f4944a941445684$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $4f4944a941445684$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $4f4944a941445684$export$23f2a1d2818174ef)(slides[0]);
        return (0, $4f4944a941445684$export$23f2a1d2818174ef)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $4f4944a941445684$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = 'current';
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $ef08903b40b10988$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $4f4944a941445684$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $4f4944a941445684$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $4f4944a941445684$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $4f4944a941445684$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $4f4944a941445684$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $ef08903b40b10988$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $ef08903b40b10988$var$processLazyPreloader(swiper, e.target);
            });
        });
        $ef08903b40b10988$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $ef08903b40b10988$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $4f4944a941445684$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $4f4944a941445684$export$d141bba7fdc215a3)($ef08903b40b10988$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $ef08903b40b10988$var$extendedDefaults;
    }
    static get defaults() {
        return $ef08903b40b10988$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$ef08903b40b10988$export$25ce5a424b770e84.prototype.__modules__) $ef08903b40b10988$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $ef08903b40b10988$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$ef08903b40b10988$export$25ce5a424b770e84.installModule(m));
            return $ef08903b40b10988$export$25ce5a424b770e84;
        }
        $ef08903b40b10988$export$25ce5a424b770e84.installModule(module);
        return $ef08903b40b10988$export$25ce5a424b770e84;
    }
}
Object.keys($ef08903b40b10988$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($ef08903b40b10988$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $ef08903b40b10988$export$25ce5a424b770e84.prototype[protoMethod] = $ef08903b40b10988$var$prototypes[prototypeGroup][protoMethod];
    });
});
$ef08903b40b10988$export$25ce5a424b770e84.use([
    $ef08903b40b10988$var$Resize,
    $ef08903b40b10988$var$Observer
]);






function $78c112997003435d$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $4f4944a941445684$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $4f4944a941445684$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $4f4944a941445684$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $4f4944a941445684$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $4f4944a941445684$export$407448d2b89b1813)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $1e4c0fd8a1b20f5f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    const window = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $4f4944a941445684$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $4f4944a941445684$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $4f4944a941445684$export$4368d992c4eafac0)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $c346b2c32528d1ad$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $4f4944a941445684$export$2d1720544b23b823)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $4f4944a941445684$export$2d1720544b23b823)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $4f4944a941445684$export$2d1720544b23b823)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $4f4944a941445684$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $4f4944a941445684$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $4f4944a941445684$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $4f4944a941445684$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $39c3d039cad5d0a4$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $4f4944a941445684$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $db5e35f8b42a9c13$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $39c3d039cad5d0a4$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $4f4944a941445684$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $4f4944a941445684$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $4f4944a941445684$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $4f4944a941445684$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $4f4944a941445684$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $4f4944a941445684$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $4f4944a941445684$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $4f4944a941445684$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $8867cace240b3327$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = '';
    return `.${classes.trim().replace(/([\.:!+\/()[\]])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $253ab9cb215bc6e2$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $8867cace240b3327$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $4f4944a941445684$export$23f2a1d2818174ef)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $4f4944a941445684$export$dda1d9f60106f0e9)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $4f4944a941445684$export$23f2a1d2818174ef)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $8867cace240b3327$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $8867cace240b3327$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $8867cace240b3327$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $4f4944a941445684$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $4f4944a941445684$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $8867cace240b3327$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $39c3d039cad5d0a4$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $4f4944a941445684$export$8b22cf2602fb60ce)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $4f4944a941445684$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $1201e8bb5130d757$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $4f4944a941445684$export$4368d992c4eafac0)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $4f4944a941445684$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $39c3d039cad5d0a4$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $8867cace240b3327$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $4f4944a941445684$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $4f4944a941445684$export$35e795649ee09318)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $4f4944a941445684$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $4f4944a941445684$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $4f4944a941445684$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $4f4944a941445684$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $4f4944a941445684$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $5d67463537997dfb$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $4f4944a941445684$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $4f4944a941445684$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $31db59fbab7330dc$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $4f4944a941445684$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $4f4944a941445684$export$342063e11d6c3cad)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $4f4944a941445684$export$342063e11d6c3cad)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $4f4944a941445684$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $4f4944a941445684$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $4f4944a941445684$export$4368d992c4eafac0)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $4f4944a941445684$export$4368d992c4eafac0)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $4f4944a941445684$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $4f4944a941445684$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $3e90ea3ad475e65b$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $4f4944a941445684$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $4f4944a941445684$export$882b5998b3b9117c)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $1229bded4a7e5ab1$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $4f4944a941445684$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $4f4944a941445684$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $8867cace240b3327$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $4f4944a941445684$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $4f4944a941445684$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $8867cace240b3327$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $4f4944a941445684$export$23f2a1d2818174ef)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $8867cace240b3327$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $4f4944a941445684$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $4f4944a941445684$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $4f4944a941445684$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $4f4944a941445684$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $4f4944a941445684$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $4f4944a941445684$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $4f4944a941445684$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $c2d78b11d49a269f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $5233158554eefdb5$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $5233158554eefdb5$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $5233158554eefdb5$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $5233158554eefdb5$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $7cee723a1751934f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
    const window = (0, $5233158554eefdb5$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $4f4944a941445684$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $644dc5bb1a0fcf22$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $423dd66587b0d553$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $4f4944a941445684$export$ae1af26003f05816)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $4f4944a941445684$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $5233158554eefdb5$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $d680c6fd8e598294$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $4f4944a941445684$export$2d1720544b23b823)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $4f4944a941445684$export$2d1720544b23b823)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $4f4944a941445684$export$2d1720544b23b823)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $4f4944a941445684$export$882b5998b3b9117c)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $4f4944a941445684$export$882b5998b3b9117c)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $4f4944a941445684$export$882b5998b3b9117c)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $90239953d16ac3a4$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $5abbbee49b8d93db$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $4f4944a941445684$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $4f4944a941445684$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $5abbbee49b8d93db$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $4f4944a941445684$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $4f4944a941445684$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $5abbbee49b8d93db$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $5abbbee49b8d93db$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $5abbbee49b8d93db$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $5abbbee49b8d93db$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $5abbbee49b8d93db$var$appendSlide.bind(swiper),
        prependSlide: $5abbbee49b8d93db$var$prependSlide.bind(swiper),
        addSlide: $5abbbee49b8d93db$var$addSlide.bind(swiper),
        removeSlide: $5abbbee49b8d93db$var$removeSlide.bind(swiper),
        removeAllSlides: $5abbbee49b8d93db$var$removeAllSlides.bind(swiper)
    });
}


function $6a44dfd59aedbaa7$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $21c43987c2bfd1db$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $4f4944a941445684$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $0874d58b140ef0e8$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $4f4944a941445684$export$882b5998b3b9117c)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $e59a358cf6803be6$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $21c43987c2bfd1db$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $4f4944a941445684$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $0874d58b140ef0e8$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6a44dfd59aedbaa7$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $14afca93b762096a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $4f4944a941445684$export$ffb5f4729a158638)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $6a44dfd59aedbaa7$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $6f03c9fa58f96bee$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $4f4944a941445684$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $4f4944a941445684$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $a33628a8a741c834$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $6f03c9fa58f96bee$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $6f03c9fa58f96bee$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $4f4944a941445684$export$ffb5f4729a158638)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $21c43987c2bfd1db$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $4f4944a941445684$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $0874d58b140ef0e8$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6a44dfd59aedbaa7$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $c5014d9f60113481$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $4f4944a941445684$export$ffb5f4729a158638)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $21c43987c2bfd1db$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $6f03c9fa58f96bee$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $6f03c9fa58f96bee$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $4f4944a941445684$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $6a44dfd59aedbaa7$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $59a10481aeb4f5cc$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $4f4944a941445684$export$ffb5f4729a158638)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $6f03c9fa58f96bee$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $21c43987c2bfd1db$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $4f4944a941445684$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $0874d58b140ef0e8$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6a44dfd59aedbaa7$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $d396657bb8244a15$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $6f03c9fa58f96bee$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $21c43987c2bfd1db$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $4f4944a941445684$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $0874d58b140ef0e8$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6a44dfd59aedbaa7$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




const $8e22ce6962ee56c6$var$selectors = {
    block: "[data-card-row]"
};
const $8e22ce6962ee56c6$var$togglePagination = (swiper)=>{
    const total = swiper.slides.length;
    const perView = swiper.params.slidesPerView;
    const controls = swiper.el.closest('[data-card-row]')?.querySelector('[data-swiper-controls]');
    if (controls) controls.style.display = total <= perView ? 'none' : '';
};
const $8e22ce6962ee56c6$var$initSwiper = (container)=>new (0, $ef08903b40b10988$export$25ce5a424b770e84)(container.querySelector(".swiper"), {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        breakpoints: {
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3
            }
        },
        navigation: {
            prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
            nextEl: container.querySelector('[data-swiper-navigation="next"]')
        },
        pagination: {
            el: container.querySelector("[data-swiper-pagination]")
        },
        on: {
            init: (swiper)=>{
                swiper.el.style.opacity = '1';
                $8e22ce6962ee56c6$var$togglePagination(swiper);
            },
            breakpoint: (swiper)=>{
                $8e22ce6962ee56c6$var$togglePagination(swiper);
            }
        }
    });
const $8e22ce6962ee56c6$var$initBlock = (block)=>{
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $db5e35f8b42a9c13$export$2e2bcd8739ae039),
        (0, $253ab9cb215bc6e2$export$2e2bcd8739ae039)
    ]);
    $8e22ce6962ee56c6$var$initSwiper(block);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($8e22ce6962ee56c6$var$selectors.block);
    blocks?.forEach($8e22ce6962ee56c6$var$initBlock);
}, {
    once: true
});


var $f57771f2c38e5958$exports = {};
const $f57771f2c38e5958$var$selectors = {
    block: '[data-form-wrapper]',
    recipientSelector: '[data-recipient-selector]',
    hiddenInput: 'input[name="input_7"]',
    radio: 'input[type="radio"]'
};
const $f57771f2c38e5958$var$getCheckedRadio = (block)=>block.querySelector(`${$f57771f2c38e5958$var$selectors.recipientSelector} ${$f57771f2c38e5958$var$selectors.radio}:checked`);
const $f57771f2c38e5958$var$updateEmail = (block, email)=>{
    const input = block.querySelector($f57771f2c38e5958$var$selectors.hiddenInput);
    if (input) input.value = email;
};
const $f57771f2c38e5958$var$observeFormRerender = (block)=>{
    const observer = new MutationObserver(()=>{
        const checked = $f57771f2c38e5958$var$getCheckedRadio(block);
        if (checked) $f57771f2c38e5958$var$updateEmail(block, checked.value);
    });
    observer.observe(block, {
        childList: true,
        subtree: true
    });
};
const $f57771f2c38e5958$var$initBlock = (block)=>{
    const selector = block.querySelector($f57771f2c38e5958$var$selectors.recipientSelector);
    if (!selector) return;
    const defaultRadio = $f57771f2c38e5958$var$getCheckedRadio(block);
    if (defaultRadio) $f57771f2c38e5958$var$updateEmail(block, defaultRadio.value);
    selector.addEventListener('change', (e)=>{
        if (e.target.name === 'representative_choice') $f57771f2c38e5958$var$updateEmail(block, e.target.value);
    });
    $f57771f2c38e5958$var$observeFormRerender(block);
};
document.addEventListener('DOMContentLoaded', ()=>{
    const blocks = document.querySelectorAll($f57771f2c38e5958$var$selectors.block);
    blocks?.forEach($f57771f2c38e5958$var$initBlock);
}, {
    once: true
});


var $872ba0b5fdcef74e$exports = {};
const $872ba0b5fdcef74e$var$selectors = {
    block: "[data-downloads]",
    tab: "[data-downloads-tab]",
    panel: "[data-downloads-panel]"
};
const $872ba0b5fdcef74e$var$setActiveTab = (activeIndex, panels)=>panels.forEach((panel, index)=>panel.setAttribute("data-downloads-panel", index === activeIndex ? "active" : ""));
const $872ba0b5fdcef74e$var$initBlock = (block)=>{
    const tabs = block.querySelectorAll($872ba0b5fdcef74e$var$selectors.tab);
    const panels = block.querySelectorAll($872ba0b5fdcef74e$var$selectors.panel);
    tabs.forEach((tab, index)=>tab.addEventListener("click", ()=>$872ba0b5fdcef74e$var$setActiveTab(index, panels)));
    tabs[0].click();
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($872ba0b5fdcef74e$var$selectors.block);
    blocks?.forEach($872ba0b5fdcef74e$var$initBlock);
}, {
    once: true
});


var $bba5c2db06278f04$exports = {};
const $bba5c2db06278f04$var$selectors = {
    block: "[data-fom]",
    trigger: "[data-fom-trigger]"
};
const $bba5c2db06278f04$var$initBlock = (block)=>{
    const trigger = block.querySelector($bba5c2db06278f04$var$selectors.trigger);
    trigger?.addEventListener("click", ()=>block.classList.add("active"));
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($bba5c2db06278f04$var$selectors.block);
    blocks?.forEach($bba5c2db06278f04$var$initBlock);
}, {
    once: true
});


var $39283e61516b30c4$exports = {};


const $39283e61516b30c4$var$selectors = {
    block: "[data-hb2b]",
    year: "[data-hb2b-year]"
};
const $39283e61516b30c4$var$initSwiper = (container, years)=>{
    const swiper = new (0, $ef08903b40b10988$export$25ce5a424b770e84)(container.querySelector(".swiper"), {
        slidesPerView: "auto",
        spaceBetween: 24,
        breakpoints: {
            1024: {
                slidesPerView: 1,
                speed: 0
            }
        },
        navigation: {
            prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
            nextEl: container.querySelector('[data-swiper-navigation="next"]')
        },
        pagination: {
            el: container.querySelector("[data-swiper-pagination]")
        },
        on: {
            realIndexChange: ({ realIndex: realIndex })=>{
                years.forEach((year, index)=>year.classList[realIndex === index ? "add" : "remove"]("active"));
            },
            init: ({ realIndex: realIndex })=>years.forEach((year, index)=>year.classList[realIndex === index ? "add" : "remove"]("active"))
        }
    });
    years.forEach((year, index)=>year.addEventListener("click", ()=>swiper.slideTo(index)));
};
const $39283e61516b30c4$var$initBlock = (block)=>{
    const years = block.querySelectorAll($39283e61516b30c4$var$selectors.year);
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $db5e35f8b42a9c13$export$2e2bcd8739ae039),
        (0, $253ab9cb215bc6e2$export$2e2bcd8739ae039),
        (0, $d680c6fd8e598294$export$2e2bcd8739ae039)
    ]);
    $39283e61516b30c4$var$initSwiper(block, years);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($39283e61516b30c4$var$selectors.block);
    blocks?.forEach($39283e61516b30c4$var$initBlock);
}, {
    once: true
});


var $9c291a20e416d0d3$exports = {};
const $9c291a20e416d0d3$var$selectors = {
    block: "[data-hb2c]",
    anchor: "[data-hb2c-anchor]",
    item: "[data-hb2c-item]"
};
const $9c291a20e416d0d3$var$highlightLink = (que, anchors)=>{
    anchors.forEach((anchor)=>{
        const isActive = anchor.href.includes(que[0]);
        anchor.setAttribute("data-hb2c-anchor", isActive ? "active" : "");
    });
};
const $9c291a20e416d0d3$var$observeItems = (items, anchors)=>{
    let que = [];
    const observer = new IntersectionObserver(([entry])=>{
        if (!entry.isIntersecting) que = que.filter((id)=>id !== entry.target.id);
        else {
            que = [
                ...que,
                entry.target.id
            ];
            $9c291a20e416d0d3$var$highlightLink(que, anchors);
        }
    }, {
        threshold: 1
    });
    items.forEach((item)=>observer.observe(item));
};
const $9c291a20e416d0d3$var$initBlock = (block)=>{
    const anchors = block.querySelectorAll($9c291a20e416d0d3$var$selectors.anchor);
    const items = block.querySelectorAll($9c291a20e416d0d3$var$selectors.item);
    $9c291a20e416d0d3$var$observeItems(items, anchors);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($9c291a20e416d0d3$var$selectors.block);
    blocks?.forEach($9c291a20e416d0d3$var$initBlock);
}, {
    once: true
});


var $15048eb7b061216f$exports = {};
const $15048eb7b061216f$var$selectors = {
    block: "[data-login]"
};
const $15048eb7b061216f$var$initBlock = (block)=>{
    const inputs = block.querySelectorAll("#user_login, #user_pass");
    inputs?.forEach((input)=>{
        input.setAttribute("placeholder", input.previousElementSibling.textContent);
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($15048eb7b061216f$var$selectors.block);
    blocks?.forEach($15048eb7b061216f$var$initBlock);
}, {
    once: true
});


var $f3ce3c92dad61958$exports = {};
const $f3ce3c92dad61958$var$selectors = {
    block: "[data-overview]",
    filterForm: "[data-overview-filters]",
    filter: "[data-overview-filter]"
};
const $f3ce3c92dad61958$var$initBlock = (block)=>{
    const searchParams = new URLSearchParams(window.location.search);
    const queryCategory = searchParams.getAll("category");
    const filterForm = block.querySelector($f3ce3c92dad61958$var$selectors.filterForm);
    const filters = block.querySelectorAll($f3ce3c92dad61958$var$selectors.filter);
    filters?.forEach((filter)=>{
        filter.checked = queryCategory.includes(filter.value);
        filter.addEventListener("click", ()=>{
            filterForm.submit();
        });
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($f3ce3c92dad61958$var$selectors.block);
    blocks?.forEach($f3ce3c92dad61958$var$initBlock);
}, {
    once: true
});


var $9411547ecd6821ce$exports = {};


const $9411547ecd6821ce$var$selectors = {
    block: "[data-pc]",
    breadcrumbs: "[data-pc-bc]",
    description: "[data-pc-description]"
};
const $9411547ecd6821ce$var$setScheme = (container, pagination, breadcrumbs, descriptions, activeIndex, previousIndex, slides)=>{
    const prevScheme = slides[previousIndex]?.dataset.pcScheme.split(" ") || [];
    const activeScheme = slides[activeIndex]?.dataset.pcScheme.split(" ");
    container.classList.remove(...prevScheme);
    container.classList.add(...activeScheme);
    pagination.classList.remove(prevScheme[0]);
    pagination.classList.add(activeScheme[0]);
    breadcrumbs.classList.remove(prevScheme[0]);
    breadcrumbs.classList.add(activeScheme[0]);
    descriptions.forEach((description, index)=>description.classList[index === activeIndex ? "add" : "remove"]("active"));
};
const $9411547ecd6821ce$var$initSwiper = (container)=>{
    const pagination = container.querySelector("[data-swiper-pagination]");
    const breadcrumbs = container.querySelector($9411547ecd6821ce$var$selectors.breadcrumbs);
    const descriptions = container.querySelectorAll($9411547ecd6821ce$var$selectors.description);
    new (0, $ef08903b40b10988$export$25ce5a424b770e84)(container.querySelector(".swiper"), {
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 24,
        centeredSlides: true,
        speed: 750,
        slideToClickedSlide: true,
        breakpoints: {
            1024: {
                slidesPerView: "auto"
            }
        },
        navigation: {
            prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
            nextEl: container.querySelector('[data-swiper-navigation="next"]')
        },
        pagination: {
            el: pagination
        },
        on: {
            realIndexChange: ({ activeIndex: activeIndex, previousIndex: previousIndex, slides: slides })=>$9411547ecd6821ce$var$setScheme(container, pagination, breadcrumbs, descriptions, activeIndex, previousIndex, slides),
            init: ({ activeIndex: activeIndex, previousIndex: previousIndex, slides: slides })=>$9411547ecd6821ce$var$setScheme(container, pagination, breadcrumbs, descriptions, activeIndex, previousIndex, slides)
        }
    });
};
const $9411547ecd6821ce$var$initBlock = (block)=>{
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $db5e35f8b42a9c13$export$2e2bcd8739ae039),
        (0, $253ab9cb215bc6e2$export$2e2bcd8739ae039),
        (0, $d680c6fd8e598294$export$2e2bcd8739ae039)
    ]);
    $9411547ecd6821ce$var$initSwiper(block);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($9411547ecd6821ce$var$selectors.block);
    blocks?.forEach($9411547ecd6821ce$var$initBlock);
}, {
    once: true
});


var $86316a66c8543ab8$exports = {};


const $86316a66c8543ab8$var$selectors = {
    block: "[data-product-categories]"
};
const $86316a66c8543ab8$var$initSwiper = (container)=>new (0, $ef08903b40b10988$export$25ce5a424b770e84)(container.querySelector(".swiper"), {
        spaceBetween: 24,
        enabled: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1
            },
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            1280: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        },
        on: {
            init: (swiper)=>{
                swiper.el.style.opacity = '1';
            }
        },
        navigation: {
            prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
            nextEl: container.querySelector('[data-swiper-navigation="next"]')
        },
        pagination: {
            el: container.querySelector("[data-swiper-pagination]")
        }
    });
const $86316a66c8543ab8$var$initBlock = (block)=>{
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $db5e35f8b42a9c13$export$2e2bcd8739ae039),
        (0, $253ab9cb215bc6e2$export$2e2bcd8739ae039)
    ]);
    $86316a66c8543ab8$var$initSwiper(block);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($86316a66c8543ab8$var$selectors.block);
    blocks?.forEach($86316a66c8543ab8$var$initBlock);
}, {
    once: true
});


var $5bc2f7e02c6a2d2b$exports = {};


const $5bc2f7e02c6a2d2b$var$selectors = {
    block: "[data-product-categories-v2]"
};
const $5bc2f7e02c6a2d2b$var$initSwiper = (container)=>new (0, $ef08903b40b10988$export$25ce5a424b770e84)(container.querySelector(".swiper"), {
        //slidesPerView: "auto",
        spaceBetween: 24,
        enabled: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1
            },
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1024: {
                initialSlide: 2,
                slidesPerView: 5,
                centeredSlides: true
            }
        },
        on: {
            init: (swiper)=>{
                swiper.el.style.opacity = '1';
            }
        },
        navigation: {
            prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
            nextEl: container.querySelector('[data-swiper-navigation="next"]')
        },
        pagination: {
            el: container.querySelector("[data-swiper-pagination]")
        }
    });
const $5bc2f7e02c6a2d2b$var$initBlock = (block)=>{
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $db5e35f8b42a9c13$export$2e2bcd8739ae039),
        (0, $253ab9cb215bc6e2$export$2e2bcd8739ae039)
    ]);
    $5bc2f7e02c6a2d2b$var$initSwiper(block);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($5bc2f7e02c6a2d2b$var$selectors.block);
    blocks?.forEach($5bc2f7e02c6a2d2b$var$initBlock);
}, {
    once: true
});


var $5ab3a902e841c548$exports = {};


const $5ab3a902e841c548$var$selectors = {
    block: "[data-pd]",
    image: "[data-pd-image]",
    navImage: "[data-pd-image-nav]",
    size: "[data-pd-size]",
    format: "[data-pd-format]",
    logos: "[data-pd-logos]"
};
const $5ab3a902e841c548$var$initLogosSwiper = (container)=>new (0, $ef08903b40b10988$export$25ce5a424b770e84)(container.querySelector($5ab3a902e841c548$var$selectors.logos), {
        slidesPerView: "auto",
        spaceBetween: 16,
        autoplay: true,
        rewind: true,
        breakpoints: {
            1024: {
                spaceBetween: 48
            }
        }
    });
const $5ab3a902e841c548$var$initNavImage = (image, navImage)=>{
    navImage.addEventListener("click", ()=>image.setAttribute("src", navImage.value));
};
const $5ab3a902e841c548$var$setFormat = (activeIndex, sizes, navImages)=>{
    sizes.forEach((size, index)=>size.classList[index === activeIndex ? "add" : "remove"]("active"));
    navImages.forEach((navImage, index)=>{
        if (index !== activeIndex) return;
        navImage.click();
    });
};
const $5ab3a902e841c548$var$initFormat = (format, index, sizes, navImages)=>{
    format.addEventListener("click", ()=>$5ab3a902e841c548$var$setFormat(index, sizes, navImages));
};
const $5ab3a902e841c548$var$initBlock = (block)=>{
    const image = block.querySelector($5ab3a902e841c548$var$selectors.image);
    const navImages = block.querySelectorAll($5ab3a902e841c548$var$selectors.navImage);
    const sizes = block.querySelectorAll($5ab3a902e841c548$var$selectors.size);
    const formats = block.querySelectorAll($5ab3a902e841c548$var$selectors.format);
    const searchParams = new URLSearchParams(window.location.search);
    const queryFormat = searchParams.get("format");
    const queryIndex = [
        ...formats
    ].findIndex((format)=>format.dataset.pdFormat === queryFormat);
    navImages?.forEach((navImage)=>$5ab3a902e841c548$var$initNavImage(image, navImage));
    formats?.forEach((format, index)=>$5ab3a902e841c548$var$initFormat(format, index, sizes, navImages));
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $644dc5bb1a0fcf22$export$2e2bcd8739ae039)
    ]);
    $5ab3a902e841c548$var$initLogosSwiper(block);
    formats?.[queryIndex > -1 ? queryIndex : 0].click();
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($5ab3a902e841c548$var$selectors.block);
    blocks?.forEach($5ab3a902e841c548$var$initBlock);
}, {
    once: true
});


var $c72f82e13c082c56$exports = {};
// const selectors = {
//   block: "[data-pf]",
//   filterForm: "[data-pf-filters]",
//   filter: "[data-pf-filter]",
// };
// const initBlock = (block) => {
//   const searchParams = new URLSearchParams(window.location.search);
//   const queryCategory = searchParams.getAll("category");
//   const filterForm = block.querySelector(selectors.filterForm);
//   const filters = block.querySelectorAll(selectors.filter);
//   filters?.forEach((filter) => {
//     filter.classList[queryCategory.includes(filter.value) ? "add" : "remove"]("active");
//     filter.addEventListener("click", () => {
//       filterForm.submit();
//     });
//   });
// };
// document.addEventListener(
//   "DOMContentLoaded",
//   async function () {
//     const blocks = document.querySelectorAll(selectors.block);
//     blocks?.forEach(initBlock);
//   },
//   {
//     once: true,
//   }
// );


const $c72f82e13c082c56$var$selectors = {
    block: "[data-pf]",
    filterForm: "[data-pf-filters]",
    filter: "[data-pf-filter]",
    slider: "[data-pf-slider]"
};
const $c72f82e13c082c56$var$initSlider = (block)=>{
    const slider = block.querySelector($c72f82e13c082c56$var$selectors.slider);
    if (!slider) return;
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $db5e35f8b42a9c13$export$2e2bcd8739ae039),
        (0, $253ab9cb215bc6e2$export$2e2bcd8739ae039)
    ]);
    // new Swiper(slider, {
    //   spaceBetween: 16,
    //   breakpoints: {
    //     0: {
    //       slidesPerView: 1,
    //       slidesPerGroup: 1,
    //     },
    //     640: {
    //       slidesPerView: 2,
    //       slidesPerGroup: 2,
    //     },
    //     1024: {
    //       slidesPerView: 3,
    //       slidesPerGroup: 3,
    //     },
    //     1280: {
    //       slidesPerView: 4,
    //       slidesPerGroup: 4,
    //     },
    //   },
    //   navigation: {
    //     prevEl: block.querySelector('[data-swiper-navigation="prev"]'),
    //     nextEl: block.querySelector('[data-swiper-navigation="next"]'),
    //   },
    //   pagination: {
    //     el: block.querySelector('[data-swiper-pagination]'),
    //   },
    // });
    new (0, $ef08903b40b10988$export$25ce5a424b770e84)(slider, {
        spaceBetween: 32,
        slidesPerView: "auto",
        slideToClickedSlide: false,
        watchOverflow: true,
        navigation: {
            prevEl: block.querySelector('[data-swiper-navigation="prev"]'),
            nextEl: block.querySelector('[data-swiper-navigation="next"]'),
            hideOnClick: false,
            disabledClass: "hidden"
        },
        pagination: {
            el: block.querySelector("[data-swiper-pagination]")
        }
    });
};
const $c72f82e13c082c56$var$initBlock = (block)=>{
    const searchParams = new URLSearchParams(window.location.search);
    const queryCategory = searchParams.getAll("category");
    const filterForm = block.querySelector($c72f82e13c082c56$var$selectors.filterForm);
    const filters = block.querySelectorAll($c72f82e13c082c56$var$selectors.filter);
    filters?.forEach((filter)=>{
        filter.classList[queryCategory.includes(filter.value) ? "add" : "remove"]("active");
        filter.addEventListener("click", ()=>{
            filterForm.submit();
        });
    });
    $c72f82e13c082c56$var$initSlider(block);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($c72f82e13c082c56$var$selectors.block);
    blocks?.forEach($c72f82e13c082c56$var$initBlock);
}, {
    once: true
});


var $821366883944f074$exports = {};
var $2734edb455aab2eb$exports = {};
$2734edb455aab2eb$exports = JSON.parse('[{"id":1,"zipcode":1000,"city":"Brussel"},{"id":2,"zipcode":1020,"city":"Laken"},{"id":3,"zipcode":1030,"city":"Schaarbeek"},{"id":4,"zipcode":1040,"city":"Etterbeek"},{"id":5,"zipcode":1050,"city":"Elsene"},{"id":6,"zipcode":1060,"city":"Sint-Gillis"},{"id":7,"zipcode":1070,"city":"Anderlecht"},{"id":8,"zipcode":1080,"city":"Sint-Jans-Molenbeek"},{"id":9,"zipcode":1081,"city":"Koekelberg"},{"id":10,"zipcode":1082,"city":"Sint-Agatha-Berchem"},{"id":11,"zipcode":1083,"city":"Ganshoren"},{"id":12,"zipcode":1090,"city":"Jette"},{"id":13,"zipcode":1120,"city":"Neder-Over-Heembeek"},{"id":14,"zipcode":1130,"city":"Haren"},{"id":15,"zipcode":1140,"city":"Evere"},{"id":16,"zipcode":1150,"city":"Sint-Pieters-Woluwe"},{"id":17,"zipcode":1160,"city":"Oudergem"},{"id":18,"zipcode":1170,"city":"Watermaal-Bosvoorde"},{"id":19,"zipcode":1180,"city":"Ukkel"},{"id":20,"zipcode":1190,"city":"Vorst"},{"id":21,"zipcode":1200,"city":"Sint-Lambrechts-Woluwe"},{"id":22,"zipcode":1210,"city":"Sint-Joost-ten-Node"},{"id":23,"zipcode":1300,"city":"Limal"},{"id":24,"zipcode":1300,"city":"Wavre"},{"id":25,"zipcode":1301,"city":"Bierges"},{"id":26,"zipcode":1310,"city":"La Hulpe"},{"id":27,"zipcode":1315,"city":"Glimes"},{"id":28,"zipcode":1315,"city":"Opprebais"},{"id":29,"zipcode":1315,"city":"Pi\xe9trebais"},{"id":30,"zipcode":1315,"city":"Roux-Miroir"},{"id":31,"zipcode":1315,"city":"Incourt"},{"id":32,"zipcode":1320,"city":"Hamme-Mille"},{"id":33,"zipcode":1320,"city":"l\'\xc9cluse"},{"id":34,"zipcode":1320,"city":"Nodebais"},{"id":35,"zipcode":1320,"city":"Tourinnes-la-Grosse"},{"id":36,"zipcode":1320,"city":"Beauvechain"},{"id":37,"zipcode":1325,"city":"Bonlez"},{"id":38,"zipcode":1325,"city":"Corroy-le-Grand"},{"id":39,"zipcode":1325,"city":"Dion-Valmont"},{"id":40,"zipcode":1325,"city":"Longueville"},{"id":41,"zipcode":1325,"city":"Chaumont-Gistoux"},{"id":42,"zipcode":1330,"city":"Rixensart"},{"id":43,"zipcode":1331,"city":"Rosi\xe8res"},{"id":44,"zipcode":1332,"city":"Genval"},{"id":45,"zipcode":1340,"city":"Ottignies"},{"id":46,"zipcode":1341,"city":"C\xe9roux-Mousty"},{"id":47,"zipcode":1342,"city":"Limelette"},{"id":48,"zipcode":1348,"city":"Louvain-la-Neuve"},{"id":49,"zipcode":1350,"city":"Enines"},{"id":50,"zipcode":1350,"city":"Folx-les-Caves"},{"id":51,"zipcode":1350,"city":"Jandrain-Jandrenouille"},{"id":52,"zipcode":1350,"city":"Jauche"},{"id":53,"zipcode":1350,"city":"Marilles"},{"id":54,"zipcode":1350,"city":"Noduwez"},{"id":55,"zipcode":1350,"city":"Orp-le-Grand"},{"id":56,"zipcode":1357,"city":"Linsmeau"},{"id":57,"zipcode":1357,"city":"Neerheylissem"},{"id":58,"zipcode":1357,"city":"Opheylissem"},{"id":59,"zipcode":1360,"city":"Mal\xe8ves-Sainte-Marie-Wastinnes"},{"id":60,"zipcode":1360,"city":"Orbais"},{"id":61,"zipcode":1360,"city":"Thorembais-les-B\xe9guines"},{"id":62,"zipcode":1360,"city":"Thorembais-Saint-Trond"},{"id":63,"zipcode":1360,"city":"Perwez"},{"id":64,"zipcode":1367,"city":"Autre-Eglise"},{"id":65,"zipcode":1367,"city":"Bomal"},{"id":66,"zipcode":1367,"city":"Geest-G\xe9rompont-Petit-Rosi\xe8re"},{"id":67,"zipcode":1367,"city":"G\xe9rompont"},{"id":68,"zipcode":1367,"city":"Grand-Rosi\xe8re-Hottomont"},{"id":69,"zipcode":1367,"city":"Huppaye"},{"id":70,"zipcode":1367,"city":"Mont-Saint-Andr\xe9"},{"id":71,"zipcode":1367,"city":"Ramillies"},{"id":72,"zipcode":1370,"city":"Dongelberg"},{"id":73,"zipcode":1370,"city":"Jauchelette"},{"id":74,"zipcode":1370,"city":"Jodoigne-Souveraine"},{"id":75,"zipcode":1370,"city":"Lathuy"},{"id":76,"zipcode":1370,"city":"M\xe9lin"},{"id":77,"zipcode":1370,"city":"Pi\xe9train"},{"id":78,"zipcode":1370,"city":"Saint-Jean-Geest"},{"id":79,"zipcode":1370,"city":"Saint-Remy-Geest"},{"id":80,"zipcode":1370,"city":"Z\xe9trud-Lumay"},{"id":81,"zipcode":1370,"city":"Jodoigne"},{"id":82,"zipcode":1380,"city":"Couture-Saint-Germain"},{"id":83,"zipcode":1380,"city":"Lasne-Chapelle-Saint-Lambert"},{"id":84,"zipcode":1380,"city":"Maransart"},{"id":85,"zipcode":1380,"city":"Ohain"},{"id":86,"zipcode":1380,"city":"Plancenoit"},{"id":87,"zipcode":1390,"city":"Archennes"},{"id":88,"zipcode":1390,"city":"Biez"},{"id":89,"zipcode":1390,"city":"Bossut-Gottechain"},{"id":90,"zipcode":1390,"city":"Nethen"},{"id":91,"zipcode":1390,"city":"Grez-Doiceau"},{"id":92,"zipcode":1400,"city":"Monstreux"},{"id":93,"zipcode":1400,"city":"Nivelles"},{"id":94,"zipcode":1401,"city":"Baulers"},{"id":95,"zipcode":1402,"city":"Thines"},{"id":96,"zipcode":1404,"city":"Bornival"},{"id":97,"zipcode":1410,"city":"Waterloo"},{"id":98,"zipcode":1420,"city":"Braine-l\'Alleud"},{"id":99,"zipcode":1421,"city":"Ophain-Bois-Seigneur-Isaac"},{"id":100,"zipcode":1428,"city":"Lillois-Witterz\xe9e"},{"id":101,"zipcode":1430,"city":"Bierghes"},{"id":102,"zipcode":1430,"city":"Quenast"},{"id":103,"zipcode":1430,"city":"Rebecq-Rognon"},{"id":104,"zipcode":1435,"city":"Corbais"},{"id":105,"zipcode":1435,"city":"H\xe9villers"},{"id":106,"zipcode":1435,"city":"Mont-Saint-Guibert"},{"id":107,"zipcode":1440,"city":"Wauthier-Braine"},{"id":108,"zipcode":1440,"city":"Braine-le-Ch\xe2teau"},{"id":109,"zipcode":1450,"city":"Chastre-Villeroux-Blanmont"},{"id":110,"zipcode":1450,"city":"Cortil-Noirmont"},{"id":111,"zipcode":1450,"city":"Gentinnes"},{"id":112,"zipcode":1450,"city":"Saint-G\xe9ry"},{"id":113,"zipcode":1457,"city":"Nil-Saint-Vincent-Saint-Martin"},{"id":114,"zipcode":1457,"city":"Tourinnes-Saint-Lambert"},{"id":115,"zipcode":1457,"city":"Walhain-Saint-Paul"},{"id":116,"zipcode":1460,"city":"Virginal-Samme"},{"id":117,"zipcode":1460,"city":"Ittre"},{"id":118,"zipcode":1461,"city":"Haut-Ittre"},{"id":119,"zipcode":1470,"city":"Baisy-Thy"},{"id":120,"zipcode":1470,"city":"Bousval"},{"id":121,"zipcode":1470,"city":"Genappe"},{"id":122,"zipcode":1471,"city":"Loupoigne"},{"id":123,"zipcode":1472,"city":"Vieux-Genappe"},{"id":124,"zipcode":1473,"city":"Glabais"},{"id":125,"zipcode":1474,"city":"Ways"},{"id":126,"zipcode":1476,"city":"Houtain-le-Val"},{"id":127,"zipcode":1480,"city":"Clabecq"},{"id":128,"zipcode":1480,"city":"Oisquercq"},{"id":129,"zipcode":1480,"city":"Saintes"},{"id":130,"zipcode":1480,"city":"Tubize"},{"id":131,"zipcode":1490,"city":"Court-Saint-Etienne"},{"id":132,"zipcode":1495,"city":"Marbais"},{"id":133,"zipcode":1495,"city":"Mellery"},{"id":134,"zipcode":1495,"city":"Sart-Dames-Avelines"},{"id":135,"zipcode":1495,"city":"Tilly"},{"id":136,"zipcode":1495,"city":"Villers-la-Ville"},{"id":137,"zipcode":1500,"city":"Halle"},{"id":138,"zipcode":1501,"city":"Buizingen"},{"id":139,"zipcode":1502,"city":"Lembeek"},{"id":140,"zipcode":1540,"city":"Herfelingen"},{"id":141,"zipcode":1540,"city":"Herne"},{"id":142,"zipcode":1541,"city":"Sint-Pieters-Kapelle"},{"id":143,"zipcode":1547,"city":"Bever"},{"id":144,"zipcode":1560,"city":"Hoeilaart"},{"id":145,"zipcode":1570,"city":"Galmaarden"},{"id":146,"zipcode":1570,"city":"Tollembeek"},{"id":147,"zipcode":1570,"city":"Vollezele"},{"id":148,"zipcode":1600,"city":"Oudenaken"},{"id":149,"zipcode":1600,"city":"Sint-Laureins-Berchem"},{"id":150,"zipcode":1600,"city":"Sint-Pieters-Leeuw"},{"id":151,"zipcode":1601,"city":"Ruisbroek"},{"id":152,"zipcode":1602,"city":"Vlezenbeek"},{"id":153,"zipcode":1620,"city":"Drogenbos"},{"id":154,"zipcode":1630,"city":"Linkebeek"},{"id":155,"zipcode":1640,"city":"Sint-Genesius-Rode"},{"id":156,"zipcode":1650,"city":"Beersel"},{"id":157,"zipcode":1651,"city":"Lot"},{"id":158,"zipcode":1652,"city":"Alsemberg"},{"id":159,"zipcode":1653,"city":"Dworp"},{"id":160,"zipcode":1654,"city":"Huizingen"},{"id":161,"zipcode":1670,"city":"Bogaarden"},{"id":162,"zipcode":1670,"city":"Heikruis"},{"id":163,"zipcode":1670,"city":"Pepingen"},{"id":164,"zipcode":1671,"city":"Elingen"},{"id":165,"zipcode":1673,"city":"Beert"},{"id":166,"zipcode":1674,"city":"Bellingen"},{"id":167,"zipcode":1700,"city":"Sint-Martens-Bodegem"},{"id":168,"zipcode":1700,"city":"Sint-Ulriks-Kapelle"},{"id":169,"zipcode":1700,"city":"Dilbeek"},{"id":170,"zipcode":1701,"city":"Itterbeek"},{"id":171,"zipcode":1702,"city":"Groot-Bijgaarden"},{"id":172,"zipcode":1703,"city":"Schepdaal"},{"id":173,"zipcode":1730,"city":"Bekkerzeel"},{"id":174,"zipcode":1730,"city":"Kobbegem"},{"id":175,"zipcode":1730,"city":"Mollem"},{"id":176,"zipcode":1730,"city":"Asse"},{"id":177,"zipcode":1731,"city":"Relegem"},{"id":178,"zipcode":1731,"city":"Zellik"},{"id":179,"zipcode":1740,"city":"Ternat"},{"id":180,"zipcode":1741,"city":"Wambeek"},{"id":181,"zipcode":1742,"city":"Sint-Katherina-Lombeek"},{"id":182,"zipcode":1745,"city":"Mazenzele"},{"id":183,"zipcode":1745,"city":"Opwijk"},{"id":184,"zipcode":1750,"city":"Gaasbeek"},{"id":185,"zipcode":1750,"city":"Sint-Kwintens-Lennik"},{"id":186,"zipcode":1750,"city":"Sint-Martens-Lennik"},{"id":187,"zipcode":1755,"city":"Gooik"},{"id":188,"zipcode":1755,"city":"Kester"},{"id":189,"zipcode":1755,"city":"Leerbeek"},{"id":190,"zipcode":1755,"city":"Oetingen"},{"id":191,"zipcode":1760,"city":"Onze-Lieve-Vrouw-Lombeek"},{"id":192,"zipcode":1760,"city":"Pamel"},{"id":193,"zipcode":1760,"city":"Strijtem"},{"id":194,"zipcode":1760,"city":"Roosdaal"},{"id":195,"zipcode":1761,"city":"Borchtlombeek"},{"id":196,"zipcode":1770,"city":"Liedekerke"},{"id":197,"zipcode":1780,"city":"Wemmel"},{"id":198,"zipcode":1785,"city":"Brussegem"},{"id":199,"zipcode":1785,"city":"Hamme"},{"id":200,"zipcode":1785,"city":"Merchtem"},{"id":201,"zipcode":1790,"city":"Essene"},{"id":202,"zipcode":1790,"city":"Hekelgem"},{"id":203,"zipcode":1790,"city":"Teralfene"},{"id":204,"zipcode":1790,"city":"Affligem"},{"id":205,"zipcode":1800,"city":"Peutie"},{"id":206,"zipcode":1800,"city":"Vilvoorde"},{"id":207,"zipcode":1820,"city":"Melsbroek"},{"id":208,"zipcode":1820,"city":"Perk"},{"id":209,"zipcode":1820,"city":"Steenokkerzeel"},{"id":210,"zipcode":1830,"city":"Machelen"},{"id":211,"zipcode":1831,"city":"Diegem"},{"id":212,"zipcode":1840,"city":"Malderen"},{"id":213,"zipcode":1840,"city":"Steenhuffel"},{"id":214,"zipcode":1840,"city":"Londerzeel"},{"id":215,"zipcode":1850,"city":"Grimbergen"},{"id":216,"zipcode":1851,"city":"Humbeek"},{"id":217,"zipcode":1852,"city":"Beigem"},{"id":218,"zipcode":1853,"city":"Strombeek-Bever"},{"id":219,"zipcode":1860,"city":"Meise"},{"id":220,"zipcode":1861,"city":"Wolvertem"},{"id":221,"zipcode":1880,"city":"Nieuwenrode"},{"id":222,"zipcode":1880,"city":"Ramsdonk"},{"id":223,"zipcode":1880,"city":"Kapelle-op-den-Bos"},{"id":224,"zipcode":1910,"city":"Berg"},{"id":225,"zipcode":1910,"city":"Buken"},{"id":226,"zipcode":1910,"city":"Nederokkerzeel"},{"id":227,"zipcode":1910,"city":"Kampenhout"},{"id":228,"zipcode":1930,"city":"Nossegem"},{"id":229,"zipcode":1930,"city":"Zaventem"},{"id":230,"zipcode":1932,"city":"Sint-Stevens-Woluwe"},{"id":231,"zipcode":1933,"city":"Sterrebeek"},{"id":232,"zipcode":1950,"city":"Kraainem"},{"id":233,"zipcode":1970,"city":"Wezembeek-Oppem"},{"id":234,"zipcode":1980,"city":"Eppegem"},{"id":235,"zipcode":1980,"city":"Zemst"},{"id":236,"zipcode":1981,"city":"Hofstade"},{"id":237,"zipcode":1982,"city":"Elewijt"},{"id":238,"zipcode":1982,"city":"Weerde"},{"id":239,"zipcode":2000,"city":"Antwerpen"},{"id":240,"zipcode":2018,"city":"Antwerpen"},{"id":241,"zipcode":2020,"city":"Antwerpen"},{"id":242,"zipcode":2030,"city":"Antwerpen"},{"id":243,"zipcode":2040,"city":"Berendrecht"},{"id":244,"zipcode":2040,"city":"Lillo"},{"id":245,"zipcode":2040,"city":"Zandvliet"},{"id":246,"zipcode":2040,"city":"Antwerpen"},{"id":247,"zipcode":2050,"city":"Antwerpen"},{"id":248,"zipcode":2060,"city":"Antwerpen"},{"id":249,"zipcode":2070,"city":"Burcht"},{"id":250,"zipcode":2070,"city":"Zwijndrecht"},{"id":251,"zipcode":2100,"city":"Deurne"},{"id":252,"zipcode":2110,"city":"Wijnegem"},{"id":253,"zipcode":2140,"city":"Borgerhout"},{"id":254,"zipcode":2150,"city":"Borsbeek"},{"id":255,"zipcode":2160,"city":"Wommelgem"},{"id":256,"zipcode":2170,"city":"Merksem"},{"id":257,"zipcode":2180,"city":"Ekeren"},{"id":258,"zipcode":2200,"city":"Morkhoven"},{"id":259,"zipcode":2200,"city":"Noorderwijk"},{"id":260,"zipcode":2200,"city":"Herentals"},{"id":261,"zipcode":2220,"city":"Hallaar"},{"id":262,"zipcode":2220,"city":"Heist-op-den-Berg"},{"id":263,"zipcode":2221,"city":"Booischot"},{"id":264,"zipcode":2222,"city":"Itegem"},{"id":265,"zipcode":2222,"city":"Wiekevorst"},{"id":266,"zipcode":2223,"city":"Schriek"},{"id":267,"zipcode":2230,"city":"Ramsel"},{"id":268,"zipcode":2230,"city":"Herselt"},{"id":269,"zipcode":2235,"city":"Houtvenne"},{"id":270,"zipcode":2235,"city":"Westmeerbeek"},{"id":271,"zipcode":2235,"city":"Hulshout"},{"id":272,"zipcode":2240,"city":"Massenhoven"},{"id":273,"zipcode":2240,"city":"Viersel"},{"id":274,"zipcode":2240,"city":"Zandhoven"},{"id":275,"zipcode":2242,"city":"Pulderbos"},{"id":276,"zipcode":2243,"city":"Pulle"},{"id":277,"zipcode":2250,"city":"Olen"},{"id":278,"zipcode":2260,"city":"Oevel"},{"id":279,"zipcode":2260,"city":"Tongerlo"},{"id":280,"zipcode":2260,"city":"Zoerle-Parwijs"},{"id":281,"zipcode":2260,"city":"Westerlo"},{"id":282,"zipcode":2270,"city":"Herenthout"},{"id":283,"zipcode":2275,"city":"Gierle"},{"id":284,"zipcode":2275,"city":"Poederlee"},{"id":285,"zipcode":2275,"city":"Wechelderzande"},{"id":286,"zipcode":2275,"city":"Lille"},{"id":287,"zipcode":2280,"city":"Grobbendonk"},{"id":288,"zipcode":2288,"city":"Bouwel"},{"id":289,"zipcode":2290,"city":"Vorselaar"},{"id":290,"zipcode":2300,"city":"Turnhout"},{"id":291,"zipcode":2310,"city":"Rijkevorsel"},{"id":292,"zipcode":2320,"city":"Hoogstraten"},{"id":293,"zipcode":2321,"city":"Meer"},{"id":294,"zipcode":2322,"city":"Minderhout"},{"id":295,"zipcode":2323,"city":"Wortel"},{"id":296,"zipcode":2328,"city":"Meerle"},{"id":297,"zipcode":2330,"city":"Merksplas"},{"id":298,"zipcode":2340,"city":"Vlimmeren"},{"id":299,"zipcode":2340,"city":"Beerse"},{"id":300,"zipcode":2350,"city":"Vosselaar"},{"id":301,"zipcode":2360,"city":"Oud-Turnhout"},{"id":302,"zipcode":2370,"city":"Arendonk"},{"id":303,"zipcode":2380,"city":"Ravels"},{"id":304,"zipcode":2381,"city":"Weelde"},{"id":305,"zipcode":2382,"city":"Poppel"},{"id":306,"zipcode":2387,"city":"Baarle-Hertog"},{"id":307,"zipcode":2390,"city":"Oostmalle"},{"id":308,"zipcode":2390,"city":"Westmalle"},{"id":309,"zipcode":2390,"city":"Malle"},{"id":310,"zipcode":2400,"city":"Mol"},{"id":311,"zipcode":2430,"city":"Eindhout"},{"id":312,"zipcode":2430,"city":"Vorst"},{"id":313,"zipcode":2431,"city":"Varendonk"},{"id":314,"zipcode":2431,"city":"Veerle"},{"id":315,"zipcode":2440,"city":"Geel"},{"id":316,"zipcode":2450,"city":"Meerhout"},{"id":317,"zipcode":2460,"city":"Lichtaart"},{"id":318,"zipcode":2460,"city":"Tielen"},{"id":319,"zipcode":2460,"city":"Kasterlee"},{"id":320,"zipcode":2470,"city":"Retie"},{"id":321,"zipcode":2480,"city":"Dessel"},{"id":322,"zipcode":2490,"city":"Balen"},{"id":323,"zipcode":2491,"city":"Olmen"},{"id":324,"zipcode":2500,"city":"Koningshooikt"},{"id":325,"zipcode":2500,"city":"Lier"},{"id":326,"zipcode":2520,"city":"Broechem"},{"id":327,"zipcode":2520,"city":"Emblem"},{"id":328,"zipcode":2520,"city":"Oelegem"},{"id":329,"zipcode":2520,"city":"Ranst"},{"id":330,"zipcode":2530,"city":"Boechout"},{"id":331,"zipcode":2531,"city":"Vremde"},{"id":332,"zipcode":2540,"city":"Hove"},{"id":333,"zipcode":2547,"city":"Lint"},{"id":334,"zipcode":2550,"city":"Waarloos"},{"id":335,"zipcode":2550,"city":"Kontich"},{"id":336,"zipcode":2560,"city":"Bevel"},{"id":337,"zipcode":2560,"city":"Kessel"},{"id":338,"zipcode":2560,"city":"Nijlen"},{"id":339,"zipcode":2570,"city":"Duffel"},{"id":340,"zipcode":2580,"city":"Beerzel"},{"id":341,"zipcode":2580,"city":"Putte"},{"id":342,"zipcode":2590,"city":"Gestel"},{"id":343,"zipcode":2590,"city":"Berlaar"},{"id":344,"zipcode":2600,"city":"Berchem"},{"id":345,"zipcode":2610,"city":"Wilrijk"},{"id":346,"zipcode":2620,"city":"Hemiksem"},{"id":347,"zipcode":2627,"city":"Schelle"},{"id":348,"zipcode":2630,"city":"Aartselaar"},{"id":349,"zipcode":2640,"city":"Mortsel"},{"id":350,"zipcode":2650,"city":"Edegem"},{"id":351,"zipcode":2660,"city":"Hoboken"},{"id":352,"zipcode":2800,"city":"Walem"},{"id":353,"zipcode":2800,"city":"Mechelen"},{"id":354,"zipcode":2801,"city":"Heffen"},{"id":355,"zipcode":2811,"city":"Hombeek"},{"id":356,"zipcode":2811,"city":"Leest"},{"id":357,"zipcode":2812,"city":"Muizen"},{"id":358,"zipcode":2820,"city":"Rijmenam"},{"id":359,"zipcode":2820,"city":"Bonheiden"},{"id":360,"zipcode":2830,"city":"Blaasveld"},{"id":361,"zipcode":2830,"city":"Heindonk"},{"id":362,"zipcode":2830,"city":"Tisselt"},{"id":363,"zipcode":2830,"city":"Willebroek"},{"id":364,"zipcode":2840,"city":"Reet"},{"id":365,"zipcode":2840,"city":"Terhagen"},{"id":366,"zipcode":2840,"city":"Rumst"},{"id":367,"zipcode":2845,"city":"Niel"},{"id":368,"zipcode":2850,"city":"Boom"},{"id":369,"zipcode":2860,"city":"Sint-Katelijne-Waver"},{"id":370,"zipcode":2861,"city":"Onze-Lieve-Vrouw-Waver"},{"id":371,"zipcode":2870,"city":"Breendonk"},{"id":372,"zipcode":2870,"city":"Liezele"},{"id":373,"zipcode":2870,"city":"Puurs"},{"id":374,"zipcode":2870,"city":"Ruisbroek"},{"id":375,"zipcode":2880,"city":"Hingene"},{"id":376,"zipcode":2880,"city":"Mariekerke"},{"id":377,"zipcode":2880,"city":"Weert"},{"id":378,"zipcode":2880,"city":"Bornem"},{"id":379,"zipcode":2890,"city":"Lippelo"},{"id":380,"zipcode":2890,"city":"Oppuurs"},{"id":381,"zipcode":2890,"city":"Sint-Amands"},{"id":382,"zipcode":2900,"city":"Schoten"},{"id":383,"zipcode":2910,"city":"Essen"},{"id":384,"zipcode":2920,"city":"Kalmthout"},{"id":385,"zipcode":2930,"city":"Brasschaat"},{"id":386,"zipcode":2940,"city":"Hoevenen"},{"id":387,"zipcode":2940,"city":"Stabroek"},{"id":388,"zipcode":2950,"city":"Kapellen"},{"id":389,"zipcode":2960,"city":"Sint-Job-in-\'t-Goor"},{"id":390,"zipcode":2960,"city":"Sint-Lenaarts"},{"id":391,"zipcode":2960,"city":"Brecht"},{"id":392,"zipcode":2970,"city":"\'s Gravenwezel"},{"id":393,"zipcode":2970,"city":"Schilde"},{"id":394,"zipcode":2980,"city":"Halle"},{"id":395,"zipcode":2980,"city":"Zoersel"},{"id":396,"zipcode":2990,"city":"Loenhout"},{"id":397,"zipcode":2990,"city":"Wuustwezel"},{"id":398,"zipcode":3000,"city":"Leuven"},{"id":399,"zipcode":3001,"city":"Heverlee"},{"id":400,"zipcode":3010,"city":"Kessel Lo"},{"id":401,"zipcode":3012,"city":"Wilsele"},{"id":402,"zipcode":3018,"city":"Wijgmaal"},{"id":403,"zipcode":3020,"city":"Veltem-Beisem"},{"id":404,"zipcode":3020,"city":"Winksele"},{"id":405,"zipcode":3020,"city":"Herent"},{"id":406,"zipcode":3040,"city":"Loonbeek"},{"id":407,"zipcode":3040,"city":"Neerijse"},{"id":408,"zipcode":3040,"city":"Ottenburg"},{"id":409,"zipcode":3040,"city":"Sint-Agatha-Rode"},{"id":410,"zipcode":3040,"city":"Huldenberg"},{"id":411,"zipcode":3050,"city":"Oud-Heverlee"},{"id":412,"zipcode":3051,"city":"Sint-Joris-Weert"},{"id":413,"zipcode":3052,"city":"Blanden"},{"id":414,"zipcode":3053,"city":"Haasrode"},{"id":415,"zipcode":3054,"city":"Vaalbeek"},{"id":416,"zipcode":3060,"city":"Korbeek-Dijle"},{"id":417,"zipcode":3060,"city":"Bertem"},{"id":418,"zipcode":3061,"city":"Leefdaal"},{"id":419,"zipcode":3070,"city":"Kortenberg"},{"id":420,"zipcode":3071,"city":"Erps-Kwerps"},{"id":421,"zipcode":3078,"city":"Everberg"},{"id":422,"zipcode":3078,"city":"Meerbeek"},{"id":423,"zipcode":3080,"city":"Duisburg"},{"id":424,"zipcode":3080,"city":"Vossem"},{"id":425,"zipcode":3080,"city":"Tervuren"},{"id":426,"zipcode":3090,"city":"Overijse"},{"id":427,"zipcode":3110,"city":"Rotselaar"},{"id":428,"zipcode":3111,"city":"Wezemaal"},{"id":429,"zipcode":3118,"city":"Werchter"},{"id":430,"zipcode":3120,"city":"Tremelo"},{"id":431,"zipcode":3128,"city":"Baal"},{"id":432,"zipcode":3130,"city":"Betekom"},{"id":433,"zipcode":3130,"city":"Begijnendijk"},{"id":434,"zipcode":3140,"city":"Keerbergen"},{"id":435,"zipcode":3150,"city":"Tildonk"},{"id":436,"zipcode":3150,"city":"Wespelaar"},{"id":437,"zipcode":3150,"city":"Haacht"},{"id":438,"zipcode":3190,"city":"Boortmeerbeek"},{"id":439,"zipcode":3191,"city":"Hever"},{"id":440,"zipcode":3200,"city":"Gelrode"},{"id":441,"zipcode":3200,"city":"Aarschot"},{"id":442,"zipcode":3201,"city":"Langdorp"},{"id":443,"zipcode":3202,"city":"Rillaar"},{"id":444,"zipcode":3210,"city":"Linden"},{"id":445,"zipcode":3210,"city":"Lubbeek"},{"id":446,"zipcode":3211,"city":"Binkom"},{"id":447,"zipcode":3212,"city":"Pellenberg"},{"id":448,"zipcode":3220,"city":"Kortrijk-Dutsel"},{"id":449,"zipcode":3220,"city":"Sint-Pieters-Rode"},{"id":450,"zipcode":3220,"city":"Holsbeek"},{"id":451,"zipcode":3221,"city":"Nieuwrode"},{"id":452,"zipcode":3270,"city":"Scherpenheuvel"},{"id":453,"zipcode":3271,"city":"Averbode"},{"id":454,"zipcode":3271,"city":"Zichem"},{"id":455,"zipcode":3272,"city":"Messelbroek"},{"id":456,"zipcode":3272,"city":"Testelt"},{"id":457,"zipcode":3290,"city":"Deurne"},{"id":458,"zipcode":3290,"city":"Schaffen"},{"id":459,"zipcode":3290,"city":"Webbekom"},{"id":460,"zipcode":3290,"city":"Diest"},{"id":461,"zipcode":3293,"city":"Kaggevinne"},{"id":462,"zipcode":3294,"city":"Molenstede"},{"id":463,"zipcode":3300,"city":"Bost"},{"id":464,"zipcode":3300,"city":"Goetsenhoven"},{"id":465,"zipcode":3300,"city":"Hakendover"},{"id":466,"zipcode":3300,"city":"Kumtich"},{"id":467,"zipcode":3300,"city":"Oorbeek"},{"id":468,"zipcode":3300,"city":"Oplinter"},{"id":469,"zipcode":3300,"city":"Sint-Margriete-Houtem"},{"id":470,"zipcode":3300,"city":"Vissenaken"},{"id":471,"zipcode":3300,"city":"Tienen"},{"id":472,"zipcode":3320,"city":"Meldert"},{"id":473,"zipcode":3320,"city":"Hoegaarden"},{"id":474,"zipcode":3321,"city":"Outgaarden"},{"id":475,"zipcode":3350,"city":"Drieslinter"},{"id":476,"zipcode":3350,"city":"Melkwezer"},{"id":477,"zipcode":3350,"city":"Neerhespen"},{"id":478,"zipcode":3350,"city":"Neerlinter"},{"id":479,"zipcode":3350,"city":"Orsmaal-Gussenhoven"},{"id":480,"zipcode":3350,"city":"Overhespen"},{"id":481,"zipcode":3350,"city":"Wommersom"},{"id":482,"zipcode":3350,"city":"Linter"},{"id":483,"zipcode":3360,"city":"Korbeek-Lo"},{"id":484,"zipcode":3360,"city":"Lovenjoel"},{"id":485,"zipcode":3360,"city":"Opvelp"},{"id":486,"zipcode":3360,"city":"Bierbeek"},{"id":487,"zipcode":3370,"city":"Kerkom"},{"id":488,"zipcode":3370,"city":"Neervelp"},{"id":489,"zipcode":3370,"city":"Roosbeek"},{"id":490,"zipcode":3370,"city":"Vertrijk"},{"id":491,"zipcode":3370,"city":"Willebringen"},{"id":492,"zipcode":3370,"city":"Boutersem"},{"id":493,"zipcode":3380,"city":"Bunsbeek"},{"id":494,"zipcode":3380,"city":"Glabbeek"},{"id":495,"zipcode":3381,"city":"Kapellen"},{"id":496,"zipcode":3384,"city":"Attenrode"},{"id":497,"zipcode":3390,"city":"Houwaart"},{"id":498,"zipcode":3390,"city":"Sint-Joris-Winge"},{"id":499,"zipcode":3390,"city":"Tielt"},{"id":500,"zipcode":3391,"city":"Meensel-Kiezegem"},{"id":501,"zipcode":3400,"city":"Eliksem"},{"id":502,"zipcode":3400,"city":"Ezemaal"},{"id":503,"zipcode":3400,"city":"Laar"},{"id":504,"zipcode":3400,"city":"Neerwinden"},{"id":505,"zipcode":3400,"city":"Overwinden"},{"id":506,"zipcode":3400,"city":"Rumsdorp"},{"id":507,"zipcode":3400,"city":"Wange"},{"id":508,"zipcode":3400,"city":"Landen"},{"id":509,"zipcode":3401,"city":"Waasmont"},{"id":510,"zipcode":3401,"city":"Walsbets"},{"id":511,"zipcode":3401,"city":"Walshoutem"},{"id":512,"zipcode":3401,"city":"Wezeren"},{"id":513,"zipcode":3404,"city":"Attenhoven"},{"id":514,"zipcode":3404,"city":"Neerlanden"},{"id":515,"zipcode":3440,"city":"Budingen"},{"id":516,"zipcode":3440,"city":"Dormaal"},{"id":517,"zipcode":3440,"city":"Halle-Booienhoven"},{"id":518,"zipcode":3440,"city":"Helen-Bos"},{"id":519,"zipcode":3440,"city":"Zoutleeuw"},{"id":520,"zipcode":3450,"city":"Grazen"},{"id":521,"zipcode":3450,"city":"Geetbets"},{"id":522,"zipcode":3454,"city":"Rummen"},{"id":523,"zipcode":3460,"city":"Assent"},{"id":524,"zipcode":3460,"city":"Bekkevoort"},{"id":525,"zipcode":3461,"city":"Molenbeek-Wersbeek"},{"id":526,"zipcode":3470,"city":"Ransberg"},{"id":527,"zipcode":3470,"city":"Sint-Margriete-Houtem"},{"id":528,"zipcode":3470,"city":"Kortenaken"},{"id":529,"zipcode":3471,"city":"Hoeleden"},{"id":530,"zipcode":3472,"city":"Kersbeek-Miskom"},{"id":531,"zipcode":3473,"city":"Waanrode"},{"id":532,"zipcode":3500,"city":"Sint-Lambrechts-Herk"},{"id":533,"zipcode":3500,"city":"Hasselt"},{"id":534,"zipcode":3501,"city":"Wimmertingen"},{"id":535,"zipcode":3510,"city":"Kermt"},{"id":536,"zipcode":3510,"city":"Spalbeek"},{"id":537,"zipcode":3511,"city":"Kuringen"},{"id":538,"zipcode":3511,"city":"Stokrooie"},{"id":539,"zipcode":3512,"city":"Stevoort"},{"id":540,"zipcode":3520,"city":"Zonhoven"},{"id":541,"zipcode":3530,"city":"Helchteren"},{"id":542,"zipcode":3530,"city":"Houthalen"},{"id":543,"zipcode":3540,"city":"Berbroek"},{"id":544,"zipcode":3540,"city":"Donk"},{"id":545,"zipcode":3540,"city":"Schulen"},{"id":546,"zipcode":3540,"city":"Herk-de-Stad"},{"id":547,"zipcode":3545,"city":"Loksbergen"},{"id":548,"zipcode":3545,"city":"Zelem"},{"id":549,"zipcode":3545,"city":"Halen"},{"id":550,"zipcode":3550,"city":"Heusden"},{"id":551,"zipcode":3550,"city":"Zolder"},{"id":552,"zipcode":3550,"city":"Heusden-Zolder"},{"id":553,"zipcode":3560,"city":"Linkhout"},{"id":554,"zipcode":3560,"city":"Meldert"},{"id":555,"zipcode":3560,"city":"Lummen"},{"id":556,"zipcode":3570,"city":"Alken"},{"id":557,"zipcode":3580,"city":"Beringen"},{"id":558,"zipcode":3581,"city":"Beverlo"},{"id":559,"zipcode":3582,"city":"Koersel"},{"id":560,"zipcode":3583,"city":"Paal"},{"id":561,"zipcode":3590,"city":"Diepenbeek"},{"id":562,"zipcode":3600,"city":"Genk"},{"id":563,"zipcode":3620,"city":"Gellik"},{"id":564,"zipcode":3620,"city":"Neerharen"},{"id":565,"zipcode":3620,"city":"Veldwezelt"},{"id":566,"zipcode":3620,"city":"Lanaken"},{"id":567,"zipcode":3621,"city":"Rekem"},{"id":568,"zipcode":3630,"city":"Eisden"},{"id":569,"zipcode":3630,"city":"Leut"},{"id":570,"zipcode":3630,"city":"Mechelen-aan-de-Maas"},{"id":571,"zipcode":3630,"city":"Meeswijk"},{"id":572,"zipcode":3630,"city":"Opgrimbie"},{"id":573,"zipcode":3630,"city":"Vucht"},{"id":574,"zipcode":3630,"city":"Maasmechelen"},{"id":575,"zipcode":3631,"city":"Boorsem"},{"id":576,"zipcode":3631,"city":"Uikhoven"},{"id":577,"zipcode":3640,"city":"Kessenich"},{"id":578,"zipcode":3640,"city":"Molenbeersel"},{"id":579,"zipcode":3640,"city":"Ophoven"},{"id":580,"zipcode":3640,"city":"Kinrooi"},{"id":581,"zipcode":3650,"city":"Dilsen"},{"id":582,"zipcode":3650,"city":"Elen"},{"id":583,"zipcode":3650,"city":"Lanklaar"},{"id":584,"zipcode":3650,"city":"Rotem"},{"id":585,"zipcode":3650,"city":"Stokkem"},{"id":586,"zipcode":3660,"city":"Opglabbeek"},{"id":587,"zipcode":3665,"city":"As"},{"id":588,"zipcode":3668,"city":"Niel-bij-As"},{"id":589,"zipcode":3670,"city":"Ellikom"},{"id":590,"zipcode":3670,"city":"Gruitrode"},{"id":591,"zipcode":3670,"city":"Meeuwen"},{"id":592,"zipcode":3670,"city":"Neerglabbeek"},{"id":593,"zipcode":3670,"city":"Wijshagen"},{"id":594,"zipcode":3680,"city":"Neeroeteren"},{"id":595,"zipcode":3680,"city":"Opoeteren"},{"id":596,"zipcode":3680,"city":"Maaseik"},{"id":597,"zipcode":3690,"city":"Zutendaal"},{"id":598,"zipcode":3700,"city":"Berg"},{"id":599,"zipcode":3700,"city":"Diets-Heur"},{"id":600,"zipcode":3700,"city":"Haren"},{"id":601,"zipcode":3700,"city":"Henis"},{"id":602,"zipcode":3700,"city":"Kolmont"},{"id":603,"zipcode":3700,"city":"Koninksem"},{"id":604,"zipcode":3700,"city":"Lauw"},{"id":605,"zipcode":3700,"city":"Mal"},{"id":606,"zipcode":3700,"city":"Neerrepen"},{"id":607,"zipcode":3700,"city":"Nerem"},{"id":608,"zipcode":3700,"city":"Overrepen"},{"id":609,"zipcode":3700,"city":"Piringen"},{"id":610,"zipcode":3700,"city":"Riksingen"},{"id":611,"zipcode":3700,"city":"Rutten"},{"id":612,"zipcode":3700,"city":"\'s Herenelderen"},{"id":613,"zipcode":3700,"city":"Sluizen"},{"id":614,"zipcode":3700,"city":"Tongeren"},{"id":615,"zipcode":3700,"city":"Vreren"},{"id":616,"zipcode":3700,"city":"Widooie"},{"id":617,"zipcode":3717,"city":"Herstappe"},{"id":618,"zipcode":3720,"city":"Kortessem"},{"id":619,"zipcode":3721,"city":"Vliermaalroot"},{"id":620,"zipcode":3722,"city":"Wintershoven"},{"id":621,"zipcode":3723,"city":"Guigoven"},{"id":622,"zipcode":3724,"city":"Vliermaal"},{"id":623,"zipcode":3730,"city":"Hoeselt"},{"id":624,"zipcode":3730,"city":"Romershoven"},{"id":625,"zipcode":3730,"city":"Sint-Huibrechts-Hern"},{"id":626,"zipcode":3730,"city":"Werm"},{"id":627,"zipcode":3732,"city":"Schalkhoven"},{"id":628,"zipcode":3740,"city":"Beverst"},{"id":629,"zipcode":3740,"city":"Bilzen"},{"id":630,"zipcode":3740,"city":"Eigenbilzen"},{"id":631,"zipcode":3740,"city":"Grote-Spouwen"},{"id":632,"zipcode":3740,"city":"Hees"},{"id":633,"zipcode":3740,"city":"Kleine-Spouwen"},{"id":634,"zipcode":3740,"city":"Mopertingen"},{"id":635,"zipcode":3740,"city":"Munsterbilzen"},{"id":636,"zipcode":3740,"city":"Rijkhoven"},{"id":637,"zipcode":3740,"city":"Rosmeer"},{"id":638,"zipcode":3740,"city":"Waltwilder"},{"id":639,"zipcode":3742,"city":"Martenslinde"},{"id":640,"zipcode":3746,"city":"Hoelbeek"},{"id":641,"zipcode":3770,"city":"Genoelselderen"},{"id":642,"zipcode":3770,"city":"Herderen"},{"id":643,"zipcode":3770,"city":"Kanne"},{"id":644,"zipcode":3770,"city":"Membruggen"},{"id":645,"zipcode":3770,"city":"Millen"},{"id":646,"zipcode":3770,"city":"Val-Meer"},{"id":647,"zipcode":3770,"city":"Vlijtingen"},{"id":648,"zipcode":3770,"city":"Vroenhoven"},{"id":649,"zipcode":3770,"city":"Zichen-Zussen-Bolder"},{"id":650,"zipcode":3770,"city":"Riemst"},{"id":651,"zipcode":3790,"city":"Moelingen"},{"id":652,"zipcode":3790,"city":"Sint-Martens-Voeren"},{"id":653,"zipcode":3791,"city":"Remersdaal"},{"id":654,"zipcode":3792,"city":"Sint-Pieters-Voeren"},{"id":655,"zipcode":3793,"city":"Teuven"},{"id":656,"zipcode":3798,"city":"\'s-Gravenvoeren"},{"id":657,"zipcode":3800,"city":"Aalst"},{"id":658,"zipcode":3800,"city":"Brustem"},{"id":659,"zipcode":3800,"city":"Engelmanshoven"},{"id":660,"zipcode":3800,"city":"Gelinden"},{"id":661,"zipcode":3800,"city":"Groot-Gelmen"},{"id":662,"zipcode":3800,"city":"Halmaal"},{"id":663,"zipcode":3800,"city":"Kerkom-bij-Sint-Truiden"},{"id":664,"zipcode":3800,"city":"Ordingen"},{"id":665,"zipcode":3800,"city":"Zepperen"},{"id":666,"zipcode":3800,"city":"Sint-Truiden"},{"id":667,"zipcode":3803,"city":"Duras"},{"id":668,"zipcode":3803,"city":"Gorsem"},{"id":669,"zipcode":3803,"city":"Runkelen"},{"id":670,"zipcode":3803,"city":"Wilderen"},{"id":671,"zipcode":3806,"city":"Velm"},{"id":672,"zipcode":3830,"city":"Berlingen"},{"id":673,"zipcode":3830,"city":"Wellen"},{"id":674,"zipcode":3831,"city":"Herten"},{"id":675,"zipcode":3832,"city":"Ulbeek"},{"id":676,"zipcode":3840,"city":"Bommershoven"},{"id":677,"zipcode":3840,"city":"Borgloon"},{"id":678,"zipcode":3840,"city":"Broekom"},{"id":679,"zipcode":3840,"city":"Gors-Opleeuw"},{"id":680,"zipcode":3840,"city":"Gotem"},{"id":681,"zipcode":3840,"city":"Groot-Loon"},{"id":682,"zipcode":3840,"city":"Haren"},{"id":683,"zipcode":3840,"city":"Hendrieken"},{"id":684,"zipcode":3840,"city":"Hoepertingen"},{"id":685,"zipcode":3840,"city":"Jesseren"},{"id":686,"zipcode":3840,"city":"Kerniel"},{"id":687,"zipcode":3840,"city":"Kolmont"},{"id":688,"zipcode":3840,"city":"Kuttekoven"},{"id":689,"zipcode":3840,"city":"Rijkel"},{"id":690,"zipcode":3840,"city":"Voort"},{"id":691,"zipcode":3850,"city":"Binderveld"},{"id":692,"zipcode":3850,"city":"Kozen"},{"id":693,"zipcode":3850,"city":"Wijer"},{"id":694,"zipcode":3850,"city":"Nieuwerkerken"},{"id":695,"zipcode":3870,"city":"Batsheers"},{"id":696,"zipcode":3870,"city":"Bovelingen"},{"id":697,"zipcode":3870,"city":"Gutshoven"},{"id":698,"zipcode":3870,"city":"Heks"},{"id":699,"zipcode":3870,"city":"Horpmaal"},{"id":700,"zipcode":3870,"city":"Klein-Gelmen"},{"id":701,"zipcode":3870,"city":"Mechelen-Bovelingen"},{"id":702,"zipcode":3870,"city":"Mettekoven"},{"id":703,"zipcode":3870,"city":"Opheers"},{"id":704,"zipcode":3870,"city":"Rukkelingen-Loon"},{"id":705,"zipcode":3870,"city":"Vechmaal"},{"id":706,"zipcode":3870,"city":"Veulen"},{"id":707,"zipcode":3870,"city":"Heers"},{"id":708,"zipcode":3890,"city":"Boekhout"},{"id":709,"zipcode":3890,"city":"Jeuk"},{"id":710,"zipcode":3890,"city":"Kortijs"},{"id":711,"zipcode":3890,"city":"Montenaken"},{"id":712,"zipcode":3890,"city":"Niel-bij-Sint-Truiden"},{"id":713,"zipcode":3890,"city":"Vorsen"},{"id":714,"zipcode":3890,"city":"Gingelom"},{"id":715,"zipcode":3891,"city":"Borlo"},{"id":716,"zipcode":3891,"city":"Buvingen"},{"id":717,"zipcode":3891,"city":"Mielen-boven-Aalst"},{"id":718,"zipcode":3891,"city":"Muizen"},{"id":719,"zipcode":3900,"city":"Overpelt"},{"id":720,"zipcode":3910,"city":"Neerpelt"},{"id":721,"zipcode":3910,"city":"Sint-Huibrechts-Lille"},{"id":722,"zipcode":3920,"city":"Lommel"},{"id":723,"zipcode":3930,"city":"Achel"},{"id":724,"zipcode":3930,"city":"Hamont"},{"id":725,"zipcode":3940,"city":"Hechtel"},{"id":726,"zipcode":3941,"city":"Eksel"},{"id":727,"zipcode":3945,"city":"Kwaadmechelen"},{"id":728,"zipcode":3945,"city":"Oostham"},{"id":729,"zipcode":3950,"city":"Kaulille"},{"id":730,"zipcode":3950,"city":"Reppel"},{"id":731,"zipcode":3950,"city":"Bocholt"},{"id":732,"zipcode":3960,"city":"Beek"},{"id":733,"zipcode":3960,"city":"Gerdingen"},{"id":734,"zipcode":3960,"city":"Opitter"},{"id":735,"zipcode":3960,"city":"Tongerlo"},{"id":736,"zipcode":3960,"city":"Bree"},{"id":737,"zipcode":3970,"city":"Leopoldsburg"},{"id":738,"zipcode":3971,"city":"Heppen"},{"id":739,"zipcode":3980,"city":"Tessenderlo"},{"id":740,"zipcode":3990,"city":"Grote-Brogel"},{"id":741,"zipcode":3990,"city":"Kleine-Brogel"},{"id":742,"zipcode":3990,"city":"Wijchmaal"},{"id":743,"zipcode":3990,"city":"Peer"},{"id":744,"zipcode":4000,"city":"Glain"},{"id":745,"zipcode":4000,"city":"Rocourt"},{"id":746,"zipcode":4000,"city":"Li\xe8ge"},{"id":747,"zipcode":4020,"city":"Bressoux"},{"id":748,"zipcode":4020,"city":"Jupille-sur-Meuse"},{"id":749,"zipcode":4020,"city":"Wandre"},{"id":750,"zipcode":4020,"city":"Li\xe8ge"},{"id":751,"zipcode":4030,"city":"Grivegn\xe9e"},{"id":752,"zipcode":4031,"city":"Angleur"},{"id":753,"zipcode":4032,"city":"Ch\xean\xe9e"},{"id":754,"zipcode":4040,"city":"Herstal"},{"id":755,"zipcode":4041,"city":"Milmort"},{"id":756,"zipcode":4041,"city":"Vottem"},{"id":757,"zipcode":4042,"city":"Liers"},{"id":758,"zipcode":4050,"city":"Chaudfontaine"},{"id":759,"zipcode":4051,"city":"Vaux-sous-Ch\xe8vremont"},{"id":760,"zipcode":4052,"city":"Beaufays"},{"id":761,"zipcode":4053,"city":"Embourg"},{"id":762,"zipcode":4100,"city":"Boncelles"},{"id":763,"zipcode":4100,"city":"Seraing"},{"id":764,"zipcode":4101,"city":"Jemeppe-sur-Meuse"},{"id":765,"zipcode":4102,"city":"Ougr\xe9e"},{"id":766,"zipcode":4120,"city":"Ehein"},{"id":767,"zipcode":4120,"city":"Rotheux-Rimi\xe8re"},{"id":768,"zipcode":4121,"city":"Neuville-en-Condroz"},{"id":769,"zipcode":4122,"city":"Plainevaux"},{"id":770,"zipcode":4130,"city":"Tilff"},{"id":771,"zipcode":4130,"city":"Esneux"},{"id":772,"zipcode":4140,"city":"Dolembreux"},{"id":773,"zipcode":4140,"city":"Gomz\xe9-Andoumont"},{"id":774,"zipcode":4140,"city":"Rouvreux"},{"id":775,"zipcode":4140,"city":"Sprimont"},{"id":776,"zipcode":4141,"city":"Louveign\xe9"},{"id":777,"zipcode":4160,"city":"Anthisnes"},{"id":778,"zipcode":4161,"city":"Villers-aux-Tours"},{"id":779,"zipcode":4162,"city":"Hody"},{"id":780,"zipcode":4163,"city":"Tavier"},{"id":781,"zipcode":4170,"city":"Comblain-au-Pont"},{"id":782,"zipcode":4171,"city":"Poulseur"},{"id":783,"zipcode":4180,"city":"Comblain-Fairon"},{"id":784,"zipcode":4180,"city":"Comblain-la-Tour"},{"id":785,"zipcode":4180,"city":"Hamoir"},{"id":786,"zipcode":4181,"city":"Filot"},{"id":787,"zipcode":4190,"city":"My"},{"id":788,"zipcode":4190,"city":"Vieuxville"},{"id":789,"zipcode":4190,"city":"Werbomont"},{"id":790,"zipcode":4190,"city":"Xhoris"},{"id":791,"zipcode":4190,"city":"Ferri\xe8res"},{"id":792,"zipcode":4210,"city":"Hann\xeache"},{"id":793,"zipcode":4210,"city":"Lamontz\xe9e"},{"id":794,"zipcode":4210,"city":"Marneffe"},{"id":795,"zipcode":4210,"city":"Oteppe"},{"id":796,"zipcode":4210,"city":"Burdinne"},{"id":797,"zipcode":4217,"city":"Lavoir"},{"id":798,"zipcode":4217,"city":"Waret-l\'\xc9v\xeaque"},{"id":799,"zipcode":4217,"city":"H\xe9ron"},{"id":800,"zipcode":4218,"city":"Couthuin"},{"id":801,"zipcode":4219,"city":"Acosse"},{"id":802,"zipcode":4219,"city":"Ambresin"},{"id":803,"zipcode":4219,"city":"Meeffe"},{"id":804,"zipcode":4219,"city":"Wasseiges"},{"id":805,"zipcode":4250,"city":"Bo\xeblhe"},{"id":806,"zipcode":4250,"city":"Hollogne-sur-Geer"},{"id":807,"zipcode":4250,"city":"Lens-Saint-Servais"},{"id":808,"zipcode":4250,"city":"Geer"},{"id":809,"zipcode":4252,"city":"Omal"},{"id":810,"zipcode":4253,"city":"Darion"},{"id":811,"zipcode":4254,"city":"Ligney"},{"id":812,"zipcode":4257,"city":"Corswarem"},{"id":813,"zipcode":4257,"city":"Rosoux-Crenwick"},{"id":814,"zipcode":4257,"city":"Berloz"},{"id":815,"zipcode":4260,"city":"Avennes"},{"id":816,"zipcode":4260,"city":"Ciplet"},{"id":817,"zipcode":4260,"city":"Fallais"},{"id":818,"zipcode":4260,"city":"Fumal"},{"id":819,"zipcode":4260,"city":"Ville-en-Hesbaye"},{"id":820,"zipcode":4260,"city":"Braives"},{"id":821,"zipcode":4261,"city":"Latinne"},{"id":822,"zipcode":4263,"city":"Tourinne"},{"id":823,"zipcode":4280,"city":"Abolens"},{"id":824,"zipcode":4280,"city":"Avernas-le-Bauduin"},{"id":825,"zipcode":4280,"city":"Avin"},{"id":826,"zipcode":4280,"city":"Bertr\xe9e"},{"id":827,"zipcode":4280,"city":"Blehen"},{"id":828,"zipcode":4280,"city":"Cras-Avernas"},{"id":829,"zipcode":4280,"city":"Crehen"},{"id":830,"zipcode":4280,"city":"Grand-Hallet"},{"id":831,"zipcode":4280,"city":"Lens-Saint-Remy"},{"id":832,"zipcode":4280,"city":"Merdorp"},{"id":833,"zipcode":4280,"city":"Moxhe"},{"id":834,"zipcode":4280,"city":"Petit-Hallet"},{"id":835,"zipcode":4280,"city":"Poucet"},{"id":836,"zipcode":4280,"city":"Thisnes"},{"id":837,"zipcode":4280,"city":"Trogn\xe9e"},{"id":838,"zipcode":4280,"city":"Villers-le-Peuplier"},{"id":839,"zipcode":4280,"city":"Wansin"},{"id":840,"zipcode":4280,"city":"Hannut"},{"id":841,"zipcode":4287,"city":"Pellaines"},{"id":842,"zipcode":4287,"city":"Racour"},{"id":843,"zipcode":4287,"city":"Lincent"},{"id":844,"zipcode":4300,"city":"Bettincourt"},{"id":845,"zipcode":4300,"city":"Bleret"},{"id":846,"zipcode":4300,"city":"Bovenistier"},{"id":847,"zipcode":4300,"city":"Grand-Axhe"},{"id":848,"zipcode":4300,"city":"Lantremange"},{"id":849,"zipcode":4300,"city":"Oleye"},{"id":850,"zipcode":4300,"city":"Waremme"},{"id":851,"zipcode":4317,"city":"Aineffe"},{"id":852,"zipcode":4317,"city":"Borlez"},{"id":853,"zipcode":4317,"city":"Celles"},{"id":854,"zipcode":4317,"city":"Les Waleffes"},{"id":855,"zipcode":4317,"city":"Viemme"},{"id":856,"zipcode":4317,"city":"Faimes"},{"id":857,"zipcode":4340,"city":"Fooz"},{"id":858,"zipcode":4340,"city":"Oth\xe9e"},{"id":859,"zipcode":4340,"city":"Villers-l\'Ev\xeaque"},{"id":860,"zipcode":4340,"city":"Awans"},{"id":861,"zipcode":4342,"city":"Hognoul"},{"id":862,"zipcode":4347,"city":"Freloux"},{"id":863,"zipcode":4347,"city":"Noville"},{"id":864,"zipcode":4347,"city":"Roloux"},{"id":865,"zipcode":4347,"city":"Voroux-Goreux"},{"id":866,"zipcode":4347,"city":"Fexhe-le-Haut-Clocher"},{"id":867,"zipcode":4350,"city":"Lamine"},{"id":868,"zipcode":4350,"city":"Momalle"},{"id":869,"zipcode":4350,"city":"Pousset"},{"id":870,"zipcode":4350,"city":"Remicourt"},{"id":871,"zipcode":4351,"city":"Hodeige"},{"id":872,"zipcode":4357,"city":"Haneffe"},{"id":873,"zipcode":4357,"city":"Jeneffe"},{"id":874,"zipcode":4357,"city":"Limont"},{"id":875,"zipcode":4357,"city":"Donceel"},{"id":876,"zipcode":4360,"city":"Bergilers"},{"id":877,"zipcode":4360,"city":"Grandville"},{"id":878,"zipcode":4360,"city":"Lens-sur-Geer"},{"id":879,"zipcode":4360,"city":"Otrange"},{"id":880,"zipcode":4360,"city":"Oreye"},{"id":881,"zipcode":4367,"city":"Fize-Le-Marsal"},{"id":882,"zipcode":4367,"city":"Kemexhe"},{"id":883,"zipcode":4367,"city":"Odeur"},{"id":884,"zipcode":4367,"city":"Thys"},{"id":885,"zipcode":4367,"city":"Crisn\xe9e"},{"id":886,"zipcode":4400,"city":"Awirs"},{"id":887,"zipcode":4400,"city":"Chokier"},{"id":888,"zipcode":4400,"city":"Fl\xe9malle-Grande"},{"id":889,"zipcode":4400,"city":"Fl\xe9malle-Haute"},{"id":890,"zipcode":4400,"city":"Gleixhe"},{"id":891,"zipcode":4400,"city":"Ivoz-Ramet"},{"id":892,"zipcode":4400,"city":"Mons-lez-Li\xe8ge"},{"id":893,"zipcode":4420,"city":"Montegn\xe9e"},{"id":894,"zipcode":4420,"city":"Tilleur"},{"id":895,"zipcode":4420,"city":"Saint-Nicolas"},{"id":896,"zipcode":4430,"city":"Ans"},{"id":897,"zipcode":4431,"city":"Loncin"},{"id":898,"zipcode":4432,"city":"Alleur"},{"id":899,"zipcode":4432,"city":"Xhendremael"},{"id":900,"zipcode":4450,"city":"Lantin"},{"id":901,"zipcode":4450,"city":"Slins"},{"id":902,"zipcode":4450,"city":"Juprelle"},{"id":903,"zipcode":4451,"city":"Voroux-lez-Liers"},{"id":904,"zipcode":4452,"city":"Paifve"},{"id":905,"zipcode":4452,"city":"Wihogne"},{"id":906,"zipcode":4453,"city":"Villers-Saint-Sim\xe9on"},{"id":907,"zipcode":4458,"city":"Fexhe-Slins"},{"id":908,"zipcode":4460,"city":"Bierset"},{"id":909,"zipcode":4460,"city":"Gr\xe2ce-Berleur"},{"id":910,"zipcode":4460,"city":"Hollogne-aux-Pierres"},{"id":911,"zipcode":4460,"city":"Horion-Hoz\xe9mont"},{"id":912,"zipcode":4460,"city":"Velroux"},{"id":913,"zipcode":4460,"city":"Gr\xe2ce-Hollogne"},{"id":914,"zipcode":4470,"city":"Saint-Georges-sur-Meuse"},{"id":915,"zipcode":4480,"city":"Clermont-sous-Huy"},{"id":916,"zipcode":4480,"city":"Ehein"},{"id":917,"zipcode":4480,"city":"Hermalle-sous-Huy"},{"id":918,"zipcode":4480,"city":"Engis"},{"id":919,"zipcode":4500,"city":"Ben-Ahin"},{"id":920,"zipcode":4500,"city":"Tihange"},{"id":921,"zipcode":4500,"city":"Huy"},{"id":922,"zipcode":4520,"city":"Antheit"},{"id":923,"zipcode":4520,"city":"Bas-Oha"},{"id":924,"zipcode":4520,"city":"Huccorgne"},{"id":925,"zipcode":4520,"city":"Moha"},{"id":926,"zipcode":4520,"city":"Vinalmont"},{"id":927,"zipcode":4520,"city":"Wanze"},{"id":928,"zipcode":4530,"city":"Fize-Fontaine"},{"id":929,"zipcode":4530,"city":"Vaux-et-Borset"},{"id":930,"zipcode":4530,"city":"Vieux-Waleffe"},{"id":931,"zipcode":4530,"city":"Warnant-Dreye"},{"id":932,"zipcode":4530,"city":"Villers-le-Bouillet"},{"id":933,"zipcode":4537,"city":"Bodegn\xe9e"},{"id":934,"zipcode":4537,"city":"Chapon-Seraing"},{"id":935,"zipcode":4537,"city":"Seraing-le-Ch\xe2teau"},{"id":936,"zipcode":4537,"city":"Verlaine"},{"id":937,"zipcode":4540,"city":"Ampsin"},{"id":938,"zipcode":4540,"city":"Fl\xf4ne"},{"id":939,"zipcode":4540,"city":"Jehay"},{"id":940,"zipcode":4540,"city":"Ombret"},{"id":941,"zipcode":4540,"city":"Amay"},{"id":942,"zipcode":4550,"city":"Saint-S\xe9verin"},{"id":943,"zipcode":4550,"city":"Villers-le-Temple"},{"id":944,"zipcode":4550,"city":"Yern\xe9e-Fraineux"},{"id":945,"zipcode":4550,"city":"Nandrin"},{"id":946,"zipcode":4557,"city":"Ab\xe9e"},{"id":947,"zipcode":4557,"city":"Fraiture"},{"id":948,"zipcode":4557,"city":"Ramelot"},{"id":949,"zipcode":4557,"city":"Seny"},{"id":950,"zipcode":4557,"city":"Soheit-Tinlot"},{"id":951,"zipcode":4557,"city":"Tinlot"},{"id":952,"zipcode":4560,"city":"Bois-et-Borsu"},{"id":953,"zipcode":4560,"city":"Les Avins"},{"id":954,"zipcode":4560,"city":"Ocquier"},{"id":955,"zipcode":4560,"city":"Pailhe"},{"id":956,"zipcode":4560,"city":"Terwagne"},{"id":957,"zipcode":4560,"city":"Clavier"},{"id":958,"zipcode":4570,"city":"Vyle-et-Tharoul"},{"id":959,"zipcode":4570,"city":"Marchin"},{"id":960,"zipcode":4577,"city":"Outrelouxhe"},{"id":961,"zipcode":4577,"city":"Str\xe9e-lez-Huy"},{"id":962,"zipcode":4577,"city":"Vierset-Barse"},{"id":963,"zipcode":4577,"city":"Modave"},{"id":964,"zipcode":4590,"city":"Ellemelle"},{"id":965,"zipcode":4590,"city":"Warz\xe9e"},{"id":966,"zipcode":4590,"city":"Ouffet"},{"id":967,"zipcode":4600,"city":"Lanaye"},{"id":968,"zipcode":4600,"city":"Lixhe"},{"id":969,"zipcode":4600,"city":"Richelle"},{"id":970,"zipcode":4600,"city":"Vis\xe9"},{"id":971,"zipcode":4601,"city":"Argenteau"},{"id":972,"zipcode":4602,"city":"Cheratte"},{"id":973,"zipcode":4606,"city":"Saint-Andr\xe9"},{"id":974,"zipcode":4607,"city":"Berneau"},{"id":975,"zipcode":4607,"city":"Bombaye"},{"id":976,"zipcode":4607,"city":"Feneur"},{"id":977,"zipcode":4607,"city":"Mortroux"},{"id":978,"zipcode":4607,"city":"Dalhem"},{"id":979,"zipcode":4608,"city":"Neufch\xe2teau"},{"id":980,"zipcode":4608,"city":"Warsage"},{"id":981,"zipcode":4610,"city":"Bellaire"},{"id":982,"zipcode":4610,"city":"Queue-du-Bois"},{"id":983,"zipcode":4610,"city":"Beyne-Heusay"},{"id":984,"zipcode":4620,"city":"Fl\xe9ron"},{"id":985,"zipcode":4621,"city":"Retinne"},{"id":986,"zipcode":4623,"city":"Magn\xe9e"},{"id":987,"zipcode":4624,"city":"Roms\xe9e"},{"id":988,"zipcode":4630,"city":"Ayeneux"},{"id":989,"zipcode":4630,"city":"Micheroux"},{"id":990,"zipcode":4630,"city":"Tign\xe9e"},{"id":991,"zipcode":4630,"city":"Soumagne"},{"id":992,"zipcode":4631,"city":"Evegn\xe9e"},{"id":993,"zipcode":4632,"city":"C\xe9rexhe-Heuseux"},{"id":994,"zipcode":4633,"city":"Melen"},{"id":995,"zipcode":4650,"city":"Chaineux"},{"id":996,"zipcode":4650,"city":"Grand-Rechain"},{"id":997,"zipcode":4650,"city":"Jul\xe9mont"},{"id":998,"zipcode":4650,"city":"Herve"},{"id":999,"zipcode":4651,"city":"Battice"},{"id":1000,"zipcode":4652,"city":"Xhendelesse"},{"id":1001,"zipcode":4653,"city":"Bolland"},{"id":1002,"zipcode":4654,"city":"Charneux"},{"id":1003,"zipcode":4670,"city":"Mortier"},{"id":1004,"zipcode":4670,"city":"Trembleur"},{"id":1005,"zipcode":4670,"city":"Bl\xe9gny"},{"id":1006,"zipcode":4671,"city":"Barchon"},{"id":1007,"zipcode":4671,"city":"Housse"},{"id":1008,"zipcode":4671,"city":"Saive"},{"id":1009,"zipcode":4672,"city":"Saint-Remy"},{"id":1010,"zipcode":4680,"city":"Herm\xe9e"},{"id":1011,"zipcode":4680,"city":"Oupeye"},{"id":1012,"zipcode":4681,"city":"Hermalle-sous-Argenteau"},{"id":1013,"zipcode":4682,"city":"Heure-le-Romain"},{"id":1014,"zipcode":4682,"city":"Houtain-Saint-Sim\xe9on"},{"id":1015,"zipcode":4683,"city":"Vivegnis"},{"id":1016,"zipcode":4684,"city":"Haccourt"},{"id":1017,"zipcode":4690,"city":"Boirs"},{"id":1018,"zipcode":4690,"city":"Eben-Emael"},{"id":1019,"zipcode":4690,"city":"Glons"},{"id":1020,"zipcode":4690,"city":"Roclenge-sur-Geer"},{"id":1021,"zipcode":4690,"city":"Wonck"},{"id":1022,"zipcode":4690,"city":"Bassenge"},{"id":1023,"zipcode":4700,"city":"Eupen"},{"id":1024,"zipcode":4701,"city":"Kettenis"},{"id":1025,"zipcode":4710,"city":"Lontzen"},{"id":1026,"zipcode":4711,"city":"Walhorn"},{"id":1027,"zipcode":4720,"city":"Kelmis"},{"id":1028,"zipcode":4721,"city":"Neu-Moresnet"},{"id":1029,"zipcode":4728,"city":"Hergenrath"},{"id":1030,"zipcode":4730,"city":"Hauset"},{"id":1031,"zipcode":4730,"city":"Raeren"},{"id":1032,"zipcode":4731,"city":"Eynatten"},{"id":1033,"zipcode":4750,"city":"Elsenborn"},{"id":1034,"zipcode":4750,"city":"Butgenbach"},{"id":1035,"zipcode":4760,"city":"Manderfeld"},{"id":1036,"zipcode":4760,"city":"B\xfcllingen"},{"id":1037,"zipcode":4761,"city":"Rocherath"},{"id":1038,"zipcode":4770,"city":"Meyerode"},{"id":1039,"zipcode":4770,"city":"Amel"},{"id":1040,"zipcode":4771,"city":"Heppenbach"},{"id":1041,"zipcode":4780,"city":"Recht"},{"id":1042,"zipcode":4780,"city":"Sankt-Vith"},{"id":1043,"zipcode":4782,"city":"Sch\xf6nberg"},{"id":1044,"zipcode":4783,"city":"Lommersweiler"},{"id":1045,"zipcode":4784,"city":"Crombach"},{"id":1046,"zipcode":4790,"city":"Reuland"},{"id":1047,"zipcode":4791,"city":"Thommen"},{"id":1048,"zipcode":4800,"city":"Ensival"},{"id":1049,"zipcode":4800,"city":"Lambermont"},{"id":1050,"zipcode":4800,"city":"Petit-Rechain"},{"id":1051,"zipcode":4800,"city":"Polleur"},{"id":1052,"zipcode":4800,"city":"Verviers"},{"id":1053,"zipcode":4801,"city":"Stembert"},{"id":1054,"zipcode":4802,"city":"Heusy"},{"id":1055,"zipcode":4820,"city":"Dison"},{"id":1056,"zipcode":4821,"city":"Andrimont"},{"id":1057,"zipcode":4830,"city":"Limbourg"},{"id":1058,"zipcode":4831,"city":"Bilstain"},{"id":1059,"zipcode":4834,"city":"Go\xe9"},{"id":1060,"zipcode":4837,"city":"Membach"},{"id":1061,"zipcode":4837,"city":"Baelen"},{"id":1062,"zipcode":4840,"city":"Welkenraedt"},{"id":1063,"zipcode":4841,"city":"Henri-Chapelle"},{"id":1064,"zipcode":4845,"city":"Sart-lez-Spa"},{"id":1065,"zipcode":4845,"city":"Jalhay"},{"id":1066,"zipcode":4850,"city":"Montzen"},{"id":1067,"zipcode":4850,"city":"Moresnet"},{"id":1068,"zipcode":4851,"city":"Gemmenich"},{"id":1069,"zipcode":4851,"city":"Sippenaeken"},{"id":1070,"zipcode":4852,"city":"Hombourg"},{"id":1071,"zipcode":4860,"city":"Cornesse"},{"id":1072,"zipcode":4860,"city":"Wegnez"},{"id":1073,"zipcode":4860,"city":"Pepinster"},{"id":1074,"zipcode":4861,"city":"Soiron"},{"id":1075,"zipcode":4870,"city":"For\xeat"},{"id":1076,"zipcode":4870,"city":"Fraipont"},{"id":1077,"zipcode":4870,"city":"Nessonvaux"},{"id":1078,"zipcode":4877,"city":"Olne"},{"id":1079,"zipcode":4880,"city":"Aubel"},{"id":1080,"zipcode":4890,"city":"Clermont"},{"id":1081,"zipcode":4890,"city":"Thimister"},{"id":1082,"zipcode":4900,"city":"Spa"},{"id":1083,"zipcode":4910,"city":"La Reid"},{"id":1084,"zipcode":4910,"city":"Polleur"},{"id":1085,"zipcode":4910,"city":"Theux"},{"id":1086,"zipcode":4920,"city":"Ernonheid"},{"id":1087,"zipcode":4920,"city":"Harz\xe9"},{"id":1088,"zipcode":4920,"city":"Louveign\xe9"},{"id":1089,"zipcode":4920,"city":"Sougn\xe9-Remouchamps"},{"id":1090,"zipcode":4920,"city":"Aywaille"},{"id":1091,"zipcode":4950,"city":"Faymonville"},{"id":1092,"zipcode":4950,"city":"Robertville"},{"id":1093,"zipcode":4950,"city":"Sourbrodt"},{"id":1094,"zipcode":4950,"city":"Weismes"},{"id":1095,"zipcode":4960,"city":"Bellevaux-Ligneuville"},{"id":1096,"zipcode":4960,"city":"Beverc\xe9"},{"id":1097,"zipcode":4960,"city":"Malmedy"},{"id":1098,"zipcode":4970,"city":"Francorchamps"},{"id":1099,"zipcode":4970,"city":"Stavelot"},{"id":1100,"zipcode":4980,"city":"Fosse"},{"id":1101,"zipcode":4980,"city":"Wanne"},{"id":1102,"zipcode":4980,"city":"Trois-Ponts"},{"id":1103,"zipcode":4983,"city":"Basse-Bodeux"},{"id":1104,"zipcode":4987,"city":"Chevron"},{"id":1105,"zipcode":4987,"city":"La Gleize"},{"id":1106,"zipcode":4987,"city":"Lorc\xe9"},{"id":1107,"zipcode":4987,"city":"Rahier"},{"id":1108,"zipcode":4987,"city":"Stoumont"},{"id":1109,"zipcode":4990,"city":"Arbrefontaine"},{"id":1110,"zipcode":4990,"city":"Bra"},{"id":1111,"zipcode":4990,"city":"Lierneux"},{"id":1112,"zipcode":5000,"city":"Beez"},{"id":1113,"zipcode":5000,"city":"Namur"},{"id":1114,"zipcode":5001,"city":"Belgrade"},{"id":1115,"zipcode":5002,"city":"Saint-Servais"},{"id":1116,"zipcode":5003,"city":"Saint-Marc"},{"id":1117,"zipcode":5004,"city":"Bouge"},{"id":1118,"zipcode":5020,"city":"Champion"},{"id":1119,"zipcode":5020,"city":"Daussoulx"},{"id":1120,"zipcode":5020,"city":"Flawinne"},{"id":1121,"zipcode":5020,"city":"Malonne"},{"id":1122,"zipcode":5020,"city":"Suarl\xe9e"},{"id":1123,"zipcode":5020,"city":"Temploux"},{"id":1124,"zipcode":5020,"city":"Vedrin"},{"id":1125,"zipcode":5021,"city":"Boninne"},{"id":1126,"zipcode":5022,"city":"Cognel\xe9e"},{"id":1127,"zipcode":5024,"city":"Gelbress\xe9e"},{"id":1128,"zipcode":5024,"city":"Marche-les-Dames"},{"id":1129,"zipcode":5030,"city":"Beuzet"},{"id":1130,"zipcode":5030,"city":"Ernage"},{"id":1131,"zipcode":5030,"city":"Grand-Manil"},{"id":1132,"zipcode":5030,"city":"Lonz\xe9e"},{"id":1133,"zipcode":5030,"city":"Sauveni\xe8re"},{"id":1134,"zipcode":5030,"city":"Gembloux"},{"id":1135,"zipcode":5031,"city":"Grand-Leez"},{"id":1136,"zipcode":5032,"city":"Bossi\xe8re"},{"id":1137,"zipcode":5032,"city":"Bothey"},{"id":1138,"zipcode":5032,"city":"Corroy-le-Ch\xe2teau"},{"id":1139,"zipcode":5032,"city":"Isnes"},{"id":1140,"zipcode":5032,"city":"Mazy"},{"id":1141,"zipcode":5060,"city":"Arsimont"},{"id":1142,"zipcode":5060,"city":"Auvelais"},{"id":1143,"zipcode":5060,"city":"Falisolle"},{"id":1144,"zipcode":5060,"city":"Keumi\xe9e"},{"id":1145,"zipcode":5060,"city":"Moignel\xe9e"},{"id":1146,"zipcode":5060,"city":"Tamines"},{"id":1147,"zipcode":5060,"city":"Velaine-sur-Sambre"},{"id":1148,"zipcode":5070,"city":"Aisemont"},{"id":1149,"zipcode":5070,"city":"Le Roux"},{"id":1150,"zipcode":5070,"city":"Sart-Eustache"},{"id":1151,"zipcode":5070,"city":"Sart-Saint-Laurent"},{"id":1152,"zipcode":5070,"city":"Vitrival"},{"id":1153,"zipcode":5070,"city":"Fosses-la-Ville"},{"id":1154,"zipcode":5080,"city":"Emines"},{"id":1155,"zipcode":5080,"city":"Rhisnes"},{"id":1156,"zipcode":5080,"city":"Villers-lez-Heest"},{"id":1157,"zipcode":5080,"city":"Warisoulx"},{"id":1158,"zipcode":5081,"city":"Bovesse"},{"id":1159,"zipcode":5081,"city":"Meux"},{"id":1160,"zipcode":5081,"city":"Saint-Denis-Bovesse"},{"id":1161,"zipcode":5100,"city":"Dave"},{"id":1162,"zipcode":5100,"city":"Jambes"},{"id":1163,"zipcode":5100,"city":"Naninne"},{"id":1164,"zipcode":5100,"city":"W\xe9pion"},{"id":1165,"zipcode":5100,"city":"Wierde"},{"id":1166,"zipcode":5101,"city":"Erpent"},{"id":1167,"zipcode":5101,"city":"Lives-sur-Meuse"},{"id":1168,"zipcode":5101,"city":"Loyers"},{"id":1169,"zipcode":5140,"city":"Boign\xe9e"},{"id":1170,"zipcode":5140,"city":"Ligny"},{"id":1171,"zipcode":5140,"city":"Tongrinne"},{"id":1172,"zipcode":5140,"city":"Sombreffe"},{"id":1173,"zipcode":5150,"city":"Floriffoux"},{"id":1174,"zipcode":5150,"city":"Frani\xe8re"},{"id":1175,"zipcode":5150,"city":"Soye"},{"id":1176,"zipcode":5150,"city":"Floreffe"},{"id":1177,"zipcode":5170,"city":"Arbre"},{"id":1178,"zipcode":5170,"city":"Bois-de-Villers"},{"id":1179,"zipcode":5170,"city":"Lesve"},{"id":1180,"zipcode":5170,"city":"Lustin"},{"id":1181,"zipcode":5170,"city":"Rivi\xe8re"},{"id":1182,"zipcode":5170,"city":"Profondeville"},{"id":1183,"zipcode":5190,"city":"Bal\xe2tre"},{"id":1184,"zipcode":5190,"city":"Ham-sur-Sambre"},{"id":1185,"zipcode":5190,"city":"Mornimont"},{"id":1186,"zipcode":5190,"city":"Moustier-sur-Sambre"},{"id":1187,"zipcode":5190,"city":"Onoz"},{"id":1188,"zipcode":5190,"city":"Saint-Martin"},{"id":1189,"zipcode":5190,"city":"Spy"},{"id":1190,"zipcode":5190,"city":"Jemeppe-sur-Sambre"},{"id":1191,"zipcode":5300,"city":"Bonneville"},{"id":1192,"zipcode":5300,"city":"Coutisse"},{"id":1193,"zipcode":5300,"city":"Landenne"},{"id":1194,"zipcode":5300,"city":"Maizeret"},{"id":1195,"zipcode":5300,"city":"Nam\xeache"},{"id":1196,"zipcode":5300,"city":"Sclayn"},{"id":1197,"zipcode":5300,"city":"Seilles"},{"id":1198,"zipcode":5300,"city":"Thon"},{"id":1199,"zipcode":5300,"city":"Vezin"},{"id":1200,"zipcode":5300,"city":"Andenne"},{"id":1201,"zipcode":5310,"city":"Aische-en-Refail"},{"id":1202,"zipcode":5310,"city":"Bolinne"},{"id":1203,"zipcode":5310,"city":"Boneffe"},{"id":1204,"zipcode":5310,"city":"Branchon"},{"id":1205,"zipcode":5310,"city":"Dhuy"},{"id":1206,"zipcode":5310,"city":"Hanret"},{"id":1207,"zipcode":5310,"city":"Leuze"},{"id":1208,"zipcode":5310,"city":"Liernu"},{"id":1209,"zipcode":5310,"city":"Longchamps"},{"id":1210,"zipcode":5310,"city":"Mehaigne"},{"id":1211,"zipcode":5310,"city":"Noville-sur-Mehaigne"},{"id":1212,"zipcode":5310,"city":"Saint-Germain"},{"id":1213,"zipcode":5310,"city":"Taviers"},{"id":1214,"zipcode":5310,"city":"Upigny"},{"id":1215,"zipcode":5310,"city":"Waret-la-Chauss\xe9e"},{"id":1216,"zipcode":5310,"city":"Eghez\xe9e"},{"id":1217,"zipcode":5330,"city":"Maillen"},{"id":1218,"zipcode":5330,"city":"Sart-Bernard"},{"id":1219,"zipcode":5330,"city":"Assesse"},{"id":1220,"zipcode":5332,"city":"Crupet"},{"id":1221,"zipcode":5333,"city":"Sorinne-la-Longue"},{"id":1222,"zipcode":5334,"city":"Flor\xe9e"},{"id":1223,"zipcode":5336,"city":"Courri\xe8re"},{"id":1224,"zipcode":5340,"city":"Faulx-les-Tombes"},{"id":1225,"zipcode":5340,"city":"Haltinne"},{"id":1226,"zipcode":5340,"city":"Mozet"},{"id":1227,"zipcode":5340,"city":"Sor\xe9e"},{"id":1228,"zipcode":5340,"city":"Gesves"},{"id":1229,"zipcode":5350,"city":"Evelette"},{"id":1230,"zipcode":5350,"city":"Ohey"},{"id":1231,"zipcode":5351,"city":"Haillot"},{"id":1232,"zipcode":5352,"city":"Perwez-Haillot"},{"id":1233,"zipcode":5353,"city":"Goesnes"},{"id":1234,"zipcode":5354,"city":"Jallet"},{"id":1235,"zipcode":5360,"city":"Natoye"},{"id":1236,"zipcode":5360,"city":"Hamois"},{"id":1237,"zipcode":5361,"city":"Mohiville"},{"id":1238,"zipcode":5361,"city":"Scy"},{"id":1239,"zipcode":5362,"city":"Achet"},{"id":1240,"zipcode":5363,"city":"Emptinne"},{"id":1241,"zipcode":5364,"city":"Schaltin"},{"id":1242,"zipcode":5370,"city":"Barvaux-Condroz"},{"id":1243,"zipcode":5370,"city":"Flostoy"},{"id":1244,"zipcode":5370,"city":"Jeneffe"},{"id":1245,"zipcode":5370,"city":"Porcheresse"},{"id":1246,"zipcode":5370,"city":"Verl\xe9e"},{"id":1247,"zipcode":5370,"city":"Havelange"},{"id":1248,"zipcode":5372,"city":"M\xe9an"},{"id":1249,"zipcode":5374,"city":"Maffe"},{"id":1250,"zipcode":5376,"city":"Mi\xe9cret"},{"id":1251,"zipcode":5377,"city":"Baillonville"},{"id":1252,"zipcode":5377,"city":"Bonsin"},{"id":1253,"zipcode":5377,"city":"Heure"},{"id":1254,"zipcode":5377,"city":"Hogne"},{"id":1255,"zipcode":5377,"city":"Nettinne"},{"id":1256,"zipcode":5377,"city":"Noiseux"},{"id":1257,"zipcode":5377,"city":"Sinsin"},{"id":1258,"zipcode":5377,"city":"Waillet"},{"id":1259,"zipcode":5377,"city":"Somme-Leuze"},{"id":1260,"zipcode":5380,"city":"Bierwart"},{"id":1261,"zipcode":5380,"city":"Cortil-Wodon"},{"id":1262,"zipcode":5380,"city":"Forville"},{"id":1263,"zipcode":5380,"city":"Franc-Waret"},{"id":1264,"zipcode":5380,"city":"Hemptinne"},{"id":1265,"zipcode":5380,"city":"Hingeon"},{"id":1266,"zipcode":5380,"city":"Marchovelette"},{"id":1267,"zipcode":5380,"city":"Noville-les-Bois"},{"id":1268,"zipcode":5380,"city":"Pontillas"},{"id":1269,"zipcode":5380,"city":"Tillier"},{"id":1270,"zipcode":5500,"city":"Anseremme"},{"id":1271,"zipcode":5500,"city":"Bouvignes-sur-Meuse"},{"id":1272,"zipcode":5500,"city":"Dr\xe9hance"},{"id":1273,"zipcode":5500,"city":"Falmagne"},{"id":1274,"zipcode":5500,"city":"Falmignoul"},{"id":1275,"zipcode":5500,"city":"Furfooz"},{"id":1276,"zipcode":5500,"city":"Dinant"},{"id":1277,"zipcode":5501,"city":"Lisogne"},{"id":1278,"zipcode":5502,"city":"Thynes"},{"id":1279,"zipcode":5503,"city":"Sorinnes"},{"id":1280,"zipcode":5504,"city":"Foy-Notre-Dame"},{"id":1281,"zipcode":5520,"city":"Anth\xe9e"},{"id":1282,"zipcode":5520,"city":"Onhaye"},{"id":1283,"zipcode":5521,"city":"Serville"},{"id":1284,"zipcode":5522,"city":"Fala\xebn"},{"id":1285,"zipcode":5523,"city":"Sommi\xe8re"},{"id":1286,"zipcode":5523,"city":"Weillen"},{"id":1287,"zipcode":5524,"city":"G\xe9rin"},{"id":1288,"zipcode":5530,"city":"Dorinne"},{"id":1289,"zipcode":5530,"city":"Durnal"},{"id":1290,"zipcode":5530,"city":"Evrehailles"},{"id":1291,"zipcode":5530,"city":"Godinne"},{"id":1292,"zipcode":5530,"city":"Houx"},{"id":1293,"zipcode":5530,"city":"Mont"},{"id":1294,"zipcode":5530,"city":"Purnode"},{"id":1295,"zipcode":5530,"city":"Spontin"},{"id":1296,"zipcode":5530,"city":"Yvoir"},{"id":1297,"zipcode":5537,"city":"Annevoie-Rouillon"},{"id":1298,"zipcode":5537,"city":"Bioul"},{"id":1299,"zipcode":5537,"city":"Den\xe9e"},{"id":1300,"zipcode":5537,"city":"Haut-le-Wastia"},{"id":1301,"zipcode":5537,"city":"Sosoye"},{"id":1302,"zipcode":5537,"city":"Warnant"},{"id":1303,"zipcode":5537,"city":"Anh\xe9e"},{"id":1304,"zipcode":5540,"city":"Hasti\xe8re-Lavaux"},{"id":1305,"zipcode":5540,"city":"Hermeton-sur-Meuse"},{"id":1306,"zipcode":5540,"city":"Waulsort"},{"id":1307,"zipcode":5541,"city":"Hasti\xe8re-par-Del\xe0"},{"id":1308,"zipcode":5542,"city":"Blaimont"},{"id":1309,"zipcode":5543,"city":"Heer"},{"id":1310,"zipcode":5544,"city":"Agimont"},{"id":1311,"zipcode":5550,"city":"Alle"},{"id":1312,"zipcode":5550,"city":"Bagimont"},{"id":1313,"zipcode":5550,"city":"Bohan"},{"id":1314,"zipcode":5550,"city":"Chairi\xe8re"},{"id":1315,"zipcode":5550,"city":"Lafor\xeat"},{"id":1316,"zipcode":5550,"city":"Membre"},{"id":1317,"zipcode":5550,"city":"Mouzaive"},{"id":1318,"zipcode":5550,"city":"Nafraiture"},{"id":1319,"zipcode":5550,"city":"Orchimont"},{"id":1320,"zipcode":5550,"city":"Pussemange"},{"id":1321,"zipcode":5550,"city":"Sugny"},{"id":1322,"zipcode":5550,"city":"Vresse-sur-Semois"},{"id":1323,"zipcode":5555,"city":"Baillamont"},{"id":1324,"zipcode":5555,"city":"Bellefontaine"},{"id":1325,"zipcode":5555,"city":"Cornimont"},{"id":1326,"zipcode":5555,"city":"Graide"},{"id":1327,"zipcode":5555,"city":"Gros-Fays"},{"id":1328,"zipcode":5555,"city":"Monceau-en-Ardenne"},{"id":1329,"zipcode":5555,"city":"Naom\xe9"},{"id":1330,"zipcode":5555,"city":"Oizy"},{"id":1331,"zipcode":5555,"city":"Petit-Fays"},{"id":1332,"zipcode":5555,"city":"Bi\xe8vre"},{"id":1333,"zipcode":5560,"city":"Ciergnon"},{"id":1334,"zipcode":5560,"city":"Finnevaux"},{"id":1335,"zipcode":5560,"city":"Hulsonniaux"},{"id":1336,"zipcode":5560,"city":"Mesnil-Eglise"},{"id":1337,"zipcode":5560,"city":"Mesnil-Saint-Blaise"},{"id":1338,"zipcode":5560,"city":"Houyet"},{"id":1339,"zipcode":5561,"city":"Celles"},{"id":1340,"zipcode":5562,"city":"Custinne"},{"id":1341,"zipcode":5563,"city":"Hour"},{"id":1342,"zipcode":5564,"city":"Wanlin"},{"id":1343,"zipcode":5570,"city":"Baronville"},{"id":1344,"zipcode":5570,"city":"Dion"},{"id":1345,"zipcode":5570,"city":"Felenne"},{"id":1346,"zipcode":5570,"city":"Feschaux"},{"id":1347,"zipcode":5570,"city":"Honnay"},{"id":1348,"zipcode":5570,"city":"Javingue"},{"id":1349,"zipcode":5570,"city":"Von\xeache"},{"id":1350,"zipcode":5570,"city":"Wancennes"},{"id":1351,"zipcode":5570,"city":"Winenne"},{"id":1352,"zipcode":5570,"city":"Beauraing"},{"id":1353,"zipcode":5571,"city":"Wiesme"},{"id":1354,"zipcode":5572,"city":"Focant"},{"id":1355,"zipcode":5573,"city":"Martouzin-Neuville"},{"id":1356,"zipcode":5574,"city":"Pondr\xf4me"},{"id":1357,"zipcode":5575,"city":"Bourseigne-Neuve"},{"id":1358,"zipcode":5575,"city":"Bourseigne-Vieille"},{"id":1359,"zipcode":5575,"city":"Houdremont"},{"id":1360,"zipcode":5575,"city":"Louette-Saint-Denis"},{"id":1361,"zipcode":5575,"city":"Louette-Saint-Pierre"},{"id":1362,"zipcode":5575,"city":"Malvoisin"},{"id":1363,"zipcode":5575,"city":"Patignies"},{"id":1364,"zipcode":5575,"city":"Rienne"},{"id":1365,"zipcode":5575,"city":"Sart-Custinne"},{"id":1366,"zipcode":5575,"city":"Vencimont"},{"id":1367,"zipcode":5575,"city":"Willerzie"},{"id":1368,"zipcode":5575,"city":"Gedinne"},{"id":1369,"zipcode":5576,"city":"Froidfontaine"},{"id":1370,"zipcode":5580,"city":"Ave-et-Auffe"},{"id":1371,"zipcode":5580,"city":"Buissonville"},{"id":1372,"zipcode":5580,"city":"Eprave"},{"id":1373,"zipcode":5580,"city":"Han-sur-Lesse"},{"id":1374,"zipcode":5580,"city":"Jemelle"},{"id":1375,"zipcode":5580,"city":"Lavaux-Sainte-Anne"},{"id":1376,"zipcode":5580,"city":"Lessive"},{"id":1377,"zipcode":5580,"city":"Mont-Gauthier"},{"id":1378,"zipcode":5580,"city":"Villers-sur-Lesse"},{"id":1379,"zipcode":5580,"city":"Wavreille"},{"id":1380,"zipcode":5580,"city":"Rochefort"},{"id":1381,"zipcode":5590,"city":"Ach\xeane"},{"id":1382,"zipcode":5590,"city":"Braibant"},{"id":1383,"zipcode":5590,"city":"Chevetogne"},{"id":1384,"zipcode":5590,"city":"Conneux"},{"id":1385,"zipcode":5590,"city":"Haversin"},{"id":1386,"zipcode":5590,"city":"Leignon"},{"id":1387,"zipcode":5590,"city":"Pessoux"},{"id":1388,"zipcode":5590,"city":"Serinchamps"},{"id":1389,"zipcode":5590,"city":"Sovet"},{"id":1390,"zipcode":5590,"city":"Ciney"},{"id":1391,"zipcode":5600,"city":"Fagnolle"},{"id":1392,"zipcode":5600,"city":"Franchimont"},{"id":1393,"zipcode":5600,"city":"Jamagne"},{"id":1394,"zipcode":5600,"city":"Jamiolle"},{"id":1395,"zipcode":5600,"city":"Merlemont"},{"id":1396,"zipcode":5600,"city":"Neuville"},{"id":1397,"zipcode":5600,"city":"Omez\xe9e"},{"id":1398,"zipcode":5600,"city":"Roly"},{"id":1399,"zipcode":5600,"city":"Romedenne"},{"id":1400,"zipcode":5600,"city":"Samart"},{"id":1401,"zipcode":5600,"city":"Sart-en-Fagne"},{"id":1402,"zipcode":5600,"city":"Sautour"},{"id":1403,"zipcode":5600,"city":"Surice"},{"id":1404,"zipcode":5600,"city":"Villers-en-Fagne"},{"id":1405,"zipcode":5600,"city":"Villers-le-Gambon"},{"id":1406,"zipcode":5600,"city":"Vodec\xe9e"},{"id":1407,"zipcode":5600,"city":"Philippeville"},{"id":1408,"zipcode":5620,"city":"Corenne"},{"id":1409,"zipcode":5620,"city":"Flavion"},{"id":1410,"zipcode":5620,"city":"Hemptinne-lez-Florennes"},{"id":1411,"zipcode":5620,"city":"Morville"},{"id":1412,"zipcode":5620,"city":"Ros\xe9e"},{"id":1413,"zipcode":5620,"city":"Saint-Aubin"},{"id":1414,"zipcode":5620,"city":"Florennes"},{"id":1415,"zipcode":5621,"city":"Hanzinelle"},{"id":1416,"zipcode":5621,"city":"Hanzinne"},{"id":1417,"zipcode":5621,"city":"Morialm\xe9"},{"id":1418,"zipcode":5621,"city":"Thy-le-Bauduin"},{"id":1419,"zipcode":5630,"city":"Daussois"},{"id":1420,"zipcode":5630,"city":"Senzeilles"},{"id":1421,"zipcode":5630,"city":"Silenrieux"},{"id":1422,"zipcode":5630,"city":"Soumoy"},{"id":1423,"zipcode":5630,"city":"Villers-Deux-Eglises"},{"id":1424,"zipcode":5630,"city":"Cerfontaine"},{"id":1425,"zipcode":5640,"city":"Biesme"},{"id":1426,"zipcode":5640,"city":"Biesmer\xe9e"},{"id":1427,"zipcode":5640,"city":"Graux"},{"id":1428,"zipcode":5640,"city":"Oret"},{"id":1429,"zipcode":5640,"city":"Saint-G\xe9rard"},{"id":1430,"zipcode":5640,"city":"Mettet"},{"id":1431,"zipcode":5641,"city":"Furnaux"},{"id":1432,"zipcode":5644,"city":"Ermeton-sur-Biert"},{"id":1433,"zipcode":5646,"city":"Stave"},{"id":1434,"zipcode":5650,"city":"Castillon"},{"id":1435,"zipcode":5650,"city":"Chastr\xe8s"},{"id":1436,"zipcode":5650,"city":"Clermont"},{"id":1437,"zipcode":5650,"city":"Fontenelle"},{"id":1438,"zipcode":5650,"city":"Fraire"},{"id":1439,"zipcode":5650,"city":"Pry"},{"id":1440,"zipcode":5650,"city":"Vogen\xe9e"},{"id":1441,"zipcode":5650,"city":"Yves-Gomez\xe9e"},{"id":1442,"zipcode":5650,"city":"Walcourt"},{"id":1443,"zipcode":5651,"city":"Berz\xe9e"},{"id":1444,"zipcode":5651,"city":"Gourdinne"},{"id":1445,"zipcode":5651,"city":"Laneffe"},{"id":1446,"zipcode":5651,"city":"Rogn\xe9e"},{"id":1447,"zipcode":5651,"city":"Somz\xe9e"},{"id":1448,"zipcode":5651,"city":"Tarcienne"},{"id":1449,"zipcode":5651,"city":"Thy-le-Ch\xe2teau"},{"id":1450,"zipcode":5660,"city":"Aublain"},{"id":1451,"zipcode":5660,"city":"Boussu-en-Fagne"},{"id":1452,"zipcode":5660,"city":"Br\xfbly"},{"id":1453,"zipcode":5660,"city":"Br\xfbly-de-Pesche"},{"id":1454,"zipcode":5660,"city":"Cul-des-Sarts"},{"id":1455,"zipcode":5660,"city":"Dailly"},{"id":1456,"zipcode":5660,"city":"Frasnes"},{"id":1457,"zipcode":5660,"city":"Gonrieux"},{"id":1458,"zipcode":5660,"city":"Mariembourg"},{"id":1459,"zipcode":5660,"city":"Pesche"},{"id":1460,"zipcode":5660,"city":"P\xe9tigny"},{"id":1461,"zipcode":5660,"city":"Petite-Chapelle"},{"id":1462,"zipcode":5660,"city":"Presgaux"},{"id":1463,"zipcode":5660,"city":"Couvin"},{"id":1464,"zipcode":5670,"city":"Dourbes"},{"id":1465,"zipcode":5670,"city":"Le Mesnil"},{"id":1466,"zipcode":5670,"city":"Maz\xe9e"},{"id":1467,"zipcode":5670,"city":"Nismes"},{"id":1468,"zipcode":5670,"city":"Oignies-en-Thi\xe9rache"},{"id":1469,"zipcode":5670,"city":"Olloy-Sur-Viroin"},{"id":1470,"zipcode":5670,"city":"Treignes"},{"id":1471,"zipcode":5670,"city":"Vierves-sur-Viroin"},{"id":1472,"zipcode":5680,"city":"Gimn\xe9e"},{"id":1473,"zipcode":5680,"city":"Gochen\xe9e"},{"id":1474,"zipcode":5680,"city":"Matagne-la-Grande"},{"id":1475,"zipcode":5680,"city":"Matagne-la-Petite"},{"id":1476,"zipcode":5680,"city":"Niverl\xe9e"},{"id":1477,"zipcode":5680,"city":"Romer\xe9e"},{"id":1478,"zipcode":5680,"city":"Soulme"},{"id":1479,"zipcode":5680,"city":"Vaucelles"},{"id":1480,"zipcode":5680,"city":"Vodel\xe9e"},{"id":1481,"zipcode":5680,"city":"Doische"},{"id":1482,"zipcode":6000,"city":"Charleroi"},{"id":1483,"zipcode":6001,"city":"Marcinelle"},{"id":1484,"zipcode":6010,"city":"Couillet"},{"id":1485,"zipcode":6020,"city":"Dampremy"},{"id":1486,"zipcode":6030,"city":"Goutroux"},{"id":1487,"zipcode":6030,"city":"Marchienne-au-Pont"},{"id":1488,"zipcode":6031,"city":"Monceau-sur-Sambre"},{"id":1489,"zipcode":6032,"city":"Mont-sur-Marchienne"},{"id":1490,"zipcode":6040,"city":"Jumet"},{"id":1491,"zipcode":6041,"city":"Gosselies"},{"id":1492,"zipcode":6042,"city":"Lodelinsart"},{"id":1493,"zipcode":6043,"city":"Ransart"},{"id":1494,"zipcode":6044,"city":"Roux"},{"id":1495,"zipcode":6060,"city":"Gilly"},{"id":1496,"zipcode":6061,"city":"Montignies-sur-Sambre"},{"id":1497,"zipcode":6110,"city":"Montigny-le-Tilleul"},{"id":1498,"zipcode":6111,"city":"Landelies"},{"id":1499,"zipcode":6120,"city":"Cour-sur-Heure"},{"id":1500,"zipcode":6120,"city":"Jamioulx"},{"id":1501,"zipcode":6120,"city":"Marbaix"},{"id":1502,"zipcode":6120,"city":"Nalinnes"},{"id":1503,"zipcode":6120,"city":"Ham-sur-Heure"},{"id":1504,"zipcode":6140,"city":"Fontaine-l\'\xc9v\xeaque"},{"id":1505,"zipcode":6141,"city":"Forchies-La-Marche"},{"id":1506,"zipcode":6142,"city":"Leernes"},{"id":1507,"zipcode":6150,"city":"Anderlues"},{"id":1508,"zipcode":6180,"city":"Courcelles"},{"id":1509,"zipcode":6181,"city":"Gouy-lez-Pi\xe9ton"},{"id":1510,"zipcode":6182,"city":"Souvret"},{"id":1511,"zipcode":6183,"city":"Trazegnies"},{"id":1512,"zipcode":6200,"city":"Bouffioulx"},{"id":1513,"zipcode":6200,"city":"Ch\xe2telineau"},{"id":1514,"zipcode":6200,"city":"Ch\xe2telet"},{"id":1515,"zipcode":6210,"city":"Frasnes-lez-Gosselies"},{"id":1516,"zipcode":6210,"city":"R\xe8ves"},{"id":1517,"zipcode":6210,"city":"Villers-Perwin"},{"id":1518,"zipcode":6210,"city":"Wayaux"},{"id":1519,"zipcode":6211,"city":"Mellet"},{"id":1520,"zipcode":6220,"city":"Heppignies"},{"id":1521,"zipcode":6220,"city":"Lambusart"},{"id":1522,"zipcode":6220,"city":"Wangenies"},{"id":1523,"zipcode":6220,"city":"Fleurus"},{"id":1524,"zipcode":6221,"city":"Saint-Amand"},{"id":1525,"zipcode":6222,"city":"Brye"},{"id":1526,"zipcode":6223,"city":"Wagnel\xe9e"},{"id":1527,"zipcode":6224,"city":"Wanferc\xe9e-Baulet"},{"id":1528,"zipcode":6230,"city":"Buzet"},{"id":1529,"zipcode":6230,"city":"Obaix"},{"id":1530,"zipcode":6230,"city":"Thim\xe9on"},{"id":1531,"zipcode":6230,"city":"Viesville"},{"id":1532,"zipcode":6230,"city":"Pont-\xe0-Celles"},{"id":1533,"zipcode":6238,"city":"Liberchies"},{"id":1534,"zipcode":6238,"city":"Luttre"},{"id":1535,"zipcode":6240,"city":"Pironchamps"},{"id":1536,"zipcode":6240,"city":"Farciennes"},{"id":1537,"zipcode":6250,"city":"Aiseau"},{"id":1538,"zipcode":6250,"city":"Pont-de-Loup"},{"id":1539,"zipcode":6250,"city":"Presles"},{"id":1540,"zipcode":6250,"city":"Roselies"},{"id":1541,"zipcode":6280,"city":"Acoz"},{"id":1542,"zipcode":6280,"city":"Gougnies"},{"id":1543,"zipcode":6280,"city":"Joncret"},{"id":1544,"zipcode":6280,"city":"Loverval"},{"id":1545,"zipcode":6280,"city":"Villers-Poterie"},{"id":1546,"zipcode":6280,"city":"Gerpinnes"},{"id":1547,"zipcode":6440,"city":"Boussu-lez-Walcourt"},{"id":1548,"zipcode":6440,"city":"Fourbechies"},{"id":1549,"zipcode":6440,"city":"Vergnies"},{"id":1550,"zipcode":6440,"city":"Froidchapelle"},{"id":1551,"zipcode":6441,"city":"Erpion"},{"id":1552,"zipcode":6460,"city":"Baili\xe8vre"},{"id":1553,"zipcode":6460,"city":"Robechies"},{"id":1554,"zipcode":6460,"city":"Saint-Remy"},{"id":1555,"zipcode":6460,"city":"Salles"},{"id":1556,"zipcode":6460,"city":"Villers-la-Tour"},{"id":1557,"zipcode":6460,"city":"Chimay"},{"id":1558,"zipcode":6461,"city":"Virelles"},{"id":1559,"zipcode":6462,"city":"Vaulx-lez-Chimay"},{"id":1560,"zipcode":6463,"city":"Lompret"},{"id":1561,"zipcode":6464,"city":"Baileux"},{"id":1562,"zipcode":6464,"city":"Bourlers"},{"id":1563,"zipcode":6464,"city":"Forges"},{"id":1564,"zipcode":6464,"city":"l\'Escaill\xe8re"},{"id":1565,"zipcode":6464,"city":"Ri\xe8zes"},{"id":1566,"zipcode":6470,"city":"Grandrieu"},{"id":1567,"zipcode":6470,"city":"Montbliart"},{"id":1568,"zipcode":6470,"city":"Rance"},{"id":1569,"zipcode":6470,"city":"Sautin"},{"id":1570,"zipcode":6470,"city":"Sivry"},{"id":1571,"zipcode":6500,"city":"Barben\xe7on"},{"id":1572,"zipcode":6500,"city":"Leugnies"},{"id":1573,"zipcode":6500,"city":"Leval-Chaudeville"},{"id":1574,"zipcode":6500,"city":"Renlies"},{"id":1575,"zipcode":6500,"city":"Solre-Saint-G\xe9ry"},{"id":1576,"zipcode":6500,"city":"Thirimont"},{"id":1577,"zipcode":6500,"city":"Beaumont"},{"id":1578,"zipcode":6511,"city":"Str\xe9e"},{"id":1579,"zipcode":6530,"city":"Leers-et-Fosteau"},{"id":1580,"zipcode":6530,"city":"Thuin"},{"id":1581,"zipcode":6531,"city":"Biesme-sous-Thuin"},{"id":1582,"zipcode":6532,"city":"Ragnies"},{"id":1583,"zipcode":6533,"city":"Bierc\xe9e"},{"id":1584,"zipcode":6534,"city":"Goz\xe9e"},{"id":1585,"zipcode":6536,"city":"Donstiennes"},{"id":1586,"zipcode":6536,"city":"Thuillies"},{"id":1587,"zipcode":6540,"city":"Mont-Sainte-Genevi\xe8ve"},{"id":1588,"zipcode":6540,"city":"Lobbes"},{"id":1589,"zipcode":6542,"city":"Sars-la-Buissi\xe8re"},{"id":1590,"zipcode":6543,"city":"Bienne-lez-Happart"},{"id":1591,"zipcode":6560,"city":"Bersillies-l\'Abbaye"},{"id":1592,"zipcode":6560,"city":"Grand-Reng"},{"id":1593,"zipcode":6560,"city":"Hantes-Wih\xe9ries"},{"id":1594,"zipcode":6560,"city":"Montignies-Saint-Christophe"},{"id":1595,"zipcode":6560,"city":"Solre-sur-Sambre"},{"id":1596,"zipcode":6560,"city":"Erquelinnes"},{"id":1597,"zipcode":6567,"city":"Fontaine-Valmont"},{"id":1598,"zipcode":6567,"city":"Labuissi\xe8re"},{"id":1599,"zipcode":6567,"city":"Merbes-Sainte-Marie"},{"id":1600,"zipcode":6567,"city":"Merbes-le-Ch\xe2teau"},{"id":1601,"zipcode":6590,"city":"Momignies"},{"id":1602,"zipcode":6591,"city":"Macon"},{"id":1603,"zipcode":6592,"city":"Monceau-Imbrechies"},{"id":1604,"zipcode":6593,"city":"Macquenoise"},{"id":1605,"zipcode":6594,"city":"Beauwelz"},{"id":1606,"zipcode":6596,"city":"Forge-Philippe"},{"id":1607,"zipcode":6596,"city":"Seloignes"},{"id":1608,"zipcode":6600,"city":"Longvilly"},{"id":1609,"zipcode":6600,"city":"Noville"},{"id":1610,"zipcode":6600,"city":"Villers-la-Bonne-Eau"},{"id":1611,"zipcode":6600,"city":"Wardin"},{"id":1612,"zipcode":6600,"city":"Bastogne"},{"id":1613,"zipcode":6630,"city":"Martelange"},{"id":1614,"zipcode":6637,"city":"Hollange"},{"id":1615,"zipcode":6637,"city":"Tintange"},{"id":1616,"zipcode":6637,"city":"Fauvillers"},{"id":1617,"zipcode":6640,"city":"Hompr\xe9"},{"id":1618,"zipcode":6640,"city":"Morhet"},{"id":1619,"zipcode":6640,"city":"Nives"},{"id":1620,"zipcode":6640,"city":"Sibret"},{"id":1621,"zipcode":6640,"city":"Vaux-lez-Rosi\xe8res"},{"id":1622,"zipcode":6640,"city":"Vaux-sur-S\xfbre"},{"id":1623,"zipcode":6642,"city":"Juseret"},{"id":1624,"zipcode":6660,"city":"Nadrin"},{"id":1625,"zipcode":6660,"city":"Houffalize"},{"id":1626,"zipcode":6661,"city":"Mont"},{"id":1627,"zipcode":6661,"city":"Tailles"},{"id":1628,"zipcode":6662,"city":"Tavigny"},{"id":1629,"zipcode":6663,"city":"Mabompr\xe9"},{"id":1630,"zipcode":6666,"city":"Wibrin"},{"id":1631,"zipcode":6670,"city":"Limerl\xe9"},{"id":1632,"zipcode":6670,"city":"Gouvy"},{"id":1633,"zipcode":6671,"city":"Bovigny"},{"id":1634,"zipcode":6672,"city":"Beho"},{"id":1635,"zipcode":6673,"city":"Cherain"},{"id":1636,"zipcode":6674,"city":"Montleban"},{"id":1637,"zipcode":6680,"city":"Amberloup"},{"id":1638,"zipcode":6680,"city":"Tillet"},{"id":1639,"zipcode":6681,"city":"Lavacherie"},{"id":1640,"zipcode":6686,"city":"Flamierge"},{"id":1641,"zipcode":6687,"city":"Bertogne"},{"id":1642,"zipcode":6688,"city":"Longchamps"},{"id":1643,"zipcode":6690,"city":"Bihain"},{"id":1644,"zipcode":6690,"city":"Vielsalm"},{"id":1645,"zipcode":6692,"city":"Petit-Thier"},{"id":1646,"zipcode":6698,"city":"Grand-Halleux"},{"id":1647,"zipcode":6700,"city":"Bonnert"},{"id":1648,"zipcode":6700,"city":"Heinsch"},{"id":1649,"zipcode":6700,"city":"Toernich"},{"id":1650,"zipcode":6700,"city":"Arlon"},{"id":1651,"zipcode":6704,"city":"Guirsch"},{"id":1652,"zipcode":6706,"city":"Autelbas"},{"id":1653,"zipcode":6717,"city":"Nobressart"},{"id":1654,"zipcode":6717,"city":"Nothomb"},{"id":1655,"zipcode":6717,"city":"Thiaumont"},{"id":1656,"zipcode":6717,"city":"Tontelange"},{"id":1657,"zipcode":6717,"city":"Attert"},{"id":1658,"zipcode":6720,"city":"Habay-la-Neuve"},{"id":1659,"zipcode":6720,"city":"Hachy"},{"id":1660,"zipcode":6721,"city":"Anlier"},{"id":1661,"zipcode":6723,"city":"Habay-la-Vieille"},{"id":1662,"zipcode":6724,"city":"Houdemont"},{"id":1663,"zipcode":6724,"city":"Rulles"},{"id":1664,"zipcode":6730,"city":"Bellefontaine"},{"id":1665,"zipcode":6730,"city":"Rossignol"},{"id":1666,"zipcode":6730,"city":"Saint-Vincent"},{"id":1667,"zipcode":6730,"city":"Tintigny"},{"id":1668,"zipcode":6740,"city":"Sainte-Marie-sur-Semois"},{"id":1669,"zipcode":6740,"city":"Villers-sur-Semois"},{"id":1670,"zipcode":6740,"city":"Etalle"},{"id":1671,"zipcode":6741,"city":"Vance"},{"id":1672,"zipcode":6742,"city":"Chantemelle"},{"id":1673,"zipcode":6743,"city":"Buzenol"},{"id":1674,"zipcode":6747,"city":"Ch\xe2tillon"},{"id":1675,"zipcode":6747,"city":"Meix-le-Tige"},{"id":1676,"zipcode":6747,"city":"Saint-L\xe9ger"},{"id":1677,"zipcode":6750,"city":"Mussy-la-Ville"},{"id":1678,"zipcode":6750,"city":"Signeulx"},{"id":1679,"zipcode":6750,"city":"Musson"},{"id":1680,"zipcode":6760,"city":"Bleid"},{"id":1681,"zipcode":6760,"city":"Ethe"},{"id":1682,"zipcode":6760,"city":"Ruette"},{"id":1683,"zipcode":6760,"city":"Virton"},{"id":1684,"zipcode":6761,"city":"Latour"},{"id":1685,"zipcode":6762,"city":"Saint-Mard"},{"id":1686,"zipcode":6767,"city":"Dampicourt"},{"id":1687,"zipcode":6767,"city":"Harnoncourt"},{"id":1688,"zipcode":6767,"city":"Lamorteau"},{"id":1689,"zipcode":6767,"city":"Torgny"},{"id":1690,"zipcode":6769,"city":"G\xe9rouville"},{"id":1691,"zipcode":6769,"city":"Robelmont"},{"id":1692,"zipcode":6769,"city":"Sommethonne"},{"id":1693,"zipcode":6769,"city":"Villers-la-Loue"},{"id":1694,"zipcode":6769,"city":"Meix-devant-Virton"},{"id":1695,"zipcode":6780,"city":"Hondelange"},{"id":1696,"zipcode":6780,"city":"Wolkrange"},{"id":1697,"zipcode":6780,"city":"Messancy"},{"id":1698,"zipcode":6781,"city":"S\xe9lange"},{"id":1699,"zipcode":6782,"city":"Habergy"},{"id":1700,"zipcode":6790,"city":"Aubange"},{"id":1701,"zipcode":6791,"city":"Athus"},{"id":1702,"zipcode":6792,"city":"Halanzy"},{"id":1703,"zipcode":6792,"city":"Rachecourt"},{"id":1704,"zipcode":6800,"city":"Bras"},{"id":1705,"zipcode":6800,"city":"Freux"},{"id":1706,"zipcode":6800,"city":"Moircy"},{"id":1707,"zipcode":6800,"city":"Recogne"},{"id":1708,"zipcode":6800,"city":"Remagne"},{"id":1709,"zipcode":6800,"city":"Sainte-Marie-Chevigny"},{"id":1710,"zipcode":6800,"city":"Saint-Pierre"},{"id":1711,"zipcode":6800,"city":"Libramont-Chevigny"},{"id":1712,"zipcode":6810,"city":"Izel"},{"id":1713,"zipcode":6810,"city":"Jamoigne"},{"id":1714,"zipcode":6810,"city":"Chiny"},{"id":1715,"zipcode":6811,"city":"Les Bulles"},{"id":1716,"zipcode":6812,"city":"Suxy"},{"id":1717,"zipcode":6813,"city":"Termes"},{"id":1718,"zipcode":6820,"city":"Fontenoille"},{"id":1719,"zipcode":6820,"city":"Muno"},{"id":1720,"zipcode":6820,"city":"Sainte-C\xe9cile"},{"id":1721,"zipcode":6820,"city":"Florenville"},{"id":1722,"zipcode":6821,"city":"Lacuisine"},{"id":1723,"zipcode":6823,"city":"Villers-devant-Orval"},{"id":1724,"zipcode":6824,"city":"Chassepierre"},{"id":1725,"zipcode":6830,"city":"Les Hayons"},{"id":1726,"zipcode":6830,"city":"Poupehan"},{"id":1727,"zipcode":6830,"city":"Rochehaut"},{"id":1728,"zipcode":6830,"city":"Bouillon"},{"id":1729,"zipcode":6831,"city":"Noirfontaine"},{"id":1730,"zipcode":6832,"city":"Sensenruth"},{"id":1731,"zipcode":6833,"city":"Ucimont"},{"id":1732,"zipcode":6833,"city":"Vivy"},{"id":1733,"zipcode":6834,"city":"Bellevaux"},{"id":1734,"zipcode":6836,"city":"Dohan"},{"id":1735,"zipcode":6838,"city":"Corbion"},{"id":1736,"zipcode":6840,"city":"Grandvoir"},{"id":1737,"zipcode":6840,"city":"Grapfontaine"},{"id":1738,"zipcode":6840,"city":"Hamipr\xe9"},{"id":1739,"zipcode":6840,"city":"Longlier"},{"id":1740,"zipcode":6840,"city":"Tournay"},{"id":1741,"zipcode":6840,"city":"Neufch\xe2teau"},{"id":1742,"zipcode":6850,"city":"Carlsbourg"},{"id":1743,"zipcode":6850,"city":"Offagne"},{"id":1744,"zipcode":6850,"city":"Paliseul"},{"id":1745,"zipcode":6851,"city":"Nollevaux"},{"id":1746,"zipcode":6852,"city":"Maissin"},{"id":1747,"zipcode":6852,"city":"Opont"},{"id":1748,"zipcode":6853,"city":"Framont"},{"id":1749,"zipcode":6856,"city":"Fays-les-Veneurs"},{"id":1750,"zipcode":6860,"city":"Assenois"},{"id":1751,"zipcode":6860,"city":"Ebly"},{"id":1752,"zipcode":6860,"city":"Mellier"},{"id":1753,"zipcode":6860,"city":"Witry"},{"id":1754,"zipcode":6860,"city":"L\xe9glise"},{"id":1755,"zipcode":6870,"city":"Arville"},{"id":1756,"zipcode":6870,"city":"Awenne"},{"id":1757,"zipcode":6870,"city":"Hatrival"},{"id":1758,"zipcode":6870,"city":"Mirwart"},{"id":1759,"zipcode":6870,"city":"Vesqueville"},{"id":1760,"zipcode":6870,"city":"Saint-Hubert"},{"id":1761,"zipcode":6880,"city":"Auby-sur-Semois"},{"id":1762,"zipcode":6880,"city":"Cugnon"},{"id":1763,"zipcode":6880,"city":"Jehonville"},{"id":1764,"zipcode":6880,"city":"Orgeo"},{"id":1765,"zipcode":6880,"city":"Bertrix"},{"id":1766,"zipcode":6887,"city":"Saint-M\xe9dard"},{"id":1767,"zipcode":6887,"city":"Straimont"},{"id":1768,"zipcode":6887,"city":"Herbeumont"},{"id":1769,"zipcode":6890,"city":"Anloy"},{"id":1770,"zipcode":6890,"city":"Ochamps"},{"id":1771,"zipcode":6890,"city":"Redu"},{"id":1772,"zipcode":6890,"city":"Smuid"},{"id":1773,"zipcode":6890,"city":"Transinne"},{"id":1774,"zipcode":6890,"city":"Villance"},{"id":1775,"zipcode":6890,"city":"Libin"},{"id":1776,"zipcode":6900,"city":"Aye"},{"id":1777,"zipcode":6900,"city":"Hargimont"},{"id":1778,"zipcode":6900,"city":"Humain"},{"id":1779,"zipcode":6900,"city":"On"},{"id":1780,"zipcode":6900,"city":"Roy"},{"id":1781,"zipcode":6900,"city":"Waha"},{"id":1782,"zipcode":6900,"city":"Marche-en-Famenne"},{"id":1783,"zipcode":6920,"city":"Sohier"},{"id":1784,"zipcode":6920,"city":"Wellin"},{"id":1785,"zipcode":6921,"city":"Chanly"},{"id":1786,"zipcode":6922,"city":"Halma"},{"id":1787,"zipcode":6924,"city":"Lomprez"},{"id":1788,"zipcode":6927,"city":"Bure"},{"id":1789,"zipcode":6927,"city":"Grupont"},{"id":1790,"zipcode":6927,"city":"Resteigne"},{"id":1791,"zipcode":6927,"city":"Tellin"},{"id":1792,"zipcode":6929,"city":"Gembes"},{"id":1793,"zipcode":6929,"city":"Haut-Fays"},{"id":1794,"zipcode":6929,"city":"Porcheresse"},{"id":1795,"zipcode":6929,"city":"Daverdisse"},{"id":1796,"zipcode":6940,"city":"Barvaux-sur-Ourthe"},{"id":1797,"zipcode":6940,"city":"Grandhan"},{"id":1798,"zipcode":6940,"city":"Septon"},{"id":1799,"zipcode":6940,"city":"W\xe9ris"},{"id":1800,"zipcode":6940,"city":"Durbuy"},{"id":1801,"zipcode":6941,"city":"Bende"},{"id":1802,"zipcode":6941,"city":"Bomal-sur-Ourthe"},{"id":1803,"zipcode":6941,"city":"Borlon"},{"id":1804,"zipcode":6941,"city":"Heyd"},{"id":1805,"zipcode":6941,"city":"Izier"},{"id":1806,"zipcode":6941,"city":"Tohogne"},{"id":1807,"zipcode":6941,"city":"Villers-Sainte-Gertrude"},{"id":1808,"zipcode":6950,"city":"Harsin"},{"id":1809,"zipcode":6950,"city":"Nassogne"},{"id":1810,"zipcode":6951,"city":"Bande"},{"id":1811,"zipcode":6952,"city":"Grune"},{"id":1812,"zipcode":6953,"city":"Ambly"},{"id":1813,"zipcode":6953,"city":"Forri\xe8res"},{"id":1814,"zipcode":6953,"city":"Lesterny"},{"id":1815,"zipcode":6953,"city":"Masbourg"},{"id":1816,"zipcode":6960,"city":"Dochamps"},{"id":1817,"zipcode":6960,"city":"Grandm\xe9nil"},{"id":1818,"zipcode":6960,"city":"Harre"},{"id":1819,"zipcode":6960,"city":"Malempr\xe9"},{"id":1820,"zipcode":6960,"city":"Odeigne"},{"id":1821,"zipcode":6960,"city":"Vaux-Chavanne"},{"id":1822,"zipcode":6970,"city":"Tenneville"},{"id":1823,"zipcode":6971,"city":"Champlon"},{"id":1824,"zipcode":6972,"city":"Erneuville"},{"id":1825,"zipcode":6980,"city":"Beausaint"},{"id":1826,"zipcode":6980,"city":"La Roche-en-Ardenne"},{"id":1827,"zipcode":6982,"city":"Samr\xe9e"},{"id":1828,"zipcode":6983,"city":"Ortho"},{"id":1829,"zipcode":6984,"city":"Hives"},{"id":1830,"zipcode":6986,"city":"Halleux"},{"id":1831,"zipcode":6987,"city":"Beffe"},{"id":1832,"zipcode":6987,"city":"Hodister"},{"id":1833,"zipcode":6987,"city":"Marcourt"},{"id":1834,"zipcode":6987,"city":"Rendeux"},{"id":1835,"zipcode":6990,"city":"Fronville"},{"id":1836,"zipcode":6990,"city":"Hampteau"},{"id":1837,"zipcode":6990,"city":"Marenne"},{"id":1838,"zipcode":6990,"city":"Hotton"},{"id":1839,"zipcode":6997,"city":"Amonines"},{"id":1840,"zipcode":6997,"city":"Mormont"},{"id":1841,"zipcode":6997,"city":"Soy"},{"id":1842,"zipcode":6997,"city":"Erez\xe9e"},{"id":1843,"zipcode":7000,"city":"Mons"},{"id":1844,"zipcode":7011,"city":"Ghlin"},{"id":1845,"zipcode":7012,"city":"Fl\xe9nu"},{"id":1846,"zipcode":7012,"city":"Jemappes"},{"id":1847,"zipcode":7020,"city":"Maisi\xe8res"},{"id":1848,"zipcode":7020,"city":"Nimy"},{"id":1849,"zipcode":7021,"city":"Havr\xe9"},{"id":1850,"zipcode":7022,"city":"Harmignies"},{"id":1851,"zipcode":7022,"city":"Harveng"},{"id":1852,"zipcode":7022,"city":"Hyon"},{"id":1853,"zipcode":7022,"city":"Mesvin"},{"id":1854,"zipcode":7022,"city":"Nouvelles"},{"id":1855,"zipcode":7024,"city":"Ciply"},{"id":1856,"zipcode":7030,"city":"Saint-Symphorien"},{"id":1857,"zipcode":7031,"city":"Villers-Saint-Ghislain"},{"id":1858,"zipcode":7032,"city":"Spiennes"},{"id":1859,"zipcode":7033,"city":"Cuesmes"},{"id":1860,"zipcode":7034,"city":"Obourg"},{"id":1861,"zipcode":7034,"city":"Saint-Denis"},{"id":1862,"zipcode":7040,"city":"Asquillies"},{"id":1863,"zipcode":7040,"city":"Aulnois"},{"id":1864,"zipcode":7040,"city":"Blaregnies"},{"id":1865,"zipcode":7040,"city":"Bougnies"},{"id":1866,"zipcode":7040,"city":"Genly"},{"id":1867,"zipcode":7040,"city":"Goegnies-Chauss\xe9e"},{"id":1868,"zipcode":7040,"city":"Qu\xe9vy-le-Grand"},{"id":1869,"zipcode":7040,"city":"Qu\xe9vy-le-Petit"},{"id":1870,"zipcode":7041,"city":"Givry"},{"id":1871,"zipcode":7041,"city":"Havay"},{"id":1872,"zipcode":7050,"city":"Erbaut"},{"id":1873,"zipcode":7050,"city":"Erbisoeul"},{"id":1874,"zipcode":7050,"city":"Herchies"},{"id":1875,"zipcode":7050,"city":"Masnuy-Saint-Jean"},{"id":1876,"zipcode":7050,"city":"Masnuy-Saint-Pierre"},{"id":1877,"zipcode":7050,"city":"Jurbise"},{"id":1878,"zipcode":7060,"city":"Horrues"},{"id":1879,"zipcode":7060,"city":"Soignies"},{"id":1880,"zipcode":7061,"city":"Casteau"},{"id":1881,"zipcode":7061,"city":"Thieusies"},{"id":1882,"zipcode":7062,"city":"Naast"},{"id":1883,"zipcode":7063,"city":"Chauss\xe9e-Notre-Dame-Louvignies"},{"id":1884,"zipcode":7063,"city":"Neufvilles"},{"id":1885,"zipcode":7070,"city":"Gottignies"},{"id":1886,"zipcode":7070,"city":"Mignault"},{"id":1887,"zipcode":7070,"city":"Thieu"},{"id":1888,"zipcode":7070,"city":"Ville-sur-Haine"},{"id":1889,"zipcode":7070,"city":"Le Roeulx"},{"id":1890,"zipcode":7080,"city":"Eugies"},{"id":1891,"zipcode":7080,"city":"La Bouverie"},{"id":1892,"zipcode":7080,"city":"Noirchain"},{"id":1893,"zipcode":7080,"city":"Sars-la-Bruy\xe8re"},{"id":1894,"zipcode":7080,"city":"Frameries"},{"id":1895,"zipcode":7090,"city":"Hennuy\xe8res"},{"id":1896,"zipcode":7090,"city":"Henripont"},{"id":1897,"zipcode":7090,"city":"Petit-R\x9culx-lez-Braine"},{"id":1898,"zipcode":7090,"city":"Ronqui\xe8res"},{"id":1899,"zipcode":7090,"city":"Steenkerque"},{"id":1900,"zipcode":7090,"city":"Braine-le-Comte"},{"id":1901,"zipcode":7100,"city":"Haine-Saint-Paul"},{"id":1902,"zipcode":7100,"city":"Haine-Saint-Pierre"},{"id":1903,"zipcode":7100,"city":"Saint-Vaast"},{"id":1904,"zipcode":7100,"city":"Trivi\xe8res"},{"id":1905,"zipcode":7100,"city":"La Louvi\xe8re"},{"id":1906,"zipcode":7110,"city":"Boussoit"},{"id":1907,"zipcode":7110,"city":"Houdeng-Aimeries"},{"id":1908,"zipcode":7110,"city":"Houdeng-Goegnies"},{"id":1909,"zipcode":7110,"city":"Maurage"},{"id":1910,"zipcode":7110,"city":"Str\xe9py-Bracquegnies"},{"id":1911,"zipcode":7120,"city":"Croix-lez-Rouveroy"},{"id":1912,"zipcode":7120,"city":"Estinnes-au-Mont"},{"id":1913,"zipcode":7120,"city":"Estinnes-au-Val"},{"id":1914,"zipcode":7120,"city":"Fauroeulx"},{"id":1915,"zipcode":7120,"city":"Haulchin"},{"id":1916,"zipcode":7120,"city":"Peissant"},{"id":1917,"zipcode":7120,"city":"Rouveroy"},{"id":1918,"zipcode":7120,"city":"Vellereille-les-Brayeux"},{"id":1919,"zipcode":7120,"city":"Vellereille-le-Sec"},{"id":1920,"zipcode":7130,"city":"Battignies"},{"id":1921,"zipcode":7130,"city":"Bray"},{"id":1922,"zipcode":7130,"city":"Binche"},{"id":1923,"zipcode":7131,"city":"Waudrez"},{"id":1924,"zipcode":7133,"city":"Buvrinnes"},{"id":1925,"zipcode":7134,"city":"Epinois"},{"id":1926,"zipcode":7134,"city":"Leval-Trahegnies"},{"id":1927,"zipcode":7134,"city":"P\xe9ronnes-lez-Binche"},{"id":1928,"zipcode":7134,"city":"Ressaix"},{"id":1929,"zipcode":7140,"city":"Morlanwelz-Mariemont"},{"id":1930,"zipcode":7141,"city":"Carni\xe8res"},{"id":1931,"zipcode":7141,"city":"Mont-Sainte-Aldegonde"},{"id":1932,"zipcode":7160,"city":"Godarville"},{"id":1933,"zipcode":7160,"city":"Pi\xe9ton"},{"id":1934,"zipcode":7160,"city":"Chapelle-lez-Herlaimont"},{"id":1935,"zipcode":7170,"city":"Bellecourt"},{"id":1936,"zipcode":7170,"city":"Bois-d\'Haine"},{"id":1937,"zipcode":7170,"city":"Fayt-lez-Manage"},{"id":1938,"zipcode":7170,"city":"La Hestre"},{"id":1939,"zipcode":7170,"city":"Manage"},{"id":1940,"zipcode":7180,"city":"Seneffe"},{"id":1941,"zipcode":7181,"city":"Arquennes"},{"id":1942,"zipcode":7181,"city":"Familleureux"},{"id":1943,"zipcode":7181,"city":"Feluy"},{"id":1944,"zipcode":7181,"city":"Petit-R\x9culx-lez-Nivelles"},{"id":1945,"zipcode":7190,"city":"\xc9caussinnes-d\'Enghien"},{"id":1946,"zipcode":7190,"city":"Marche-lez-\xc9caussinnes"},{"id":1947,"zipcode":7191,"city":"Ecaussinnes-Lalaing"},{"id":1948,"zipcode":7300,"city":"Boussu"},{"id":1949,"zipcode":7301,"city":"Hornu"},{"id":1950,"zipcode":7320,"city":"Bernissart"},{"id":1951,"zipcode":7321,"city":"Blaton"},{"id":1952,"zipcode":7321,"city":"Harchies"},{"id":1953,"zipcode":7322,"city":"Pommeroeul"},{"id":1954,"zipcode":7322,"city":"Ville-Pommeroeul"},{"id":1955,"zipcode":7330,"city":"Saint-Ghislain"},{"id":1956,"zipcode":7331,"city":"Baudour"},{"id":1957,"zipcode":7332,"city":"Neufmaison"},{"id":1958,"zipcode":7332,"city":"Sirault"},{"id":1959,"zipcode":7333,"city":"Tertre"},{"id":1960,"zipcode":7334,"city":"Hautrage"},{"id":1961,"zipcode":7334,"city":"Villerot"},{"id":1962,"zipcode":7340,"city":"P\xe2turages"},{"id":1963,"zipcode":7340,"city":"Warquignies"},{"id":1964,"zipcode":7340,"city":"Wasmes"},{"id":1965,"zipcode":7340,"city":"Colfontaine"},{"id":1966,"zipcode":7350,"city":"Hainin"},{"id":1967,"zipcode":7350,"city":"Montr\x9cul-sur-Haine"},{"id":1968,"zipcode":7350,"city":"Thulin"},{"id":1969,"zipcode":7350,"city":"Hensies"},{"id":1970,"zipcode":7370,"city":"Blaugies"},{"id":1971,"zipcode":7370,"city":"Elouges"},{"id":1972,"zipcode":7370,"city":"Wih\xe9ries"},{"id":1973,"zipcode":7370,"city":"Dour"},{"id":1974,"zipcode":7380,"city":"Baisieux"},{"id":1975,"zipcode":7380,"city":"Qui\xe9vrain"},{"id":1976,"zipcode":7382,"city":"Audregnies"},{"id":1977,"zipcode":7387,"city":"Angre"},{"id":1978,"zipcode":7387,"city":"Angreau"},{"id":1979,"zipcode":7387,"city":"Athis"},{"id":1980,"zipcode":7387,"city":"Autreppe"},{"id":1981,"zipcode":7387,"city":"Erquennes"},{"id":1982,"zipcode":7387,"city":"Fayt-le-Franc"},{"id":1983,"zipcode":7387,"city":"Marchipont"},{"id":1984,"zipcode":7387,"city":"Montignies-sur-Roc"},{"id":1985,"zipcode":7387,"city":"Onnezies"},{"id":1986,"zipcode":7387,"city":"Roisin"},{"id":1987,"zipcode":7390,"city":"Wasmuel"},{"id":1988,"zipcode":7390,"city":"Quaregnon"},{"id":1989,"zipcode":7500,"city":"Ere"},{"id":1990,"zipcode":7500,"city":"Saint-Maur"},{"id":1991,"zipcode":7500,"city":"Tournai"},{"id":1992,"zipcode":7501,"city":"Orcq"},{"id":1993,"zipcode":7502,"city":"Esplechin"},{"id":1994,"zipcode":7503,"city":"Froyennes"},{"id":1995,"zipcode":7504,"city":"Froidmont"},{"id":1996,"zipcode":7506,"city":"Willemeau"},{"id":1997,"zipcode":7520,"city":"Ramegnies-Chin"},{"id":1998,"zipcode":7520,"city":"Templeuve"},{"id":1999,"zipcode":7521,"city":"Chercq"},{"id":2000,"zipcode":7522,"city":"Blandain"},{"id":2001,"zipcode":7522,"city":"Hertain"},{"id":2002,"zipcode":7522,"city":"Lamain"},{"id":2003,"zipcode":7522,"city":"Marquain"},{"id":2004,"zipcode":7530,"city":"Gaurain-Ramecroix"},{"id":2005,"zipcode":7531,"city":"Havinnes"},{"id":2006,"zipcode":7532,"city":"B\xe9clers"},{"id":2007,"zipcode":7533,"city":"Thimougies"},{"id":2008,"zipcode":7534,"city":"Barry"},{"id":2009,"zipcode":7534,"city":"Maulde"},{"id":2010,"zipcode":7536,"city":"Vaulx"},{"id":2011,"zipcode":7538,"city":"Vezon"},{"id":2012,"zipcode":7540,"city":"Kain"},{"id":2013,"zipcode":7540,"city":"Melles"},{"id":2014,"zipcode":7540,"city":"Quartes"},{"id":2015,"zipcode":7540,"city":"Rumillies"},{"id":2016,"zipcode":7542,"city":"Mont-Saint-Aubert"},{"id":2017,"zipcode":7543,"city":"Mourcourt"},{"id":2018,"zipcode":7548,"city":"Warchin"},{"id":2019,"zipcode":7600,"city":"P\xe9ruwelz"},{"id":2020,"zipcode":7601,"city":"Roucourt"},{"id":2021,"zipcode":7602,"city":"Bury"},{"id":2022,"zipcode":7603,"city":"Bon-Secours"},{"id":2023,"zipcode":7604,"city":"Baugnies"},{"id":2024,"zipcode":7604,"city":"Braffe"},{"id":2025,"zipcode":7604,"city":"Brasm\xe9nil"},{"id":2026,"zipcode":7604,"city":"Callenelle"},{"id":2027,"zipcode":7604,"city":"Wasmes-Audemez-Briffoeil"},{"id":2028,"zipcode":7608,"city":"Wiers"},{"id":2029,"zipcode":7610,"city":"Rumes"},{"id":2030,"zipcode":7611,"city":"La Glanerie"},{"id":2031,"zipcode":7618,"city":"Taintignies"},{"id":2032,"zipcode":7620,"city":"Bl\xe9haries"},{"id":2033,"zipcode":7620,"city":"Guignies"},{"id":2034,"zipcode":7620,"city":"Hollain"},{"id":2035,"zipcode":7620,"city":"Jollain-Merlin"},{"id":2036,"zipcode":7620,"city":"Wez-Velvain"},{"id":2037,"zipcode":7621,"city":"Lesdain"},{"id":2038,"zipcode":7622,"city":"Laplaigne"},{"id":2039,"zipcode":7623,"city":"Rongy"},{"id":2040,"zipcode":7624,"city":"Howardries"},{"id":2041,"zipcode":7640,"city":"Maubray"},{"id":2042,"zipcode":7640,"city":"P\xe9ronnes-lez-Antoing"},{"id":2043,"zipcode":7640,"city":"Antoing"},{"id":2044,"zipcode":7641,"city":"Bruyelle"},{"id":2045,"zipcode":7642,"city":"Calonne"},{"id":2046,"zipcode":7643,"city":"Fontenoy"},{"id":2047,"zipcode":7700,"city":"Luingne"},{"id":2048,"zipcode":7700,"city":"Moeskroen"},{"id":2049,"zipcode":7711,"city":"Dottenijs"},{"id":2050,"zipcode":7712,"city":"Herseaux"},{"id":2051,"zipcode":7730,"city":"Bailleul"},{"id":2052,"zipcode":7730,"city":"Estaimbourg"},{"id":2053,"zipcode":7730,"city":"Evregnies"},{"id":2054,"zipcode":7730,"city":"Leers-Nord"},{"id":2055,"zipcode":7730,"city":"N\xe9chin"},{"id":2056,"zipcode":7730,"city":"Saint-L\xe9ger"},{"id":2057,"zipcode":7730,"city":"Estaimpuis"},{"id":2058,"zipcode":7740,"city":"Warcoing"},{"id":2059,"zipcode":7740,"city":"Pecq"},{"id":2060,"zipcode":7742,"city":"H\xe9rinnes-lez-Pecq"},{"id":2061,"zipcode":7743,"city":"Esquelmes"},{"id":2062,"zipcode":7743,"city":"Obigies"},{"id":2063,"zipcode":7750,"city":"Amougies"},{"id":2064,"zipcode":7750,"city":"Anseroeul"},{"id":2065,"zipcode":7750,"city":"Orroir"},{"id":2066,"zipcode":7750,"city":"Russeignies"},{"id":2067,"zipcode":7760,"city":"Escanaffles"},{"id":2068,"zipcode":7760,"city":"Molenbaix"},{"id":2069,"zipcode":7760,"city":"Popuelles"},{"id":2070,"zipcode":7760,"city":"Pottes"},{"id":2071,"zipcode":7760,"city":"Velaines"},{"id":2072,"zipcode":7760,"city":"Celles"},{"id":2073,"zipcode":7780,"city":"Komen"},{"id":2074,"zipcode":7780,"city":"Komen-Waasten"},{"id":2075,"zipcode":7781,"city":"Houthem"},{"id":2076,"zipcode":7782,"city":"Ploegsteert"},{"id":2077,"zipcode":7783,"city":"Bizet"},{"id":2078,"zipcode":7784,"city":"Neerwaasten"},{"id":2079,"zipcode":7784,"city":"Waasten"},{"id":2080,"zipcode":7800,"city":"Lanquesaint"},{"id":2081,"zipcode":7800,"city":"Ath"},{"id":2082,"zipcode":7801,"city":"Irchonwelz"},{"id":2083,"zipcode":7802,"city":"Ormeignies"},{"id":2084,"zipcode":7803,"city":"Bouvignies"},{"id":2085,"zipcode":7804,"city":"Ostiches"},{"id":2086,"zipcode":7804,"city":"Rebaix"},{"id":2087,"zipcode":7810,"city":"Maffle"},{"id":2088,"zipcode":7811,"city":"Arbre"},{"id":2089,"zipcode":7812,"city":"Houtaing"},{"id":2090,"zipcode":7812,"city":"Ligne"},{"id":2091,"zipcode":7812,"city":"Mainvault"},{"id":2092,"zipcode":7812,"city":"Moulbaix"},{"id":2093,"zipcode":7812,"city":"Villers-Notre-Dame"},{"id":2094,"zipcode":7812,"city":"Villers-Saint-Amand"},{"id":2095,"zipcode":7822,"city":"Ghislenghien"},{"id":2096,"zipcode":7822,"city":"Isi\xe8res"},{"id":2097,"zipcode":7822,"city":"Meslin-l\'\xc9v\xeaque"},{"id":2098,"zipcode":7823,"city":"Gibecq"},{"id":2099,"zipcode":7830,"city":"Bassilly"},{"id":2100,"zipcode":7830,"city":"Fouleng"},{"id":2101,"zipcode":7830,"city":"Gondregnies"},{"id":2102,"zipcode":7830,"city":"Graty"},{"id":2103,"zipcode":7830,"city":"Hellebecq"},{"id":2104,"zipcode":7830,"city":"Hoves"},{"id":2105,"zipcode":7830,"city":"Thoricourt"},{"id":2106,"zipcode":7830,"city":"Silly"},{"id":2107,"zipcode":7850,"city":"Lettelingen"},{"id":2108,"zipcode":7850,"city":"Mark"},{"id":2109,"zipcode":7850,"city":"Edingen"},{"id":2110,"zipcode":7860,"city":"Lessines"},{"id":2111,"zipcode":7861,"city":"Papignies"},{"id":2112,"zipcode":7861,"city":"Wannebecq"},{"id":2113,"zipcode":7862,"city":"Ogy"},{"id":2114,"zipcode":7863,"city":"Ghoy"},{"id":2115,"zipcode":7864,"city":"Deux-Acren"},{"id":2116,"zipcode":7866,"city":"Bois-de-Lessines"},{"id":2117,"zipcode":7866,"city":"Ollignies"},{"id":2118,"zipcode":7870,"city":"Bauffe"},{"id":2119,"zipcode":7870,"city":"Cambron-Saint-Vincent"},{"id":2120,"zipcode":7870,"city":"Lombise"},{"id":2121,"zipcode":7870,"city":"Montignies-lez-Lens"},{"id":2122,"zipcode":7870,"city":"Lens"},{"id":2123,"zipcode":7880,"city":"Vloesberg"},{"id":2124,"zipcode":7890,"city":"Lahamaide"},{"id":2125,"zipcode":7890,"city":"Wodecq"},{"id":2126,"zipcode":7890,"city":"Ellezelles"},{"id":2127,"zipcode":7900,"city":"Grandmetz"},{"id":2128,"zipcode":7900,"city":"Leuze-en-Hainaut"},{"id":2129,"zipcode":7901,"city":"Thieulain"},{"id":2130,"zipcode":7903,"city":"Blicquy"},{"id":2131,"zipcode":7903,"city":"Chapelle-\xe0-Oie"},{"id":2132,"zipcode":7903,"city":"Chapelle-\xe0-Wattines"},{"id":2133,"zipcode":7904,"city":"Pipaix"},{"id":2134,"zipcode":7904,"city":"Tourpes"},{"id":2135,"zipcode":7904,"city":"Willaupuis"},{"id":2136,"zipcode":7906,"city":"Gallaix"},{"id":2137,"zipcode":7910,"city":"Anvaing"},{"id":2138,"zipcode":7910,"city":"Arc-Aini\xe8res"},{"id":2139,"zipcode":7910,"city":"Arc-Wattripont"},{"id":2140,"zipcode":7910,"city":"Cordes"},{"id":2141,"zipcode":7910,"city":"Ellignies-lez-Frasnes"},{"id":2142,"zipcode":7910,"city":"Forest"},{"id":2143,"zipcode":7910,"city":"Wattripont"},{"id":2144,"zipcode":7911,"city":"Buissenal"},{"id":2145,"zipcode":7911,"city":"Frasnes-lez-Buissenal"},{"id":2146,"zipcode":7911,"city":"Hacquegnies"},{"id":2147,"zipcode":7911,"city":"Herquegies"},{"id":2148,"zipcode":7911,"city":"Montr\x9cul-au-Bois"},{"id":2149,"zipcode":7911,"city":"Moustier"},{"id":2150,"zipcode":7911,"city":"Oeudeghien"},{"id":2151,"zipcode":7912,"city":"Dergneau"},{"id":2152,"zipcode":7912,"city":"Saint-Sauveur"},{"id":2153,"zipcode":7940,"city":"Cambron-Casteau"},{"id":2154,"zipcode":7940,"city":"Brugelette"},{"id":2155,"zipcode":7941,"city":"Attre"},{"id":2156,"zipcode":7942,"city":"M\xe9vergnies-lez-Lens"},{"id":2157,"zipcode":7943,"city":"Gages"},{"id":2158,"zipcode":7950,"city":"Grosage"},{"id":2159,"zipcode":7950,"city":"Huissignies"},{"id":2160,"zipcode":7950,"city":"Ladeuze"},{"id":2161,"zipcode":7950,"city":"Tongre-Saint-Martin"},{"id":2162,"zipcode":7950,"city":"Chi\xe8vres"},{"id":2163,"zipcode":7951,"city":"Tongre-Notre-Dame"},{"id":2164,"zipcode":7970,"city":"Beloeil"},{"id":2165,"zipcode":7971,"city":"Bas\xe8cles"},{"id":2166,"zipcode":7971,"city":"Ramegnies"},{"id":2167,"zipcode":7971,"city":"Thumaide"},{"id":2168,"zipcode":7971,"city":"Wadelincourt"},{"id":2169,"zipcode":7972,"city":"Aubechies"},{"id":2170,"zipcode":7972,"city":"Ellignies-Sainte-Anne"},{"id":2171,"zipcode":7972,"city":"Quevaucamps"},{"id":2172,"zipcode":7973,"city":"Grandglise"},{"id":2173,"zipcode":7973,"city":"Stambruges"},{"id":2174,"zipcode":8000,"city":"Koolkerke"},{"id":2175,"zipcode":8000,"city":"Brugge"},{"id":2176,"zipcode":8020,"city":"Hertsberge"},{"id":2177,"zipcode":8020,"city":"Ruddervoorde"},{"id":2178,"zipcode":8020,"city":"Waardamme"},{"id":2179,"zipcode":8020,"city":"Oostkamp"},{"id":2180,"zipcode":8200,"city":"Sint-Andries"},{"id":2181,"zipcode":8200,"city":"Sint-Michiels"},{"id":2182,"zipcode":8210,"city":"Loppem"},{"id":2183,"zipcode":8210,"city":"Veldegem"},{"id":2184,"zipcode":8210,"city":"Zedelgem"},{"id":2185,"zipcode":8211,"city":"Aartrijke"},{"id":2186,"zipcode":8300,"city":"Knokke"},{"id":2187,"zipcode":8300,"city":"Westkapelle"},{"id":2188,"zipcode":8301,"city":"Heist-aan-Zee"},{"id":2189,"zipcode":8301,"city":"Ramskapelle"},{"id":2190,"zipcode":8310,"city":"Assebroek"},{"id":2191,"zipcode":8310,"city":"Sint-Kruis"},{"id":2192,"zipcode":8340,"city":"Hoeke"},{"id":2193,"zipcode":8340,"city":"Lapscheure"},{"id":2194,"zipcode":8340,"city":"Moerkerke"},{"id":2195,"zipcode":8340,"city":"Oostkerke"},{"id":2196,"zipcode":8340,"city":"Sijsele"},{"id":2197,"zipcode":8340,"city":"Damme"},{"id":2198,"zipcode":8370,"city":"Uitkerke"},{"id":2199,"zipcode":8370,"city":"Blankenberge"},{"id":2200,"zipcode":8377,"city":"Houtave"},{"id":2201,"zipcode":8377,"city":"Meetkerke"},{"id":2202,"zipcode":8377,"city":"Nieuwmunster"},{"id":2203,"zipcode":8377,"city":"Zuienkerke"},{"id":2204,"zipcode":8380,"city":"Dudzele"},{"id":2205,"zipcode":8380,"city":"Lissewege"},{"id":2206,"zipcode":8380,"city":"Zeebrugge"},{"id":2207,"zipcode":8400,"city":"Stene"},{"id":2208,"zipcode":8400,"city":"Zandvoorde"},{"id":2209,"zipcode":8400,"city":"Oostende"},{"id":2210,"zipcode":8420,"city":"Klemskerke"},{"id":2211,"zipcode":8420,"city":"Wenduine"},{"id":2212,"zipcode":8420,"city":"De Haan"},{"id":2213,"zipcode":8421,"city":"Vlissegem"},{"id":2214,"zipcode":8430,"city":"Middelkerke"},{"id":2215,"zipcode":8431,"city":"Wilskerke"},{"id":2216,"zipcode":8432,"city":"Leffinge"},{"id":2217,"zipcode":8433,"city":"Mannekensvere"},{"id":2218,"zipcode":8433,"city":"Schore"},{"id":2219,"zipcode":8433,"city":"Sint-Pieters-Kapelle"},{"id":2220,"zipcode":8433,"city":"Slijpe"},{"id":2221,"zipcode":8434,"city":"Lombardsijde"},{"id":2222,"zipcode":8434,"city":"Westende"},{"id":2223,"zipcode":8450,"city":"Bredene"},{"id":2224,"zipcode":8460,"city":"Ettelgem"},{"id":2225,"zipcode":8460,"city":"Roksem"},{"id":2226,"zipcode":8460,"city":"Westkerke"},{"id":2227,"zipcode":8460,"city":"Oudenburg"},{"id":2228,"zipcode":8470,"city":"Moere"},{"id":2229,"zipcode":8470,"city":"Snaaskerke"},{"id":2230,"zipcode":8470,"city":"Zevekote"},{"id":2231,"zipcode":8470,"city":"Gistel"},{"id":2232,"zipcode":8480,"city":"Bekegem"},{"id":2233,"zipcode":8480,"city":"Eernegem"},{"id":2234,"zipcode":8480,"city":"Ichtegem"},{"id":2235,"zipcode":8490,"city":"Snellegem"},{"id":2236,"zipcode":8490,"city":"Stalhille"},{"id":2237,"zipcode":8490,"city":"Varsenare"},{"id":2238,"zipcode":8490,"city":"Zerkegem"},{"id":2239,"zipcode":8490,"city":"Jabbeke"},{"id":2240,"zipcode":8500,"city":"Kortrijk"},{"id":2241,"zipcode":8501,"city":"Bissegem"},{"id":2242,"zipcode":8501,"city":"Heule"},{"id":2243,"zipcode":8510,"city":"Bellegem"},{"id":2244,"zipcode":8510,"city":"Kooigem"},{"id":2245,"zipcode":8510,"city":"Marke"},{"id":2246,"zipcode":8510,"city":"Rollegem"},{"id":2247,"zipcode":8511,"city":"Aalbeke"},{"id":2248,"zipcode":8520,"city":"Kuurne"},{"id":2249,"zipcode":8530,"city":"Harelbeke"},{"id":2250,"zipcode":8531,"city":"Bavikhove"},{"id":2251,"zipcode":8531,"city":"Hulste"},{"id":2252,"zipcode":8540,"city":"Deerlijk"},{"id":2253,"zipcode":8550,"city":"Zwevegem"},{"id":2254,"zipcode":8551,"city":"Heestert"},{"id":2255,"zipcode":8552,"city":"Moen"},{"id":2256,"zipcode":8553,"city":"Otegem"},{"id":2257,"zipcode":8554,"city":"Sint-Denijs"},{"id":2258,"zipcode":8560,"city":"Gullegem"},{"id":2259,"zipcode":8560,"city":"Moorsele"},{"id":2260,"zipcode":8560,"city":"Wevelgem"},{"id":2261,"zipcode":8570,"city":"Gijzelbrechtegem"},{"id":2262,"zipcode":8570,"city":"Ingooigem"},{"id":2263,"zipcode":8570,"city":"Vichte"},{"id":2264,"zipcode":8570,"city":"Anzegem"},{"id":2265,"zipcode":8572,"city":"Kaster"},{"id":2266,"zipcode":8573,"city":"Tiegem"},{"id":2267,"zipcode":8580,"city":"Avelgem"},{"id":2268,"zipcode":8581,"city":"Kerkhove"},{"id":2269,"zipcode":8581,"city":"Waarmaarde"},{"id":2270,"zipcode":8582,"city":"Outrijve"},{"id":2271,"zipcode":8583,"city":"Bossuit"},{"id":2272,"zipcode":8587,"city":"Helkijn"},{"id":2273,"zipcode":8587,"city":"Spiere"},{"id":2274,"zipcode":8600,"city":"Beerst"},{"id":2275,"zipcode":8600,"city":"Driekapellen"},{"id":2276,"zipcode":8600,"city":"Esen"},{"id":2277,"zipcode":8600,"city":"Kaaskerke"},{"id":2278,"zipcode":8600,"city":"Keiem"},{"id":2279,"zipcode":8600,"city":"Lampernisse"},{"id":2280,"zipcode":8600,"city":"Leke"},{"id":2281,"zipcode":8600,"city":"Nieuwkapelle"},{"id":2282,"zipcode":8600,"city":"Oostkerke"},{"id":2283,"zipcode":8600,"city":"Oudekapelle"},{"id":2284,"zipcode":8600,"city":"Pervijze"},{"id":2285,"zipcode":8600,"city":"Sint-Jacobs-Kapelle"},{"id":2286,"zipcode":8600,"city":"Stuivekenskerke"},{"id":2287,"zipcode":8600,"city":"Vladslo"},{"id":2288,"zipcode":8600,"city":"Woumen"},{"id":2289,"zipcode":8600,"city":"Diksmuide"},{"id":2290,"zipcode":8610,"city":"Handzame"},{"id":2291,"zipcode":8610,"city":"Werken"},{"id":2292,"zipcode":8610,"city":"Zarren"},{"id":2293,"zipcode":8610,"city":"Kortemark"},{"id":2294,"zipcode":8620,"city":"Ramskapelle"},{"id":2295,"zipcode":8620,"city":"Sint-Joris"},{"id":2296,"zipcode":8620,"city":"Nieuwpoort"},{"id":2297,"zipcode":8630,"city":"Avekapelle"},{"id":2298,"zipcode":8630,"city":"Booitshoeke"},{"id":2299,"zipcode":8630,"city":"Bulskamp"},{"id":2300,"zipcode":8630,"city":"De Moeren"},{"id":2301,"zipcode":8630,"city":"Eggewaartskapelle"},{"id":2302,"zipcode":8630,"city":"Houtem"},{"id":2303,"zipcode":8630,"city":"Steenkerke"},{"id":2304,"zipcode":8630,"city":"Vinkem"},{"id":2305,"zipcode":8630,"city":"Wulveringem"},{"id":2306,"zipcode":8630,"city":"Zoutenaaie"},{"id":2307,"zipcode":8630,"city":"Veurne"},{"id":2308,"zipcode":8640,"city":"Oostvleteren"},{"id":2309,"zipcode":8640,"city":"Westvleteren"},{"id":2310,"zipcode":8640,"city":"Woesten"},{"id":2311,"zipcode":8647,"city":"Lo"},{"id":2312,"zipcode":8647,"city":"Noordschote"},{"id":2313,"zipcode":8647,"city":"Pollinkhove"},{"id":2314,"zipcode":8647,"city":"Reninge"},{"id":2315,"zipcode":8650,"city":"Klerken"},{"id":2316,"zipcode":8650,"city":"Merkem"},{"id":2317,"zipcode":8650,"city":"Houthulst"},{"id":2318,"zipcode":8660,"city":"Adinkerke"},{"id":2319,"zipcode":8660,"city":"De Panne"},{"id":2320,"zipcode":8670,"city":"Oostduinkerke"},{"id":2321,"zipcode":8670,"city":"Wulpen"},{"id":2322,"zipcode":8670,"city":"Koksijde"},{"id":2323,"zipcode":8680,"city":"Bovekerke"},{"id":2324,"zipcode":8680,"city":"Zande"},{"id":2325,"zipcode":8680,"city":"Koekelare"},{"id":2326,"zipcode":8690,"city":"Hoogstade"},{"id":2327,"zipcode":8690,"city":"Oeren"},{"id":2328,"zipcode":8690,"city":"Sint-Rijkers"},{"id":2329,"zipcode":8690,"city":"Alveringem"},{"id":2330,"zipcode":8691,"city":"Beveren-aan-de-IJzer"},{"id":2331,"zipcode":8691,"city":"Gijverinkhove"},{"id":2332,"zipcode":8691,"city":"Izenberge"},{"id":2333,"zipcode":8691,"city":"Leisele"},{"id":2334,"zipcode":8691,"city":"Stavele"},{"id":2335,"zipcode":8700,"city":"Aarsele"},{"id":2336,"zipcode":8700,"city":"Kanegem"},{"id":2337,"zipcode":8700,"city":"Schuiferskapelle"},{"id":2338,"zipcode":8700,"city":"Tielt"},{"id":2339,"zipcode":8710,"city":"Ooigem"},{"id":2340,"zipcode":8710,"city":"Sint-Baafs-Vijve"},{"id":2341,"zipcode":8710,"city":"Wielsbeke"},{"id":2342,"zipcode":8720,"city":"Markegem"},{"id":2343,"zipcode":8720,"city":"Oeselgem"},{"id":2344,"zipcode":8720,"city":"Wakken"},{"id":2345,"zipcode":8720,"city":"Dentergem"},{"id":2346,"zipcode":8730,"city":"Oedelem"},{"id":2347,"zipcode":8730,"city":"Sint-Joris"},{"id":2348,"zipcode":8730,"city":"Beernem"},{"id":2349,"zipcode":8740,"city":"Egem"},{"id":2350,"zipcode":8740,"city":"Pittem"},{"id":2351,"zipcode":8750,"city":"Zwevezele"},{"id":2352,"zipcode":8750,"city":"Wingene"},{"id":2353,"zipcode":8755,"city":"Ruiselede"},{"id":2354,"zipcode":8760,"city":"Meulebeke"},{"id":2355,"zipcode":8770,"city":"Ingelmunster"},{"id":2356,"zipcode":8780,"city":"Oostrozebeke"},{"id":2357,"zipcode":8790,"city":"Waregem"},{"id":2358,"zipcode":8791,"city":"Beveren"},{"id":2359,"zipcode":8792,"city":"Desselgem"},{"id":2360,"zipcode":8793,"city":"Sint-Eloois-Vijve"},{"id":2361,"zipcode":8800,"city":"Beveren"},{"id":2362,"zipcode":8800,"city":"Oekene"},{"id":2363,"zipcode":8800,"city":"Rumbeke"},{"id":2364,"zipcode":8800,"city":"Roeselare"},{"id":2365,"zipcode":8810,"city":"Lichtervelde"},{"id":2366,"zipcode":8820,"city":"Torhout"},{"id":2367,"zipcode":8830,"city":"Gits"},{"id":2368,"zipcode":8830,"city":"Hooglede"},{"id":2369,"zipcode":8840,"city":"Oostnieuwkerke"},{"id":2370,"zipcode":8840,"city":"Westrozebeke"},{"id":2371,"zipcode":8840,"city":"Staden"},{"id":2372,"zipcode":8850,"city":"Ardooie"},{"id":2373,"zipcode":8851,"city":"Koolskamp"},{"id":2374,"zipcode":8860,"city":"Lendelede"},{"id":2375,"zipcode":8870,"city":"Emelgem"},{"id":2376,"zipcode":8870,"city":"Kachtem"},{"id":2377,"zipcode":8870,"city":"Izegem"},{"id":2378,"zipcode":8880,"city":"Rollegem-Kapelle"},{"id":2379,"zipcode":8880,"city":"Sint-Eloois-Winkel"},{"id":2380,"zipcode":8880,"city":"Ledegem"},{"id":2381,"zipcode":8890,"city":"Dadizele"},{"id":2382,"zipcode":8890,"city":"Moorslede"},{"id":2383,"zipcode":8900,"city":"Brielen"},{"id":2384,"zipcode":8900,"city":"Dikkebus"},{"id":2385,"zipcode":8900,"city":"Sint-Jan"},{"id":2386,"zipcode":8900,"city":"Ieper"},{"id":2387,"zipcode":8902,"city":"Hollebeke"},{"id":2388,"zipcode":8902,"city":"Voormezele"},{"id":2389,"zipcode":8902,"city":"Zillebeke"},{"id":2390,"zipcode":8904,"city":"Boezinge"},{"id":2391,"zipcode":8904,"city":"Zuidschote"},{"id":2392,"zipcode":8906,"city":"Elverdinge"},{"id":2393,"zipcode":8908,"city":"Vlamertinge"},{"id":2394,"zipcode":8920,"city":"Bikschote"},{"id":2395,"zipcode":8920,"city":"Langemark"},{"id":2396,"zipcode":8920,"city":"Poelkapelle"},{"id":2397,"zipcode":8930,"city":"Lauwe"},{"id":2398,"zipcode":8930,"city":"Rekkem"},{"id":2399,"zipcode":8930,"city":"Menen"},{"id":2400,"zipcode":8940,"city":"Geluwe"},{"id":2401,"zipcode":8940,"city":"Wervik"},{"id":2402,"zipcode":8950,"city":"Nieuwkerke"},{"id":2403,"zipcode":8951,"city":"Dranouter"},{"id":2404,"zipcode":8952,"city":"Wulvergem"},{"id":2405,"zipcode":8953,"city":"Wijtschate"},{"id":2406,"zipcode":8954,"city":"Westouter"},{"id":2407,"zipcode":8956,"city":"Kemmel"},{"id":2408,"zipcode":8957,"city":"Mesen"},{"id":2409,"zipcode":8958,"city":"Loker"},{"id":2410,"zipcode":8970,"city":"Reningelst"},{"id":2411,"zipcode":8970,"city":"Poperinge"},{"id":2412,"zipcode":8972,"city":"Krombeke"},{"id":2413,"zipcode":8972,"city":"Proven"},{"id":2414,"zipcode":8972,"city":"Roesbrugge-Haringe"},{"id":2415,"zipcode":8978,"city":"Watou"},{"id":2416,"zipcode":8980,"city":"Beselare"},{"id":2417,"zipcode":8980,"city":"Geluveld"},{"id":2418,"zipcode":8980,"city":"Passendale"},{"id":2419,"zipcode":8980,"city":"Zandvoorde"},{"id":2420,"zipcode":8980,"city":"Zonnebeke"},{"id":2421,"zipcode":9000,"city":"Gent"},{"id":2422,"zipcode":9030,"city":"Mariakerke"},{"id":2423,"zipcode":9031,"city":"Drongen"},{"id":2424,"zipcode":9032,"city":"Wondelgem"},{"id":2425,"zipcode":9040,"city":"Sint-Amandsberg"},{"id":2426,"zipcode":9041,"city":"Oostakker"},{"id":2427,"zipcode":9042,"city":"Desteldonk"},{"id":2428,"zipcode":9042,"city":"Mendonk"},{"id":2429,"zipcode":9042,"city":"Sint-Kruis-Winkel"},{"id":2430,"zipcode":9050,"city":"Gentbrugge"},{"id":2431,"zipcode":9050,"city":"Ledeberg"},{"id":2432,"zipcode":9051,"city":"Afsnee"},{"id":2433,"zipcode":9051,"city":"Sint-Denijs-Westrem"},{"id":2434,"zipcode":9052,"city":"Zwijnaarde"},{"id":2435,"zipcode":9060,"city":"Zelzate"},{"id":2436,"zipcode":9070,"city":"Heusden"},{"id":2437,"zipcode":9070,"city":"Destelbergen"},{"id":2438,"zipcode":9080,"city":"Beervelde"},{"id":2439,"zipcode":9080,"city":"Zaffelare"},{"id":2440,"zipcode":9080,"city":"Zeveneken"},{"id":2441,"zipcode":9080,"city":"Lochristi"},{"id":2442,"zipcode":9090,"city":"Gontrode"},{"id":2443,"zipcode":9090,"city":"Melle"},{"id":2444,"zipcode":9100,"city":"Nieuwkerken-Waas"},{"id":2445,"zipcode":9100,"city":"Sint-Niklaas"},{"id":2446,"zipcode":9111,"city":"Belsele"},{"id":2447,"zipcode":9112,"city":"Sinaai-Waas"},{"id":2448,"zipcode":9120,"city":"Beveren-Waas"},{"id":2449,"zipcode":9120,"city":"Haasdonk"},{"id":2450,"zipcode":9120,"city":"Kallo"},{"id":2451,"zipcode":9120,"city":"Melsele"},{"id":2452,"zipcode":9120,"city":"Vrasene"},{"id":2453,"zipcode":9130,"city":"Doel"},{"id":2454,"zipcode":9130,"city":"Kallo"},{"id":2455,"zipcode":9130,"city":"Kieldrecht"},{"id":2456,"zipcode":9130,"city":"Verrebroek"},{"id":2457,"zipcode":9140,"city":"Elversele"},{"id":2458,"zipcode":9140,"city":"Steendorp"},{"id":2459,"zipcode":9140,"city":"Tielrode"},{"id":2460,"zipcode":9140,"city":"Temse"},{"id":2461,"zipcode":9150,"city":"Bazel"},{"id":2462,"zipcode":9150,"city":"Kruibeke"},{"id":2463,"zipcode":9150,"city":"Rupelmonde"},{"id":2464,"zipcode":9160,"city":"Daknam"},{"id":2465,"zipcode":9160,"city":"Eksaarde"},{"id":2466,"zipcode":9160,"city":"Lokeren"},{"id":2467,"zipcode":9170,"city":"De Klinge"},{"id":2468,"zipcode":9170,"city":"Meerdonk"},{"id":2469,"zipcode":9170,"city":"Sint-Pauwels"},{"id":2470,"zipcode":9170,"city":"Sint-Gillis-Waas"},{"id":2471,"zipcode":9180,"city":"Moerbeke-Waas"},{"id":2472,"zipcode":9185,"city":"Wachtebeke"},{"id":2473,"zipcode":9190,"city":"Kemzeke"},{"id":2474,"zipcode":9190,"city":"Stekene"},{"id":2475,"zipcode":9200,"city":"Appels"},{"id":2476,"zipcode":9200,"city":"Baasrode"},{"id":2477,"zipcode":9200,"city":"Grembergen"},{"id":2478,"zipcode":9200,"city":"Mespelare"},{"id":2479,"zipcode":9200,"city":"Oudegem"},{"id":2480,"zipcode":9200,"city":"Schoonaarde"},{"id":2481,"zipcode":9200,"city":"Sint-Gillis-Dendermonde"},{"id":2482,"zipcode":9200,"city":"Dendermonde"},{"id":2483,"zipcode":9220,"city":"Moerzeke"},{"id":2484,"zipcode":9220,"city":"Hamme"},{"id":2485,"zipcode":9230,"city":"Massemen"},{"id":2486,"zipcode":9230,"city":"Westrem"},{"id":2487,"zipcode":9230,"city":"Wetteren"},{"id":2488,"zipcode":9240,"city":"Zele"},{"id":2489,"zipcode":9250,"city":"Waasmunster"},{"id":2490,"zipcode":9255,"city":"Opdorp"},{"id":2491,"zipcode":9255,"city":"Buggenhout"},{"id":2492,"zipcode":9260,"city":"Schellebelle"},{"id":2493,"zipcode":9260,"city":"Serskamp"},{"id":2494,"zipcode":9260,"city":"Wichelen"},{"id":2495,"zipcode":9270,"city":"Kalken"},{"id":2496,"zipcode":9270,"city":"Laarne"},{"id":2497,"zipcode":9280,"city":"Denderbelle"},{"id":2498,"zipcode":9280,"city":"Wieze"},{"id":2499,"zipcode":9280,"city":"Lebbeke"},{"id":2500,"zipcode":9290,"city":"Overmere"},{"id":2501,"zipcode":9290,"city":"Uitbergen"},{"id":2502,"zipcode":9290,"city":"Berlare"},{"id":2503,"zipcode":9300,"city":"Aalst"},{"id":2504,"zipcode":9308,"city":"Gijzegem"},{"id":2505,"zipcode":9308,"city":"Hofstade"},{"id":2506,"zipcode":9310,"city":"Baardegem"},{"id":2507,"zipcode":9310,"city":"Herdersem"},{"id":2508,"zipcode":9310,"city":"Meldert"},{"id":2509,"zipcode":9310,"city":"Moorsel"},{"id":2510,"zipcode":9320,"city":"Erembodegem"},{"id":2511,"zipcode":9320,"city":"Nieuwerkerken"},{"id":2512,"zipcode":9340,"city":"Impe"},{"id":2513,"zipcode":9340,"city":"Oordegem"},{"id":2514,"zipcode":9340,"city":"Smetlede"},{"id":2515,"zipcode":9340,"city":"Wanzele"},{"id":2516,"zipcode":9340,"city":"Lede"},{"id":2517,"zipcode":9400,"city":"Appelterre-Eichem"},{"id":2518,"zipcode":9400,"city":"Denderwindeke"},{"id":2519,"zipcode":9400,"city":"Lieferinge"},{"id":2520,"zipcode":9400,"city":"Nederhasselt"},{"id":2521,"zipcode":9400,"city":"Okegem"},{"id":2522,"zipcode":9400,"city":"Voorde"},{"id":2523,"zipcode":9400,"city":"Ninove"},{"id":2524,"zipcode":9401,"city":"Pollare"},{"id":2525,"zipcode":9402,"city":"Meerbeke"},{"id":2526,"zipcode":9403,"city":"Neigem"},{"id":2527,"zipcode":9404,"city":"Aspelare"},{"id":2528,"zipcode":9406,"city":"Outer"},{"id":2529,"zipcode":9420,"city":"Aaigem"},{"id":2530,"zipcode":9420,"city":"Bambrugge"},{"id":2531,"zipcode":9420,"city":"Burst"},{"id":2532,"zipcode":9420,"city":"Erondegem"},{"id":2533,"zipcode":9420,"city":"Erpe"},{"id":2534,"zipcode":9420,"city":"Mere"},{"id":2535,"zipcode":9420,"city":"Ottergem"},{"id":2536,"zipcode":9420,"city":"Vlekkem"},{"id":2537,"zipcode":9450,"city":"Denderhoutem"},{"id":2538,"zipcode":9450,"city":"Heldergem"},{"id":2539,"zipcode":9450,"city":"Haaltert"},{"id":2540,"zipcode":9451,"city":"Kerksken"},{"id":2541,"zipcode":9470,"city":"Denderleeuw"},{"id":2542,"zipcode":9472,"city":"iddergem"},{"id":2543,"zipcode":9473,"city":"Welle"},{"id":2544,"zipcode":9500,"city":"Goeferdinge"},{"id":2545,"zipcode":9500,"city":"Moerbeke"},{"id":2546,"zipcode":9500,"city":"Nederboelare"},{"id":2547,"zipcode":9500,"city":"Onkerzele"},{"id":2548,"zipcode":9500,"city":"Ophasselt"},{"id":2549,"zipcode":9500,"city":"Overboelare"},{"id":2550,"zipcode":9500,"city":"Viane"},{"id":2551,"zipcode":9500,"city":"Zarlardinge"},{"id":2552,"zipcode":9500,"city":"Geraardsbergen"},{"id":2553,"zipcode":9506,"city":"Grimminge"},{"id":2554,"zipcode":9506,"city":"idegem"},{"id":2555,"zipcode":9506,"city":"Nieuwenhove"},{"id":2556,"zipcode":9506,"city":"Schendelbeke"},{"id":2557,"zipcode":9506,"city":"Smeerebbe-Vloerzegem"},{"id":2558,"zipcode":9506,"city":"Waarbeke"},{"id":2559,"zipcode":9506,"city":"Zandbergen"},{"id":2560,"zipcode":9520,"city":"Bavegem"},{"id":2561,"zipcode":9520,"city":"Oombergen"},{"id":2562,"zipcode":9520,"city":"Vlierzele"},{"id":2563,"zipcode":9520,"city":"Zonnegem"},{"id":2564,"zipcode":9520,"city":"Sint-Lievens-Houtem"},{"id":2565,"zipcode":9521,"city":"Letterhoutem"},{"id":2566,"zipcode":9550,"city":"Hillegem"},{"id":2567,"zipcode":9550,"city":"Sint-Antelinks"},{"id":2568,"zipcode":9550,"city":"Sint-Lievens-Esse"},{"id":2569,"zipcode":9550,"city":"Steenhuize-Wijnhuize"},{"id":2570,"zipcode":9550,"city":"Woubrechtegem"},{"id":2571,"zipcode":9550,"city":"Herzele"},{"id":2572,"zipcode":9551,"city":"Ressegem"},{"id":2573,"zipcode":9552,"city":"Borsbeke"},{"id":2574,"zipcode":9570,"city":"Deftinge"},{"id":2575,"zipcode":9570,"city":"Sint-Maria-Lierde"},{"id":2576,"zipcode":9571,"city":"Hemelveerdegem"},{"id":2577,"zipcode":9572,"city":"Sint-Martens-Lierde"},{"id":2578,"zipcode":9600,"city":"Ronse"},{"id":2579,"zipcode":9620,"city":"Elene"},{"id":2580,"zipcode":9620,"city":"Erwetegem"},{"id":2581,"zipcode":9620,"city":"Godveerdegem"},{"id":2582,"zipcode":9620,"city":"Grotenberge"},{"id":2583,"zipcode":9620,"city":"Leeuwergem"},{"id":2584,"zipcode":9620,"city":"Oombergen"},{"id":2585,"zipcode":9620,"city":"Sint-Goriks-Oudenhove"},{"id":2586,"zipcode":9620,"city":"Sint-Maria-Oudenhove"},{"id":2587,"zipcode":9620,"city":"Strijpen"},{"id":2588,"zipcode":9620,"city":"Velzeke-Ruddershove"},{"id":2589,"zipcode":9620,"city":"Zottegem"},{"id":2590,"zipcode":9630,"city":"Beerlegem"},{"id":2591,"zipcode":9630,"city":"Dikkele"},{"id":2592,"zipcode":9630,"city":"Hundelgem"},{"id":2593,"zipcode":9630,"city":"Meilegem"},{"id":2594,"zipcode":9630,"city":"Munkzwalm"},{"id":2595,"zipcode":9630,"city":"Paulatem"},{"id":2596,"zipcode":9630,"city":"Roborst"},{"id":2597,"zipcode":9630,"city":"Rozebeke"},{"id":2598,"zipcode":9630,"city":"Sint-Blasius-Boekel"},{"id":2599,"zipcode":9630,"city":"Sint-Denijs-Boekel"},{"id":2600,"zipcode":9630,"city":"Sint-Maria-Latem"},{"id":2601,"zipcode":9636,"city":"Nederzwalm-Hermelgem"},{"id":2602,"zipcode":9660,"city":"Elst"},{"id":2603,"zipcode":9660,"city":"Everbeek"},{"id":2604,"zipcode":9660,"city":"Michelbeke"},{"id":2605,"zipcode":9660,"city":"Nederbrakel"},{"id":2606,"zipcode":9660,"city":"Opbrakel"},{"id":2607,"zipcode":9660,"city":"Sint-Maria-Oudenhove"},{"id":2608,"zipcode":9660,"city":"Zegelsem"},{"id":2609,"zipcode":9660,"city":"Brakel"},{"id":2610,"zipcode":9661,"city":"Parike"},{"id":2611,"zipcode":9667,"city":"Sint-Kornelis-Horebeke"},{"id":2612,"zipcode":9667,"city":"Sint-Maria-Horebeke"},{"id":2613,"zipcode":9680,"city":"Etikhove"},{"id":2614,"zipcode":9680,"city":"Maarke-Kerkem"},{"id":2615,"zipcode":9681,"city":"Nukerke"},{"id":2616,"zipcode":9688,"city":"Schorisse"},{"id":2617,"zipcode":9690,"city":"Berchem"},{"id":2618,"zipcode":9690,"city":"Kwaremont"},{"id":2619,"zipcode":9690,"city":"Ruien"},{"id":2620,"zipcode":9690,"city":"Zulzeke"},{"id":2621,"zipcode":9700,"city":"Bevere"},{"id":2622,"zipcode":9700,"city":"Edelare"},{"id":2623,"zipcode":9700,"city":"Eine"},{"id":2624,"zipcode":9700,"city":"Ename"},{"id":2625,"zipcode":9700,"city":"Heurne"},{"id":2626,"zipcode":9700,"city":"Leupegem"},{"id":2627,"zipcode":9700,"city":"Mater"},{"id":2628,"zipcode":9700,"city":"Melden"},{"id":2629,"zipcode":9700,"city":"Mullem"},{"id":2630,"zipcode":9700,"city":"Nederename"},{"id":2631,"zipcode":9700,"city":"Ooike"},{"id":2632,"zipcode":9700,"city":"Volkegem"},{"id":2633,"zipcode":9700,"city":"Welden"},{"id":2634,"zipcode":9700,"city":"Oudenaarde"},{"id":2635,"zipcode":9750,"city":"Huise"},{"id":2636,"zipcode":9750,"city":"Ouwegem"},{"id":2637,"zipcode":9750,"city":"Zingem"},{"id":2638,"zipcode":9770,"city":"Kruishoutem"},{"id":2639,"zipcode":9771,"city":"Nokere"},{"id":2640,"zipcode":9772,"city":"Wannegem-Lede"},{"id":2641,"zipcode":9790,"city":"Elsegem"},{"id":2642,"zipcode":9790,"city":"Moregem"},{"id":2643,"zipcode":9790,"city":"Ooike"},{"id":2644,"zipcode":9790,"city":"Petegem-aan-de-Schelde"},{"id":2645,"zipcode":9790,"city":"Wortegem"},{"id":2646,"zipcode":9800,"city":"Astene"},{"id":2647,"zipcode":9800,"city":"Bachte-Maria-Leerne"},{"id":2648,"zipcode":9800,"city":"Gottem"},{"id":2649,"zipcode":9800,"city":"Grammene"},{"id":2650,"zipcode":9800,"city":"Meigem"},{"id":2651,"zipcode":9800,"city":"Petegem-aan-de-Leie"},{"id":2652,"zipcode":9800,"city":"Sint-Martens-Leerne"},{"id":2653,"zipcode":9800,"city":"Vinkt"},{"id":2654,"zipcode":9800,"city":"Wontergem"},{"id":2655,"zipcode":9800,"city":"Zeveren"},{"id":2656,"zipcode":9800,"city":"Deinze"},{"id":2657,"zipcode":9810,"city":"Eke"},{"id":2658,"zipcode":9810,"city":"Nazareth"},{"id":2659,"zipcode":9820,"city":"Bottelare"},{"id":2660,"zipcode":9820,"city":"Lemberge"},{"id":2661,"zipcode":9820,"city":"Melsen"},{"id":2662,"zipcode":9820,"city":"Merelbeke"},{"id":2663,"zipcode":9820,"city":"Munte"},{"id":2664,"zipcode":9820,"city":"Schelderode"},{"id":2665,"zipcode":9830,"city":"Sint-Martens-Latem"},{"id":2666,"zipcode":9831,"city":"Deurle"},{"id":2667,"zipcode":9840,"city":"De Pinte"},{"id":2668,"zipcode":9840,"city":"Zevergem"},{"id":2669,"zipcode":9850,"city":"Hansbeke"},{"id":2670,"zipcode":9850,"city":"Landegem"},{"id":2671,"zipcode":9850,"city":"Merendree"},{"id":2672,"zipcode":9850,"city":"Nevele"},{"id":2673,"zipcode":9850,"city":"Poesele"},{"id":2674,"zipcode":9850,"city":"Vosselare"},{"id":2675,"zipcode":9860,"city":"Balegem"},{"id":2676,"zipcode":9860,"city":"Gijzenzele"},{"id":2677,"zipcode":9860,"city":"Landskouter"},{"id":2678,"zipcode":9860,"city":"Moortsele"},{"id":2679,"zipcode":9860,"city":"Scheldewindeke"},{"id":2680,"zipcode":9860,"city":"Oosterzele"},{"id":2681,"zipcode":9870,"city":"Machelen"},{"id":2682,"zipcode":9870,"city":"Olsene"},{"id":2683,"zipcode":9870,"city":"Zulte"},{"id":2684,"zipcode":9880,"city":"Lotenhulle"},{"id":2685,"zipcode":9880,"city":"Poeke"},{"id":2686,"zipcode":9880,"city":"Aalter"},{"id":2687,"zipcode":9881,"city":"Bellem"},{"id":2688,"zipcode":9890,"city":"Asper"},{"id":2689,"zipcode":9890,"city":"Baaigem"},{"id":2690,"zipcode":9890,"city":"Dikkelvenne"},{"id":2691,"zipcode":9890,"city":"Semmerzake"},{"id":2692,"zipcode":9890,"city":"Vurste"},{"id":2693,"zipcode":9890,"city":"Gavere"},{"id":2694,"zipcode":9900,"city":"Eeklo"},{"id":2695,"zipcode":9910,"city":"Knesselare"},{"id":2696,"zipcode":9910,"city":"Ursel"},{"id":2697,"zipcode":9920,"city":"Lovendegem"},{"id":2698,"zipcode":9921,"city":"Vinderhoute"},{"id":2699,"zipcode":9930,"city":"Zomergem"},{"id":2700,"zipcode":9931,"city":"Oostwinkel"},{"id":2701,"zipcode":9932,"city":"Ronsele"},{"id":2702,"zipcode":9940,"city":"Ertvelde"},{"id":2703,"zipcode":9940,"city":"Kluizen"},{"id":2704,"zipcode":9940,"city":"Sleidinge"},{"id":2705,"zipcode":9940,"city":"Evergem"},{"id":2706,"zipcode":9950,"city":"Waarschoot"},{"id":2707,"zipcode":9960,"city":"Assenede"},{"id":2708,"zipcode":9961,"city":"Boekhoute"},{"id":2709,"zipcode":9968,"city":"Bassevelde"},{"id":2710,"zipcode":9968,"city":"Oosteeklo"},{"id":2711,"zipcode":9970,"city":"Kaprijke"},{"id":2712,"zipcode":9971,"city":"Lembeke"},{"id":2713,"zipcode":9980,"city":"Sint-Laureins"},{"id":2714,"zipcode":9981,"city":"Sint-Margriete"},{"id":2715,"zipcode":9982,"city":"Sint-Jan-in-Eremo"},{"id":2716,"zipcode":9988,"city":"Waterland-Oudeman"},{"id":2717,"zipcode":9988,"city":"Watervliet"},{"id":2718,"zipcode":9990,"city":"Maldegem"},{"id":2719,"zipcode":9991,"city":"Adegem"},{"id":2720,"zipcode":9992,"city":"Middelburg"}]');


const $821366883944f074$var$selectors = {
    block: "[data-rp]",
    form: "[data-rp-form]",
    formInput: "[data-rp-form-input]",
    formList: "[data-rp-form-list]"
};
const $821366883944f074$var$renderResults = (list, results)=>{
    if (!results.length) return list.classList.remove("active");
    const resultNodes = results.map(({ zipcode: zipcode, city: city })=>`<span class="py-2 px-3 text-body-300 hover:text-heading transition-colors cursor-pointer">${zipcode} ${city}</span>`);
    list.classList.add("active");
    list.innerHTML = resultNodes.join("\n");
};
const $821366883944f074$var$handleSearchInput = (value, list)=>{
    let results = [];
    if (value.length >= 3) results = (0, (/*@__PURE__*/$parcel$interopDefault($2734edb455aab2eb$exports))).filter(({ zipcode: zipcode, city: city })=>zipcode.toString().startsWith(value) || city.toLowerCase().includes(value));
    $821366883944f074$var$renderResults(list, results);
};
const $821366883944f074$var$handleSearchOptionClick = (option, input, list)=>{
    input.value = option;
    list.classList.remove("active");
};
const $821366883944f074$var$initBlock = (block)=>{
    const form = block.querySelector($821366883944f074$var$selectors.form);
    const formInput = block.querySelector($821366883944f074$var$selectors.formInput);
    const formList = block.querySelector($821366883944f074$var$selectors.formList);
    form?.addEventListener("submit", (event)=>handleFormSubmit(event));
    formInput?.addEventListener("input", ({ target: { value: value } })=>$821366883944f074$var$handleSearchInput(value.toLowerCase(), formList));
    formList?.addEventListener("click", ({ target: { textContent: textContent } })=>$821366883944f074$var$handleSearchOptionClick(textContent, formInput, formList));
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($821366883944f074$var$selectors.block);
    blocks?.forEach($821366883944f074$var$initBlock);
}, {
    once: true
});


var $bdd15a79f3b80e35$exports = {};


/*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ const $f53fd9aa530d4ce2$export$844ec244b1367d54 = (t)=>"string" == typeof t;


/*! License details at fancyapps.com/license */ const $d85d37926b6a3a9e$export$8ee0fc9ee280b4ee = (n)=>n && null !== n && n instanceof Element && "nodeType" in n;


/*! License details at fancyapps.com/license */ const $86ffa1e8b3d1fbe0$export$2bb74740c4e19def = function(e) {
    if (!(e && e instanceof Element && e.offsetParent)) return !1;
    const n = e.scrollHeight > e.clientHeight, t = window.getComputedStyle(e).overflowY, o = -1 !== t.indexOf("hidden"), i = -1 !== t.indexOf("visible");
    return n && !o && !i;
}, $86ffa1e8b3d1fbe0$export$e41e80160bed5714 = function(t, o) {
    return !t || t === document.body || o && t === o ? null : $86ffa1e8b3d1fbe0$export$2bb74740c4e19def(t) ? t : $86ffa1e8b3d1fbe0$export$e41e80160bed5714(t.parentElement, o);
};


/*! License details at fancyapps.com/license */ const $d05c6dadc12263a9$export$b368690db5627d91 = function(e) {
    var t = (new DOMParser).parseFromString(e, "text/html").body;
    if (t.childElementCount > 1) {
        for(var n = document.createElement("div"); t.firstChild;)n.appendChild(t.firstChild);
        return n;
    }
    let r = t.firstChild;
    return !r || r instanceof HTMLElement ? r : ((n = document.createElement("div")).appendChild(r), n);
};


/*! License details at fancyapps.com/license */ const $e99c7d958570a616$export$7d15b64cf5a3a4c4 = function(t = 0, n = 0, a = 0) {
    return Math.max(Math.min(n, a), t);
};


/*! License details at fancyapps.com/license */ 
/*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ const $e2409a96f5c7a13e$export$53b83ca8eaab0383 = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t);


function $fac85a8a3e3ec516$var$e(e) {
    return (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(e) || Array.isArray(e);
}
function $fac85a8a3e3ec516$export$248d38f6296296c5(t, r) {
    const o = Object.keys(t), c = Object.keys(r);
    return o.length === c.length && o.every((o)=>{
        const c = t[o], i = r[o];
        return "function" == typeof c ? `${c}` == `${i}` : $fac85a8a3e3ec516$var$e(c) && $fac85a8a3e3ec516$var$e(i) ? $fac85a8a3e3ec516$export$248d38f6296296c5(c, i) : c === i;
    });
}


const $bb38fc976d943d50$var$e = function(n) {
    for (const t of $bb38fc976d943d50$var$s)t.getState() === $bb38fc976d943d50$export$7f967bab4408cae2.Running && t.tick($bb38fc976d943d50$var$a ? n - $bb38fc976d943d50$var$a : 0);
    $bb38fc976d943d50$var$a = n, $bb38fc976d943d50$var$u = window.requestAnimationFrame($bb38fc976d943d50$var$e);
};
var $bb38fc976d943d50$export$7f967bab4408cae2, $bb38fc976d943d50$var$o, $bb38fc976d943d50$export$b4fa0e08d7ac6a23;
!function(n) {
    n[n.Initializing = 0] = "Initializing", n[n.Running = 1] = "Running", n[n.Paused = 2] = "Paused", n[n.Completed = 3] = "Completed", n[n.Destroyed = 4] = "Destroyed";
}($bb38fc976d943d50$export$7f967bab4408cae2 || ($bb38fc976d943d50$export$7f967bab4408cae2 = {})), function(n) {
    n[n.Spring = 0] = "Spring", n[n.Ease = 1] = "Ease";
}($bb38fc976d943d50$var$o || ($bb38fc976d943d50$var$o = {})), function(n) {
    n[n.Loop = 0] = "Loop", n[n.Reverse = 1] = "Reverse";
}($bb38fc976d943d50$export$b4fa0e08d7ac6a23 || ($bb38fc976d943d50$export$b4fa0e08d7ac6a23 = {}));
const $bb38fc976d943d50$var$s = new Set;
let $bb38fc976d943d50$var$u = null, $bb38fc976d943d50$var$a = 0;
function $bb38fc976d943d50$export$208a41d6b4e37b97() {
    let a = $bb38fc976d943d50$export$7f967bab4408cae2.Initializing, f = $bb38fc976d943d50$var$o.Ease, l = 0, g = 0, p = $bb38fc976d943d50$export$208a41d6b4e37b97.Easings.Linear, m = 500, d = 0, b = 0, S = 0, h = 0, y = 1 / 0, E = .01, R = .01, M = !1, j = {}, w = null, v = {}, O = {}, C = {}, L = 0, I = 0, D = $bb38fc976d943d50$export$b4fa0e08d7ac6a23.Loop, z = $bb38fc976d943d50$export$208a41d6b4e37b97.Easings.Linear;
    const N = new Map;
    function V(n, ...t) {
        for (const e of N.get(n) || [])e(...t);
    }
    function q(n) {
        return g = 0, n ? w = setTimeout(()=>{
            x();
        }, n) : x(), F;
    }
    function x() {
        a = $bb38fc976d943d50$export$7f967bab4408cae2.Running, V("start", v, O);
    }
    function A() {
        if (a = $bb38fc976d943d50$export$7f967bab4408cae2.Completed, C = {}, V("end", v), a === $bb38fc976d943d50$export$7f967bab4408cae2.Completed) {
            if (l < L) {
                if (l++, D === $bb38fc976d943d50$export$b4fa0e08d7ac6a23.Reverse) {
                    const n = Object.assign({}, j);
                    j = Object.assign({}, O), O = n;
                }
                q(I);
            } else l = 0;
        }
        return F;
    }
    const F = {
        getState: function() {
            return a;
        },
        easing: function(n) {
            return p = n, f = $bb38fc976d943d50$var$o.Ease, C = {}, F;
        },
        duration: function(n) {
            return m = n, F;
        },
        spring: function(n = {}) {
            f = $bb38fc976d943d50$var$o.Spring;
            const t = {
                velocity: 0,
                mass: 1,
                tension: 170,
                friction: 26,
                restDelta: .1,
                restSpeed: .1,
                maxSpeed: 1 / 0,
                clamp: !0
            }, { velocity: e, mass: i, tension: r, friction: s, restDelta: u, restSpeed: a, maxSpeed: c, clamp: l } = Object.assign(Object.assign({}, t), n);
            return d = e, b = i, S = r, h = s, R = u, E = a, y = c, M = l, C = {}, F;
        },
        isRunning: function() {
            return a === $bb38fc976d943d50$export$7f967bab4408cae2.Running;
        },
        isSpring: function() {
            return f === $bb38fc976d943d50$var$o.Spring;
        },
        from: function(n) {
            return v = Object.assign({}, n), F;
        },
        to: function(n) {
            return O = n, F;
        },
        repeat: function(n, t = 0, e = $bb38fc976d943d50$export$b4fa0e08d7ac6a23.Loop, i) {
            return L = n, I = t, D = e, z = i || p, F;
        },
        on: function(n, t) {
            var e, i;
            return e = n, i = t, N.set(e, [
                ...N.get(e) || [],
                i
            ]), F;
        },
        off: function(n, t) {
            var e, i;
            return e = n, i = t, N.has(e) && N.set(e, N.get(e).filter((n)=>n !== i)), F;
        },
        start: function(n) {
            return a = $bb38fc976d943d50$export$7f967bab4408cae2.Initializing, j = Object.assign({}, v), (0, $fac85a8a3e3ec516$export$248d38f6296296c5)(j, O) || ($bb38fc976d943d50$var$s.add(this), $bb38fc976d943d50$var$u || ($bb38fc976d943d50$var$u = window.requestAnimationFrame($bb38fc976d943d50$var$e)), q(n)), F;
        },
        pause: function() {
            return w && (clearTimeout(w), w = null), a === $bb38fc976d943d50$export$7f967bab4408cae2.Running && (a = $bb38fc976d943d50$export$7f967bab4408cae2.Paused, V("pause", v)), F;
        },
        end: A,
        tick: function(e) {
            e > 50 && (e = 50), g += e;
            let s = 0, u = !1;
            if (a !== $bb38fc976d943d50$export$7f967bab4408cae2.Running) return F;
            if (f === $bb38fc976d943d50$var$o.Ease) {
                s = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(0, g / m, 1), u = 1 === s;
                const t = D === $bb38fc976d943d50$export$b4fa0e08d7ac6a23.Reverse ? z : p;
                for(const n in v)v[n] = j[n] + (O[n] - j[n]) * t(s);
            }
            if (f === $bb38fc976d943d50$var$o.Spring) {
                const t = .001 * e;
                let i = 0;
                for(const e in v){
                    const o = O[e];
                    let r = v[e];
                    if ("number" != typeof o || isNaN(o) || "number" != typeof r || isNaN(r)) continue;
                    if (Math.abs(o - r) <= R) {
                        v[e] = o, C[e] = 0;
                        continue;
                    }
                    C[e] || ("object" == typeof d && "number" == typeof d[e] ? C[e] = d[e] : C[e] = "number" == typeof d ? d : 0);
                    let s = C[e];
                    s = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(-1 * Math.abs(y), s, Math.abs(y));
                    const u = s * b * h;
                    s += ((r > o ? -1 : 1) * (Math.abs(o - r) * S) - u) / b * t, r += s * t;
                    const a = v[e] > o ? r < o : r > o;
                    let c = Math.abs(s) < E && Math.abs(o - r) <= R;
                    M && a && (c = !0), c ? (r = o, s = 0) : i++, v[e] = r, C[e] = s;
                }
                u = !i;
            }
            const c = Object.assign({}, O);
            return V("step", v, j, O, s), u && a === $bb38fc976d943d50$export$7f967bab4408cae2.Running && (0, $fac85a8a3e3ec516$export$248d38f6296296c5)(O, c) && (a = $bb38fc976d943d50$export$7f967bab4408cae2.Completed, A()), F;
        },
        getStartValues: function() {
            return j;
        },
        getCurrentValues: function() {
            return v;
        },
        getCurrentVelocities: function() {
            return C;
        },
        getEndValues: function() {
            return O;
        },
        destroy: function() {
            a = $bb38fc976d943d50$export$7f967bab4408cae2.Destroyed, w && (clearTimeout(w), w = null), j = v = O = {}, $bb38fc976d943d50$var$s.delete(this);
        }
    };
    return F;
}
$bb38fc976d943d50$export$208a41d6b4e37b97.destroy = ()=>{
    for (const n of $bb38fc976d943d50$var$s)n.destroy();
    $bb38fc976d943d50$var$u && (cancelAnimationFrame($bb38fc976d943d50$var$u), $bb38fc976d943d50$var$u = null);
}, $bb38fc976d943d50$export$208a41d6b4e37b97.Easings = {
    Linear: function(n) {
        return n;
    },
    EaseIn: function(n) {
        return 0 === n ? 0 : Math.pow(2, 10 * n - 10);
    },
    EaseOut: function(n) {
        return 1 === n ? 1 : 1 - Math.pow(2, -10 * n);
    },
    EaseInOut: function(n) {
        return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? Math.pow(2, 20 * n - 10) / 2 : (2 - Math.pow(2, -20 * n + 10)) / 2;
    }
};


/*! License details at fancyapps.com/license */ function $cdb23866a53185e4$export$6385f9b89f59465f(e) {
    const t = [], n = "undefined" != typeof TouchEvent && e instanceof TouchEvent ? e.touches : e instanceof MouseEvent && "mouseup" !== e.type ? [
        e
    ] : [];
    for (const e of n)t.push({
        x: e.clientX,
        y: e.clientY,
        ts: Date.now()
    });
    return t;
}
function $cdb23866a53185e4$export$1ae15396032099be(e) {
    const t = [], n = "undefined" != typeof TouchEvent && e instanceof TouchEvent ? e.changedTouches : e instanceof MouseEvent ? [
        e
    ] : [];
    for (const e of n)t.push({
        x: e.clientX,
        y: e.clientY,
        ts: Date.now()
    });
    return t;
}
function $cdb23866a53185e4$export$b820caf342892892(e) {
    const t = e[0], n = e[1] || t;
    return {
        x: (t.x + n.x) / 2,
        y: (t.y + n.y) / 2,
        ts: n.ts
    };
}
function $cdb23866a53185e4$export$79376507b09a66f(e) {
    const t = e[0], n = e[1] || e[0];
    return t && n ? -1 * Math.sqrt((n.x - t.x) * (n.x - t.x) + (n.y - t.y) * (n.y - t.y)) : 0;
}
const $cdb23866a53185e4$var$s = (e)=>{
    e.cancelable && e.preventDefault();
}, $cdb23866a53185e4$var$i = {
    passive: !1
}, $cdb23866a53185e4$var$c = {
    panThreshold: 5,
    swipeThreshold: 3,
    ignore: [
        "textarea",
        "input",
        "select",
        "[contenteditable]",
        "[data-selectable]",
        "[data-draggable]"
    ]
};
let $cdb23866a53185e4$var$a = !1, $cdb23866a53185e4$var$r = !0;
const $cdb23866a53185e4$export$1f911e2d31b2843e = (u, l)=>{
    let d, f, h, v = Object.assign(Object.assign({}, $cdb23866a53185e4$var$c), l), p = [], m = [], E = [], g = !1, w = !1, y = !1, T = 0, b = 0, M = 0, x = 0, L = 0, P = 0, D = 0, X = 0, Y = 0, j = [], k = 0, R = 0;
    const z = new Map;
    function A(e) {
        const t = $cdb23866a53185e4$export$79376507b09a66f(m), n = $cdb23866a53185e4$export$79376507b09a66f(E), s = t && n ? t / n : 0, i = Math.abs(D) > Math.abs(X) ? D : X, c = {
            srcEvent: d,
            isPanRecognized: g,
            isSwipeRecognized: w,
            firstTouch: p,
            previousTouch: E,
            currentTouch: m,
            deltaX: M,
            deltaY: x,
            offsetX: L,
            offsetY: P,
            velocityX: D,
            velocityY: X,
            velocity: i,
            angle: Y,
            axis: h,
            scale: s,
            center: f
        };
        for (const t of z.get(e) || [])t(c);
    }
    function O(e) {
        const t = Date.now();
        j = j.filter((e)=>!e.ts || e.ts > t - 100), e && j.push(e);
    }
    function S() {
        if (D = 0, X = 0, j.length > 3) {
            const e = j[0], t = j[j.length - 1];
            if (e && t) {
                const n = t.x - e.x, o = t.y - e.y, s = e.ts && t.ts ? t.ts - e.ts : 0;
                s > 0 && (D = Math.abs(n) > 3 ? n / (s / 30) : 0, X = Math.abs(o) > 3 ? o / (s / 30) : 0);
            }
        }
    }
    function q(t) {
        if (t instanceof MouseEvent) {
            if ($cdb23866a53185e4$var$a) return;
        } else $cdb23866a53185e4$var$a = !0;
        const o = t.composedPath()[0], i = v.ignore.join(",");
        if (o.matches(i) || o.closest(i)) return;
        if ("undefined" != typeof MouseEvent && t instanceof MouseEvent && (!t.buttons || 0 !== t.button)) return;
        t instanceof MouseEvent && $cdb23866a53185e4$var$s(t);
        const c = Date.now(), r = c - (T || c);
        y = r > 0 && r <= 250, T = c, clearTimeout(k), d = t, t instanceof MouseEvent && (window.addEventListener("mousemove", C), window.addEventListener("mouseup", I)), window.addEventListener("blur", B), m = $cdb23866a53185e4$export$6385f9b89f59465f(t), p = [
            ...m
        ], E = [], b = m.length, f = $cdb23866a53185e4$export$b820caf342892892(m), 1 === b && (g = !1, w = !1), b && O($cdb23866a53185e4$export$b820caf342892892(m)), A("start");
    }
    function C(t) {
        var s;
        if (!p.length) return;
        if (t.defaultPrevented) return;
        d = t, E = [
            ...m
        ], m = $cdb23866a53185e4$export$6385f9b89f59465f(t), b = m.length, f = $cdb23866a53185e4$export$b820caf342892892(m);
        const i = f, c = $cdb23866a53185e4$export$b820caf342892892(E);
        if (M = i.x - c.x, x = i.y - c.y, O(i), S(), A("move"), m.length > 1) {
            const e = $cdb23866a53185e4$export$79376507b09a66f(m), t = $cdb23866a53185e4$export$79376507b09a66f(E);
            Math.abs(e - t) >= .1 && A("pinch");
        }
        if (!g && p.length) {
            const e = $cdb23866a53185e4$export$b820caf342892892(p);
            L = i.x - e.x, P = i.y - e.y, g = Math.abs(L) > v.panThreshold || Math.abs(P) > v.panThreshold, g && ($cdb23866a53185e4$var$r = !1, clearTimeout(R), R = 0, Y = Math.abs(180 * Math.atan2(P, L) / Math.PI), h = Y > 45 && Y < 135 ? "y" : "x", p = [
                ...m
            ], E = [
                ...m
            ], null === (s = window.getSelection()) || void 0 === s || s.removeAllRanges(), A("panstart"));
        }
        g && (M || x) && A("pan");
    }
    function I(o) {
        if (d = o, !p.length) return;
        const s = $cdb23866a53185e4$export$6385f9b89f59465f(o), i = $cdb23866a53185e4$export$1ae15396032099be(o);
        if (b = s.length, f = $cdb23866a53185e4$export$b820caf342892892(i), i.length && O($cdb23866a53185e4$export$b820caf342892892(i)), S(), E = [
            ...m
        ], m = [
            ...s
        ], p = [
            ...s
        ], s.length > 0) A("end"), g = !1, w = !1, j = [];
        else {
            const e = v.swipeThreshold;
            (Math.abs(D) > e || Math.abs(X) > e) && (w = !0), g && A("panend"), w && A("swipe"), g || w || (A("tap"), y ? A("doubleTap") : k = setTimeout(function() {
                A("singleTap");
            }, 250)), A("end"), F();
        }
    }
    function B() {
        clearTimeout(k), F(), g && A("panend"), A("end");
    }
    function F() {
        g = !1, w = !1, y = !1, b = 0, j = [], m = [], E = [], p = [], M = 0, x = 0, L = 0, P = 0, D = 0, X = 0, Y = 0, h = void 0, window.removeEventListener("mousemove", C), window.removeEventListener("mouseup", I), window.removeEventListener("blur", B), $cdb23866a53185e4$var$r || R || (R = setTimeout(()=>{
            $cdb23866a53185e4$var$r = !0, R = 0;
        }, 100));
    }
    function G(e) {
        const t = e.target;
        $cdb23866a53185e4$var$a = !1, t && !e.defaultPrevented && ($cdb23866a53185e4$var$r || ($cdb23866a53185e4$var$s(e), e.stopPropagation()));
    }
    const H = {
        init: function() {
            if (u) return u.addEventListener("click", G, $cdb23866a53185e4$var$i), u.addEventListener("mousedown", q, $cdb23866a53185e4$var$i), u.addEventListener("touchstart", q, $cdb23866a53185e4$var$i), u.addEventListener("touchmove", C, $cdb23866a53185e4$var$i), u.addEventListener("touchend", I), u.addEventListener("touchcancel", I), H;
        },
        on: function(e, t) {
            return function(e, t) {
                z.set(e, [
                    ...z.get(e) || [],
                    t
                ]);
            }(e, t), H;
        },
        off: function(e, t) {
            return z.has(e) && z.set(e, z.get(e).filter((e)=>e !== t)), H;
        },
        isPointerDown: ()=>b > 0,
        destroy: function() {
            clearTimeout(k), clearTimeout(R), R = 0, u && (u.removeEventListener("click", G, $cdb23866a53185e4$var$i), u.removeEventListener("mousedown", q, $cdb23866a53185e4$var$i), u.removeEventListener("touchstart", q, $cdb23866a53185e4$var$i), u.removeEventListener("touchmove", C, $cdb23866a53185e4$var$i), u.removeEventListener("touchend", I), u.removeEventListener("touchcancel", I)), u = null, F();
        }
    };
    return H;
};
$cdb23866a53185e4$export$1f911e2d31b2843e.isClickAllowed = ()=>$cdb23866a53185e4$var$r;


/*! License details at fancyapps.com/license */ const $f770271f96ecd80a$export$30568d076ec2f42 = {
    IMAGE_ERROR: "This image couldn't be loaded. <br /> Please try again later.",
    MOVE_UP: "Move up",
    MOVE_DOWN: "Move down",
    MOVE_LEFT: "Move left",
    MOVE_RIGHT: "Move right",
    ZOOM_IN: "Zoom in",
    ZOOM_OUT: "Zoom out",
    TOGGLE_FULL: "Toggle zoom level",
    TOGGLE_1TO1: "Toggle zoom level",
    ITERATE_ZOOM: "Toggle zoom level",
    ROTATE_CCW: "Rotate counterclockwise",
    ROTATE_CW: "Rotate clockwise",
    FLIP_X: "Flip horizontally",
    FLIP_Y: "Flip vertically",
    RESET: "Reset"
};


/*! License details at fancyapps.com/license */ const $956098cca6f71028$export$d2cf6cd1dc7067d3 = (s, t = "")=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.add(t);
    });
};


const $0d16c58404501d51$var$f = (e)=>{
    e.cancelable && e.preventDefault();
}, $0d16c58404501d51$var$d = (e, t = 1e4)=>(e = parseFloat(e + "") || 0, Math.round((e + Number.EPSILON) * t) / t);
var $0d16c58404501d51$export$9520bccbaf78266, $0d16c58404501d51$export$97fb49bddd4ef65d;
!function(e) {
    e.Reset = "reset", e.Zoom = "zoom", e.ZoomIn = "zoomIn", e.ZoomOut = "zoomOut", e.ZoomTo = "zoomTo", e.ToggleCover = "toggleCover", e.ToggleFull = "toggleFull", e.ToggleMax = "toggleMax", e.IterateZoom = "iterateZoom", e.Pan = "pan", e.Swipe = "swipe", e.Move = "move", e.MoveLeft = "moveLeft", e.MoveRight = "moveRight", e.MoveUp = "moveUp", e.MoveDown = "moveDown", e.RotateCCW = "rotateCCW", e.RotateCW = "rotateCW", e.FlipX = "flipX", e.FlipY = "flipY";
}($0d16c58404501d51$export$9520bccbaf78266 || ($0d16c58404501d51$export$9520bccbaf78266 = {})), function(e) {
    e.Cover = "cover", e.Full = "full", e.Max = "max";
}($0d16c58404501d51$export$97fb49bddd4ef65d || ($0d16c58404501d51$export$97fb49bddd4ef65d = {}));
const $0d16c58404501d51$export$15463f5204f2871f = {
    x: 0,
    y: 0,
    scale: 1,
    angle: 0,
    flipX: 1,
    flipY: 1
}, $0d16c58404501d51$var$p = {
    bounds: !0,
    classes: {
        container: "f-panzoom",
        wrapper: "f-panzoom__wrapper",
        content: "f-panzoom__content",
        viewport: "f-panzoom__viewport"
    },
    clickAction: $0d16c58404501d51$export$9520bccbaf78266.ToggleFull,
    dblClickAction: !1,
    gestures: {},
    height: "auto",
    l10n: (0, $f770271f96ecd80a$export$30568d076ec2f42),
    maxScale: 4,
    minScale: 1,
    mouseMoveFactor: 1,
    panMode: "drag",
    protected: !1,
    singleClickAction: !1,
    spinnerTpl: '<div class="f-spinner"></div>',
    wheelAction: $0d16c58404501d51$export$9520bccbaf78266.Zoom,
    width: "auto"
};
let $0d16c58404501d51$var$v, $0d16c58404501d51$var$b = 0, $0d16c58404501d51$var$y = 0, $0d16c58404501d51$var$x = 0;
const $0d16c58404501d51$export$b704d075ddd20210 = (c, h = {}, w = {})=>{
    let M, E, T, k, L, j, O, A = 0, C = Object.assign(Object.assign({}, $0d16c58404501d51$var$p), h), S = {}, F = Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), Z = Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f);
    const X = [];
    function Y(e) {
        let t = C[e];
        return t && "function" == typeof t ? t(de) : t;
    }
    const P = new Map;
    function I(e, ...t) {
        const n = P.get(e) || [];
        C.on && n.push(C.on[e]);
        for (const e of n)e && e instanceof Function && e(de, ...t);
        "*" !== e && I("*", e, ...t);
    }
    function R(e) {
        if (3 !== A) return;
        const t = e.target;
        if ((0, $86ffa1e8b3d1fbe0$export$e41e80160bed5714)(t)) return;
        const i = Date.now(), a = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(e, t) {
            return Math.abs(t) > Math.abs(e) ? t : e;
        }), s = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(-1, a, 1);
        I("wheel", e, s);
        const l = Y("wheelAction");
        if (!l) return;
        if (e.defaultPrevented) return;
        const r = Z.scale;
        let c = r * (s > 0 ? 1.5 : .5);
        if (l === $0d16c58404501d51$export$9520bccbaf78266.Zoom) {
            const t = Math.abs(e.deltaY) < 100 && Math.abs(e.deltaX) < 100;
            if (i - $0d16c58404501d51$var$y < (t ? 200 : 45)) return void $0d16c58404501d51$var$f(e);
            $0d16c58404501d51$var$y = i;
            const n = N(), a = J();
            if ($0d16c58404501d51$var$d(c) < $0d16c58404501d51$var$d(n) && $0d16c58404501d51$var$d(r) <= $0d16c58404501d51$var$d(n) ? ($0d16c58404501d51$var$x += Math.abs(s), c = n) : $0d16c58404501d51$var$d(c) > $0d16c58404501d51$var$d(a) && $0d16c58404501d51$var$d(r) >= $0d16c58404501d51$var$d(a) ? ($0d16c58404501d51$var$x += Math.abs(s), c = a) : ($0d16c58404501d51$var$x = 0, c = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(n, c, a)), $0d16c58404501d51$var$x > 7) return;
        }
        switch($0d16c58404501d51$var$f(e), l){
            case $0d16c58404501d51$export$9520bccbaf78266.Pan:
                te(l, {
                    srcEvent: e,
                    deltaX: 2 * -e.deltaX,
                    deltaY: 2 * -e.deltaY
                });
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.Zoom:
                te($0d16c58404501d51$export$9520bccbaf78266.ZoomTo, {
                    srcEvent: e,
                    scale: c,
                    center: {
                        x: e.clientX,
                        y: e.clientY
                    }
                });
                break;
            default:
                te(l, {
                    srcEvent: e
                });
        }
    }
    function z(e) {
        var n, i;
        const o = e.composedPath()[0];
        if (!(0, $cdb23866a53185e4$export$1f911e2d31b2843e).isClickAllowed()) return;
        if (!(0, $d85d37926b6a3a9e$export$8ee0fc9ee280b4ee)(o) || e.defaultPrevented) return;
        if (!(null == c ? void 0 : c.contains(o))) return;
        if (o.hasAttribute("disabled") || o.hasAttribute("aria-disabled")) return;
        const a = o.closest("[data-panzoom-action]"), s = null === (n = null == a ? void 0 : a.dataset) || void 0 === n ? void 0 : n.panzoomAction, l = (null === (i = null == a ? void 0 : a.dataset) || void 0 === i ? void 0 : i.panzoomValue) || "";
        if (s) {
            switch(s){
                case $0d16c58404501d51$export$9520bccbaf78266.ZoomTo:
                case $0d16c58404501d51$export$9520bccbaf78266.ZoomIn:
                case $0d16c58404501d51$export$9520bccbaf78266.ZoomOut:
                    te(s, {
                        scale: parseFloat(l || "") || void 0
                    });
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.MoveLeft:
                case $0d16c58404501d51$export$9520bccbaf78266.MoveRight:
                    te(s, {
                        deltaX: parseFloat(l || "") || void 0
                    });
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.MoveUp:
                case $0d16c58404501d51$export$9520bccbaf78266.MoveDown:
                    te(s, {
                        deltaY: parseFloat(l || "") || void 0
                    });
                    break;
                default:
                    te(s);
            }
            return;
        }
        if (!(null == M ? void 0 : M.contains(o))) return;
        const u = {
            srcEvent: e
        };
        if (te(Y("clickAction"), u), Y("dblClickAction")) {
            const e = Date.now(), t = e - ($0d16c58404501d51$var$b || e);
            $0d16c58404501d51$var$b = e, t > 0 && t <= 250 ? ($0d16c58404501d51$var$v && (clearTimeout($0d16c58404501d51$var$v), $0d16c58404501d51$var$v = void 0), te(Y("dblClickAction"), u)) : $0d16c58404501d51$var$v = setTimeout(()=>{
                te(Y("singleClickAction"), u);
            }, 250);
        }
    }
    function D(e) {
        if (O = e, !$()) return;
        if (3 !== A || F.scale <= 1 || Z.scale <= 1) return;
        if (((null == M ? void 0 : M.dataset.animationName) || "").indexOf("zoom") > -1) return;
        const t = _(Z.scale);
        if (!t) return;
        const { x: n, y: i } = t;
        te($0d16c58404501d51$export$9520bccbaf78266.Pan, {
            deltaX: n - Z.x,
            deltaY: i - Z.y
        });
    }
    function H() {
        var e;
        if (c && (null === (e = c.querySelector(".f-spinner")) || void 0 === e || e.remove(), c.classList.remove("is-loading")), !c || !M) return;
        if (E instanceof HTMLImageElement && (!E.complete || !E.naturalWidth)) return A = 2, null == M || M.classList.add("has-error"), void I("error");
        I("loaded");
        const { width: t, height: n } = q();
        E && (E.setAttribute("width", t + ""), E.setAttribute("height", n + "")), M && (M.classList.remove("has-error"), M.setAttribute("width", t + ""), M.setAttribute("height", n + ""), M.style.aspectRatio = `${t / n || ""}`), L = (0, $bb38fc976d943d50$export$208a41d6b4e37b97)().on("start", (e, t)=>{
            Z = Object.assign(Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), t), void 0 !== t.angle && (t.angle = 90 * Math.round(t.angle / 90)), void 0 !== t.flipX && (t.flipX = t.flipX > 0 ? 1 : -1), void 0 !== t.flipY && (t.flipY = t.flipY > 0 ? 1 : -1), ee(), I("animationStart");
        }).on("pause", (e)=>{
            Z = Object.assign(Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), e);
        }).on("step", (e)=>{
            if (3 !== A) return;
            if (!L) return;
            if (!c || !c.parentElement) return void L.end();
            if (F = Object.assign(Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), e), $() || !Y("bounds") || (null == k ? void 0 : k.isPointerDown()) || Z.scale > F.scale || Z.scale < V()) return void ne();
            const t = K(Z.scale);
            let n = !1, i = !1, a = !1, s = !1;
            F.x < t.x[0] && (n = !0), F.x > t.x[1] && (i = !0), F.y < t.y[0] && (s = !0), F.y > t.y[1] && (a = !0);
            let l = !1, r = !1, u = !1, f = !1;
            Z.x < t.x[0] && (l = !0), Z.x > t.x[1] && (r = !0), Z.y < t.y[0] && (f = !0), Z.y > t.y[1] && (u = !0);
            let d = !1;
            (i && r || n && l) && (Z.x = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(t.x[0], Z.x, t.x[1]), d = !0), (a && u || s && f) && (Z.y = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(t.y[0], Z.y, t.y[1]), d = !0), d && L.spring({
                tension: 94,
                friction: 17,
                maxSpeed: 555 * Z.scale,
                restDelta: .1,
                restSpeed: .1,
                velocity: L.getCurrentVelocities()
            }).from(F).to(Z).start(), ne();
        }).on("end", ()=>{
            Q(), (null == L ? void 0 : L.isRunning()) || (ee(), I("animationEnd"));
        }), function() {
            const e = Y("gestures");
            e && T && E && (k = (0, $cdb23866a53185e4$export$1f911e2d31b2843e)(T, e).on("start", (e)=>{
                if (!L) return;
                const t = e.srcEvent;
                $() || ((F.scale > 1 || e.currentTouch.length > 1) && (null == t || t.stopPropagation(), L.pause()), 1 === e.currentTouch.length && I("touchStart"));
            }).on("move", (e)=>{
                $() || (1 !== Z.scale || e.currentTouch.length > 1) && (e.srcEvent.preventDefault(), e.srcEvent.stopPropagation());
            }).on("pan", (e)=>{
                if ($()) return;
                const t = e.srcEvent;
                (1 !== Z.scale || e.currentTouch.length > 1) && ($0d16c58404501d51$var$f(t), te($0d16c58404501d51$export$9520bccbaf78266.Pan, e));
            }).on("swipe", (e)=>{
                $() || Z.scale > 1 && te($0d16c58404501d51$export$9520bccbaf78266.Swipe, e);
            }).on("tap", (e)=>{
                I("click", e);
            }).on("singleTap", (e)=>{
                I("singleClick", e);
            }).on("doubleTap", (e)=>{
                I("dblClick", e);
            }).on("pinch", (e)=>{
                $() || (e.scale > V() ? te($0d16c58404501d51$export$9520bccbaf78266.ZoomIn, e) : e.scale < V() ? te($0d16c58404501d51$export$9520bccbaf78266.ZoomOut, e) : te($0d16c58404501d51$export$9520bccbaf78266.Pan, e));
            }).on("end", (e)=>{
                $() || (e.currentTouch.length ? (e.srcEvent.stopPropagation(), $0d16c58404501d51$var$f(e.srcEvent), null == L || L.end()) : (ee(), Q(), I("touchEnd")));
            }).init());
        }(), T && (T.addEventListener("wheel", R, {
            passive: !1
        }), X.push(()=>{
            null == T || T.removeEventListener("wheel", R, {
                passive: !1
            });
        })), null == c || c.addEventListener("click", z), null === document || void 0 === document || document.addEventListener("mousemove", D), X.push(()=>{
            null == c || c.removeEventListener("click", z), null === document || void 0 === document || document.removeEventListener("mousemove", D);
        });
        const i = Object.assign(Object.assign({}, Y("startPos") || {}), {
            scale: V()
        });
        if (F = Object.assign(Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), i), Z = Object.assign(Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), i), $()) {
            const e = _(Z.scale);
            if (e) {
                const { x: t, y: n } = e;
                F.x = t, F.y = n, Z.x = t, Z.y = n;
            }
        }
        A = 3, ne(), ee(), I("ready"), requestAnimationFrame(()=>{
            T && (T.style.visibility = "");
        });
    }
    function W() {
        const e = {
            top: 0,
            left: 0,
            width: 0,
            height: 0
        };
        if (M) {
            const t = M.getBoundingClientRect();
            Z.angle % 180 == 90 ? (e.top = t.top + .5 * t.height - .5 * t.width, e.left = t.left + .5 * t.width - .5 * t.height, e.width = t.height, e.height = t.width) : (e.top = t.top, e.left = t.left, e.width = t.width, e.height = t.height);
        }
        return e;
    }
    function q() {
        let t = Y("width"), n = Y("height");
        if (E && "auto" === t) {
            const e = E.getAttribute("width");
            t = e ? parseFloat(e + "") : void 0 !== E.dataset.width ? parseFloat(E.dataset.width + "") : T instanceof HTMLImageElement ? T.naturalWidth : E instanceof HTMLImageElement ? E.naturalWidth : E.getBoundingClientRect().width;
        } else t = (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(t) ? parseFloat(t) : t;
        if (E && "auto" === n) {
            const e = E.getAttribute("height");
            n = e ? parseFloat(e + "") : void 0 !== E.dataset.height ? parseFloat(E.dataset.height + "") : T instanceof HTMLImageElement ? T.naturalHeight : E instanceof HTMLImageElement ? E.naturalHeight : E.getBoundingClientRect().height;
        } else n = (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(n) ? parseFloat(n) : n;
        return {
            width: t,
            height: n
        };
    }
    function $() {
        return "mousemove" === Y("panMode") && matchMedia("(hover: hover)").matches;
    }
    function _(e) {
        const t = O || Y("event"), n = null == M ? void 0 : M.getBoundingClientRect();
        if (!t || !n || e <= 1) return {
            x: 0,
            y: 0
        };
        const i = (t.clientX || 0) - n.left, a = (t.clientY || 0) - n.top, s = n.width, l = n.height, r = K(e);
        if (e > 1) {
            const t = Y("mouseMoveFactor");
            t > 1 && (e *= t);
        }
        let c = s * e, u = l * e, f = .5 * (c - s) - i / s * 100 / 100 * (c - s), d = .5 * (u - l) - a / l * 100 / 100 * (u - l);
        return f = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(r.x[0], f, r.x[1]), d = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(r.y[0], d, r.y[1]), {
            x: f,
            y: d
        };
    }
    function B(e = "base") {
        if (!c) return 1;
        const t = c.getBoundingClientRect(), n = W(), { width: i, height: a } = q(), s = (e)=>{
            if ("number" == typeof e) return e;
            switch(e){
                case "min":
                case "base":
                    return 1;
                case "cover":
                    return Math.max(t.height / n.height, t.width / n.width) || 1;
                case "full":
                case "max":
                    {
                        const e = Z.angle % 180 == 90 ? a : i;
                        return e && n.width ? e / n.width : 1;
                    }
            }
        }, l = Y("minScale"), r = Y("maxScale"), u = Math.min(s("full"), s(l)), f = "number" == typeof r ? s("full") * r : Math.min(s("full"), s(r));
        switch(e){
            case "min":
                return u;
            case "base":
                return (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(u, 1, f);
            case "cover":
                return s("cover");
            case "full":
                return Math.min(f, s("full"));
            case "max":
                return f;
        }
    }
    function N() {
        return B("min");
    }
    function V() {
        return B("base");
    }
    function U() {
        return B("cover");
    }
    function G() {
        return B("full");
    }
    function J() {
        return B("max");
    }
    function K(e) {
        const t = {
            x: [
                0,
                0
            ],
            y: [
                0,
                0
            ]
        }, n = null == c ? void 0 : c.getBoundingClientRect();
        if (!n) return t;
        const i = W(), o = n.width, a = n.height;
        let s = i.width, l = i.height, r = e = void 0 === e ? Z.scale : e, u = e;
        if ($() && e > 1) {
            const t = Y("mouseMoveFactor");
            t > 1 && (s * e > o + .01 && (r *= t), l * e > a + .01 && (u *= t));
        }
        return s *= r, l *= u, e > 1 && (s > o && (t.x[0] = .5 * (o - s), t.x[1] = .5 * (s - o)), t.x[0] -= .5 * (i.left - n.left), t.x[1] -= .5 * (i.left - n.left), t.x[0] -= .5 * (i.left + i.width - n.right), t.x[1] -= .5 * (i.left + i.width - n.right), l > a && (t.y[0] = .5 * (a - l), t.y[1] = .5 * (l - a)), t.y[0] -= .5 * (i.top - n.top), t.y[1] -= .5 * (i.top - n.top), t.y[0] -= .5 * (i.top + i.height - n.bottom), t.y[1] -= .5 * (i.top + i.height - n.bottom)), t;
    }
    function Q() {
        if (!Y("bounds")) return;
        if (3 !== A) return;
        if (!(null == c ? void 0 : c.parentElement)) return;
        if (!L) return;
        const e = N(), t = J(), n = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(e, Z.scale, t);
        if (Z.scale < e - .01 || Z.scale > t + .01) return void te($0d16c58404501d51$export$9520bccbaf78266.ZoomTo, {
            scale: n
        });
        if (L.isRunning()) return;
        if (null == k ? void 0 : k.isPointerDown()) return;
        const i = K(n);
        Z.x < i.x[0] || Z.x > i.x[1] || Z.y < i.y[0] || Z.y > i.y[1] ? (Z.x = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(i.x[0], Z.x, i.x[1]), Z.y = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(i.y[0], Z.y, i.y[1]), L.spring({
            tension: 170,
            friction: 17,
            restDelta: .001,
            restSpeed: .001,
            maxSpeed: 1 / 0,
            velocity: L.getCurrentVelocities()
        }), L.from(F).to(Z).start()) : ne();
    }
    function ee() {
        if (!c || !c.parentElement || !M) return;
        const e = re(), t = ce(), n = ue(), i = fe(), o = oe(), a = ae();
        M.classList.toggle("is-fullsize", i), M.classList.toggle("is-expanded", n), M.classList.toggle("is-dragging", t), M.classList.toggle("can-drag", e), M.classList.toggle("will-zoom-in", o), M.classList.toggle("will-zoom-out", a);
        const s = se(), l = le(), r = 3 !== A;
        for (const e of (null == c ? void 0 : c.querySelectorAll("[data-panzoom-action]")) || []){
            const t = e.dataset.panzoomAction;
            let n = !1;
            if (r) n = !0;
            else switch(t){
                case $0d16c58404501d51$export$9520bccbaf78266.ZoomIn:
                    s || (n = !0);
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.ZoomOut:
                    l || (n = !0);
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.ToggleFull:
                    s || l || (n = !0);
                    const t1 = e.querySelector("g");
                    t1 && (t1.style.display = i ? "none" : "");
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.ToggleCover:
                case $0d16c58404501d51$export$9520bccbaf78266.ToggleMax:
                    s || l || (n = !0);
            }
            n ? (e.setAttribute("aria-disabled", ""), e.setAttribute("tabindex", "-1")) : (e.removeAttribute("aria-disabled"), e.removeAttribute("tabindex"));
        }
    }
    function te(e, t) {
        var n;
        if (!c || !E || !L) return;
        if (e === $0d16c58404501d51$export$9520bccbaf78266.Swipe && Math.abs(L.getCurrentVelocities().scale) > .01) return;
        let i = Object.assign({}, Z), a = K($() ? Z.scale : F.scale);
        const r = L.getCurrentVelocities(), u = W(), f = ((null === (n = (t = t || {}).currentTouch) || void 0 === n ? void 0 : n.length) || 0) > 1, d = t.velocityX || 0, h = t.velocityY || 0;
        let p = t.center;
        !p && t.srcEvent && (p = (0, $cdb23866a53185e4$export$b820caf342892892)((0, $cdb23866a53185e4$export$1ae15396032099be)(t.srcEvent)));
        let v = t.deltaX || 0, b = t.deltaY || 0;
        switch(e){
            case $0d16c58404501d51$export$9520bccbaf78266.MoveRight:
                v = t.deltaX || 100;
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.MoveLeft:
                v = t.deltaX || -100;
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.MoveUp:
                b = t.deltaY || -100;
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.MoveDown:
                b = t.deltaY || 100;
        }
        let y = [];
        switch(e){
            case $0d16c58404501d51$export$9520bccbaf78266.Reset:
                Z = Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), Z.scale = V();
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.Pan:
            case $0d16c58404501d51$export$9520bccbaf78266.Move:
            case $0d16c58404501d51$export$9520bccbaf78266.MoveLeft:
            case $0d16c58404501d51$export$9520bccbaf78266.MoveRight:
            case $0d16c58404501d51$export$9520bccbaf78266.MoveUp:
            case $0d16c58404501d51$export$9520bccbaf78266.MoveDown:
                if (null == k ? void 0 : k.isPointerDown()) {
                    let e = 1, t = 1;
                    Z.x <= a.x[0] && d <= 0 && (e = Math.max(.01, 1 - Math.abs(1 / u.width * Math.abs(Z.x - a.x[0]))), e *= .2), Z.x >= a.x[1] && d >= 0 && (e = Math.max(.01, 1 - Math.abs(1 / u.width * Math.abs(Z.x - a.x[1]))), e *= .2), Z.y <= a.y[0] && h <= 0 && (t = Math.max(.01, 1 - Math.abs(1 / u.height * Math.abs(Z.y - a.y[0]))), t *= .2), Z.y >= a.y[1] && h >= 0 && (t = Math.max(.01, 1 - Math.abs(1 / u.height * Math.abs(Z.y - a.y[1]))), t *= .2), Z.x += v * e, Z.y += b * t;
                } else Z.x = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(a.x[0], Z.x + v, a.x[1]), Z.y = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(a.y[0], Z.y + b, a.y[1]);
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.Swipe:
                const e1 = (e = 0)=>Math.sign(e) * Math.pow(Math.abs(e), 1.5);
                Z.x += (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(-1000, e1(d), 1e3), Z.y += (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(-1000, e1(h), 1e3), h && !d && (Z.x = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(a.x[0], Z.x, a.x[1])), !h && d && (Z.y = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(a.y[0], Z.y, a.y[1])), r.x = d, r.y = h;
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.ZoomTo:
                Z.scale = t.scale || 1;
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.ZoomIn:
                Z.scale = Z.scale * (t.scale || 2), f || (Z.scale = Math.min(Z.scale, J()));
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.ZoomOut:
                Z.scale = Z.scale * (t.scale || .5), f || (Z.scale = Math.max(Z.scale, N()));
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.ToggleCover:
                y = [
                    V(),
                    U()
                ];
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.ToggleFull:
                y = [
                    V(),
                    G()
                ];
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.ToggleMax:
                y = [
                    V(),
                    J()
                ];
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.IterateZoom:
                y = [
                    V(),
                    G(),
                    J()
                ];
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.Zoom:
                const n1 = G();
                Z.scale >= n1 - .05 ? Z.scale = V() : Z.scale = Math.min(n1, Z.scale * (t.scale || 2));
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.RotateCW:
                Z.angle += 90;
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.RotateCCW:
                Z.angle -= 90;
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.FlipX:
                Z.flipX *= -1;
                break;
            case $0d16c58404501d51$export$9520bccbaf78266.FlipY:
                Z.flipY *= -1;
        }
        if (void 0 !== F.angle && Math.abs(F.angle) >= 360 && (Z.angle -= 360 * Math.floor(F.angle / 360), F.angle -= 360 * Math.floor(F.angle / 360)), y.length) {
            const e = y.findIndex((e)=>e > Z.scale + 1e-4);
            Z.scale = y[e] || y[0];
        }
        if (f && (Z.scale = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(N() * (f ? .8 : 1), Z.scale, J() * (f ? 1.6 : 1))), $()) {
            const e = _(Z.scale);
            if (e) {
                const { x: t, y: n } = e;
                Z.x = t, Z.y = n;
            }
        } else if (Z.scale !== i.scale) {
            let e = 0, t = 0;
            if (p) e = p.x, t = p.y;
            else {
                const n = c.getBoundingClientRect();
                e = n.x + .5 * n.width, t = n.y + .5 * n.height;
            }
            let n = e - u.left, s = t - u.top;
            n -= .5 * u.width, s -= .5 * u.height;
            const l = (n - i.x) / i.scale, r = (s - i.y) / i.scale;
            Z.x = n - l * Z.scale, Z.y = s - r * Z.scale, !f && Y("bounds") && (a = K(Z.scale), Z.x = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(a.x[0], Z.x, a.x[1]), Z.y = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(a.y[0], Z.y, a.y[1]));
        }
        if (e === $0d16c58404501d51$export$9520bccbaf78266.Swipe) {
            let e = 94, t = 17, n = 500 * Z.scale, i = r;
            L.spring({
                tension: e,
                friction: t,
                maxSpeed: n,
                restDelta: .1,
                restSpeed: .1,
                velocity: i
            });
        } else e === $0d16c58404501d51$export$9520bccbaf78266.Pan || f ? L.spring({
            tension: 750,
            friction: 17,
            restDelta: .01,
            restSpeed: .01,
            maxSpeed: 1
        }) : L.spring({
            tension: 170,
            friction: 17,
            restDelta: .001,
            restSpeed: .001,
            maxSpeed: 1 / 0,
            velocity: r
        });
        e === $0d16c58404501d51$export$9520bccbaf78266.Reset && 0 === t.velocity ? F = Object.assign({}, Z) : L.from(F).to(Z).start(), I("action", e);
    }
    function ne() {
        if (!M || !E) return;
        if (E instanceof HTMLImageElement) {
            const { width: e, height: t } = q();
            M.style.maxWidth = `min(${e}px, 100%)`, M.style.maxHeight = `min(${t}px, 100%)`;
        }
        let { x: e, y: t, scale: n, angle: i, flipX: o, flipY: a } = F;
        const s = function() {
            const e = W(), t = e.width, n = e.height, { width: i, height: o } = q();
            if (!c) return {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                scale: 0,
                flipX: 0,
                flipY: 0,
                angle: 0,
                fitWidth: t,
                fitHeight: n,
                fullWidth: i,
                fullHeight: o
            };
            let { x: a, y: s, scale: l, angle: r, flipX: u, flipY: f } = F, d = 1 / G(), g = i, h = o, m = F.scale * d, p = Z.scale * d;
            const v = Math.max(t, n), b = Math.min(t, n);
            i > o ? (g = v, h = b) : (g = b, h = v);
            m = i > o ? v * l / i || 1 : v * l / o || 1;
            let y = g ? i * p : 0, x = h ? o * p : 0;
            return a = a + .5 * g - .5 * y, s = s + .5 * h - .5 * x, {
                x: a,
                y: s,
                width: y,
                height: x,
                scale: g && h ? i * m / y : 0,
                flipX: u,
                flipY: f,
                angle: r,
                fitWidth: t,
                fitHeight: n,
                fullWidth: i,
                fullHeight: o
            };
        }();
        if (M && s) {
            const { x: e, y: t, width: n, height: o, scale: a, flipX: l, flipY: r } = s;
            let c = `translate(${$0d16c58404501d51$var$d(e)}px, ${$0d16c58404501d51$var$d(t)}px)`;
            c += 1 !== l || 1 !== r ? ` scaleX(${$0d16c58404501d51$var$d(a * l)}) scaleY(${$0d16c58404501d51$var$d(a * r)})` : ` scale(${$0d16c58404501d51$var$d(a)})`, 0 !== i && (c += ` rotate(${i}deg)`), T && (T.style.width = `${$0d16c58404501d51$var$d(n)}px`, T.style.height = `${$0d16c58404501d51$var$d(o)}px`, T.style.transform = `${c}`);
        }
        I("render");
    }
    function ie() {
        let e = Z.scale;
        const t = Y("clickAction");
        let n = V();
        if (t) {
            let i = [];
            switch(t){
                case $0d16c58404501d51$export$9520bccbaf78266.ZoomIn:
                    n = 2 * e;
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.ZoomOut:
                    n = .5 * e;
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.ToggleCover:
                    i = [
                        V(),
                        U()
                    ];
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.ToggleFull:
                    i = [
                        V(),
                        G()
                    ];
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.ToggleMax:
                    i = [
                        V(),
                        J()
                    ];
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.IterateZoom:
                    i = [
                        V(),
                        G(),
                        J()
                    ];
                    break;
                case $0d16c58404501d51$export$9520bccbaf78266.Zoom:
                    const t1 = G();
                    n = e >= t1 - .05 ? V() : Math.min(t1, 2 * e);
            }
            if (i.length) {
                const t = i.findIndex((t)=>t > e + 1e-4);
                n = i[t] || V();
            }
        }
        return n = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(N(), n, J()), n;
    }
    function oe() {
        return 3 === A && ie() > Z.scale;
    }
    function ae() {
        return 3 === A && ie() < Z.scale;
    }
    function se() {
        return 3 === A && Z.scale < J();
    }
    function le() {
        return 3 === A && Z.scale > N();
    }
    function re() {
        return 3 === A && ue() && !!k && !$();
    }
    function ce() {
        return 3 === A && (null == k ? void 0 : k.isPointerDown()) && !$();
    }
    function ue() {
        return 3 === A && Z.scale > V();
    }
    function fe() {
        return 3 === A && Z.scale >= G();
    }
    const de = {
        canDrag: re,
        canZoomIn: se,
        canZoomOut: le,
        destroy: function() {
            I("destroy");
            for (const e of Object.values(S))null == e || e.destroy(de);
            for (const e of X)e();
            return M && (M.style.aspectRatio = "", M.style.maxWidth = "", M.style.maxHeight = ""), T && (T.style.width = "", T.style.height = "", T.style.transform = ""), M = void 0, E = void 0, T = void 0, F = Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), Z = Object.assign({}, $0d16c58404501d51$export$15463f5204f2871f), null == L || L.destroy(), L = void 0, null == k || k.destroy(), k = void 0, A = 4, de;
        },
        emit: I,
        execute: te,
        getBoundaries: K,
        getContainer: function() {
            return c;
        },
        getFullDim: q,
        getGestures: function() {
            return k;
        },
        getMousemovePos: _,
        getOptions: function() {
            return C;
        },
        getScale: B,
        getState: function() {
            return A;
        },
        getTransform: function(e) {
            return !0 === e ? Z : F;
        },
        getTween: function() {
            return L;
        },
        getViewport: function() {
            return T;
        },
        getWrapper: function() {
            return M;
        },
        init: function() {
            return A = 0, I("init"), function() {
                for (const [e, t] of Object.entries(Object.assign(Object.assign({}, w), C.plugins || {})))if (e && !S[e] && t instanceof Function) {
                    const n = t();
                    n.init(de), S[e] = n;
                }
                I("initPlugins");
            }(), function() {
                if (!c) return;
                const e = Object.assign(Object.assign({}, $0d16c58404501d51$var$p.classes), Y("classes"));
                if ((0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(c, e.container), E = c.querySelector("." + e.content), !E) return;
                E.setAttribute("draggable", "false"), M = c.querySelector("." + e.wrapper), M || (M = document.createElement("div"), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(M, e.wrapper), E.insertAdjacentElement("beforebegin", M), M.insertAdjacentElement("afterbegin", E));
                if (!(E instanceof HTMLImageElement || E instanceof HTMLPictureElement)) return;
                if (T = c.querySelector("." + e.viewport), !T) {
                    T = document.createElement("div"), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(T, e.viewport);
                    const t = E.cloneNode(!0);
                    t.classList.remove("is-lazyloading"), t.classList.remove("is-lazyloaded"), T.insertAdjacentElement("afterbegin", t), M.insertAdjacentElement("beforeend", T);
                }
                E instanceof HTMLPictureElement && (E = E.querySelector("img"));
                T instanceof HTMLPictureElement && (T = T.querySelector("img"));
                if (T.style.visibility = "hidden", Y("protected")) {
                    T.addEventListener("contextmenu", (e)=>{
                        e.preventDefault();
                    });
                    const e = document.createElement("div");
                    (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(e, "f-panzoom__protected"), T.appendChild(e);
                }
                I("initLayout");
            }(), function() {
                if (!(E && E instanceof HTMLImageElement)) return;
                A = 1, I("loading");
                const e = ()=>{
                    E && E instanceof HTMLImageElement && E.decode().then(()=>{
                        requestAnimationFrame(()=>{
                            H();
                        });
                    }).catch(()=>{
                        H();
                    });
                };
                if (E.src && E.complete) return void e();
                (function() {
                    const e = null == c ? void 0 : c.querySelector(".f-spinner");
                    if (!c || e) return;
                    const t = Y("spinnerTpl"), n = (0, $d05c6dadc12263a9$export$b368690db5627d91)(t);
                    n && (n.classList.add("f-spinner"), c.classList.add("is-loading"), null == M || M.insertAdjacentElement("afterbegin", n));
                })(), E.addEventListener("load", e, !1), E.addEventListener("error", e, !1), X.push(()=>{
                    null == E || E.removeEventListener("load", e, !1), null == E || E.removeEventListener("error", e, !1);
                });
            }(), function() {
                if (c && M && !j) {
                    let e = null;
                    j = new ResizeObserver(()=>{
                        e || (e = requestAnimationFrame(()=>{
                            c && c.parentElement && 3 === A && (ee(), Q(), I("refresh")), e = null;
                        }));
                    }), j.observe(M), X.push(()=>{
                        null == j || j.disconnect(), j = void 0, e && (cancelAnimationFrame(e), e = null);
                    });
                }
            }(), de;
        },
        isDragging: ce,
        isExpanded: ue,
        isFullsize: fe,
        localize: function(e, t = []) {
            const n = Y("l10n") || {};
            e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
            for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
            return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
        },
        off: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])P.has(n) && P.set(n, P.get(n).filter((e)=>e !== t));
            return de;
        },
        on: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])P.set(n, [
                ...P.get(n) || [],
                t
            ]);
            return de;
        },
        version: "6.0.18",
        willZoomIn: oe,
        willZoomOut: ae
    };
    return de;
};
$0d16c58404501d51$export$b704d075ddd20210.l10n = {
    en_EN: (0, $f770271f96ecd80a$export$30568d076ec2f42)
}, $0d16c58404501d51$export$b704d075ddd20210.getDefaults = ()=>$0d16c58404501d51$var$p;


/*! License details at fancyapps.com/license */ 



/*! License details at fancyapps.com/license */ const $98d57eda244cdfc4$export$2b0209f2592da03b = (e, o)=>{
    let t = [];
    return e.childNodes.forEach((e)=>{
        e.nodeType !== Node.ELEMENT_NODE || o && !e.matches(o) || t.push(e);
    }), t;
};


/*! License details at fancyapps.com/license */ 
const $dcc16499f8d8077d$export$8b58be045bf06082 = (t, ...e)=>{
    const n = e.length;
    for(let c = 0; c < n; c++){
        const n = e[c] || {};
        Object.entries(n).forEach(([e, n])=>{
            const c = Array.isArray(n) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: c
            }), (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(n) ? Object.assign(t[e], $dcc16499f8d8077d$export$8b58be045bf06082(c, n)) : Array.isArray(n) ? Object.assign(t, {
                [e]: [
                    ...n
                ]
            }) : Object.assign(t, {
                [e]: n
            });
        });
    }
    return t;
};


/*! License details at fancyapps.com/license */ 
const $fff5597b4228e002$export$871de8747c9eaa88 = function(t = 0, n = 0, r = 0, c = 0, m = 0, p = !1) {
    const s = (t - n) / (r - n) * (m - c) + c;
    return p ? c < m ? (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(c, s, m) : (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(m, s, c) : s;
};





/*! License details at fancyapps.com/license */ const $c5899590eea05f92$export$c2255604a80b4506 = (s, t = "")=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.remove(t);
    });
};


/*! License details at fancyapps.com/license */ const $00a976fcbdb71c27$export$4a80062ca50b57c7 = (s, t = "", c)=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.toggle(t, c || !1);
    });
};




/*! License details at fancyapps.com/license */ 
const $bfaeb8c92ccc8716$export$30568d076ec2f42 = Object.assign(Object.assign({}, (0, $f770271f96ecd80a$export$30568d076ec2f42)), {
    ERROR: "Something went wrong. <br /> Please try again later.",
    NEXT: "Next page",
    PREV: "Previous page",
    GOTO: "Go to page #%d",
    DOWNLOAD: "Download",
    TOGGLE_FULLSCREEN: "Toggle full-screen mode",
    TOGGLE_EXPAND: "Toggle full-size mode",
    TOGGLE_THUMBS: "Toggle thumbnails",
    TOGGLE_AUTOPLAY: "Toggle slideshow"
});


const $8024d5e188ad0565$var$g = (e)=>{
    e.cancelable && e.preventDefault();
}, $8024d5e188ad0565$var$m = {
    adaptiveHeight: !1,
    center: !0,
    classes: {
        container: "f-carousel",
        isEnabled: "is-enabled",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        hasAdaptiveHeight: "has-adaptive-height",
        viewport: "f-carousel__viewport",
        slide: "f-carousel__slide",
        isSelected: "is-selected"
    },
    dragFree: !1,
    enabled: !0,
    errorTpl: '<div class="f-html">{{ERROR}}</div>',
    fill: !1,
    infinite: !0,
    initialPage: 0,
    l10n: (0, $bfaeb8c92ccc8716$export$30568d076ec2f42),
    rtl: !1,
    slides: [],
    slidesPerPage: "auto",
    spinnerTpl: '<div class="f-spinner"></div>',
    transition: "fade",
    tween: {
        clamp: !0,
        mass: 1,
        tension: 200,
        friction: 25,
        restDelta: 1,
        restSpeed: 1,
        velocity: 0
    },
    vertical: !1
};
let $8024d5e188ad0565$var$h, $8024d5e188ad0565$var$b = 0;
const $8024d5e188ad0565$export$144901db2ea8e967 = (v, x = {}, w = {})=>{
    $8024d5e188ad0565$var$b++;
    let y, M, S, j, P, L = 0, T = Object.assign({}, $8024d5e188ad0565$var$m), O = Object.assign({}, $8024d5e188ad0565$var$m), R = {}, A = null, C = null, V = !1, H = !1, $ = !1, D = !1, z = "height", F = 0, q = !0, B = 0, I = 0, k = 0, N = 0, _ = "*", G = [], X = [];
    const Y = new Set;
    let J = [], K = [], Q = 0, U = 0;
    function W(e, ...t) {
        let n = O[e];
        return n && n instanceof Function ? n(Re, ...t) : n;
    }
    function Z(e, t = []) {
        const n = W("l10n") || {};
        e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
        for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    const ee = new Map;
    function te(e, ...t) {
        const n = ee.get(e) || [];
        O.on && n.push(O.on[e]);
        for (const e of n)e && e instanceof Function && e(Re, ...t);
        "*" !== e && te("*", e, ...t);
    }
    function ne() {
        var t, n;
        const r = (0, $dcc16499f8d8077d$export$8b58be045bf06082)({}, $8024d5e188ad0565$var$m, T);
        (0, $dcc16499f8d8077d$export$8b58be045bf06082)(r, $8024d5e188ad0565$var$m, T);
        let l = "";
        const u = T.breakpoints || {};
        if (u) for (const [e, t] of Object.entries(u))window.matchMedia(e).matches && (l += e, (0, $dcc16499f8d8077d$export$8b58be045bf06082)(r, t));
        if (void 0 === P || l !== P) {
            if (P = l, 0 !== L) {
                let e = null === (n = null === (t = K[B]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === n ? void 0 : n.index;
                void 0 === e && (e = O.initialSlide), r.initialSlide = e, r.slides = [];
                for (const e of G)e.isVirtual && r.slides.push(e);
            }
            Oe(), O = r, !1 !== O.enabled && (L = 0, te("init"), function() {
                for (const [e, t] of Object.entries(Object.assign(Object.assign({}, w), O.plugins || {})))if (e && !R[e] && t instanceof Function) {
                    const n = t();
                    n.init(Re, $8024d5e188ad0565$export$144901db2ea8e967), R[e] = n;
                }
                te("initPlugins");
            }(), function() {
                if (!A) return;
                const t = W("classes") || {};
                (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(A, t.container), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(A, t.isEnabled);
                const n = W("style");
                if (n && (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(n)) for (const [e, t] of Object.entries(n))A.style.setProperty(e, t);
                C = A.querySelector(`.${t.viewport}`), C || (C = document.createElement("div"), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(C, t.viewport), C.append(...(0, $98d57eda244cdfc4$export$2b0209f2592da03b)(A, `.${t.slide}`)), A.insertAdjacentElement("afterbegin", C)), V = "visible" === window.getComputedStyle(C).getPropertyValue("overflow"), A.carousel = Re, te("initLayout");
            }(), function() {
                if (!C) return;
                const e = W("classes") || {};
                G = [], [
                    ...(0, $98d57eda244cdfc4$export$2b0209f2592da03b)(C, `.${e.slide}`)
                ].forEach((e)=>{
                    e.parentElement && (G.push(ve(Object.assign({
                        el: e,
                        isVirtual: !1
                    }, e.dataset || {}))), e.parentElement.removeChild(e));
                }), pe(W("slides"));
                for (const e of G)te("addSlide", e);
                te("initSlides");
            }(), M = (0, $bb38fc976d943d50$export$208a41d6b4e37b97)().on("start", ()=>{
                y && y.isPointerDown() || (se(), Te());
            }).on("step", (e)=>{
                const t = F;
                F = e.pos, F !== t && (q = !1, Te());
            }).on("end", (e)=>{
                (null == y ? void 0 : y.isPointerDown()) || (F = e.pos, M && !H && (F < k || F > N) ? M.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 200,
                    friction: 25,
                    velocity: 0,
                    restDelta: 1,
                    restSpeed: 1
                }).from({
                    pos: F
                }).to({
                    pos: (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(k, F, N)
                }).start() : q || (q = !0, te("settle")));
            }), function() {
                const e = W("gestures");
                C && !1 !== e && (y = (0, $cdb23866a53185e4$export$1f911e2d31b2843e)(C, e).on("start", (e)=>{
                    var t, n;
                    if (!M) return;
                    const { srcEvent: i } = e;
                    function o(e) {
                        const t = window.getComputedStyle(e), n = new DOMMatrixReadOnly(t.transform);
                        return {
                            width: n.m41 || 0,
                            height: n.m42 || 0
                        };
                    }
                    D && $8024d5e188ad0565$var$g(i), M.pause(), M.getCurrentVelocities().pos = 0;
                    const s = null === (t = K[B]) || void 0 === t ? void 0 : t.slides[0];
                    s && Y.has(s.index) && s.el && (F = s.offset || 0, F += (o(s.el)[z] || 0) * ($ && !D ? 1 : -1)), we(), H || (F < k || F > N) && M.spring({
                        clamp: !0,
                        mass: 1,
                        tension: 500,
                        friction: 25,
                        velocity: (null === (n = M.getCurrentVelocities()) || void 0 === n ? void 0 : n.pos) || 0,
                        restDelta: 1,
                        restSpeed: 1
                    }).from({
                        pos: F
                    }).to({
                        pos: (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(k, F, N)
                    }).start();
                }).on("move", (e)=>{
                    const { srcEvent: t, axis: n } = e, o = e.srcEvent.target;
                    o && (0, $86ffa1e8b3d1fbe0$export$e41e80160bed5714)(o) || (n || (t.stopPropagation(), t.stopImmediatePropagation()), ("y" === n && D || "x" === n && !D) && ($8024d5e188ad0565$var$g(t), t.stopPropagation()));
                }).on("panstart", (e)=>{
                    (null == e ? void 0 : e.axis) === (D ? "y" : "x") && (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(C, "is-dragging");
                }).on("panend", ()=>{
                    (0, $c5899590eea05f92$export$c2255604a80b4506)(C, "is-dragging");
                }).on("pan", (e)=>{
                    var t;
                    const { deltaX: n, deltaY: i, currentTouch: o, axis: s } = e;
                    if (!M) return;
                    if (o.length > 1) return;
                    if ("y" === s && !D || "x" === s && D) return;
                    const r = $ && !D ? 1 : -1;
                    let l = D ? i : n, a = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : F, c = 1;
                    H || (a <= k && l * r < 0 ? (c = Math.max(.01, 1 - Math.abs(1 / de() * Math.abs(a - k))), c *= .2) : a >= N && l * r > 0 && (c = Math.max(.01, 1 - Math.abs(1 / de() * Math.abs(a - N))), c *= .2)), a += l * c * r, M.spring({
                        clamp: !0,
                        mass: 1,
                        tension: 700,
                        friction: 25,
                        velocity: (null === (t = M.getCurrentVelocities()) || void 0 === t ? void 0 : t.pos) || 0,
                        restDelta: 1,
                        restSpeed: 1
                    }).from({
                        pos: F
                    }).to({
                        pos: a
                    }).start();
                }).on("end", (e)=>{
                    var t, n;
                    const { axis: i, velocityX: o, velocityY: s, currentTouch: r } = e, l = K.length, c = W("dragFree");
                    if (r.length > 0 || !M) return;
                    if (!l) return;
                    const d = W("vertical") ? s : o;
                    let u = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : F;
                    const f = $ && !D ? 1 : -1;
                    if (u += d * (c ? 5 : 1) * f, !H && (d * f <= 0 && u < k || d * f >= 0 && u > N)) {
                        let e = 0;
                        return Math.abs(d) > 0 && (e = 2 * Math.abs(d), e = Math.min(.3 * de(), e)), u = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(k + -1 * e, u, N + e), void M.spring({
                            clamp: !0,
                            mass: 1,
                            tension: 380,
                            friction: 25,
                            velocity: -1 * d,
                            restDelta: 1,
                            restSpeed: 1
                        }).from({
                            pos: F
                        }).to({
                            pos: u
                        }).start();
                    }
                    if (c || (null === (t = R.Autoscroll) || void 0 === t ? void 0 : t.isEnabled())) return void (Math.abs(d) > 10 ? M.spring({
                        clamp: !0,
                        mass: 1,
                        tension: 150,
                        friction: 25,
                        velocity: -1 * d,
                        restDelta: 1,
                        restSpeed: 1
                    }).from({
                        pos: F
                    }).to({
                        pos: u
                    }).start() : M.isRunning() || q || (q = !0, te("settle")));
                    if (!c && !(null === (n = R.Autoscroll) || void 0 === n ? void 0 : n.isEnabled()) && (!e.offsetX && !e.offsetY || "y" === i && !D || "x" === i && D)) return void Le(B, {
                        transition: "tween"
                    });
                    let p = ae(u);
                    Math.abs(d) > 10 && p === B && (p += d > 0 ? $ && !D ? 1 : -1 : $ && !D ? -1 : 1), Le(p, {
                        transition: "tween",
                        tween: {
                            tension: 160,
                            friction: 25,
                            velocity: -1 * d
                        }
                    });
                }).init());
            }(), Ee(), function() {
                if (A && (A.addEventListener("click", Me, {
                    passive: !1
                }), document.addEventListener("mousemove", ie), !S)) {
                    let e = null;
                    S = new ResizeObserver((t)=>{
                        e || (e = requestAnimationFrame(()=>{
                            !function(e) {
                                if (!A) return;
                                let t = e[0].contentBoxSize[0].blockSize, n = e[0].contentBoxSize[0].inlineSize;
                                if (0 === L) return Q = t, U = n, L = 1, Te(), re(), void te("ready");
                                if (1 !== L) return;
                                const i = K.length;
                                Ee();
                                const o = A.getBoundingClientRect();
                                t = o.height, n = o.width, i > 1 && (D && Math.abs(t - Q) < .5 || !D && Math.abs(n - U) < .5) || (Q = t, U = n, D && !t || !D && !n || A && C && (i === K.length && (null == y ? void 0 : y.isPointerDown()) || (W("dragFree") && (H || F > k && F < N) ? (se(), Te()) : Le(B, {
                                    transition: !1
                                }))));
                            }(t), e = null;
                        }));
                    }), S.observe(A);
                }
            }());
        }
    }
    function ie(e) {
        $8024d5e188ad0565$var$h = e;
    }
    function oe(e = "*") {
        var t;
        const n = [];
        for (const i of G)("*" === e || i.class && i.class.includes(e) || i.el && (null === (t = i.el) || void 0 === t ? void 0 : t.classList.contains(e))) && n.push(i);
        j = void 0, _ = e, X = [
            ...n
        ];
    }
    function se() {
        if (!M) return;
        const e = ae((null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : F);
        e !== B && (j = B, B = e, Pe(), re(), le(), te("change", B, j));
    }
    function re() {
        var e;
        if (!A) return;
        (0, $00a976fcbdb71c27$export$4a80062ca50b57c7)(C, "is-draggable", !!y && K.length > 0);
        for (const e of A.querySelectorAll("[data-carousel-index]"))e.innerHTML = B + "";
        for (const e of A.querySelectorAll("[data-carousel-page]"))e.innerHTML = B + 1 + "";
        for (const e of A.querySelectorAll("[data-carousel-pages]"))e.innerHTML = K.length + "";
        let t = !1;
        const n = null === (e = K[B]) || void 0 === e ? void 0 : e.slides[0];
        n && (n.downloadSrc || "image" === n.type && n.src) && (t = !0);
        for (const e of A.querySelectorAll("[data-carousel-download]"))e.toggleAttribute("aria-disabled", !t);
    }
    function le(e) {
        var t;
        if (!A) return;
        e || (e = null === (t = K[B]) || void 0 === t ? void 0 : t.slides[0]);
        const n = e.el;
        if (n) for (const t of n.querySelectorAll("[data-slide-index]"))t.innerHTML = e.index + 1 + "";
    }
    function ae(e) {
        if (!K.length || !M) return 0;
        const t = ue();
        let n = e;
        H ? n -= Math.floor((e - K[0].pos) / t) * t : n = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(K[0].pos, e, K[K.length - 1].pos);
        const i = new Map;
        let o = 0;
        for (const e of K){
            const s = Math.abs(e.pos - n), r = Math.abs(e.pos - n - t), l = Math.abs(e.pos - n + t), a = Math.min(s, r, l);
            i.set(o, a), o++;
        }
        const s = i.size > 0 ? [
            ...i.entries()
        ].reduce((e, t)=>t[1] < e[1] ? t : e) : [
            B,
            0
        ];
        return parseInt(s[0]);
    }
    function ce() {
        return C && parseFloat(getComputedStyle(C).getPropertyValue("--f-carousel-gap")) || 0;
    }
    function de() {
        return C && C.getBoundingClientRect()[z] || 0;
    }
    function ue(e = !0) {
        const t = ce();
        return X.reduce((e, t)=>e + t.dim, 0) + (X.length - (H && e ? 0 : 1)) * t;
    }
    function fe(e) {
        const t = ce(), n = ue();
        let i = de();
        if (!C) return [];
        const o = [];
        if (!n || !i) return [];
        e = void 0 === e ? F : e, H && (e -= Math.floor(e / n) * n);
        let s = 0, r = 0;
        if (V) {
            const e = C.getBoundingClientRect();
            s = e.left, r = e.right - e.width;
        }
        let l = 0;
        for (let a of X){
            const c = (t = 0)=>{
                o.indexOf(a) > -1 || (a.pos = l - e + t || 0, a.offset + t > e - a.dim - s + .51 && a.offset + t < e + i + r - .51 && o.push(a));
            };
            if (a.offset = l, H) for(let e = -1; e <= 1; e++)c(n * e);
            else c();
            l += a.dim + t;
        }
        return o;
    }
    function pe(e, t) {
        const n = [];
        for (const t of Array.isArray(e) ? e : [
            e
        ]){
            const e = ve(Object.assign(Object.assign({}, t), {
                isVirtual: !0
            }));
            n.push(e);
        }
        G.splice(void 0 === t ? G.length : t, 0, ...n), be();
        for (const e of n)ge(e);
        return oe(_), n;
    }
    function ve(e) {
        return ((0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(e) || e instanceof HTMLElement) && (e = {
            html: e
        }), Object.assign({
            index: -1,
            el: void 0,
            class: "",
            isVirtual: !0,
            dim: 0,
            pos: 0,
            offset: 0,
            html: "",
            src: ""
        }, e);
    }
    function ge(e) {
        if (!e) return;
        let t = e.el;
        t || (t = document.createElement("div"), e.el = t);
        const n = e.html ? e.html instanceof HTMLElement ? e.html : (0, $d05c6dadc12263a9$export$b368690db5627d91)(e.html) : void 0;
        n && ((0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(n, "f-html"), e.htmlEl = n, (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(t, "has-html"), t.append(n), te("contentReady", e));
    }
    function me(e) {
        if (!C || !e) return;
        let t = e.el;
        if (t) {
            if (t.setAttribute("index", e.index + ""), t.parentElement !== C) {
                let n;
                (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(t, O.classes.slide), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(t, e.class), Pe(e);
                for (const t of G)if (t.index > e.index) {
                    n = t.el;
                    break;
                }
                C.insertBefore(t, n && C.contains(n) ? n : null), te("attachSlideEl", e);
            }
            return t;
        }
    }
    function he(e) {
        const t = null == e ? void 0 : e.el;
        t && (t.remove(), xe(t), te("detachSlideEl", e));
    }
    function be() {
        for(let e = 0; e < G.length; e++){
            const t = G[e], n = t.el;
            n && (t.index !== e && xe(n), n.setAttribute("index", `${e}`)), t.index = e;
        }
    }
    function Ee() {
        var e, n, i;
        if (!A || !C) return;
        $ = W("rtl"), D = W("vertical"), z = D ? "height" : "width";
        const o = W("classes");
        (0, $00a976fcbdb71c27$export$4a80062ca50b57c7)(A, o.isLTR, !$), (0, $00a976fcbdb71c27$export$4a80062ca50b57c7)(A, o.isRTL, $), (0, $00a976fcbdb71c27$export$4a80062ca50b57c7)(A, o.isHorizontal, !D), (0, $00a976fcbdb71c27$export$4a80062ca50b57c7)(A, o.isVertical, D), (0, $00a976fcbdb71c27$export$4a80062ca50b57c7)(A, o.hasAdaptiveHeight, W("adaptiveHeight"));
        const s = C.getBoundingClientRect();
        if (!s.width && !s.height) return;
        const r = function() {
            let e = 0;
            if (C) {
                let t = document.createElement("div");
                (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(t, O.classes.slide), C.appendChild(t), e = t.getBoundingClientRect()[z], t.remove(), t = void 0;
            }
            return e;
        }();
        for (const n of X){
            const i = n.el;
            let o = 0;
            if (!n.isVirtual && i && (0, $d85d37926b6a3a9e$export$8ee0fc9ee280b4ee)(i)) {
                let t = !1;
                i.parentElement && i.parentElement === C || (C.appendChild(i), t = !0), o = i.getBoundingClientRect()[z], t && (null === (e = i.parentElement) || void 0 === e || e.removeChild(i));
            } else o = r;
            n.dim = o;
        }
        if (H = !1, W("infinite")) {
            H = !0;
            const e = ue(), t = ce();
            let n = de();
            if (V) {
                const e = C.getBoundingClientRect();
                n += e.left, n += e.right - e.width;
            }
            for(let i = 0; i < X.length; i++){
                const o = X[i].dim + t;
                if (e - o < n && e - o - n < o) {
                    H = !1;
                    break;
                }
            }
        }
        if (function() {
            if (!A) return;
            be();
            const e = de(), t = ce(), n = ue(!1);
            let i = W("slidesPerPage");
            i = "auto" === i ? 1 / 0 : parseFloat(i + ""), K = [];
            let o = 0, s = 0;
            for (const n of X)(!K.length || o + n.dim - e > .05 || s >= i) && (K.push({
                index: K.length,
                slides: [],
                dim: 0,
                offset: 0,
                pos: 0
            }), o = 0, s = 0), K[K.length - 1].slides.push(n), o += n.dim + t, s++;
            const r = W("center"), l = W("fill");
            let c = 0;
            for (const i of K){
                i.dim = (i.slides.length - 1) * t;
                for (const e of i.slides)i.dim += e.dim;
                i.offset = c, i.pos = c, !1 !== r && (i.pos -= .5 * (e - i.dim)), l && !H && n > e && (i.pos = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(0, i.pos, n - e)), c += i.dim + t;
            }
            const d = [];
            let u;
            for (const e of K){
                const t = Object.assign({}, e);
                u && t.pos === u.pos ? (u.dim += t.dim, u.slides = [
                    ...u.slides,
                    ...t.slides
                ]) : (u = t, t.index = d.length, d.push(t));
            }
            K = d, re();
        }(), k = (null === (n = K[0]) || void 0 === n ? void 0 : n.pos) || 0, N = (null === (i = K[K.length - 1]) || void 0 === i ? void 0 : i.pos) || 0, 0 === L) !function() {
            var e;
            j = void 0, B = W("initialPage");
            const t = W("initialSlide") || void 0;
            void 0 !== t && (B = Re.getPageIndex(t) || 0), B = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(0, B, K.length - 1), F = (null === (e = K[B]) || void 0 === e ? void 0 : e.pos) || 0, I = F;
        }();
        else {
            const e = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : F;
            (e < k || e > N) && (B = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(0, B, K.length - 1), I = K[B || 0].pos || 0);
        }
        te("refresh");
    }
    function xe(e) {
        if (!e || !(0, $d85d37926b6a3a9e$export$8ee0fc9ee280b4ee)(e)) return;
        const n = parseInt(e.getAttribute("index") || "-1");
        let i = "";
        for (const t of Array.from(e.classList)){
            const e = t.match(/^f-(\w+)(Out|In)$/);
            e && e[1] && (i = e[1] + "");
        }
        if (!e || !i) return;
        const o = [
            `f-${i}Out`,
            `f-${i}In`,
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        e.removeEventListener("animationend", ye), (0, $c5899590eea05f92$export$c2255604a80b4506)(e, o.join(" ")), Y.delete(n);
    }
    function we() {
        if (!C) return;
        const e = Y.size;
        for (const e of X)xe(e.el);
        Y.clear(), e && Te();
    }
    function ye(e) {
        "f-" === e.animationName.substring(0, 2) && (xe(e.target), Y.size || ((0, $c5899590eea05f92$export$c2255604a80b4506)(A, "in-transition"), !q && Math.abs(Re.getPosition(!0) - I) < .5 && (q = !0, te("settle"))), Te());
    }
    function Me(e) {
        if (e.defaultPrevented) return;
        const t = e.composedPath()[0];
        if (t.closest("[data-carousel-go-prev]")) return $8024d5e188ad0565$var$g(e), void Re.prev();
        if (t.closest("[data-carousel-go-next]")) return $8024d5e188ad0565$var$g(e), void Re.next();
        const n = t.closest("[data-carousel-go-to]");
        if (n) return $8024d5e188ad0565$var$g(e), void Re.goTo(parseFloat(n.dataset.carouselGoTo || "") || 0);
        if (t.closest("[data-carousel-download]")) {
            $8024d5e188ad0565$var$g(e);
            const t = K[B].slides[0];
            if (t.downloadSrc || "image" === t.type && t.src) {
                const e = t.downloadFilename, n = document.createElement("a"), i = t.downloadSrc || t.src || "";
                n.href = i, n.target = "_blank", n.download = e || i, n.click();
            }
        } else te("click", e);
    }
    function Se(e) {
        var t;
        const n = e.el;
        n && (null === (t = n.querySelector(".f-spinner")) || void 0 === t || t.remove(), (0, $c5899590eea05f92$export$c2255604a80b4506)(n, "is-loading"));
    }
    function je(e) {
        var t;
        const n = e.el;
        n && (null === (t = n.querySelector(".f-html.is-error")) || void 0 === t || t.remove(), (0, $c5899590eea05f92$export$c2255604a80b4506)(n, "has-error"));
    }
    function Pe(e) {
        var t;
        e || (e = null === (t = K[B]) || void 0 === t ? void 0 : t.slides[0]);
        const i = null == e ? void 0 : e.el;
        if (!i) return;
        let o = W("formatCaption", e);
        void 0 === o && (o = e.caption), o = o || "";
        const s = W("captionEl");
        if (s && s instanceof HTMLElement) {
            if (e.index !== B) return;
            if ((0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(o) && (s.innerHTML = Z(o + "")), o instanceof HTMLElement) {
                if (o.parentElement === s) return;
                s.innerHTML = "", o.parentElement && (o = o.cloneNode(!0)), s.append(o);
            }
            return;
        }
        if (!o) return;
        let r = e.captionEl || i.querySelector(".f-caption");
        !r && o instanceof HTMLElement && o.classList.contains("f-caption") && (r = o), r || (r = document.createElement("div"), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(r, "f-caption"), (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(o) ? r.innerHTML = Z(o + "") : o instanceof HTMLElement && (o.parentElement && (o = o.cloneNode(!0)), r.append(o)));
        const l = `f-caption-${$8024d5e188ad0565$var$b}_${e.index}`;
        r.setAttribute("id", l), r.dataset.selectable = "true", (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(i, "has-caption"), i.setAttribute("aria-labelledby", l), e.captionEl = r, i.insertAdjacentElement("beforeend", r);
    }
    function Le(t, i) {
        let { transition: o, tween: s } = Object.assign({
            transition: O.transition,
            tween: O.tween
        }, i || {});
        if (!A || !M) return;
        const r = K.length;
        if (!r) return;
        if (function(e, t) {
            var i, o, s, r;
            if (!(A && M && t && (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(t) && "tween" !== t)) return !1;
            if ((null === (i = K[B]) || void 0 === i ? void 0 : i.slides.length) > 1) return !1;
            const l = K.length;
            let u = e > B ? 1 : -1;
            e = H ? (e % l + l) % l : (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(0, e, l - 1), $ && (u *= -1);
            const f = null === (o = K[B]) || void 0 === o ? void 0 : o.slides[0], p = null == f ? void 0 : f.index, v = null === (s = K[e]) || void 0 === s ? void 0 : s.slides[0], g = null == v ? void 0 : v.index, m = null === (r = K[e]) || void 0 === r ? void 0 : r.pos;
            if (void 0 === g || void 0 === p || p === g || F === m || Math.abs(de() - ((null == v ? void 0 : v.dim) || 0)) > 1) return !1;
            q = !1, M.pause(), we(), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(A, "in-transition"), F = I = m;
            const h = me(f), b = me(v);
            return se(), h && (Y.add(p), h.style.transform = "", h.addEventListener("animationend", ye), (0, $c5899590eea05f92$export$c2255604a80b4506)(h, O.classes.isSelected), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(h, `f-${t}Out to-${u > 0 ? "next" : "prev"}`)), b && (Y.add(g), b.style.transform = "", b.addEventListener("animationend", ye), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(b, O.classes.isSelected), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(b, `f-${t}In from-${u > 0 ? "prev" : "next"}`)), Te(), !0;
        }(t, o)) return;
        t = H ? (t % r + r) % r : (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(0, t, r - 1), I = K[t || 0].pos || 0;
        const l = M.isRunning() ? M.getEndValues().pos : F;
        if (Math.abs(I - l) < 1) return F = I, B !== t && (Pe(), re(), le(), j = B, B = t, te("change", B, j)), Te(), void (q || (q = !0, te("settle")));
        if (M.pause(), we(), H) {
            const e = ue(), t = Math.floor((l - K[0].pos) / e), n = I + t * e;
            I = [
                n + e,
                n,
                n - e
            ].reduce(function(e, t) {
                return Math.abs(t - l) < Math.abs(e - l) ? t : e;
            });
        }
        !1 !== o && (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(s) ? M.spring(s).from({
            pos: F
        }).to({
            pos: I
        }).start() : (F = I, se(), Te(), q || (q = !0, te("settle")));
    }
    function Te() {
        var e;
        if (!A || !C) return;
        const t = K[B];
        J = fe();
        const n = new Set;
        let i;
        const s = [];
        for (const o of X){
            if (o.isVirtual && !Y.has(o.index) && J.indexOf(o) < 0) continue;
            let l = me(o);
            if (!l) continue;
            s.push(o);
            const a = (null === (e = null == t ? void 0 : t.slides) || void 0 === e ? void 0 : e.indexOf(o)) > -1;
            if (a && n.add(l), !Y.has(o.index)) {
                const e = o.pos ? Math.round(1e4 * o.pos) / 1e4 : 0, t = D ? 0 : $ ? -1 * e : e, n = D ? e : 0, i = (0, $fff5597b4228e002$export$871de8747c9eaa88)(t, 0, o.dim, 0, 100), s = (0, $fff5597b4228e002$export$871de8747c9eaa88)(n, 0, o.dim, 0, 100), a = O.setTransform || void 0;
                a instanceof Function ? a(Re, o, {
                    x: t,
                    y: n,
                    xPercent: i,
                    yPercent: s
                }) : l.style.transform = t || n ? `translate3d(${i}%, ${s}%,0)` : "", l.dataset.x = `${t}`;
            }
            if (W("adaptiveHeight") && a) {
                const e = (l.firstElementChild || l).getBoundingClientRect().height;
                i = null == i ? e : Math.max(i, e);
            }
        }
        [
            ...(0, $98d57eda244cdfc4$export$2b0209f2592da03b)(C, `.${O.classes.slide}`)
        ].forEach((e)=>{
            const t = parseInt(e.getAttribute("index") || "-1"), i = G[t];
            i || e.remove(), (0, $00a976fcbdb71c27$export$4a80062ca50b57c7)(e, O.classes.isSelected, n.has(e)), i.isVirtual && !Y.has(i.index) && J.indexOf(i) < 0 && he(i);
        }), C && i && (C.style.height = `${i}px`), te("render", s);
    }
    function Oe() {
        var e;
        null == A || A.removeEventListener("click", Me), we(), document.removeEventListener("mousemove", ie), null == S || S.disconnect(), S = void 0;
        for (const n of G)n.el && (0, $d85d37926b6a3a9e$export$8ee0fc9ee280b4ee)(n.el) && (n.state = void 0, Se(n), je(n), he(n), n.isVirtual ? (null === (e = n.el) || void 0 === e || e.remove(), n.el = void 0) : (n.el.style.transform = "", null == C || C.appendChild(n.el)));
        for (const e of Object.values(R))null == e || e.destroy();
        R = {}, null == y || y.destroy(), y = void 0, null == M || M.destroy(), M = void 0;
        for (const e of Object.values(O.classes || {}))(0, $c5899590eea05f92$export$c2255604a80b4506)(A, e);
        (0, $c5899590eea05f92$export$c2255604a80b4506)(C, "is-draggable");
    }
    const Re = {
        add: function(e, t) {
            let n = F;
            const i = B, o = ue(), s = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : F, r = Math.floor((s - K[0].pos) / o), l = pe(e, t);
            for (const e of l)te("addSlide", e);
            return oe(_), Ee(), M && (i === B && (n -= r * o), I = K[B || 0].pos || 0, M.spring({
                clamp: !0,
                mass: 1,
                tension: 300,
                friction: 25,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: n
            }).to({
                pos: I
            }).start()), Te(), Re;
        },
        canGoPrev: function() {
            return H || B > 0;
        },
        canGoNext: function() {
            return H || B < K.length - 1;
        },
        destroy: function() {
            return te("destroy"), window.removeEventListener("resize", ne), Oe(), ee.clear(), A = null, K = [], G = [], O = Object.assign({}, $8024d5e188ad0565$var$m), R = {}, X = [], P = "", _ = "*", L = 2, Re;
        },
        emit: te,
        filter: function(e = "*") {
            return oe(e), Ee(), Te(), te("filter", e), Re;
        },
        getContainer: function() {
            return A;
        },
        getGapDim: ce,
        getGestures: function() {
            return y;
        },
        getLastMouseMove: function() {
            return $8024d5e188ad0565$var$h;
        },
        getOption: function(e) {
            return W(e);
        },
        getOptions: function() {
            return O;
        },
        getPage: function() {
            return K[B];
        },
        getPageIndex: function(e) {
            if (void 0 !== e) {
                for (const t of K || [])for (const n of t.slides)if (n.index === e) return t.index;
                return -1;
            }
            return B;
        },
        getPageProgress: function(e, t) {
            void 0 === e && (e = B);
            const n = K[e];
            if (!n) return e > B ? -1 : 1;
            const i = ue(), o = ce();
            let s = n.pos, r = Re.getPosition();
            if (H && !0 !== t) {
                const e = Math.floor((r - K[0].pos) / i);
                r -= e * i, s = [
                    s + i,
                    s,
                    s - i
                ].reduce(function(e, t) {
                    return Math.abs(t - r) < Math.abs(e - r) ? t : e;
                });
            }
            return (r - s) / (n.dim + o);
        },
        getPageVisibility: function(e) {
            void 0 === e && (e = B);
            const t = K[e];
            if (!t) return e > B ? -1 : 1;
            const n = Re.getPosition(), i = de();
            let o = t.pos;
            if (H) {
                const e = Re.getPosition(), t = ue(), n = o + Math.floor((e - K[0].pos) / t) * t;
                o = [
                    n + t,
                    n,
                    n - t
                ].reduce(function(t, n) {
                    return Math.abs(n - e) < Math.abs(t - e) ? n : t;
                });
            }
            return o > n && o + t.dim < n + i ? 1 : o < n ? (o + t.dim - n) / t.dim : o + t.dim > n + i ? (n + i - o) / t.dim : 0;
        },
        getPages: function() {
            return K;
        },
        getPlugins: function() {
            return R;
        },
        getPosition: function(e) {
            var t;
            let n = F;
            if (H && !0 !== e) {
                const e = ue();
                n -= Math.floor((F - (null === (t = K[0]) || void 0 === t ? void 0 : t.pos) || 0) / e) * e;
            }
            return n;
        },
        getSlides: function() {
            return G;
        },
        getState: function() {
            return L;
        },
        getTotalSlideDim: ue,
        getTween: function() {
            return M;
        },
        getViewport: function() {
            return C;
        },
        getViewportDim: de,
        getVisibleSlides: function(e) {
            return void 0 === e ? J : fe(e);
        },
        goTo: Le,
        hasNavigated: function() {
            return void 0 !== j;
        },
        hideError: je,
        hideLoading: Se,
        init: function() {
            if (!v || !(0, $d85d37926b6a3a9e$export$8ee0fc9ee280b4ee)(v)) throw new Error("No Element found");
            return 0 !== L && (Oe(), L = 0), A = v, T = x, window.removeEventListener("resize", ne), T.breakpoints && window.addEventListener("resize", ne), ne(), Re;
        },
        isInfinite: function() {
            return H;
        },
        isInTransition: function() {
            return Y.size > 0;
        },
        isRTL: function() {
            return $;
        },
        isSettled: function() {
            return q;
        },
        localize: function(e, t = []) {
            return Z(e, t);
        },
        next: function(e = {}) {
            return Le(B + 1, e), Re;
        },
        off: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])ee.has(n) && ee.set(n, ee.get(n).filter((e)=>e !== t));
            return Re;
        },
        on: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])ee.set(n, [
                ...ee.get(n) || [],
                t
            ]);
            return Re;
        },
        prev: function(e = {}) {
            return Le(B - 1, e), Re;
        },
        remove: function(e) {
            void 0 === e && (e = G.length - 1);
            const t = G[e];
            return t && (te("removeSlide", t), t.el && (xe(t.el), t.el.remove(), t.el = void 0), G.splice(e, 1), oe(_), Ee(), Te()), Re;
        },
        setPosition: function(e) {
            F = e, se(), Te();
        },
        showError: function(e, t) {
            Se(e), je(e);
            const n = e.el;
            if (n) {
                const i = document.createElement("div");
                (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(i, "f-html"), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(i, "is-error"), i.innerHTML = Z(t || "<p>{{ERROR}}</p>"), e.htmlEl = i, (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(n, "has-html"), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(n, "has-error"), n.insertAdjacentElement("afterbegin", i), te("contentReady", e);
            }
            return Re;
        },
        showLoading: function(e) {
            const t = e.el, n = null == t ? void 0 : t.querySelector(".f-spinner");
            if (!t || n) return Re;
            const i = W("spinnerTpl"), o = (0, $d05c6dadc12263a9$export$b368690db5627d91)(i);
            return o && ((0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(o, "f-spinner"), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(t, "is-loading"), t.insertAdjacentElement("beforeend", o)), Re;
        },
        version: "6.0.18"
    };
    return Re;
};
$8024d5e188ad0565$export$144901db2ea8e967.l10n = {
    en_EN: (0, $bfaeb8c92ccc8716$export$30568d076ec2f42)
}, $8024d5e188ad0565$export$144901db2ea8e967.getDefaults = ()=>$8024d5e188ad0565$var$m;


/*! License details at fancyapps.com/license */ 




/*! License details at fancyapps.com/license */ const $b3fda993920a4c14$export$b539ed14f4f9e78 = (t = !0, e = "--f-scrollbar-compensate", s = "--f-body-margin", o = "hide-scrollbar")=>{
    const n = document, r = n.body, l = n.documentElement;
    if (t) {
        if (r.classList.contains(o)) return;
        let t = window.innerWidth - l.getBoundingClientRect().width;
        t < 0 && (t = 0), l.style.setProperty(e, `${t}px`);
        const n = parseFloat(window.getComputedStyle(r).marginRight);
        n && r.style.setProperty(s, `${n}px`), r.classList.add(o);
    } else r.classList.remove(o), r.style.setProperty(s, ""), n.documentElement.style.setProperty(e, "");
};



/*! License details at fancyapps.com/license */ function $d1923504fa01932f$export$71594e8a50f746f4() {
    return !("undefined" == typeof window || !window.document || !window.document.createElement);
}






/*! License details at fancyapps.com/license */ 

/*! License details at fancyapps.com/license */ const $daa87a3edc07a964$export$b8b3234b4edfc4c2 = function(n = "", t = "", o = "") {
    return n.split(t).join(o);
};



const $efc2762d4fdebb63$var$a = {
    tpl: (e)=>`<img class="f-panzoom__content" \n    ${e.srcset ? 'data-lazy-srcset="{{srcset}}"' : ""} \n    ${e.sizes ? 'data-lazy-sizes="{{sizes}}"' : ""} \n    data-lazy-src="{{src}}" alt="{{alt}}" />`
}, $efc2762d4fdebb63$export$b7fc409e12a7dcec = ()=>{
    let s;
    function l(t, o) {
        const n = null == s ? void 0 : s.getOptions().Zoomable;
        let i = ((0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(n) ? Object.assign(Object.assign({}, $efc2762d4fdebb63$var$a), n) : $efc2762d4fdebb63$var$a)[t];
        return i && "function" == typeof i && o ? i(o) : i;
    }
    function r() {
        s && (s.on("addSlide", u), s.on("removeSlide", f), s.on("attachSlideEl", m), s.on("click", d), s.on("change", c));
    }
    function c() {
        g();
    }
    function d(e, t) {
        const o = t.target;
        o && !t.defaultPrevented && o.dataset.panzoomAction && p(o.dataset.panzoomAction);
    }
    function u(e, i) {
        if (!s) return;
        const a = i.el;
        if (!a) return;
        const r = i.src || i.lazySrc || "", c = i.alt || i.caption || `Image #${i.index}`, d = i.srcset || i.lazySrcset || "", u = i.sizes || i.lazySizes || "";
        if (r && (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(r) && !i.html && (!i.type || "image" === i.type)) {
            i.type = "image";
            let e = l("tpl", i);
            e = (0, $daa87a3edc07a964$export$b8b3234b4edfc4c2)(e, "{{src}}", r + ""), e = (0, $daa87a3edc07a964$export$b8b3234b4edfc4c2)(e, "{{alt}}", c + ""), e = (0, $daa87a3edc07a964$export$b8b3234b4edfc4c2)(e, "{{srcset}}", d + ""), e = (0, $daa87a3edc07a964$export$b8b3234b4edfc4c2)(e, "{{sizes}}", u + ""), a.insertAdjacentHTML("afterbegin", e);
        }
        if (!a.querySelector(".f-panzoom__content")) return;
        const f = i.width && "auto" !== i.width ? parseFloat(i.width + "") : "auto", m = i.height && "auto" !== i.height ? parseFloat(i.height + "") : "auto", p = (0, $0d16c58404501d51$export$b704d075ddd20210)(a, Object.assign({
            width: f,
            height: m,
            classes: {
                container: "f-zoomable"
            },
            event: ()=>null == s ? void 0 : s.getLastMouseMove(),
            spinnerTpl: ()=>(null == s ? void 0 : s.getOption("spinnerTpl")) || ""
        }, l("Panzoom")));
        p.on("*", (e, t, ...o)=>{
            s && ("loading" === t && (i.state = 0), "loaded" === t && (i.state = 1), "error" === t && (i.state = 2, null == s || s.showError(i, "{{IMAGE_ERROR}}")), s.emit(`panzoom:${t}`, i, ...o), "ready" === t && s.emit("contentReady", i), i.index === s.getPageIndex() && g());
        }), i.panzoomRef = p;
    }
    function f(e, t) {
        t.panzoomRef && (t.panzoomRef.destroy(), t.panzoomRef = void 0);
    }
    function m(e, t) {
        const o = t.panzoomRef;
        if (o) switch(o.getState()){
            case 0:
                o.init();
                break;
            case 3:
                o.execute((0, $0d16c58404501d51$export$9520bccbaf78266).Reset, {
                    velocity: 0
                });
        }
    }
    function g() {
        var e;
        const t = null == s ? void 0 : s.getContainer();
        if (!t) return;
        const o = null === (e = null == s ? void 0 : s.getPage()) || void 0 === e ? void 0 : e.slides[0].panzoomRef, n = (null == o ? void 0 : o.canZoomIn()) || !1, a = (null == o ? void 0 : o.canZoomOut()) || !1, l = (null == o ? void 0 : o.isFullsize()) || !1, r = !o || 3 !== (null == o ? void 0 : o.getState());
        for (const e of (null == t ? void 0 : t.querySelectorAll("[data-panzoom-action]")) || []){
            const t = e.dataset.panzoomAction;
            let o = !1;
            if (r) o = !0;
            else switch(t){
                case (0, $0d16c58404501d51$export$9520bccbaf78266).ZoomIn:
                    n || (o = !0);
                    break;
                case (0, $0d16c58404501d51$export$9520bccbaf78266).ZoomOut:
                    a || (o = !0);
                    break;
                case (0, $0d16c58404501d51$export$9520bccbaf78266).ToggleFull:
                    n || a || (o = !0);
                    const t1 = e.querySelector("g");
                    t1 && (t1.style.display = l ? "none" : "");
                    break;
                case (0, $0d16c58404501d51$export$9520bccbaf78266).ToggleCover:
                case (0, $0d16c58404501d51$export$9520bccbaf78266).ToggleMax:
                    n || a || (o = !0);
            }
            o ? (e.setAttribute("aria-disabled", ""), e.setAttribute("tabindex", "-1")) : (e.removeAttribute("aria-disabled"), e.removeAttribute("tabindex"));
        }
    }
    function p(e, ...t) {
        var o;
        null === (o = null == s ? void 0 : s.getPage().slides[0].panzoomRef) || void 0 === o || o.execute(e, ...t);
    }
    return {
        init: function(e) {
            s = e, !1 !== s.getOptions().Zoomable && s.on("initPlugins", r);
        },
        destroy: function() {
            if (s) {
                s.off("addSlide", u), s.off("removeSlide", f), s.off("attachSlideEl", m), s.off("change", c);
                for (const e of s.getSlides())f(0, e);
            }
            s = void 0;
        },
        execute: p
    };
};


/*! License details at fancyapps.com/license */ 
const $ea05e57d53ba8559$var$e = {
    syncOnChange: !1,
    syncOnClick: !0,
    syncOnHover: !1
}, $ea05e57d53ba8559$export$2ae15352e0a80063 = ()=>{
    let i, t;
    function o() {
        const t = null == i ? void 0 : i.getOptions().Sync;
        return (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(t) ? Object.assign(Object.assign({}, $ea05e57d53ba8559$var$e), t) : $ea05e57d53ba8559$var$e;
    }
    function s(n) {
        var e, s, l;
        i && n && (t = n, i.getOptions().classes = Object.assign(Object.assign({}, i.getOptions().classes), {
            isSelected: ""
        }), i.getOptions().initialSlide = (null === (s = null === (e = t.getPage()) || void 0 === e ? void 0 : e.slides[0]) || void 0 === s ? void 0 : s.index) || 0, o().syncOnChange && i.on("change", c), o().syncOnClick && i.on("click", g), o().syncOnHover && (null === (l = i.getViewport()) || void 0 === l || l.addEventListener("mouseover", u)), function() {
            if (!i || !t) return;
            i.on("ready", d), i.on("refresh", a), t.on("change", r), t.on("filter", f);
        }());
    }
    function l() {
        const n = o().target;
        i && n && s(n);
    }
    function d() {
        v();
    }
    function c() {
        var n;
        if (i && t) {
            const e = (null === (n = i.getPage()) || void 0 === n ? void 0 : n.slides) || [], o = t.getPageIndex(e[0].index || 0);
            o > -1 && t.goTo(o, i.hasNavigated() ? void 0 : {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function r() {
        var n;
        if (i && t) {
            const e = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
            e > -1 && i.goTo(e, t.hasNavigated() ? void 0 : {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function g(n, e) {
        var o;
        if (!i || !t) return;
        if (null === (o = i.getTween()) || void 0 === o ? void 0 : o.isRunning()) return;
        const s = null == i ? void 0 : i.getOptions().classes.slide;
        if (!s) return;
        const l = s ? e.target.closest(`.${s}`) : null;
        if (l) {
            const n = parseInt(l.getAttribute("index") || "") || 0, e = t.getPageIndex(n);
            t.goTo(e);
        }
    }
    function u(n) {
        i && g(0, n);
    }
    function a() {
        var n;
        if (i && t) {
            const e = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
            e > -1 && i.goTo(e, {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function f(n, e) {
        i && t && (i.filter(e), r());
    }
    function v() {
        var n, e, o;
        if (!t) return;
        const s = (null === (e = null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0]) || void 0 === e ? void 0 : e.index) || 0;
        for (const n of (null == i ? void 0 : i.getSlides()) || [])null === (o = n.el) || void 0 === o || o.classList.toggle("is-selected", n.index === s);
    }
    return {
        init: function(n) {
            i = n, i.on("initSlides", l);
        },
        destroy: function() {
            var n;
            null == i || i.off("ready", d), null == i || i.off("refresh", a), null == i || i.off("change", c), null == i || i.off("click", g), null === (n = null == i ? void 0 : i.getViewport()) || void 0 === n || n.removeEventListener("mouseover", u), null == t || t.off("change", r), null == t || t.off("filter", f), t = void 0, null == i || i.off("initSlides", l), i = void 0;
        },
        getTarget: function() {
            return t;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $c4fe8e007dd1caef$var$t = {
    showLoading: !0,
    preload: 1
}, $c4fe8e007dd1caef$var$a = "is-lazyloading", $c4fe8e007dd1caef$var$s = "is-lazyloaded", $c4fe8e007dd1caef$export$6f539aaa4f74fdd1 = ()=>{
    let l;
    function n() {
        const a = null == l ? void 0 : l.getOptions().Lazyload;
        return (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(a) ? Object.assign(Object.assign({}, $c4fe8e007dd1caef$var$t), a) : $c4fe8e007dd1caef$var$t;
    }
    function o(e) {
        const t = e.el;
        if (!t) return;
        const o = "[data-lazy-src],[data-lazy-srcset],[data-lazy-bg]", i = Array.from(t.querySelectorAll(o));
        t.matches(o) && i.push(t);
        for (const t of i){
            const o = t.dataset.lazySrc, i = t.dataset.lazySrcset, d = t.dataset.lazySizes, r = t.dataset.lazyBg, c = (t instanceof HTMLImageElement || t instanceof HTMLSourceElement) && (o || i), u = t instanceof HTMLElement && r;
            if (!c && !u) continue;
            const f = o || i || r;
            if (f) {
                if (c && f) n().showLoading && (null == l || l.showLoading(e)), t.addEventListener("load", ()=>{
                    null == l || l.hideLoading(e), t instanceof HTMLImageElement ? t.decode().then(()=>{
                        t.classList.remove($c4fe8e007dd1caef$var$a), t.classList.add($c4fe8e007dd1caef$var$s);
                    }) : (t.classList.remove($c4fe8e007dd1caef$var$a), t.classList.add($c4fe8e007dd1caef$var$s)), null == l || l.emit("lazyLoad:loaded", e, t, f);
                }), t.addEventListener("error", ()=>{
                    null == l || l.hideLoading(e), t.classList.remove($c4fe8e007dd1caef$var$a), t.classList.add("has-lazyerror"), null == l || l.emit("lazyLoad:error", e, t, f);
                }), t.classList.add("f-lazyload"), t.classList.add($c4fe8e007dd1caef$var$a), null == l || l.emit("lazyLoad:load", e, t, f), o && (t.src = o), i && (t.srcset = i), d && (t.sizes = d);
                else if (u) {
                    if (!document.body.contains(t)) document.createElement("img").src = r;
                    t.style.backgroundImage = `url('${r}')`;
                }
                delete t.dataset.lazySrc, delete t.dataset.lazySrcset, delete t.dataset.lazySizes, delete t.dataset.lazyBg;
            }
        }
    }
    function i() {
        if (!l) return;
        const e = n().preload, t = [
            ...l.getVisibleSlides()
        ], a = l.getPosition(), s = l.getViewportDim();
        t.push(...l.getVisibleSlides(a + s * e), ...l.getVisibleSlides(a - s * e));
        for (const e of t || [])o(e);
    }
    return {
        init: function(e) {
            l = e, l.on("render", i);
        },
        destroy: function() {
            null == l || l.off("render", i), l = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 


const $b28e7e2e7c1326ec$var$o = {
    prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg>',
    nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg>'
}, $b28e7e2e7c1326ec$export$b6e350ab9915297a = ()=>{
    let r, i, s;
    function l(n) {
        if (!r) return;
        const i = `<button data-carousel-go-${n} tabindex="0" class="f-button is-arrow is-${n}" title="{{${n.toUpperCase()}}}">` + function() {
            const e = null == r ? void 0 : r.getOptions().Arrows;
            return (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $b28e7e2e7c1326ec$var$o), e) : $b28e7e2e7c1326ec$var$o;
        }()[`${n}Tpl`] + "</button";
        return (0, $d05c6dadc12263a9$export$b368690db5627d91)(r.localize(i)) || void 0;
    }
    function a() {
        var t;
        null == i || i.remove(), i = void 0, null == s || s.remove(), s = void 0, null === (t = null == r ? void 0 : r.getContainer()) || void 0 === t || t.classList.remove("has-arrows");
    }
    function u() {
        r && !1 !== r.getOptions().Arrows && r.getPages().length > 1 ? (!function() {
            if (!r) return;
            const t = r.getViewport();
            t && (i || (i = l("prev"), i && t.insertAdjacentElement("beforebegin", i)), s || (s = l("next"), s && t.insertAdjacentElement("afterend", s)), (0, $00a976fcbdb71c27$export$4a80062ca50b57c7)(r.getContainer(), "has-arrows", !(!i && !s)));
        }(), r && (null == i || i.toggleAttribute("aria-disabled", !r.canGoPrev()), null == s || s.toggleAttribute("aria-disabled", !r.canGoNext()))) : a();
    }
    return {
        init: function(t) {
            r = t.on([
                "change",
                "refresh"
            ], u);
        },
        destroy: function() {
            a(), null == r || r.off([
                "change",
                "refresh"
            ], u), r = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 


/*! License details at fancyapps.com/license */ const $7de7f345654b3e19$export$1a5903fe7331d64a = {
    moveLeft: {
        tpl: '<button data-panzoom-action="moveLeft" class="f-button" title="{{MOVE_LEFT}}"><svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg></button>'
    },
    moveRight: {
        tpl: '<button data-panzoom-action="moveRight" class="f-button" title="{{MOVE_RIGHT}}"><svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg></button>'
    },
    moveUp: {
        tpl: '<button data-panzoom-action="moveUp" class="f-button" title="{{MOVE_UP}}"><svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg></button>'
    },
    moveDown: {
        tpl: '<button data-panzoom-action="moveDown" class="f-button" title="{{MOVE_DOWN}}"><svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg></button>'
    },
    zoomIn: {
        tpl: '<button data-panzoom-action="zoomIn" class="f-button" title="{{ZOOM_IN}}"><svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg></button>'
    },
    zoomOut: {
        tpl: '<button data-panzoom-action="zoomOut" class="f-button" title="{{ZOOM_OUT}}"><svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg></button>'
    },
    toggle1to1: {
        tpl: '<button data-panzoom-action="toggleFull" class="f-button" title="{{TOGGLE_FULL}}"><svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg></button>'
    },
    toggleFull: {
        tpl: '<button data-panzoom-action="toggleFull" class="f-button" title="{{TOGGLE_FULL}}"><svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg></button>'
    },
    rotateCCW: {
        tpl: '<button data-panzoom-action="rotateCCW" class="f-button" title="{{ROTATE_CCW}}"><svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg></button>'
    },
    rotateCW: {
        tpl: '<button data-panzoom-action="rotateCW" class="f-button" title="{{ROTATE_CW}}"><svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg></button>'
    },
    flipX: {
        tpl: '<button data-panzoom-action="flipX" class="f-button" title="{{FLIP_X}}"><svg><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg></button>'
    },
    flipY: {
        tpl: '<button data-panzoom-action="flipY" class="f-button" title="{{FLIP_Y}}"><svg><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg></button>'
    },
    reset: {
        tpl: '<button data-panzoom-action="reset" class="f-button" title="{{RESET}}"><svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg></button>'
    }
};



var $1a887a2c6587884b$export$68ae38b485887054;
!function(t) {
    t.Left = "left", t.middle = "middle", t.right = "right";
}($1a887a2c6587884b$export$68ae38b485887054 || ($1a887a2c6587884b$export$68ae38b485887054 = {}));
const $1a887a2c6587884b$var$s = Object.assign({
    counter: {
        tpl: '<div class="f-carousel__counter"><span data-carousel-page></span>/<span data-carousel-pages></span></div>'
    },
    download: {
        tpl: '<button data-carousel-download class="f-button" title="{{DOWNLOAD}}"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></button>'
    },
    autoplay: {
        tpl: '<button data-autoplay-action="toggle" class="f-button" title="{{TOGGLE_AUTOPLAY}}"><svg><g><path d="M5 3.5 19 12 5 20.5Z"/></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
    },
    thumbs: {
        tpl: '<button data-thumbs-action="toggle" class="f-button" title="{{TOGGLE_THUMBS}}"><svg><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1M9 21h1M14 21h1M19 21h1"/></svg></button>'
    }
}, (0, $7de7f345654b3e19$export$1a5903fe7331d64a)), $1a887a2c6587884b$var$a = {
    absolute: !1,
    display: {
        left: [],
        middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY",
            "reset"
        ],
        right: []
    },
    enabled: "auto",
    items: {}
}, $1a887a2c6587884b$export$4c260019440d418f = ()=>{
    let i, u;
    function d() {
        const e = null == i ? void 0 : i.getOptions().Toolbar;
        return (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $1a887a2c6587884b$var$a), e) : $1a887a2c6587884b$var$a;
    }
    function r() {
        var t, a, r;
        if (!(null == i ? void 0 : i.getOptions().Toolbar)) return;
        if (!i || u) return;
        let c = d().enabled;
        if (!c) return;
        let f = d().absolute;
        const g = i.getSlides().length > 1;
        let p = !1, b = !1;
        for (const t of i.getSlides())t.panzoomRef && (p = !0), (t.downloadSrc || "image" === t.type && t.src) && (b = !0);
        let m = (null === (t = i.getPlugins().Thumbs) || void 0 === t ? void 0 : t.isEnabled()) || !1, v = g && i.getPlugins().Autoplay || !1, h = i.getPlugins().Fullscreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled);
        if ("auto" === c && (c = p), !c) return;
        u = document.createElement("div"), u.classList.add("f-carousel__toolbar");
        const j = d().display, y = (0, $dcc16499f8d8077d$export$8b58be045bf06082)({}, $1a887a2c6587884b$var$s, d().items);
        for (const t of [
            "left",
            "middle",
            "right"
        ]){
            const l = j[t] || [], s = document.createElement("div");
            s.classList.add("f-carousel__toolbar__column"), s.classList.add(`is-${t}`);
            for (const t of l){
                let l;
                if ((0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(t)) {
                    if ("counter" === t && !g) continue;
                    if ("autoplay" === t && !v) continue;
                    if ((0, $7de7f345654b3e19$export$1a5903fe7331d64a)[t] && !p) continue;
                    if ("fullscreen" === t && !h) continue;
                    if ("thumbs" === t && !m) continue;
                    if ("download" === t && !b) continue;
                    l = y[t];
                }
                if ("object" == typeof t && (l = t), l && l.tpl) {
                    let t = i.localize(l.tpl);
                    t = t.split("<svg>").join('<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24">');
                    const e = (0, $d05c6dadc12263a9$export$b368690db5627d91)(t);
                    e && ("function" == typeof l.click && i && e.addEventListener("click", (t)=>{
                        t.preventDefault(), t.stopPropagation(), "function" == typeof l.click && i && l.click(i, t);
                    }), s.append(e));
                }
            }
            u.append(s);
        }
        u.childElementCount && (!0 === f && u.classList.add("is-absolute"), null === (a = i.getContainer()) || void 0 === a || a.classList.add("has-toolbar"), null === (r = i.getViewport()) || void 0 === r || r.insertAdjacentElement("beforebegin", u));
    }
    return {
        init: function(t) {
            i = t, i.on("initSlides", r);
        },
        destroy: function() {
            var t;
            null == i || i.off("initSlides", r), null === (t = null == i ? void 0 : i.getContainer()) || void 0 === t || t.classList.remove("has-toolbar"), null == u || u.remove(), u = void 0;
        },
        add: function(t, e) {
            $1a887a2c6587884b$var$s[t] = e;
        },
        isEnabled: function() {
            return !!u;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $c67740581e990826$var$e = {
    autoStart: !0,
    pauseOnHover: !0,
    showProgressbar: !0,
    timeout: 2e3
}, $c67740581e990826$export$6c96167f46662e38 = ()=>{
    let n, o, i = !1, a = !1, l = !1, s = null;
    function r(o) {
        const i = null == n ? void 0 : n.getOptions().Autoplay;
        let a = ((0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(i) ? Object.assign(Object.assign({}, $c67740581e990826$var$e), i) : $c67740581e990826$var$e)[o];
        return a && "function" == typeof a && n ? a(n) : a;
    }
    function u() {
        var t;
        const e = (null === (t = null == n ? void 0 : n.getPage()) || void 0 === t ? void 0 : t.slides) || [];
        for (const t of e)if (0 === t.state) return !0;
        return !1;
    }
    function d() {
        clearTimeout(o), o = void 0;
    }
    function g() {
        if (o) return;
        if (l) return;
        if (u()) return;
        if (!(null == n ? void 0 : n.isSettled())) return;
        !function() {
            var t, e, o, i;
            if (!n) return;
            if (v(), !r("showProgressbar")) return;
            let a = r("progressbarParentEl");
            !a && (null === (t = n.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled()) && (a = n.getContainer());
            if (!a && !0 !== (null === (e = n.getPlugins().Toolbar) || void 0 === e ? void 0 : e.isEnabled())) {
                const t = (null === (o = n.getPages()[0]) || void 0 === o ? void 0 : o.slides) || [], e = (null === (i = n.getPage()) || void 0 === i ? void 0 : i.slides) || [];
                1 === t.length && 1 === e.length && (a = e[0].el);
            }
            a || (a = n.getViewport());
            if (!a) return;
            s = document.createElement("div"), s.classList.add("f-progressbar"), a.prepend(s);
            const l = r("timeout") || 1e3;
            s.style.animationDuration = `${l}ms`;
        }();
        const t = r("timeout");
        o = setTimeout(()=>{
            n && i && !a && (n.isInfinite() || n.getPageIndex() !== n.getPages().length - 1 ? n.next() : n.goTo(0));
        }, t);
    }
    function f() {
        var t, e;
        if (!n || n.getPages().length < 2 || !1 === n.getOptions().Autoplay) return;
        if (i) return;
        i = !0, n.emit("autoplay:start", r("timeout")), null === (t = n.getContainer()) || void 0 === t || t.classList.add("has-autoplay"), null === (e = n.getTween()) || void 0 === e || e.on("start", b);
        const o = null == n ? void 0 : n.getContainer();
        o && r("pauseOnHover") && matchMedia("(hover: hover)").matches && (o.addEventListener("mouseenter", E, !1), o.addEventListener("mouseleave", x, !1)), n.on("change", h), n.on("settle", y), n.on("contentReady", p), n.on("panzoom:animationStart", c), n.isSettled() && g();
    }
    function c() {
        var t, e;
        if (d(), v(), i && n) {
            n.emit("autoplay:end"), null === (t = n.getContainer()) || void 0 === t || t.classList.remove("has-autoplay"), null === (e = n.getTween()) || void 0 === e || e.off("start", b);
            const o = null == n ? void 0 : n.getContainer();
            o && (o.removeEventListener("mouseenter", E, !1), o.removeEventListener("mouseleave", x, !1));
        }
        n && (n.off("change", h), n.off("settle", y), n.off("contentReady", p), n.off("panzoom:animationStart", c)), i = !1, a = !1;
    }
    function v() {
        s && (s.remove(), s = null);
    }
    function m() {
        n && n.getPages().length > 1 && r("autoStart") && f();
    }
    function p(t) {
        n && n.getPageIndex(t.index) === n.getPageIndex() && (!i || l || u() || g());
    }
    function P(t, e) {
        const n = e.target;
        n && !e.defaultPrevented && "toggle" === n.dataset.autoplayAction && L.toggle();
    }
    function h() {
        !n || !(null == n ? void 0 : n.isInfinite()) && n.getPageIndex() === n.getPages().length - 1 ? c() : (v(), d());
    }
    function y() {
        !i || l || a || g();
    }
    function b() {
        d(), v();
    }
    function E() {
        l = !0, i && (v(), d());
    }
    function x() {
        l = !1, i && !a && (null == n ? void 0 : n.isSettled()) && g();
    }
    const L = {
        init: function(t) {
            n = t, n.on("ready", m), n.on("click", P);
        },
        destroy: function() {
            c(), null == n || n.off("ready", m), null == n || n.off("click", P), n = void 0;
        },
        isEnabled: ()=>i,
        pause: function() {
            a = !0, d();
        },
        resume: function() {
            a = !1, i && !l && g();
        },
        start () {
            f();
        },
        stop () {
            c();
        },
        toggle () {
            i ? c() : f();
        }
    };
    return L;
};


/*! License details at fancyapps.com/license */ 





const $9bd794b081a4d35f$var$s = {
    Carousel: {
        Lazyload: {
            showLoading: !1
        }
    },
    minCount: 2,
    showOnStart: !0,
    thumbTpl: '<button aria-label="Slide to #{{page}}"><img draggable="false" alt="{{alt}}" data-lazy-src="{{src}}" /></button>',
    type: "modern"
};
let $9bd794b081a4d35f$var$r;
const $9bd794b081a4d35f$export$73e055b807a6709 = ()=>{
    let u, a, d, c = 0, f = 0, g = !0;
    function m(e) {
        const n = null == u ? void 0 : u.getOptions().Thumbs;
        let i = ((0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(n) ? Object.assign(Object.assign({}, $9bd794b081a4d35f$var$s), n) : $9bd794b081a4d35f$var$s)[e];
        return i && "function" == typeof i ? i() : i;
    }
    function h() {
        if (!u) return !1;
        if (!1 === (null == u ? void 0 : u.getOptions().Thumbs)) return !1;
        let t = 0;
        for (const e of u.getSlides())e.thumbSrc && t++;
        return t >= m("minCount");
    }
    function p() {
        return "modern" === m("type");
    }
    function v(t = !1) {
        const e = null == u ? void 0 : u.getContainer();
        if (u && e && !d && h()) {
            if (!d) {
                const t = e.nextElementSibling;
                (null == t ? void 0 : t.classList.contains("f-thumbs")) && (d = t);
            }
            if (!d) {
                d = document.createElement("div"), d.classList.add("f-thumbs");
                const t = m("parentEl");
                t ? t.insertAdjacentElement("beforeend", d) : e.insertAdjacentElement("afterend", d);
            }
            d.classList.add(`is-${m("type")}`), d.classList.add("is-syncing"), t && (d.style.maxHeight = "0px");
        }
    }
    function b(t) {
        let e = t.thumb ? t.thumb instanceof HTMLImageElement ? t.thumb.src : t.thumb : t.thumbSrc || void 0, i = m("thumbTpl");
        return i = (0, $daa87a3edc07a964$export$b8b3234b4edfc4c2)(i, "{{alt}}", `Thumbnail #${t.index}`), i = (0, $daa87a3edc07a964$export$b8b3234b4edfc4c2)(i, "{{src}}", e + ""), i = (0, $daa87a3edc07a964$export$b8b3234b4edfc4c2)(i, "{{index}}", `${t.index}`), i = (0, $daa87a3edc07a964$export$b8b3234b4edfc4c2)(i, "{{page}}", `${t.index || 1}`), {
            html: i,
            class: t.thumbClass
        };
    }
    function y() {
        var t, n;
        if (!$9bd794b081a4d35f$var$r) return;
        if (!u || !d || a) return;
        const i = [];
        for (const t of u.getSlides())i.push(b(t));
        i.length && (a = $9bd794b081a4d35f$var$r(d, (0, $dcc16499f8d8077d$export$8b58be045bf06082)({}, {
            Sync: {
                target: u
            },
            Lazyload: {
                preload: 1
            },
            slides: i,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                slide: "f-thumbs__slide"
            },
            initialSlide: u.getOptions().initialPage,
            center: !0,
            fill: !p(),
            infinite: !1,
            dragFree: !0,
            rtl: u.getOptions().rtl || !1,
            slidesPerPage: (t)=>{
                let e = 0;
                return p() && (!function() {
                    if (!p()) return;
                    if (!d) return;
                    const t = (t)=>d && parseFloat(getComputedStyle(d).getPropertyValue("--f-thumb-" + t)) || 0;
                    c = t("width"), f = t("clip-width");
                }(), e = 4 * (c - f)), t && t.getTotalSlideDim() <= t.getViewportDim() - e ? 1 / 0 : 1;
            }
        }, $9bd794b081a4d35f$var$s.Carousel || {}, m("Carousel") || {}), {
            Sync: (0, $ea05e57d53ba8559$export$2ae15352e0a80063),
            Lazyload: (0, $c4fe8e007dd1caef$export$6f539aaa4f74fdd1)
        }).init(), null === (t = a.getGestures()) || void 0 === t || t.on("start", ()=>{
            g = !1;
        }), a.on("click", (t, e)=>{
            const n = e.target;
            if (n) {
                const t = n.matches("button") ? n : n.firstElementChild;
                t && t.matches("button") && (e.preventDefault(), t.focus({}));
            }
        }), null === (n = u.getContainer()) || void 0 === n || n.classList.add("has-thumbs"), w());
    }
    function x() {
        var t;
        h() && (m("showOnStart") && (v(), y()), null === (t = null == u ? void 0 : u.getGestures()) || void 0 === t || t.on("start", P), null == u || u.on("addSlide", L), null == u || u.on("click", j));
    }
    function P() {
        var t, e;
        g = !0;
        (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = document.activeElement) || void 0 === e || e.blur());
    }
    function S() {
        var t, e;
        null == d || d.classList.toggle("is-syncing", !1 === (null == u ? void 0 : u.hasNavigated()) || (null === (t = null == u ? void 0 : u.getTween()) || void 0 === t ? void 0 : t.isRunning())), w(), (null === (e = null == u ? void 0 : u.getGestures()) || void 0 === e ? void 0 : e.isPointerDown()) && function() {
            if (!p()) return;
            if (!u || !a) return;
            if (!g) return;
            const t = a.getTween(), e = a.getPages(), n = u.getPageIndex() || 0, o = u.getPageProgress() || 0;
            if (!(u && e && e[n] && t)) return;
            const l = t.isRunning() ? t.getCurrentValues().pos : a.getPosition();
            if (void 0 === l) return;
            let s = e[n].pos + o * (c - f);
            s = (0, $e99c7d958570a616$export$7d15b64cf5a3a4c4)(e[0].pos, s, e[e.length - 1].pos), t.from({
                pos: l
            }).to({
                pos: s
            }).start();
        }();
    }
    function C() {
        g = !0;
    }
    function L(t, e) {
        null == a || a.add(b(e), e.index);
    }
    function j(t, e) {
        const n = e.target;
        n && !e.defaultPrevented && "toggle" === n.dataset.thumbsAction && function() {
            if (d || (v(!0), y()), !d) return;
            const t = d.style.maxHeight;
            d.style.maxHeight = t ? "" : "0px";
        }();
    }
    function w() {
        if (!p()) return;
        if (!u || !a) return;
        const t = (null == a ? void 0 : a.getSlides()) || [];
        let e = -0.5 * c;
        for (const n of t){
            const t = n.el;
            if (!t) continue;
            let i = u.getPageProgress(n.index) || 0;
            i = Math.max(-1, Math.min(1, i)), i > -1 && i < 1 && (e += .5 * c * (1 - Math.abs(i))), i = Math.round(1e4 * i) / 1e4, e = Math.round(1e4 * e) / 1e4, t.style.setProperty("--progress", `${Math.abs(i)}`), t.style.setProperty("--shift", `${(null == u ? void 0 : u.isRTL()) ? -1 * e : e}px`), i > -1 && i < 1 && (e += .5 * c * (1 - Math.abs(i)));
        }
    }
    return {
        init: function(t, e) {
            $9bd794b081a4d35f$var$r = e, u = t, u.on("ready", x), u.on("render", S), u.on("change", C);
        },
        destroy: function() {
            var t, e;
            null == u || u.off("ready", x), null == u || u.off("render", S), null == u || u.off("change", C), null == u || u.off("addSlide", L), null == u || u.off("click", j), null === (t = null == u ? void 0 : u.getGestures()) || void 0 === t || t.off("start", P), null === (e = null == u ? void 0 : u.getContainer()) || void 0 === e || e.classList.remove("has-thumbs"), u = void 0, null == a || a.destroy(), a = void 0, null == d || d.remove(), d = void 0;
        },
        getContainer: function() {
            return d;
        },
        isEnabled: function() {
            return h();
        }
    };
};


/*! License details at fancyapps.com/license */ 

const $e7347e6cffdde041$var$a = {
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    }
}, $e7347e6cffdde041$export$13f9d3c4397c4713 = ()=>{
    let i;
    function l(t, a) {
        let i = a.src;
        if (!(0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(i)) return;
        let l = a.type;
        if (!l) {
            if (l || ("#" === i.charAt(0) ? l = "inline" : i.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.((a)?png|avif|gif|jp(g|eg)|pjp(eg)?|jfif|svg|webp|bmp|ico|tif(f)?)((\?|#).*)?$)/i) ? l = "image" : i.match(/\.(pdf)((\?|#).*)?$/i) ? l = "pdf" : i.match(/\.(html|php)((\?|#).*)?$/i) && (l = "iframe")), !l) {
                const t = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i);
                t && (i = `https://maps.google.${t[1]}/?ll=${(t[2] ? t[2] + "&z=" + Math.floor(parseFloat(t[3])) + (t[4] ? t[4].replace(/^\//, "&") : "") : t[4] + "").replace(/\?/, "&")}&output=${t[4] && t[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, l = "gmap");
            }
            if (!l) {
                const t = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i);
                t && (i = `https://maps.google.${t[1]}/maps?q=${t[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, l = "gmap");
            }
            a.src = i, a.type = l;
        }
    }
    function o(e, l) {
        "iframe" !== l.type && "pdf" !== l.type && "gmap" !== l.type || function(e) {
            if (!i || !e.el || !e.src) return;
            const l = document.createElement("iframe");
            l.classList.add("f-iframe");
            for (const [e, o] of Object.entries(function() {
                const e = null == i ? void 0 : i.getOptions().Html;
                return (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $e7347e6cffdde041$var$a), e) : $e7347e6cffdde041$var$a;
            }().iframeAttr || {}))l.setAttribute(e, o);
            l.onerror = ()=>{
                i && 1 === i.getState() && i.showError(e, "{{IFRAME_ERROR}}");
            }, l.src = e.src;
            const o = document.createElement("div");
            if (o.classList.add("f-html"), o.append(l), e.width) {
                let t = `${e.width}`;
                t.match(/^\d+$/) && (t += "px"), o.style.maxWidth = `${t}`;
            }
            if (e.height) {
                let t = `${e.height}`;
                t.match(/^\d+$/) && (t += "px"), o.style.maxHeight = `${t}`;
            }
            if (e.aspectRatio) {
                const t = e.el.getBoundingClientRect();
                o.style.aspectRatio = `${e.aspectRatio}`, o.style[t.width > t.height ? "width" : "height"] = "auto", o.style[t.width > t.height ? "maxWidth" : "maxHeight"] = "none";
            }
            e.contentEl = l, e.htmlEl = o, e.el.classList.add("has-html"), e.el.classList.add("has-iframe"), e.el.classList.add(`has-${e.type}`), e.el.prepend(o), i.emit("contentReady", e);
        }(l);
    }
    function n(t, e) {
        var a, l;
        "iframe" !== e.type && "pdf" !== e.type && "gmap" !== e.type || (null == i || i.hideError(e), null === (a = e.contentEl) || void 0 === a || a.remove(), e.contentEl = void 0, null === (l = e.htmlEl) || void 0 === l || l.remove(), e.htmlEl = void 0);
    }
    return {
        init: function(t) {
            i = t, i.on("addSlide", l), i.on("attachSlideEl", o), i.on("detachSlideEl", n);
        },
        destroy: function() {
            null == i || i.off("addSlide", l), null == i || i.off("attachSlideEl", o), null == i || i.off("detachSlideEl", n), i = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 


const $499b83a5b5d74860$var$n = (t, e = {})=>{
    const o = new URL(t), n = new URLSearchParams(o.search), i = new URLSearchParams;
    for (const [t, o] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = o + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && i.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else i.set(t, e);
    }
    let l = i + "", s = t.match(/#t=((.*)?\d+s)/);
    return s && (l += `#t=${s[1]}`), l;
}, $499b83a5b5d74860$var$i = {
    autoplay: !1,
    html5videoTpl: '<video class="f-html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n    <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto",
        credentialless: ""
    },
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $499b83a5b5d74860$export$ae01dedf5c052bb = ()=>{
    let l, s = !1;
    function a() {
        const e = null == l ? void 0 : l.getOptions().Video;
        return (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $499b83a5b5d74860$var$i), e) : $499b83a5b5d74860$var$i;
    }
    function r() {
        var t;
        return null === (t = null == l ? void 0 : l.getPage()) || void 0 === t ? void 0 : t.slides[0];
    }
    const c = (t)=>{
        var e;
        try {
            let o = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === o.event) for (let o of Array.from((null === (e = null == l ? void 0 : l.getContainer()) || void 0 === e ? void 0 : e.getElementsByClassName("f-iframe")) || []))o instanceof HTMLIFrameElement && o.contentWindow === t.source && (o.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === o.event) {
                const t = document.getElementById(o.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    };
    function d(t, o) {
        const i = o.src;
        if (!(0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(i)) return;
        let l = o.type;
        if (!l || "html5video" === l) {
            const t = i.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i);
            t && (l = "html5video", o.html5videoFormat = o.html5videoFormat || "video/" + ("ogv" === t[1] ? "ogg" : t[1]));
        }
        if (!l || "youtube" === l) {
            const t = i.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i);
            if (t) {
                const e = Object.assign(Object.assign({}, a().youtube), o.youtube || {}), s = `www.youtube${e.nocookie ? "-nocookie" : ""}.com`, r = $499b83a5b5d74860$var$n(i, e), c = encodeURIComponent(t[2]);
                o.videoId = c, o.src = `https://${s}/embed/${c}?${r}`, o.thumb = o.thumb || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, l = "youtube";
            }
        }
        if (!l || "vimeo" === l) {
            const t = i.match(/^.+vimeo.com\/(?:\/)?(video\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/);
            if (t) {
                const e = Object.assign(Object.assign({}, a().vimeo), o.vimeo || {}), s = $499b83a5b5d74860$var$n(i, e), r = encodeURIComponent(t[2]), c = t[5] || "";
                o.videoId = r, o.src = `https://player.vimeo.com/video/${r}?${c ? `h=${c}${s ? "&" : ""}` : ""}${s}`, l = "vimeo";
            }
        }
        o.type = l;
    }
    function u(t, n) {
        "html5video" === n.type && function(t) {
            if (!l || !t.el || !t.src) return;
            const { el: n, src: i } = t;
            if (!n || !i) return;
            const s = t.html5videoTpl || a().html5videoTpl, r = t.html5videoFormat || a().html5videoFormat;
            if (!s) return;
            const c = t.poster || (t.thumb && (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(t.thumb) ? t.thumb : ""), d = (0, $d05c6dadc12263a9$export$b368690db5627d91)(s.replace(/\{\{src\}\}/gi, i + "").replace(/\{\{format\}\}/gi, r || "").replace(/\{\{poster\}\}/gi, c + ""));
            if (!d) return;
            const u = document.createElement("div");
            u.classList.add("f-html"), u.append(d), t.contentEl = d, t.htmlEl = u, n.classList.add(`has-${t.type}`), n.prepend(u), h(t), l.emit("contentReady", t);
        }(n), "youtube" !== n.type && "vimeo" !== n.type || function(t) {
            if (!l || !t.el || !t.src) return;
            const e = document.createElement("iframe");
            e.classList.add("f-iframe"), e.setAttribute("id", `f-iframe_${t.videoId}`);
            for (const [t, o] of Object.entries(a().iframeAttr || {}))e.setAttribute(t, o);
            e.onload = ()=>{
                var o;
                l && 1 === l.getState() && "youtube" === t.type && (null === (o = e.contentWindow) || void 0 === o || o.postMessage(JSON.stringify({
                    event: "listening",
                    id: e.getAttribute("id")
                }), "*"));
            }, e.onerror = ()=>{
                l && 1 === l.getState() && (null == l || l.showError(t, "{{IFRAME_ERROR}}"));
            }, e.src = t.src;
            const o = document.createElement("div");
            o.classList.add("f-html"), o.append(e), t.contentEl = e, t.htmlEl = o, t.el.classList.add("has-html"), t.el.classList.add("has-iframe"), t.el.classList.add(`has-${t.type}`), t.el.prepend(o), h(t), l.emit("contentReady", t);
        }(n);
    }
    function m(t, e) {
        var o, n;
        "html5video" !== e.type && "youtube" !== e.type && "vimeo" !== e.type || (null === (o = e.contentEl) || void 0 === o || o.remove(), e.contentEl = void 0, null === (n = e.htmlEl) || void 0 === n || n.remove(), e.htmlEl = void 0), e.poller && clearTimeout(e.poller);
    }
    function f() {
        s = !1;
    }
    function p() {
        if (s) return;
        s = !0;
        const t = r();
        (t && void 0 !== t.autoplay ? t.autoplay : a().autoplay) && (function() {
            var t;
            const e = r(), o = null == e ? void 0 : e.el;
            if (o && "html5video" === (null == e ? void 0 : e.type)) try {
                const t = o.querySelector("video");
                if (t) {
                    const e = t.play();
                    void 0 !== e && e.then(()=>{}).catch((e)=>{
                        t.muted = !0, t.play();
                    });
                }
            } catch (t) {}
            const n = null == e ? void 0 : e.htmlEl;
            n instanceof HTMLIFrameElement && (null === (t = n.contentWindow) || void 0 === t || t.postMessage('{"event":"command","func":"stopVideo","args":""}', "*"));
        }(), function() {
            const t = r(), e = null == t ? void 0 : t.type;
            if (!(null == t ? void 0 : t.el) || "youtube" !== e && "vimeo" !== e) return;
            const o = ()=>{
                if (t.contentEl && t.contentEl instanceof HTMLIFrameElement && t.contentEl.contentWindow) {
                    let e;
                    if ("true" === t.contentEl.dataset.ready) return e = "youtube" === t.type ? {
                        event: "command",
                        func: "playVideo"
                    } : {
                        method: "play",
                        value: "true"
                    }, e && t.contentEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                    "youtube" === t.type && (e = {
                        event: "listening",
                        id: t.contentEl.getAttribute("id")
                    }, t.contentEl.contentWindow.postMessage(JSON.stringify(e), "*"));
                }
                t.poller = setTimeout(o, 250);
            };
            o();
        }());
    }
    function h(t) {
        const e = null == t ? void 0 : t.htmlEl;
        if (t && e && ("html5video" === t.type || "youtube" === t.type || "vimeo" === t.type)) {
            if (e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.style.maxWidth = "", e.style.maxHeight = "", t.width) {
                let o = `${t.width}`;
                o.match(/^\d+$/) && (o += "px"), e.style.maxWidth = `${o}`;
            }
            if (t.height) {
                let o = `${t.height}`;
                o.match(/^\d+$/) && (o += "px"), e.style.maxHeight = `${o}`;
            }
            if (t.aspectRatio) {
                const o = t.aspectRatio.split("/"), n = parseFloat(o[0].trim()), i = o[1] ? parseFloat(o[1].trim()) : 0, l = n && i ? n / i : n;
                e.offsetHeight;
                const s = e.getBoundingClientRect(), a = l < (s.width || 1) / (s.height || 1);
                e.style.aspectRatio = `${t.aspectRatio}`, e.style.width = a ? "auto" : "", e.style.height = a ? "" : "auto";
            }
        }
    }
    function v() {
        h(r());
    }
    return {
        init: function(t) {
            l = t, l.on("addSlide", d), l.on("attachSlideEl", u), l.on("detachSlideEl", m), l.on("ready", p), l.on("change", f), l.on("settle", p), l.on("refresh", v), window.addEventListener("message", c);
        },
        destroy: function() {
            null == l || l.off("addSlide", d), null == l || l.off("attachSlideEl", u), null == l || l.off("detachSlideEl", m), null == l || l.off("ready", p), null == l || l.off("change", f), null == l || l.off("settle", p), null == l || l.off("refresh", v), window.removeEventListener("message", c), l = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $a9301b5c0275503c$var$n = {
    autoStart: !1,
    btnTpl: '<button data-fullscreen-action="toggle" class="f-button" title="{{TOGGLE_FULLSCREEN}}"><svg><g><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
}, $a9301b5c0275503c$var$t = "in-fullscreen-mode", $a9301b5c0275503c$export$159cd03be7087f39 = ()=>{
    let l;
    function u(t) {
        const u = null == l ? void 0 : l.getOptions().Fullscreen;
        let o = ((0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(u) ? Object.assign(Object.assign({}, $a9301b5c0275503c$var$n), u) : $a9301b5c0275503c$var$n)[t];
        return o && "function" == typeof o && l ? o(l) : o;
    }
    function o() {
        var e;
        null === (e = null == l ? void 0 : l.getPlugins().Toolbar) || void 0 === e || e.add("fullscreen", {
            tpl: u("btnTpl")
        });
    }
    function c() {
        if (u("autoStart")) {
            const e = r();
            e && d(e);
        }
    }
    function i(e, n) {
        const t = n.target;
        t && !n.defaultPrevented && "toggle" === t.dataset.fullscreenAction && b();
    }
    function s(e) {
        r() && "Escape" === e.key && !e.defaultPrevented && b();
    }
    function r() {
        return u("el") || (null == l ? void 0 : l.getContainer()) || void 0;
    }
    function a() {
        const e = document;
        return e.fullscreenEnabled ? !!e.fullscreenElement : !!e.webkitFullscreenEnabled && !!e.webkitFullscreenElement;
    }
    function d(e) {
        const n = document;
        let l;
        return e || (e = n.documentElement), n.fullscreenEnabled ? l = e.requestFullscreen() : n.webkitFullscreenEnabled && (l = e.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)), l && l.then(()=>{
            e.classList.add($a9301b5c0275503c$var$t);
        }), l;
    }
    function f() {
        const e = document;
        let n;
        return e.fullscreenEnabled ? n = e.fullscreenElement && e.exitFullscreen() : e.webkitFullscreenEnabled && (n = e.webkitFullscreenElement && e.webkitExitFullscreen()), n && n.then(()=>{
            var e;
            null === (e = r()) || void 0 === e || e.classList.remove($a9301b5c0275503c$var$t);
        }), n;
    }
    function b() {
        const e = r();
        e && (a() ? f() : d(e));
    }
    return {
        init: function(e) {
            l = e, l.on("initPlugins", o), l.on("ready", c), l.on("click", i);
        },
        destroy: function() {
            null == l || l.off("initPlugins", o), null == l || l.off("ready", c), null == l || l.off("click", i), document.removeEventListener("keydown", s, !0);
        },
        exit: f,
        inFullscreen: a,
        request: d,
        toggle: b
    };
};


/*! License details at fancyapps.com/license */ 
let $6e235e51c361c72d$var$e, $6e235e51c361c72d$var$n = !1, $6e235e51c361c72d$var$o = !1, $6e235e51c361c72d$var$i = !1, $6e235e51c361c72d$var$r = !1;
const $6e235e51c361c72d$var$l = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), n = e[e.length - 1], o = n && /^\+?\d+$/.test(n) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: o
    };
}, $6e235e51c361c72d$var$a = ()=>{
    if (!$6e235e51c361c72d$var$e || $6e235e51c361c72d$var$e.getInstance()) return;
    const { slug: t, index: n } = $6e235e51c361c72d$var$l();
    if (!t) return;
    let o = document.querySelector(`[data-slug="${t}"]`);
    if (o && o.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), !$6e235e51c361c72d$var$e || $6e235e51c361c72d$var$e.getInstance()) return;
    const i = document.querySelectorAll(`[data-fancybox="${t}"]`);
    i.length && (o = i[n - 1], o && o.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $6e235e51c361c72d$var$s = ()=>{
    var t, n, o;
    if (!$6e235e51c361c72d$var$e) return;
    if ($6e235e51c361c72d$var$i) return;
    const s = null == $6e235e51c361c72d$var$e ? void 0 : $6e235e51c361c72d$var$e.getInstance();
    if (!1 === (null == s ? void 0 : s.getOptions().Hash)) return;
    const { slug: c, index: u } = $6e235e51c361c72d$var$l(), d = (null === (t = null == s ? void 0 : s.getSlide()) || void 0 === t ? void 0 : t.fancybox) || (null === (n = null == s ? void 0 : s.getSlide()) || void 0 === n ? void 0 : n.slug) || void 0;
    s && d && (c === d ? null === (o = s.getCarousel()) || void 0 === o || o.goTo(u - 1) : ($6e235e51c361c72d$var$r = !0, s.close(), $6e235e51c361c72d$var$r = !1)), $6e235e51c361c72d$var$a();
}, $6e235e51c361c72d$var$c = ()=>{
    $6e235e51c361c72d$var$e && setTimeout(()=>{
        $6e235e51c361c72d$var$n = !0, $6e235e51c361c72d$var$a(), $6e235e51c361c72d$var$n = !1, window.addEventListener("hashchange", $6e235e51c361c72d$var$s, !1);
    }, 300);
}, $6e235e51c361c72d$export$ab85ecd77ce6a5cd = ()=>{
    let t, e = "auto", a = "";
    function s() {
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const i = t.getCarousel();
        if (!i) return;
        const { hash: r, slug: s } = $6e235e51c361c72d$var$l(), u = t.getSlide();
        if (!u) return;
        let d = u.fancybox || "", h = parseInt(u.index + "", 10) + 1;
        if (!d) return;
        let f = `#${d}-${h}`;
        if (r !== f && (a = r), history.scrollRestoration && (e = history.scrollRestoration, history.scrollRestoration = "manual"), i.on("change", c), !$6e235e51c361c72d$var$n) {
            if (d === s) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + f);
            } catch (t) {}
            else try {
                window.history.pushState({}, document.title, window.location.pathname + window.location.search + f), $6e235e51c361c72d$var$o = !0;
            } catch (t) {}
        }
    }
    function c() {
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const { slug: e } = $6e235e51c361c72d$var$l(), n = t.getSlide();
        if (!n) return;
        let o = n.fancybox || "", r = `#${o}-${n.index + 1}`;
        if (o === e) {
            $6e235e51c361c72d$var$i = !0;
            try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + r);
            } catch (t) {}
            $6e235e51c361c72d$var$i = !1;
        }
    }
    function u() {
        if ($6e235e51c361c72d$var$r) return;
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const e = t.getSlide();
        if (!e) return;
        if (e.fancybox || "") {
            $6e235e51c361c72d$var$i = !0;
            try {
                !$6e235e51c361c72d$var$o || $6e235e51c361c72d$var$n || function() {
                    if (window.parent === window) return !1;
                    try {
                        var t = window.frameElement;
                    } catch (e) {
                        t = null;
                    }
                    return null === t ? "data:" === location.protocol : t.hasAttribute("sandbox");
                }() ? window.history.replaceState({}, document.title, window.location.pathname + window.location.search + a) : window.history.back();
            } catch (t) {}
            $6e235e51c361c72d$var$i = !1;
        }
    }
    return {
        init: function(e) {
            t = e, t.on("ready", s), t.on("close", u);
        },
        destroy: function() {
            null == t || t.off("ready", s), null == t || t.off("close", u);
            const n = null == t ? void 0 : t.getCarousel();
            n && n.off("change", c), t = void 0, history.scrollRestoration && e && (history.scrollRestoration = e);
        }
    };
};
$6e235e51c361c72d$export$ab85ecd77ce6a5cd.startFromUrl = $6e235e51c361c72d$var$a, $6e235e51c361c72d$export$ab85ecd77ce6a5cd.setup = function(n) {
    $6e235e51c361c72d$var$e || ($6e235e51c361c72d$var$e = n, (0, $d1923504fa01932f$export$71594e8a50f746f4)() && (/complete|interactive|loaded/.test(document.readyState) ? $6e235e51c361c72d$var$c() : document.addEventListener("DOMContentLoaded", $6e235e51c361c72d$var$c)));
};



/*! License details at fancyapps.com/license */ 
const $5c1ff80d56ae0569$export$30568d076ec2f42 = Object.assign(Object.assign({}, (0, $bfaeb8c92ccc8716$export$30568d076ec2f42)), {
    CLOSE: "Close",
    NEXT: "Next",
    PREV: "Previous",
    MODAL: "You can close this modal content with the ESC key",
    ELEMENT_NOT_FOUND: "HTML Element Not Found",
    IFRAME_ERROR: "Error Loading Page"
});




const $d92b22a47c84057b$var$C = '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="M19.286 4.714 4.714 19.286M4.714 4.714l14.572 14.572" /></svg></button>';
(0, $1a887a2c6587884b$export$4c260019440d418f)().add("close", {
    tpl: $d92b22a47c84057b$var$C
});
const $d92b22a47c84057b$var$T = (e)=>{
    e && e.dispatchEvent(new CustomEvent("animationend", {
        bubbles: !1,
        cancelable: !0,
        currentTarget: e
    }));
}, $d92b22a47c84057b$var$A = (e = null, t = "", n)=>{
    if (!e || !e.parentElement || !t) return void (n && n());
    $d92b22a47c84057b$var$T(e);
    const o = (i)=>{
        i.target === e && e.dataset.animationName && (e.removeEventListener("animationend", o), delete e.dataset.animationName, n && n(), e.classList.remove(t));
    };
    e.dataset.animationName = t, e.addEventListener("animationend", o), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(e, t);
};
var $d92b22a47c84057b$export$b3af8f1b99ca9976;
!function(e) {
    e[e.Init = 0] = "Init", e[e.Ready = 1] = "Ready", e[e.Closing = 2] = "Closing", e[e.Destroyed = 3] = "Destroyed";
}($d92b22a47c84057b$export$b3af8f1b99ca9976 || ($d92b22a47c84057b$export$b3af8f1b99ca9976 = {}));
const $d92b22a47c84057b$var$k = {
    ajax: null,
    backdropClick: "close",
    Carousel: {},
    closeButton: "auto",
    closeExisting: !1,
    delegateEl: void 0,
    dragToClose: !0,
    fadeEffect: !0,
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    id: void 0,
    idle: !1,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: (0, $5c1ff80d56ae0569$export$30568d076ec2f42),
    mainClass: "",
    mainStyle: {},
    mainTpl: '<dialog class="fancybox__dialog">\n    <div class="fancybox__container" tabindex="0" aria-label="{{MODAL}}">\n      <div class="fancybox__backdrop"></div>\n      <div class="fancybox__carousel"></div>\n    </div>\n  </dialog>',
    on: {},
    parentEl: void 0,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    sync: void 0,
    theme: "dark",
    triggerEl: void 0,
    triggerEvent: void 0,
    zoomEffect: !0
}, $d92b22a47c84057b$var$O = new Map;
let $d92b22a47c84057b$var$_ = 0;
const $d92b22a47c84057b$var$D = "with-fancybox", $d92b22a47c84057b$var$R = ()=>{
    let l, w, j, R, z, H = $d92b22a47c84057b$export$b3af8f1b99ca9976.Init, B = Object.assign({}, $d92b22a47c84057b$var$k), N = -1, q = {}, V = [], F = !1, W = !0, $ = 0;
    function K(e, ...t) {
        let n = B[e];
        return n && "function" == typeof n ? n(je, ...t) : n;
    }
    function U(e, t = []) {
        const n = K("l10n") || {};
        e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
        for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    const X = new Map;
    function G(e, ...t) {
        const n = X.get(e) || [];
        for (const [t, o] of Object.entries(B.on || {}))(t === e || t.split(" ").indexOf(e) > -1) && n.push(o);
        for (const e of n)e && "function" == typeof e && e(je, ...t);
        "*" !== e && G("*", e, ...t);
    }
    function Y(t = [], n = {}) {
        H !== $d92b22a47c84057b$export$b3af8f1b99ca9976.Init && (je.destroy(), H = $d92b22a47c84057b$export$b3af8f1b99ca9976.Init), B = (0, $dcc16499f8d8077d$export$8b58be045bf06082)({}, $d92b22a47c84057b$var$k, n), N = K("id") || "fancybox-" + ++$d92b22a47c84057b$var$_;
        const a = $d92b22a47c84057b$var$O.get(N);
        if (a && a.destroy(), $d92b22a47c84057b$var$O.set(N, je), G("init"), function() {
            for (const [e, t] of Object.entries(Object.assign(Object.assign({}, $d92b22a47c84057b$export$cb45b08d97cdc4fd.Plugins), B.plugins || {})))if (e && !q[e] && t instanceof Function) {
                const n = t();
                n.init(je), q[e] = n;
            }
            G("initPlugins");
        }(), function(e = []) {
            G("initSlides", e), V = [
                ...e
            ];
        }(t), function() {
            const t = K("parentEl") || document.body;
            if (!(t && t instanceof HTMLElement)) return;
            const n = U(K("mainTpl") || "");
            if (l = (0, $d05c6dadc12263a9$export$b368690db5627d91)(n) || void 0, !(l && l instanceof HTMLDialogElement)) return;
            if (w = l.querySelector(".fancybox__container"), !(w && w instanceof HTMLElement)) return;
            const s = K("mainClass");
            s && (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(w, s);
            const a = K("mainStyle");
            if (a && (0, $e2409a96f5c7a13e$export$53b83ca8eaab0383)(a)) for (const [e, t] of Object.entries(a))w.style.setProperty(e, t);
            const u = K("theme"), d = "auto" === u ? window.matchMedia("(prefers-color-scheme:light)").matches : "light" === u;
            w.setAttribute("theme", d ? "light" : "dark"), l.setAttribute("id", `${N}`), l.addEventListener("keydown", (e)=>{
                "Escape" === e.key && e.preventDefault();
            }), l.addEventListener("wheel", (e)=>{
                const t = e.target;
                let n = K("wheel", e);
                t.closest(".f-thumbs") && (n = "slide");
                const o = "slide" === n, r = [
                    -e.deltaX || 0,
                    -e.deltaY || 0,
                    -e.detail || 0
                ].reduce(function(e, t) {
                    return Math.abs(t) > Math.abs(e) ? t : e;
                }), s = Math.max(-1, Math.min(1, r)), l = Date.now();
                $ && l - $ < 300 ? o && e.preventDefault() : ($ = l, G("wheel", e, s), e.defaultPrevented || ("close" === n ? xe(e) : "slide" === n && R && !(0, $86ffa1e8b3d1fbe0$export$e41e80160bed5714)(t) && (e.preventDefault(), R[s > 0 ? "prev" : "next"]())));
            }, {
                capture: !0,
                passive: !1
            }), l.addEventListener("cancel", (e)=>{
                xe(e);
            }), t.append(l), 1 === $d92b22a47c84057b$var$O.size && (K("hideScrollbar") && (0, $b3fda993920a4c14$export$b539ed14f4f9e78)(!0), document.documentElement.classList.add($d92b22a47c84057b$var$D));
            l.showModal(), G("initLayout");
        }(), function() {
            if (j = (null == l ? void 0 : l.querySelector(".fancybox__carousel")) || void 0, !j) return;
            const e = (0, $dcc16499f8d8077d$export$8b58be045bf06082)({
                Autoplay: {
                    autoStart: !1,
                    pauseOnHover: !1,
                    progressbarParentEl: (e)=>{
                        const t = e.getContainer();
                        return (null == t ? void 0 : t.querySelector(".f-carousel__toolbar [data-autoplay-action]")) || t;
                    }
                },
                Fullscreen: {
                    el: w
                },
                Toolbar: {
                    absolute: !0,
                    display: {
                        left: [
                            "counter"
                        ],
                        right: [
                            "toggleFull",
                            "autoplay",
                            "fullscreen",
                            "thumbs",
                            "close"
                        ]
                    }
                },
                Video: {
                    autoplay: !0
                },
                Zoomable: {
                    Panzoom: {
                        event: K("triggerEvent")
                    }
                },
                classes: {
                    container: "fancybox__carousel",
                    viewport: "fancybox__viewport",
                    slide: "fancybox__slide"
                },
                spinnerTpl: '<div class="f-spinner" data-fancybox-close></div>',
                dragFree: !1,
                slidesPerPage: 1,
                plugins: {
                    Sync: (0, $ea05e57d53ba8559$export$2ae15352e0a80063),
                    Arrows: (0, $b28e7e2e7c1326ec$export$b6e350ab9915297a),
                    Lazyload: (0, $c4fe8e007dd1caef$export$6f539aaa4f74fdd1),
                    Zoomable: (0, $efc2762d4fdebb63$export$b7fc409e12a7dcec),
                    Html: (0, $e7347e6cffdde041$export$13f9d3c4397c4713),
                    Video: (0, $499b83a5b5d74860$export$ae01dedf5c052bb),
                    Autoplay: (0, $c67740581e990826$export$6c96167f46662e38),
                    Fullscreen: (0, $a9301b5c0275503c$export$159cd03be7087f39),
                    Thumbs: (0, $9bd794b081a4d35f$export$73e055b807a6709),
                    Toolbar: (0, $1a887a2c6587884b$export$4c260019440d418f)
                }
            }, K("Carousel") || {}, {
                slides: V,
                enabled: !0,
                initialPage: K("startIndex") || 0,
                l10n: K("l10n")
            });
            R = (0, $8024d5e188ad0565$export$144901db2ea8e967)(j, e), G("initCarousel", R), R.on("*", (e, t, ...n)=>{
                G(`Carousel.${t}`, e, ...n);
            }), null == R || R.on("addSlide", te), R.on("attachSlideEl", ne), R.on("detachSlideEl", oe), R.on("contentReady", ce), R.on("ready", se), R.on("change", re), R.on("settle", le), R.init();
        }(), l && w) {
            if (K("closeExisting")) for (const [e, t] of $d92b22a47c84057b$var$O.entries())e !== N && t.close();
            K("fadeEffect") ? (setTimeout(()=>{
                Z();
            }, 500), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(w, "is-revealing")) : Z(), w.classList.add("is-ready"), H = $d92b22a47c84057b$export$b3af8f1b99ca9976.Ready, G("ready");
        }
    }
    function Z() {
        (0, $c5899590eea05f92$export$c2255604a80b4506)(w, "is-revealing");
        try {
            if (document.activeElement === l) ((null == w ? void 0 : w.querySelector("[autofocus]")) || w).focus();
        } catch (e) {}
    }
    function J(e) {
        if (!fe()) return;
        if (H !== $d92b22a47c84057b$export$b3af8f1b99ca9976.Ready) return e.preventDefault(), void e.stopPropagation();
        if (e.defaultPrevented) return;
        if (!(0, $cdb23866a53185e4$export$1f911e2d31b2843e).isClickAllowed()) return;
        const t = e.composedPath()[0];
        t.closest(".fancybox__carousel") && t.classList.contains("fancybox__slide") && Q(e);
    }
    function Q(e) {
        if (!!e.composedPath()[0].closest("[data-fancybox-close]")) return void xe(e);
        if (G("backdropClick", e), e.defaultPrevented) return;
        K("backdropClick") && xe(e);
    }
    function ee(e) {
        if (!fe()) return;
        if (H !== $d92b22a47c84057b$export$b3af8f1b99ca9976.Ready) return;
        if (be(), e.defaultPrevented) return;
        const t = e.composedPath()[0], n = !!t.closest("[data-fancybox-close]"), o = t.classList.contains("fancybox__backdrop");
        (n || o) && Q(e);
    }
    function te(e, t) {
        var n;
        null === (n = t.el) || void 0 === n || n.addEventListener("click", J);
    }
    function ne(e, n) {
        ie(n), "inline" !== n.type && "clone" !== n.type || function(e) {
            if (!R || !e || !e.el) return;
            let n = null;
            if ((0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(e.src)) {
                const t = e.src.split("#", 2).pop();
                n = t ? document.getElementById(t) : null;
            }
            if (n) {
                if ((0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(n, "f-html"), "clone" === e.type || n.closest(".fancybox__carousel")) {
                    n = n.cloneNode(!0);
                    const t = n.dataset.animationName;
                    t && (n.classList.remove(t), delete n.dataset.animationName);
                    let o = n.getAttribute("id");
                    o = o ? `${o}--clone` : `clone-${N}-${e.index}`, n.setAttribute("id", o);
                } else if (n.parentNode) {
                    const t = document.createElement("div");
                    t.inert = !0, n.parentNode.insertBefore(t, n), e.placeholderEl = t;
                }
                e.htmlEl = n, (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(e.el, "has-html"), e.el.prepend(n), n.classList.remove("hidden"), "none" === n.style.display && (n.style.display = ""), "none" === getComputedStyle(n).getPropertyValue("display") && (n.style.display = n.dataset.display || "flex"), null == R || R.emit("contentReady", e);
            } else null == R || R.showError(e, "{{ELEMENT_NOT_FOUND}}");
        }(n), "ajax" === n.type && function(e) {
            const t = e.el;
            if (!t) return;
            if (e.htmlEl || e.xhr) return;
            null == R || R.showLoading(e), e.state = 0;
            const n = new XMLHttpRequest;
            n.onreadystatechange = function() {
                if (n.readyState === XMLHttpRequest.DONE && H === $d92b22a47c84057b$export$b3af8f1b99ca9976.Ready) {
                    if (null == R || R.hideLoading(e), e.state = 1, 200 === n.status) {
                        let o = n.responseText + "", i = null, r = null;
                        if (e.filter) {
                            const t = document.createElement("div");
                            t.innerHTML = o, r = t.querySelector(e.filter + "");
                        }
                        r && r instanceof HTMLElement ? i = r : (i = document.createElement("div"), i.innerHTML = o), i.classList.add("f-html"), e.htmlEl = i, t.classList.add("has-html"), t.classList.add("has-ajax"), t.prepend(i), null == R || R.emit("contentReady", e);
                    } else null == R || R.showError(e);
                }
            };
            const o = K("ajax") || null;
            n.open(o ? "POST" : "GET", e.src + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(o), e.xhr = n;
        }(n);
    }
    function oe(e, t) {
        !function(e) {
            e.closeButtonEl && (e.closeButtonEl.remove(), e.closeButtonEl = void 0);
        }(t), "inline" !== t.type && "clone" !== t.type || function(e) {
            const t = e.htmlEl, n = e.placeholderEl;
            t && ("none" !== getComputedStyle(t).getPropertyValue("display") && (t.style.display = "none"), t.offsetHeight);
            n && (t && n.parentNode && n.parentNode.insertBefore(t, n), n.remove());
            e.htmlEl = void 0, e.placeholderEl = void 0;
        }(t), t.xhr && (t.xhr.abort(), t.xhr = void 0);
    }
    function ie(e) {
        var t;
        const { el: n, htmlEl: i, closeButtonEl: r } = e;
        if (!n || !i || r) return;
        let s = K("closeButton");
        if ("auto" === s && (s = !0 !== (null === (t = null == R ? void 0 : R.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled())), s) {
            const t = (0, $d05c6dadc12263a9$export$b368690db5627d91)(U($d92b22a47c84057b$var$C));
            t && (e.closeButtonEl = i.insertAdjacentElement("afterbegin", t), n.classList.add("has-close-btn"));
        }
    }
    function re() {
        W = !1, w && R && w.classList.remove("is-revealing");
        const e = K("sync");
        if (R && e) {
            const t = e.getPageIndex(R.getPageIndex()) || 0;
            e.goTo(t, {
                transition: !1
            });
        }
    }
    function se() {
        var e;
        if (H !== $d92b22a47c84057b$export$b3af8f1b99ca9976.Ready) return;
        ae(me()), function() {
            if (!K("dragToClose")) return;
            if (!R) return;
            const e = R.getViewport();
            if (!e) return;
            const t = (0, $cdb23866a53185e4$export$1f911e2d31b2843e)(e).init();
            if (!t) return;
            let n = 0, o = 0, r = (0, $bb38fc976d943d50$export$208a41d6b4e37b97)().on("step", (e)=>{
                n = e.y;
                const t = null == R ? void 0 : R.getViewport();
                if (w && t) {
                    const e = (0, $fff5597b4228e002$export$871de8747c9eaa88)(Math.abs(n), 0, .5 * t.getBoundingClientRect().height, 1, .5);
                    w.style.setProperty("--f-drag-opacity", e + ""), w.style.setProperty("--f-drag-offset", n + "px");
                }
            }).on("end", ()=>{
                if (!n) {
                    w && w.style.removeProperty("--f-opacity");
                    const e = null == R ? void 0 : R.getViewport();
                    e && (e.style.transform = "");
                }
            });
            t.on("start", function() {
                r.pause();
            }).on("panstart", (e)=>{
                var t;
                const n = e.srcEvent.target;
                n && !(0, $86ffa1e8b3d1fbe0$export$e41e80160bed5714)(n) && (null === (t = null == R ? void 0 : R.getViewport()) || void 0 === t || t.classList.add("is-dragging"));
            }).on("pan", function(e) {
                const t = e.srcEvent.target;
                t && (0, $86ffa1e8b3d1fbe0$export$e41e80160bed5714)(t) || (null == R ? void 0 : R.getViewport()) && "y" === e.axis && (o += e.deltaY, r.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 860,
                    friction: 17,
                    restDelta: .01,
                    restSpeed: .01
                }).from({
                    y: n
                }).to({
                    y: o
                }).start());
            }).on("end", function(e) {
                r.pause(), "y" === e.axis && Math.abs(e.velocityY) > 5 && Math.abs(o) > 0 && (xe(e.srcEvent, "f-throwOut" + (e.velocityY > 0 ? "Down" : "Up")), H === $d92b22a47c84057b$export$b3af8f1b99ca9976.Closing) || 0 !== o && (o = 0, r.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 140,
                    friction: 25,
                    restDelta: .1,
                    restSpeed: .1,
                    maxSpeed: 1 / 0
                }).from({
                    y: n
                }).to({
                    y: o
                }).start());
            });
        }(), document.body.addEventListener("click", ee), document.body.addEventListener("keydown", de, {
            passive: !1,
            capture: !0
        }), ye();
        const t = K("sync");
        t && (null === (e = t.getTween()) || void 0 === e || e.start());
    }
    function le() {
        (null == R ? void 0 : R.canGoNext()) ? ye() : Ee();
    }
    function ae(e) {
        if (!(W && R && 1 === R.getState() && e && e.index === R.getOptions().initialPage && e.el && e.el.parentElement)) return;
        if (void 0 !== e.state && 1 !== e.state) return;
        W = !1;
        const t = e.panzoomRef, n = null == t ? void 0 : t.getTween(), o = K("zoomEffect") ? ge(e) : void 0;
        if (t && n && o) {
            const e = t.getScale("base") || 1, { x: i, y: r } = t.getMousemovePos(e) || {
                x: 0,
                y: 0
            };
            return void n.spring({
                tension: 225,
                friction: 25,
                restDelta: .001,
                restSpeed: .001,
                maxSpeed: 1 / 0
            }).from(o).to({
                x: i,
                y: r,
                scale: e
            }).start();
        }
        const i = (null == t ? void 0 : t.getWrapper()) || e.htmlEl;
        i && $d92b22a47c84057b$var$A(i, K("showClass", e));
    }
    function ce(e, t) {
        ie(t), ae(t);
    }
    function ue() {
        be();
    }
    function de(e) {
        if (!fe()) return;
        if (H !== $d92b22a47c84057b$export$b3af8f1b99ca9976.Ready) return;
        const t = e.key, o = K("keyboard");
        if (!o) return;
        if (e.ctrlKey || e.altKey || e.shiftKey) return;
        const i = e.composedPath()[0];
        if (!(0, $d85d37926b6a3a9e$export$8ee0fc9ee280b4ee)(i)) return;
        if ("Escape" !== t && ((e)=>{
            const t = [
                "input",
                "textarea",
                "select",
                "option",
                "video",
                "iframe",
                "[contenteditable]",
                "[data-selectable]",
                "[data-draggable]"
            ].join(",");
            return e.matches(t) || e.closest(t);
        })(i)) return;
        if (G("keydown", e), e.defaultPrevented) return;
        const r = o[t];
        if (r) switch(r){
            case "close":
                xe(e);
                break;
            case "next":
                e.preventDefault(), null == R || R.next();
                break;
            case "prev":
                e.preventDefault(), null == R || R.prev();
        }
    }
    function fe() {
        var e;
        return (null === (e = $d92b22a47c84057b$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getId()) === N;
    }
    function me() {
        var e;
        return null === (e = null == R ? void 0 : R.getPage()) || void 0 === e ? void 0 : e.slides[0];
    }
    function pe() {
        const e = me();
        return e ? e.triggerEl || K("triggerEl") : void 0;
    }
    function ge(e) {
        var t, n;
        const o = null === (n = null === (t = e.panzoomRef) || void 0 === t ? void 0 : t.getWrapper()) || void 0 === n ? void 0 : n.getBoundingClientRect(), i = null == o ? void 0 : o.width, r = null == o ? void 0 : o.height;
        if (!i || !r) return;
        const s = e.thumbEl;
        if (!s) return;
        const l = s.getBoundingClientRect();
        let a = l.width, c = l.height, u = l.left, d = l.top;
        if (!l || !a || !c) return;
        if (!((e)=>{
            const t = e.getBoundingClientRect(), n = e.closest("[style]"), o = null == n ? void 0 : n.parentElement;
            if (n && n.style.transform && o) {
                const e = o.getBoundingClientRect();
                if (t.left < e.left || t.left > e.left + e.width - t.width) return !1;
                if (t.top < e.top || t.top > e.top + e.height - t.height) return !1;
            }
            const i = Math.max(document.documentElement.clientHeight, window.innerHeight), r = Math.max(document.documentElement.clientWidth, window.innerWidth);
            return !(t.bottom < 0 || t.top - i >= 0 || t.right < 0 || t.left - r >= 0);
        })(s)) return;
        if (s instanceof HTMLImageElement) {
            const e = window.getComputedStyle(s).getPropertyValue("object-fit");
            if ("contain" === e || "scale-down" === e) {
                const { width: t, height: n } = ((e, t, n, o, i = "contain")=>{
                    if ("contain" === i || e > n || t > o) {
                        const i = n / e, r = o / t, s = Math.min(i, r);
                        e *= s, t *= s;
                    }
                    return {
                        width: e,
                        height: t
                    };
                })(s.naturalWidth, s.naturalHeight, a, c, e);
                u += .5 * (a - t), d += .5 * (c - n), a = t, c = n;
            }
        }
        if (Math.abs(i / r - a / c) > .1) return;
        return {
            x: u + .5 * a - (o.left + .5 * i),
            y: d + .5 * c - (o.top + .5 * r),
            scale: a / i
        };
    }
    function ve() {
        z && clearTimeout(z), z = void 0, document.removeEventListener("mousemove", ue);
    }
    function ye() {
        if (F) return;
        if (z) return;
        const e = K("idle");
        e && (z = setTimeout(he, e));
    }
    function he() {
        w && (ve(), (0, $956098cca6f71028$export$d2cf6cd1dc7067d3)(w, "is-idle"), document.addEventListener("mousemove", ue), F = !0);
    }
    function be() {
        F && (Ee(), ye());
    }
    function Ee() {
        ve(), null == w || w.classList.remove("is-idle"), F = !1;
    }
    function xe(e, t) {
        var n, o, i, r, l, a;
        if (H === $d92b22a47c84057b$export$b3af8f1b99ca9976.Closing || H === $d92b22a47c84057b$export$b3af8f1b99ca9976.Destroyed) return;
        const c = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (G("shouldClose", c, e), c.defaultPrevented) return;
        if (ve(), e) {
            if (e.defaultPrevented) return;
            e.cancelable && e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
        if (H = $d92b22a47c84057b$export$b3af8f1b99ca9976.Closing, R) {
            null === (n = R.getGestures()) || void 0 === n || n.destroy(), null === (o = R.getTween()) || void 0 === o || o.pause();
            const e = me(), t = null == e ? void 0 : e.panzoomRef;
            e && t && (0, $dcc16499f8d8077d$export$8b58be045bf06082)(t.getOptions(), {
                clickAction: !1,
                wheelAction: !1,
                bounds: !1,
                minScale: 0,
                maxScale: 1 / 0
            });
            for (const e of R.getSlides())null === (r = null === (i = e.panzoomRef) || void 0 === i ? void 0 : i.getGestures()) || void 0 === r || r.destroy(), null === (a = null === (l = e.panzoomRef) || void 0 === l ? void 0 : l.getTween()) || void 0 === a || a.pause();
        }
        const u = null == R ? void 0 : R.getPlugins().fullscreen;
        u && u.inFullscreen() ? Promise.resolve(u.exit()).then(()=>{
            setTimeout(()=>{
                we(e, t);
            }, 150);
        }) : we(e, t);
    }
    function we(e, t) {
        var n, o, i, r, s;
        if (H !== $d92b22a47c84057b$export$b3af8f1b99ca9976.Closing) return;
        if (G("close", e), K("placeFocusBack")) {
            const e = pe();
            !e || (s = e.getBoundingClientRect()).bottom > 0 && s.right > 0 && s.left < (window.innerWidth || document.documentElement.clientWidth) && s.top < (window.innerHeight || document.documentElement.clientHeight) || e.scrollIntoView({
                behavior: "instant",
                block: "center",
                inline: "center"
            });
        }
        K("fadeEffect") && (null == w || w.classList.remove("is-ready"), null == w || w.classList.add("is-hiding")), null == w || w.classList.add("is-closing");
        const l = me(), a = null == l ? void 0 : l.panzoomRef, c = null === (n = null == l ? void 0 : l.panzoomRef) || void 0 === n ? void 0 : n.getTween(), d = t || K("hideClass");
        let f = !1, m = !1;
        if (R && l && a && c) {
            let e;
            K("zoomEffect") && ((null === (i = null === (o = R.getTween()) || void 0 === o ? void 0 : o.getCurrentVelocities()) || void 0 === i ? void 0 : i.pos) || 0) < 700 && 1 === l.state && (e = ge(l)), e && (f = !0, R.on("refresh", ()=>{
                const e = ge(l);
                e && c.to(Object.assign(Object.assign({}, (0, $0d16c58404501d51$export$15463f5204f2871f)), e));
            }), c.easing((0, $bb38fc976d943d50$export$208a41d6b4e37b97).Easings.EaseOut).duration(350).from(Object.assign({}, a.getTransform())).to(Object.assign(Object.assign({}, (0, $0d16c58404501d51$export$15463f5204f2871f)), e)).start());
        }
        const p = (null == l ? void 0 : l.htmlEl) || (null === (r = null == l ? void 0 : l.panzoomRef) || void 0 === r ? void 0 : r.getWrapper());
        p && $d92b22a47c84057b$var$T(p), !f && d && p && (m = !0, $d92b22a47c84057b$var$A(p, d, ()=>{
            Le();
        })), f || m ? setTimeout(()=>{
            Le();
        }, 350) : Le();
    }
    function Le() {
        var e, t, n, o, i;
        if (H === $d92b22a47c84057b$export$b3af8f1b99ca9976.Destroyed) return;
        H = $d92b22a47c84057b$export$b3af8f1b99ca9976.Destroyed, document.body.removeEventListener("click", ee), document.body.removeEventListener("keydown", de, {
            passive: !1,
            capture: !0
        });
        const s = pe();
        G("destroy"), null === (t = null === (e = K("sync")) || void 0 === e ? void 0 : e.getPlugins().Autoplay) || void 0 === t || t.resume(), null === (o = null === (n = K("sync")) || void 0 === n ? void 0 : n.getPlugins().Autoscroll) || void 0 === o || o.resume(), l instanceof HTMLDialogElement && l.close(), null === (i = null == R ? void 0 : R.getContainer()) || void 0 === i || i.classList.remove("is-idle"), null == R || R.destroy();
        for (const e of Object.values(q))null == e || e.destroy();
        if (q = {}, null == l || l.remove(), l = void 0, w = void 0, R = void 0, $d92b22a47c84057b$var$O.delete(N), !$d92b22a47c84057b$var$O.size && ((0, $b3fda993920a4c14$export$b539ed14f4f9e78)(!1), document.documentElement.classList.remove($d92b22a47c84057b$var$D), K("placeFocusBack"))) try {
            null == s || s.focus({
                preventScroll: !0
            });
        } catch (e) {}
    }
    const je = {
        close: xe,
        destroy: Le,
        getCarousel: function() {
            return R;
        },
        getContainer: function() {
            return w;
        },
        getId: function() {
            return N;
        },
        getOptions: function() {
            return B;
        },
        getPlugins: function() {
            return q;
        },
        getSlide: function() {
            return me();
        },
        getState: function() {
            return H;
        },
        init: function(e = [], t = {}) {
            return Y(e, t), je;
        },
        isCurrentSlide: function(e) {
            const t = me();
            return !(!e || !t) && t.index === e.index;
        },
        isTopMost: function() {
            return fe();
        },
        off: function(e, t) {
            return X.has(e) && X.set(e, X.get(e).filter((e)=>e !== t)), je;
        },
        on: function(e, t) {
            return X.set(e, [
                ...X.get(e) || [],
                t
            ]), je;
        },
        toggleIdle (e) {
            (F || !0 === e) && he(), F && !1 !== e || Ee();
        }
    };
    return je;
};
const $d92b22a47c84057b$export$cb45b08d97cdc4fd = {
    Plugins: {
        Hash: (0, $6e235e51c361c72d$export$ab85ecd77ce6a5cd)
    },
    version: "6.0.18",
    openers: new Map,
    bind: function(e, n, o) {
        if (!(0, $d1923504fa01932f$export$71594e8a50f746f4)()) return;
        let i = document.body, r = "[data-fancybox]", s = {};
        if ((0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(e) ? (i = document.body, r = e, "object" == typeof n && (s = n || {})) : e instanceof Element && (i = e, (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(n) && (r = n), "object" == typeof o && (s = o || {})), !(i && i instanceof Element && r)) return !1;
        const a = $d92b22a47c84057b$export$cb45b08d97cdc4fd.openers.get(i) || new Map;
        if (a.set(r, s), $d92b22a47c84057b$export$cb45b08d97cdc4fd.openers.set(i, a), 1 === a.size) {
            i.addEventListener("click", $d92b22a47c84057b$export$cb45b08d97cdc4fd.fromEvent);
            for (const e of Object.values($d92b22a47c84057b$export$cb45b08d97cdc4fd.Plugins)){
                const t = e.setup;
                "function" == typeof t && t($d92b22a47c84057b$export$cb45b08d97cdc4fd);
            }
        }
        return !0;
    },
    close: function(e = !0, ...t) {
        if (e) for (const e of $d92b22a47c84057b$var$O.values())e.close(...t);
        else {
            const e = $d92b22a47c84057b$export$cb45b08d97cdc4fd.getInstance();
            e && e.close(...t);
        }
    },
    destroy: function() {
        let e;
        for(; e = $d92b22a47c84057b$export$cb45b08d97cdc4fd.getInstance();)e.destroy();
        for (const e of $d92b22a47c84057b$export$cb45b08d97cdc4fd.openers.keys())e.removeEventListener("click", $d92b22a47c84057b$export$cb45b08d97cdc4fd.fromEvent);
        $d92b22a47c84057b$export$cb45b08d97cdc4fd.openers.clear();
    },
    fromEvent: function(e) {
        var t, n, o;
        if (e.defaultPrevented) return;
        if (e.button && 0 !== e.button) return;
        if (e.ctrlKey || e.metaKey || e.shiftKey) return;
        let i = e.composedPath()[0];
        if (i.closest(".fancybox__container.is-hiding")) return e.preventDefault(), void e.stopPropagation();
        const r = i.closest("[data-fancybox-delegate]") || void 0;
        if (r) {
            const e = r.dataset.fancyboxDelegate || "", t = document.querySelectorAll(`[data-fancybox="${e}"]`);
            i = t[parseInt(r.dataset.fancyboxIndex || "", 10) || 0] || t[0];
        }
        if (!(i && i instanceof Element)) return;
        let l, a, c = {};
        for (const [e, t] of $d92b22a47c84057b$export$cb45b08d97cdc4fd.openers)if (t && e.contains(i)) for (const [n, o] of t){
            let t = null;
            try {
                t = i.closest(n);
            } catch (e) {}
            t && (i = t, l = e, a = n, (0, $dcc16499f8d8077d$export$8b58be045bf06082)(c, o || {}));
        }
        if (!l || !a) return;
        e.preventDefault();
        const u = (0, $dcc16499f8d8077d$export$8b58be045bf06082)({}, $d92b22a47c84057b$var$k, {
            triggerEvent: e,
            triggerEl: i,
            delegateEl: r
        }, c), d = u.groupAll, f = u.groupAttr, m = f && i ? i.getAttribute(`${f}`) : "";
        let p = [];
        const g = null === (t = i.closest(".f-carousel")) || void 0 === t ? void 0 : t.carousel;
        if (g) {
            const e = [];
            for (const t of null == g ? void 0 : g.getSlides()){
                const n = t.el;
                n && (n.matches(a) ? e.push(n) : e.push(...[].slice.call(n.querySelectorAll(a))));
            }
            e.length && (p = [
                ...e
            ], null === (n = g.getPlugins().Autoplay) || void 0 === n || n.pause(), null === (o = g.getPlugins().Autoscroll) || void 0 === o || o.pause(), u.sync = g);
        } else (!i || m || d) && (p = [].slice.call(l.querySelectorAll(a)));
        if (i && !d && (p = m ? p.filter((e)=>e.getAttribute(`${f}`) === m) : [
            i
        ]), !p.length) return;
        const v = $d92b22a47c84057b$export$cb45b08d97cdc4fd.getInstance();
        if (v) {
            const e = v.getOptions().triggerEl;
            if (e && p.indexOf(e) > -1) return;
        }
        return Object.assign({}, u.Carousel || {}).rtl && (p = p.reverse()), i && (u.startIndex = p.indexOf(i)), $d92b22a47c84057b$export$cb45b08d97cdc4fd.fromNodes(p, u);
    },
    fromNodes: function(e, t) {
        t = (0, $dcc16499f8d8077d$export$8b58be045bf06082)({}, $d92b22a47c84057b$var$k, t || {});
        const n = [], o = (e)=>e instanceof HTMLImageElement ? e : e instanceof HTMLElement ? e.querySelector("img:not([aria-hidden])") : void 0;
        for (const i of e){
            const r = i.dataset || {}, s = t.delegateEl && e.indexOf(i) === t.startIndex ? t.delegateEl : void 0, l = o(s) || o(i) || void 0, a = r.src || i.getAttribute("href") || i.getAttribute("currentSrc") || i.getAttribute("src") || void 0, c = r.thumb || r.thumbSrc || (null == l ? void 0 : l.getAttribute("currentSrc")) || (null == l ? void 0 : l.getAttribute("src")) || (null == l ? void 0 : l.dataset.lazySrc) || void 0, u = {
                src: a,
                alt: r.alt || (null == l ? void 0 : l.getAttribute("alt")) || void 0,
                thumbSrc: c,
                thumbEl: l,
                triggerEl: i,
                delegateEl: s
            };
            for(const e in r){
                let t = r[e] + "";
                t = "false" !== t && ("true" === t || t), u[e] = t;
            }
            n.push(u);
        }
        return $d92b22a47c84057b$export$cb45b08d97cdc4fd.show(n, t);
    },
    fromSelector: function(e, n, o) {
        let i = document.body, r = "", l = {};
        if ((0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(e) ? r = e : e instanceof Element && (i = e, (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(n) && (r = n), "object" == typeof o && (l = o || {})), !(i && i instanceof Element && r)) return;
        const a = $d92b22a47c84057b$export$cb45b08d97cdc4fd.openers.get(i);
        return a ? (l = (0, $dcc16499f8d8077d$export$8b58be045bf06082)({}, a.get(r) || {}, l), l ? $d92b22a47c84057b$export$cb45b08d97cdc4fd.fromNodes(Array.from(i.querySelectorAll(r)), l) : void 0) : void 0;
    },
    getCarousel: function() {
        var e;
        return (null === (e = $d92b22a47c84057b$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getCarousel()) || void 0;
    },
    getDefaults: function() {
        return $d92b22a47c84057b$var$k;
    },
    getInstance: function(e) {
        if (e) {
            const t = $d92b22a47c84057b$var$O.get(e);
            return t && t.getState() !== $d92b22a47c84057b$export$b3af8f1b99ca9976.Destroyed ? t : void 0;
        }
        return Array.from($d92b22a47c84057b$var$O.values()).reverse().find((e)=>{
            if (e.getState() !== $d92b22a47c84057b$export$b3af8f1b99ca9976.Destroyed) return e;
        }) || void 0;
    },
    getSlide: function() {
        var e;
        return (null === (e = $d92b22a47c84057b$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getSlide()) || void 0;
    },
    show: function(e = [], t = {}) {
        return $d92b22a47c84057b$var$R().init(e, t);
    },
    unbind: function(e, n) {
        let o = document.body, i = "";
        if ((0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(e) ? i = e : e instanceof Element && (o = e, (0, $f53fd9aa530d4ce2$export$844ec244b1367d54)(n) && (i = n)), o) {
            const e = $d92b22a47c84057b$export$cb45b08d97cdc4fd.openers.get(o);
            e && i && e.delete(i), (null == e ? void 0 : e.size) && i || $d92b22a47c84057b$export$cb45b08d97cdc4fd.openers.delete(o), o.removeEventListener("click", $d92b22a47c84057b$export$cb45b08d97cdc4fd.fromEvent);
        }
    }
};














(0, $d92b22a47c84057b$export$cb45b08d97cdc4fd).bind('[data-fancybox="slider-image"]');
const $bdd15a79f3b80e35$var$selectors = {
    block: "[data-slider-image]"
};
const $bdd15a79f3b80e35$var$initSwiper = (container)=>new (0, $ef08903b40b10988$export$25ce5a424b770e84)(container.querySelector(".swiper"), {
        spaceBetween: 24,
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            1280: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        },
        navigation: {
            prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
            nextEl: container.querySelector('[data-swiper-navigation="next"]')
        },
        pagination: {
            el: container.querySelector("[data-swiper-pagination]")
        },
        on: {
            init: (swiper)=>{
                swiper.el.style.opacity = '1';
            }
        }
    });
const $bdd15a79f3b80e35$var$initBlock = (block)=>{
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $db5e35f8b42a9c13$export$2e2bcd8739ae039),
        (0, $253ab9cb215bc6e2$export$2e2bcd8739ae039),
        (0, $d680c6fd8e598294$export$2e2bcd8739ae039)
    ]);
    $bdd15a79f3b80e35$var$initSwiper(block);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($bdd15a79f3b80e35$var$selectors.block);
    blocks?.forEach($bdd15a79f3b80e35$var$initBlock);
}, {
    once: true
});


var $d7b90c97be224ee1$exports = {};



(0, $d92b22a47c84057b$export$cb45b08d97cdc4fd).bind('[data-fancybox="slider-video"]');
const $d7b90c97be224ee1$var$selectors = {
    block: "[data-slider-video]"
};
const $d7b90c97be224ee1$var$initSwiper = (container)=>new (0, $ef08903b40b10988$export$25ce5a424b770e84)(container.querySelector(".swiper"), {
        slidesPerView: "auto",
        spaceBetween: 24,
        navigation: {
            prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
            nextEl: container.querySelector('[data-swiper-navigation="next"]')
        },
        pagination: {
            el: container.querySelector("[data-swiper-pagination]")
        }
    });
const $d7b90c97be224ee1$var$initBlock = (block)=>{
    (0, $ef08903b40b10988$export$25ce5a424b770e84).use([
        (0, $db5e35f8b42a9c13$export$2e2bcd8739ae039),
        (0, $253ab9cb215bc6e2$export$2e2bcd8739ae039)
    ]);
    $d7b90c97be224ee1$var$initSwiper(block);
};
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($d7b90c97be224ee1$var$selectors.block);
    blocks?.forEach($d7b90c97be224ee1$var$initBlock);
}, {
    once: true
});


var $69de7dc88eaa0c92$exports = {};
const $69de7dc88eaa0c92$var$selectors = {
    block: "[data-target-group]",
    button: "[data-target-group-button]"
};
const $69de7dc88eaa0c92$var$initBlock = (block)=>{
    const buttons = block.querySelectorAll($69de7dc88eaa0c92$var$selectors.button);
    // buttons.forEach((button) =>
    //   button.addEventListener("click", () => (document.cookie = `target-group=${button.dataset.targetGroupButton}`))
    // );
    buttons.forEach((button)=>button.addEventListener("click", ()=>{
            $69de7dc88eaa0c92$var$setCookie('user_type_preference', button.dataset.targetGroupButton, 365);
        }));
};
function $69de7dc88eaa0c92$var$setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 86400000);
    const domain = window.location.hostname.replace(/^www\./, '');
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;domain=.${domain};SameSite=Lax`;
}
document.addEventListener("DOMContentLoaded", async function() {
    const blocks = document.querySelectorAll($69de7dc88eaa0c92$var$selectors.block);
    blocks?.forEach($69de7dc88eaa0c92$var$initBlock);
}, {
    once: true
});


var $b2dee57296f21247$exports = {};

(0, $d92b22a47c84057b$export$cb45b08d97cdc4fd).bind('[data-fancybox="video"]');


$6391e2b97e6756d6$exports = {
    "components": {
        "card-product": {
            "index copy": $008cc81fbaa87c40$exports,
            "index": $6d529dde93b473aa$exports
        },
        "language-switcher": {
            "index": $6565e75a167d356f$exports
        }
    },
    "blocks": {
        "card-row": {
            "index": $8e22ce6962ee56c6$exports
        },
        "contact-representative": {
            "index": $f57771f2c38e5958$exports
        },
        "downloads": {
            "index": $872ba0b5fdcef74e$exports
        },
        "frituur-of-the-month": {
            "index": $bba5c2db06278f04$exports
        },
        "history-b2b": {
            "index": $39283e61516b30c4$exports
        },
        "history-b2c": {
            "index": $9c291a20e416d0d3$exports
        },
        "login": {
            "index": $15048eb7b061216f$exports
        },
        "overview": {
            "index": $f3ce3c92dad61958$exports
        },
        "product-categories-b2c": {
            "index": $9411547ecd6821ce$exports
        },
        "product-categories-slider": {
            "index": $86316a66c8543ab8$exports
        },
        "product-categories-slider-v2": {
            "index": $5bc2f7e02c6a2d2b$exports
        },
        "product-details": {
            "index": $5ab3a902e841c548$exports
        },
        "product-filter": {
            "index": $c72f82e13c082c56$exports
        },
        "representatives": {
            "index": $821366883944f074$exports
        },
        "slider-image": {
            "index": $bdd15a79f3b80e35$exports
        },
        "slider-video": {
            "index": $d7b90c97be224ee1$exports
        },
        "target-group": {
            "index": $69de7dc88eaa0c92$exports
        },
        "video": {
            "index": $b2dee57296f21247$exports
        }
    }
};


var $aa41ebd6a0896cb8$exports = {};
var $4d94c3d0cd8b9267$exports = {};

$parcel$export($4d94c3d0cd8b9267$exports, "animate", function () { return $4d94c3d0cd8b9267$export$e3607ec2d7a891c4; });
$parcel$export($4d94c3d0cd8b9267$exports, "getCookieValue", function () { return $4d94c3d0cd8b9267$export$2edfe291d87a018a; });
const $4d94c3d0cd8b9267$export$e3607ec2d7a891c4 = (image)=>{
    let frame = 1;
    let positionX = 1;
    const totalFrames = 49;
    const imageWidth = image.getBoundingClientRect().width;
    const interval = setInterval(()=>{
        if (frame === totalFrames) clearInterval(interval);
        frame++;
        positionX -= imageWidth;
        image.style.setProperty("--bg-position", `${positionX}px 0px`);
    }, 60);
};
const $4d94c3d0cd8b9267$export$2edfe291d87a018a = (name)=>{
    const regex = new RegExp(`(^| )${name}=([^;]+)`);
    const match = document.cookie.match(regex);
    if (match) return match[2];
};


$aa41ebd6a0896cb8$exports = {
    "utils": $4d94c3d0cd8b9267$exports
};



})();
//# sourceMappingURL=index.js.map
